/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2020 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */

(function webpackUniversalModuleDefinition (root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') { module.exports = factory() } else if (typeof define === 'function' && define.amd) { define('pdfjs-dist/build/pdf', [], factory) } else if (typeof exports === 'object') { exports['pdfjs-dist/build/pdf'] = factory() } else { root['pdfjs-dist/build/pdf'] = root.pdfjsLib = factory() }
})(this, function () {
  return /******/ (function (modules) { // webpackBootstrap
    /******/ 	// The module cache
    /******/ 	const installedModules = {}
    /******/
    /******/ 	// The require function
    /******/ 	function __w_pdfjs_require__ (moduleId) {
      /******/
      /******/ 		// Check if module is in cache
      /******/ 		if (installedModules[moduleId]) {
        /******/ 			return installedModules[moduleId].exports
        /******/ 		}
      /******/ 		// Create a new module (and put it into the cache)
      /******/ 		const module = installedModules[moduleId] = {
        /******/ 			i: moduleId,
        /******/ 			l: false,
        /******/ 			exports: {}
        /******/ 		}
      /******/
      /******/ 		// Execute the module function
      /******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__)
      /******/
      /******/ 		// Flag the module as loaded
      /******/ 		module.l = true
      /******/
      /******/ 		// Return the exports of the module
      /******/ 		return module.exports
      /******/ 	}
    /******/
    /******/
    /******/ 	// expose the modules object (__webpack_modules__)
    /******/ 	__w_pdfjs_require__.m = modules
    /******/
    /******/ 	// expose the module cache
    /******/ 	__w_pdfjs_require__.c = installedModules
    /******/
    /******/ 	// define getter function for harmony exports
    /******/ 	__w_pdfjs_require__.d = function (exports, name, getter) {
      /******/ 		if (!__w_pdfjs_require__.o(exports, name)) {
        /******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter })
        /******/ 		}
      /******/ 	}
    /******/
    /******/ 	// define __esModule on exports
    /******/ 	__w_pdfjs_require__.r = function (exports) {
      /******/ 		if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' })
        /******/ 		}
      /******/ 		Object.defineProperty(exports, '__esModule', { value: true })
      /******/ 	}
    /******/
    /******/ 	// create a fake namespace object
    /******/ 	// mode & 1: value is a module id, require it
    /******/ 	// mode & 2: merge all properties of value into the ns
    /******/ 	// mode & 4: return value when already ns object
    /******/ 	// mode & 8|1: behave like require
    /******/ 	__w_pdfjs_require__.t = function (value, mode) {
      /******/ 		if (mode & 1) value = __w_pdfjs_require__(value)
      /******/ 		if (mode & 8) return value
      /******/ 		if ((mode & 4) && typeof value === 'object' && value && value.__esModule) return value
      /******/ 		const ns = Object.create(null)
      /******/ 		__w_pdfjs_require__.r(ns)
      /******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value })
      /******/ 		if (mode & 2 && typeof value !== 'string') for (const key in value) __w_pdfjs_require__.d(ns, key, function (key) { return value[key] }.bind(null, key))
      /******/ 		return ns
      /******/ 	}
    /******/
    /******/ 	// getDefaultExport function for compatibility with non-harmony modules
    /******/ 	__w_pdfjs_require__.n = function (module) {
      /******/ 		const getter = module && module.__esModule
      /******/ 			? function getDefault () { return module.default }
      /******/ 			: function getModuleExports () { return module }
      /******/ 		__w_pdfjs_require__.d(getter, 'a', getter)
      /******/ 		return getter
      /******/ 	}
    /******/
    /******/ 	// Object.prototype.hasOwnProperty.call
    /******/ 	__w_pdfjs_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property) }
    /******/
    /******/ 	// __webpack_public_path__
    /******/ 	__w_pdfjs_require__.p = ''
    /******/
    /******/
    /******/ 	// Load entry module and return exports
    /******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 0)
    /******/ })
  /************************************************************************/
  /******/ ([
    /* 0 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const pdfjsVersion = '2.4.456'
      const pdfjsBuild = '228a591c'

      const pdfjsSharedUtil = __w_pdfjs_require__(1)

      const pdfjsDisplayAPI = __w_pdfjs_require__(190)

      const pdfjsDisplayTextLayer = __w_pdfjs_require__(205)

      const pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(206)

      const pdfjsDisplayDisplayUtils = __w_pdfjs_require__(194)

      const pdfjsDisplaySVG = __w_pdfjs_require__(207)

      const pdfjsDisplayWorkerOptions = __w_pdfjs_require__(199)

      const pdfjsDisplayAPICompatibility = __w_pdfjs_require__(196)

      {
        const _require = __w_pdfjs_require__(48)
        const isNodeJS = _require.isNodeJS

        if (isNodeJS) {
          const PDFNodeStream = __w_pdfjs_require__(208).PDFNodeStream

          pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
            return new PDFNodeStream(params)
          })
        } else {
          const PDFNetworkStream = __w_pdfjs_require__(211).PDFNetworkStream

          let PDFFetchStream

          if (pdfjsDisplayDisplayUtils.isFetchSupported()) {
            PDFFetchStream = __w_pdfjs_require__(212).PDFFetchStream
          }

          pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
            if (PDFFetchStream && pdfjsDisplayDisplayUtils.isValidFetchUrl(params.url)) {
              return new PDFFetchStream(params)
            }

            return new PDFNetworkStream(params)
          })
        }
      }
      exports.build = pdfjsDisplayAPI.build
      exports.version = pdfjsDisplayAPI.version
      exports.getDocument = pdfjsDisplayAPI.getDocument
      exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort
      exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport
      exports.PDFWorker = pdfjsDisplayAPI.PDFWorker
      exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer
      exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer
      exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability
      exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses
      exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException
      exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException
      exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics
      exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding
      exports.CMapCompressionType = pdfjsSharedUtil.CMapCompressionType
      exports.PermissionFlag = pdfjsSharedUtil.PermissionFlag
      exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException
      exports.OPS = pdfjsSharedUtil.OPS
      exports.VerbosityLevel = pdfjsSharedUtil.VerbosityLevel
      exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES
      exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl
      exports.createObjectURL = pdfjsSharedUtil.createObjectURL
      exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters
      exports.shadow = pdfjsSharedUtil.shadow
      exports.Util = pdfjsSharedUtil.Util
      exports.RenderingCancelledException = pdfjsDisplayDisplayUtils.RenderingCancelledException
      exports.getFilenameFromUrl = pdfjsDisplayDisplayUtils.getFilenameFromUrl
      exports.LinkTarget = pdfjsDisplayDisplayUtils.LinkTarget
      exports.addLinkAttributes = pdfjsDisplayDisplayUtils.addLinkAttributes
      exports.loadScript = pdfjsDisplayDisplayUtils.loadScript
      exports.PDFDateString = pdfjsDisplayDisplayUtils.PDFDateString
      exports.GlobalWorkerOptions = pdfjsDisplayWorkerOptions.GlobalWorkerOptions
      exports.apiCompatibilityParams = pdfjsDisplayAPICompatibility.apiCompatibilityParams
      /***/ },
    /* 1 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.arrayByteLength = arrayByteLength
      exports.arraysToBytes = arraysToBytes
      exports.assert = assert
      exports.bytesToString = bytesToString
      exports.createPromiseCapability = createPromiseCapability
      exports.getVerbosityLevel = getVerbosityLevel
      exports.info = info
      exports.isArrayBuffer = isArrayBuffer
      exports.isArrayEqual = isArrayEqual
      exports.isBool = isBool
      exports.isEmptyObj = isEmptyObj
      exports.isNum = isNum
      exports.isString = isString
      exports.isSameOrigin = isSameOrigin
      exports.createValidAbsoluteUrl = createValidAbsoluteUrl
      exports.removeNullCharacters = removeNullCharacters
      exports.setVerbosityLevel = setVerbosityLevel
      exports.shadow = shadow
      exports.string32 = string32
      exports.stringToBytes = stringToBytes
      exports.stringToPDFString = stringToPDFString
      exports.stringToUTF8String = stringToUTF8String
      exports.utf8StringToString = utf8StringToString
      exports.warn = warn
      exports.unreachable = unreachable
      exports.IsEvalSupportedCached = exports.IsLittleEndianCached = exports.createObjectURL = exports.FormatError = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.NativeImageDecoding = exports.MissingPDFException = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationStateModelType = exports.AnnotationReviewState = exports.AnnotationReplyType = exports.AnnotationMarkedState = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VerbosityLevel = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = exports.BaseException = void 0

      __w_pdfjs_require__(2)

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _possibleConstructorReturn (self, call) { if (call && (_typeof(call) === 'object' || typeof call === 'function')) { return call } return _assertThisInitialized(self) }

      function _assertThisInitialized (self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called") } return self }

      function _getPrototypeOf (o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf (o) { return o.__proto__ || Object.getPrototypeOf(o) }; return _getPrototypeOf(o) }

      function _inherits (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function') } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass) }

      function _setPrototypeOf (o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf (o, p) { o.__proto__ = p; return o }; return _setPrototypeOf(o, p) }

      const IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0]
      exports.IDENTITY_MATRIX = IDENTITY_MATRIX
      const FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0]
      exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX
      const NativeImageDecoding = {
        NONE: 'none',
        DECODE: 'decode',
        DISPLAY: 'display'
      }
      exports.NativeImageDecoding = NativeImageDecoding
      const PermissionFlag = {
        PRINT: 0x04,
        MODIFY_CONTENTS: 0x08,
        COPY: 0x10,
        MODIFY_ANNOTATIONS: 0x20,
        FILL_INTERACTIVE_FORMS: 0x100,
        COPY_FOR_ACCESSIBILITY: 0x200,
        ASSEMBLE: 0x400,
        PRINT_HIGH_QUALITY: 0x800
      }
      exports.PermissionFlag = PermissionFlag
      const TextRenderingMode = {
        FILL: 0,
        STROKE: 1,
        FILL_STROKE: 2,
        INVISIBLE: 3,
        FILL_ADD_TO_PATH: 4,
        STROKE_ADD_TO_PATH: 5,
        FILL_STROKE_ADD_TO_PATH: 6,
        ADD_TO_PATH: 7,
        FILL_STROKE_MASK: 3,
        ADD_TO_PATH_FLAG: 4
      }
      exports.TextRenderingMode = TextRenderingMode
      const ImageKind = {
        GRAYSCALE_1BPP: 1,
        RGB_24BPP: 2,
        RGBA_32BPP: 3
      }
      exports.ImageKind = ImageKind
      const AnnotationType = {
        TEXT: 1,
        LINK: 2,
        FREETEXT: 3,
        LINE: 4,
        SQUARE: 5,
        CIRCLE: 6,
        POLYGON: 7,
        POLYLINE: 8,
        HIGHLIGHT: 9,
        UNDERLINE: 10,
        SQUIGGLY: 11,
        STRIKEOUT: 12,
        STAMP: 13,
        CARET: 14,
        INK: 15,
        POPUP: 16,
        FILEATTACHMENT: 17,
        SOUND: 18,
        MOVIE: 19,
        WIDGET: 20,
        SCREEN: 21,
        PRINTERMARK: 22,
        TRAPNET: 23,
        WATERMARK: 24,
        THREED: 25,
        REDACT: 26
      }
      exports.AnnotationType = AnnotationType
      const AnnotationStateModelType = {
        MARKED: 'Marked',
        REVIEW: 'Review'
      }
      exports.AnnotationStateModelType = AnnotationStateModelType
      const AnnotationMarkedState = {
        MARKED: 'Marked',
        UNMARKED: 'Unmarked'
      }
      exports.AnnotationMarkedState = AnnotationMarkedState
      const AnnotationReviewState = {
        ACCEPTED: 'Accepted',
        REJECTED: 'Rejected',
        CANCELLED: 'Cancelled',
        COMPLETED: 'Completed',
        NONE: 'None'
      }
      exports.AnnotationReviewState = AnnotationReviewState
      const AnnotationReplyType = {
        GROUP: 'Group',
        REPLY: 'R'
      }
      exports.AnnotationReplyType = AnnotationReplyType
      const AnnotationFlag = {
        INVISIBLE: 0x01,
        HIDDEN: 0x02,
        PRINT: 0x04,
        NOZOOM: 0x08,
        NOROTATE: 0x10,
        NOVIEW: 0x20,
        READONLY: 0x40,
        LOCKED: 0x80,
        TOGGLENOVIEW: 0x100,
        LOCKEDCONTENTS: 0x200
      }
      exports.AnnotationFlag = AnnotationFlag
      const AnnotationFieldFlag = {
        READONLY: 0x0000001,
        REQUIRED: 0x0000002,
        NOEXPORT: 0x0000004,
        MULTILINE: 0x0001000,
        PASSWORD: 0x0002000,
        NOTOGGLETOOFF: 0x0004000,
        RADIO: 0x0008000,
        PUSHBUTTON: 0x0010000,
        COMBO: 0x0020000,
        EDIT: 0x0040000,
        SORT: 0x0080000,
        FILESELECT: 0x0100000,
        MULTISELECT: 0x0200000,
        DONOTSPELLCHECK: 0x0400000,
        DONOTSCROLL: 0x0800000,
        COMB: 0x1000000,
        RICHTEXT: 0x2000000,
        RADIOSINUNISON: 0x2000000,
        COMMITONSELCHANGE: 0x4000000
      }
      exports.AnnotationFieldFlag = AnnotationFieldFlag
      const AnnotationBorderStyleType = {
        SOLID: 1,
        DASHED: 2,
        BEVELED: 3,
        INSET: 4,
        UNDERLINE: 5
      }
      exports.AnnotationBorderStyleType = AnnotationBorderStyleType
      const StreamType = {
        UNKNOWN: 'UNKNOWN',
        FLATE: 'FLATE',
        LZW: 'LZW',
        DCT: 'DCT',
        JPX: 'JPX',
        JBIG: 'JBIG',
        A85: 'A85',
        AHX: 'AHX',
        CCF: 'CCF',
        RLX: 'RLX'
      }
      exports.StreamType = StreamType
      const FontType = {
        UNKNOWN: 'UNKNOWN',
        TYPE1: 'TYPE1',
        TYPE1C: 'TYPE1C',
        CIDFONTTYPE0: 'CIDFONTTYPE0',
        CIDFONTTYPE0C: 'CIDFONTTYPE0C',
        TRUETYPE: 'TRUETYPE',
        CIDFONTTYPE2: 'CIDFONTTYPE2',
        TYPE3: 'TYPE3',
        OPENTYPE: 'OPENTYPE',
        TYPE0: 'TYPE0',
        MMTYPE1: 'MMTYPE1'
      }
      exports.FontType = FontType
      const VerbosityLevel = {
        ERRORS: 0,
        WARNINGS: 1,
        INFOS: 5
      }
      exports.VerbosityLevel = VerbosityLevel
      const CMapCompressionType = {
        NONE: 0,
        BINARY: 1,
        STREAM: 2
      }
      exports.CMapCompressionType = CMapCompressionType
      const OPS = {
        dependency: 1,
        setLineWidth: 2,
        setLineCap: 3,
        setLineJoin: 4,
        setMiterLimit: 5,
        setDash: 6,
        setRenderingIntent: 7,
        setFlatness: 8,
        setGState: 9,
        save: 10,
        restore: 11,
        transform: 12,
        moveTo: 13,
        lineTo: 14,
        curveTo: 15,
        curveTo2: 16,
        curveTo3: 17,
        closePath: 18,
        rectangle: 19,
        stroke: 20,
        closeStroke: 21,
        fill: 22,
        eoFill: 23,
        fillStroke: 24,
        eoFillStroke: 25,
        closeFillStroke: 26,
        closeEOFillStroke: 27,
        endPath: 28,
        clip: 29,
        eoClip: 30,
        beginText: 31,
        endText: 32,
        setCharSpacing: 33,
        setWordSpacing: 34,
        setHScale: 35,
        setLeading: 36,
        setFont: 37,
        setTextRenderingMode: 38,
        setTextRise: 39,
        moveText: 40,
        setLeadingMoveText: 41,
        setTextMatrix: 42,
        nextLine: 43,
        showText: 44,
        showSpacedText: 45,
        nextLineShowText: 46,
        nextLineSetSpacingShowText: 47,
        setCharWidth: 48,
        setCharWidthAndBounds: 49,
        setStrokeColorSpace: 50,
        setFillColorSpace: 51,
        setStrokeColor: 52,
        setStrokeColorN: 53,
        setFillColor: 54,
        setFillColorN: 55,
        setStrokeGray: 56,
        setFillGray: 57,
        setStrokeRGBColor: 58,
        setFillRGBColor: 59,
        setStrokeCMYKColor: 60,
        setFillCMYKColor: 61,
        shadingFill: 62,
        beginInlineImage: 63,
        beginImageData: 64,
        endInlineImage: 65,
        paintXObject: 66,
        markPoint: 67,
        markPointProps: 68,
        beginMarkedContent: 69,
        beginMarkedContentProps: 70,
        endMarkedContent: 71,
        beginCompat: 72,
        endCompat: 73,
        paintFormXObjectBegin: 74,
        paintFormXObjectEnd: 75,
        beginGroup: 76,
        endGroup: 77,
        beginAnnotations: 78,
        endAnnotations: 79,
        beginAnnotation: 80,
        endAnnotation: 81,
        paintJpegXObject: 82,
        paintImageMaskXObject: 83,
        paintImageMaskXObjectGroup: 84,
        paintImageXObject: 85,
        paintInlineImageXObject: 86,
        paintInlineImageXObjectGroup: 87,
        paintImageXObjectRepeat: 88,
        paintImageMaskXObjectRepeat: 89,
        paintSolidColorImageMask: 90,
        constructPath: 91
      }
      exports.OPS = OPS
      const UNSUPPORTED_FEATURES = {
        unknown: 'unknown',
        forms: 'forms',
        javaScript: 'javaScript',
        smask: 'smask',
        shadingPattern: 'shadingPattern',
        font: 'font'
      }
      exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES
      const PasswordResponses = {
        NEED_PASSWORD: 1,
        INCORRECT_PASSWORD: 2
      }
      exports.PasswordResponses = PasswordResponses
      let verbosity = VerbosityLevel.WARNINGS

      function setVerbosityLevel (level) {
        if (Number.isInteger(level)) {
          verbosity = level
        }
      }

      function getVerbosityLevel () {
        return verbosity
      }

      function info (msg) {
        if (verbosity >= VerbosityLevel.INFOS) {
          console.log('Info: '.concat(msg))
        }
      }

      function warn (msg) {
        if (verbosity >= VerbosityLevel.WARNINGS) {
          console.log('Warning: '.concat(msg))
        }
      }

      function unreachable (msg) {
        throw new Error(msg)
      }

      function assert (cond, msg) {
        if (!cond) {
          unreachable(msg)
        }
      }

      function isSameOrigin (baseUrl, otherUrl) {
        let base

        try {
          base = new URL(baseUrl)

          if (!base.origin || base.origin === 'null') {
            return false
          }
        } catch (e) {
          return false
        }

        const other = new URL(otherUrl, base)
        return base.origin === other.origin
      }

      function _isValidProtocol (url) {
        if (!url) {
          return false
        }

        switch (url.protocol) {
          case 'http:':
          case 'https:':
          case 'ftp:':
          case 'mailto:':
          case 'tel:':
            return true

          default:
            return false
        }
      }

      function createValidAbsoluteUrl (url, baseUrl) {
        if (!url) {
          return null
        }

        try {
          const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url)

          if (_isValidProtocol(absoluteUrl)) {
            return absoluteUrl
          }
        } catch (ex) {}

        return null
      }

      function shadow (obj, prop, value) {
        Object.defineProperty(obj, prop, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: false
        })
        return value
      }

      const BaseException = (function BaseExceptionClosure () {
        function BaseException (message) {
          if (this.constructor === BaseException) {
            unreachable('Cannot initialize BaseException.')
          }

          this.message = message
          this.name = this.constructor.name
        }

        BaseException.prototype = new Error()
        BaseException.constructor = BaseException
        return BaseException
      }())

      exports.BaseException = BaseException

      const PasswordException = /* #__PURE__ */(function (_BaseException) {
        _inherits(PasswordException, _BaseException)

        function PasswordException (msg, code) {
          let _this

          _classCallCheck(this, PasswordException)

          _this = _possibleConstructorReturn(this, _getPrototypeOf(PasswordException).call(this, msg))
          _this.code = code
          return _this
        }

        return PasswordException
      }(BaseException))

      exports.PasswordException = PasswordException

      const UnknownErrorException = /* #__PURE__ */(function (_BaseException2) {
        _inherits(UnknownErrorException, _BaseException2)

        function UnknownErrorException (msg, details) {
          let _this2

          _classCallCheck(this, UnknownErrorException)

          _this2 = _possibleConstructorReturn(this, _getPrototypeOf(UnknownErrorException).call(this, msg))
          _this2.details = details
          return _this2
        }

        return UnknownErrorException
      }(BaseException))

      exports.UnknownErrorException = UnknownErrorException

      const InvalidPDFException = /* #__PURE__ */(function (_BaseException3) {
        _inherits(InvalidPDFException, _BaseException3)

        function InvalidPDFException () {
          _classCallCheck(this, InvalidPDFException)

          return _possibleConstructorReturn(this, _getPrototypeOf(InvalidPDFException).apply(this, arguments))
        }

        return InvalidPDFException
      }(BaseException))

      exports.InvalidPDFException = InvalidPDFException

      const MissingPDFException = /* #__PURE__ */(function (_BaseException4) {
        _inherits(MissingPDFException, _BaseException4)

        function MissingPDFException () {
          _classCallCheck(this, MissingPDFException)

          return _possibleConstructorReturn(this, _getPrototypeOf(MissingPDFException).apply(this, arguments))
        }

        return MissingPDFException
      }(BaseException))

      exports.MissingPDFException = MissingPDFException

      const UnexpectedResponseException = /* #__PURE__ */(function (_BaseException5) {
        _inherits(UnexpectedResponseException, _BaseException5)

        function UnexpectedResponseException (msg, status) {
          let _this3

          _classCallCheck(this, UnexpectedResponseException)

          _this3 = _possibleConstructorReturn(this, _getPrototypeOf(UnexpectedResponseException).call(this, msg))
          _this3.status = status
          return _this3
        }

        return UnexpectedResponseException
      }(BaseException))

      exports.UnexpectedResponseException = UnexpectedResponseException

      const FormatError = /* #__PURE__ */(function (_BaseException6) {
        _inherits(FormatError, _BaseException6)

        function FormatError () {
          _classCallCheck(this, FormatError)

          return _possibleConstructorReturn(this, _getPrototypeOf(FormatError).apply(this, arguments))
        }

        return FormatError
      }(BaseException))

      exports.FormatError = FormatError

      const AbortException = /* #__PURE__ */(function (_BaseException7) {
        _inherits(AbortException, _BaseException7)

        function AbortException () {
          _classCallCheck(this, AbortException)

          return _possibleConstructorReturn(this, _getPrototypeOf(AbortException).apply(this, arguments))
        }

        return AbortException
      }(BaseException))

      exports.AbortException = AbortException
      const NullCharactersRegExp = /\x00/g

      function removeNullCharacters (str) {
        if (typeof str !== 'string') {
          warn('The argument for removeNullCharacters must be a string.')
          return str
        }

        return str.replace(NullCharactersRegExp, '')
      }

      function bytesToString (bytes) {
        assert(bytes !== null && _typeof(bytes) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString')
        const length = bytes.length
        const MAX_ARGUMENT_COUNT = 8192

        if (length < MAX_ARGUMENT_COUNT) {
          return String.fromCharCode.apply(null, bytes)
        }

        const strBuf = []

        for (let i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
          const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length)
          const chunk = bytes.subarray(i, chunkEnd)
          strBuf.push(String.fromCharCode.apply(null, chunk))
        }

        return strBuf.join('')
      }

      function stringToBytes (str) {
        assert(typeof str === 'string', 'Invalid argument for stringToBytes')
        const length = str.length
        const bytes = new Uint8Array(length)

        for (let i = 0; i < length; ++i) {
          bytes[i] = str.charCodeAt(i) & 0xff
        }

        return bytes
      }

      function arrayByteLength (arr) {
        if (arr.length !== undefined) {
          return arr.length
        }

        assert(arr.byteLength !== undefined)
        return arr.byteLength
      }

      function arraysToBytes (arr) {
        const length = arr.length

        if (length === 1 && arr[0] instanceof Uint8Array) {
          return arr[0]
        }

        let resultLength = 0

        for (let i = 0; i < length; i++) {
          resultLength += arrayByteLength(arr[i])
        }

        let pos = 0
        const data = new Uint8Array(resultLength)

        for (let _i = 0; _i < length; _i++) {
          let item = arr[_i]

          if (!(item instanceof Uint8Array)) {
            if (typeof item === 'string') {
              item = stringToBytes(item)
            } else {
              item = new Uint8Array(item)
            }
          }

          const itemLength = item.byteLength
          data.set(item, pos)
          pos += itemLength
        }

        return data
      }

      function string32 (value) {
        return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff)
      }

      function isLittleEndian () {
        const buffer8 = new Uint8Array(4)
        buffer8[0] = 1
        const view32 = new Uint32Array(buffer8.buffer, 0, 1)
        return view32[0] === 1
      }

      const IsLittleEndianCached = {
        get value () {
          return shadow(this, 'value', isLittleEndian())
        }

      }
      exports.IsLittleEndianCached = IsLittleEndianCached

      function isEvalSupported () {
        try {
          new Function('')
          return true
        } catch (e) {
          return false
        }
      }

      const IsEvalSupportedCached = {
        get value () {
          return shadow(this, 'value', isEvalSupported())
        }

      }
      exports.IsEvalSupportedCached = IsEvalSupportedCached
      const rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')']

      const Util = /* #__PURE__ */(function () {
        function Util () {
          _classCallCheck(this, Util)
        }

        _createClass(Util, null, [{
          key: 'makeCssRgb',
          value: function makeCssRgb (r, g, b) {
            rgbBuf[1] = r
            rgbBuf[3] = g
            rgbBuf[5] = b
            return rgbBuf.join('')
          }
        }, {
          key: 'transform',
          value: function transform (m1, m2) {
            return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]]
          }
        }, {
          key: 'applyTransform',
          value: function applyTransform (p, m) {
            const xt = p[0] * m[0] + p[1] * m[2] + m[4]
            const yt = p[0] * m[1] + p[1] * m[3] + m[5]
            return [xt, yt]
          }
        }, {
          key: 'applyInverseTransform',
          value: function applyInverseTransform (p, m) {
            const d = m[0] * m[3] - m[1] * m[2]
            const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d
            const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d
            return [xt, yt]
          }
        }, {
          key: 'getAxialAlignedBoundingBox',
          value: function getAxialAlignedBoundingBox (r, m) {
            const p1 = Util.applyTransform(r, m)
            const p2 = Util.applyTransform(r.slice(2, 4), m)
            const p3 = Util.applyTransform([r[0], r[3]], m)
            const p4 = Util.applyTransform([r[2], r[1]], m)
            return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])]
          }
        }, {
          key: 'inverseTransform',
          value: function inverseTransform (m) {
            const d = m[0] * m[3] - m[1] * m[2]
            return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d]
          }
        }, {
          key: 'apply3dTransform',
          value: function apply3dTransform (m, v) {
            return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]]
          }
        }, {
          key: 'singularValueDecompose2dScale',
          value: function singularValueDecompose2dScale (m) {
            const transpose = [m[0], m[2], m[1], m[3]]
            const a = m[0] * transpose[0] + m[1] * transpose[2]
            const b = m[0] * transpose[1] + m[1] * transpose[3]
            const c = m[2] * transpose[0] + m[3] * transpose[2]
            const d = m[2] * transpose[1] + m[3] * transpose[3]
            const first = (a + d) / 2
            const second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2
            const sx = first + second || 1
            const sy = first - second || 1
            return [Math.sqrt(sx), Math.sqrt(sy)]
          }
        }, {
          key: 'normalizeRect',
          value: function normalizeRect (rect) {
            const r = rect.slice(0)

            if (rect[0] > rect[2]) {
              r[0] = rect[2]
              r[2] = rect[0]
            }

            if (rect[1] > rect[3]) {
              r[1] = rect[3]
              r[3] = rect[1]
            }

            return r
          }
        }, {
          key: 'intersect',
          value: function intersect (rect1, rect2) {
            function compare (a, b) {
              return a - b
            }

            const orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare)
            const orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare)
            const result = []
            rect1 = Util.normalizeRect(rect1)
            rect2 = Util.normalizeRect(rect2)

            if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
              result[0] = orderedX[1]
              result[2] = orderedX[2]
            } else {
              return null
            }

            if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
              result[1] = orderedY[1]
              result[3] = orderedY[2]
            } else {
              return null
            }

            return result
          }
        }])

        return Util
      }())

      exports.Util = Util
      const PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC]

      function stringToPDFString (str) {
        const length = str.length
        const strBuf = []

        if (str[0] === '\xFE' && str[1] === '\xFF') {
          for (let i = 2; i < length; i += 2) {
            strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)))
          }
        } else if (str[0] === '\xFF' && str[1] === '\xFE') {
          for (let _i2 = 2; _i2 < length; _i2 += 2) {
            strBuf.push(String.fromCharCode(str.charCodeAt(_i2 + 1) << 8 | str.charCodeAt(_i2)))
          }
        } else {
          for (let _i3 = 0; _i3 < length; ++_i3) {
            const code = PDFStringTranslateTable[str.charCodeAt(_i3)]
            strBuf.push(code ? String.fromCharCode(code) : str.charAt(_i3))
          }
        }

        return strBuf.join('')
      }

      function stringToUTF8String (str) {
        return decodeURIComponent(escape(str))
      }

      function utf8StringToString (str) {
        return unescape(encodeURIComponent(str))
      }

      function isEmptyObj (obj) {
        for (const key in obj) {
          return false
        }

        return true
      }

      function isBool (v) {
        return typeof v === 'boolean'
      }

      function isNum (v) {
        return typeof v === 'number'
      }

      function isString (v) {
        return typeof v === 'string'
      }

      function isArrayBuffer (v) {
        return _typeof(v) === 'object' && v !== null && v.byteLength !== undefined
      }

      function isArrayEqual (arr1, arr2) {
        if (arr1.length !== arr2.length) {
          return false
        }

        return arr1.every(function (element, index) {
          return element === arr2[index]
        })
      }

      function createPromiseCapability () {
        const capability = Object.create(null)
        let isSettled = false
        Object.defineProperty(capability, 'settled', {
          get: function get () {
            return isSettled
          }
        })
        capability.promise = new Promise(function (resolve, reject) {
          capability.resolve = function (data) {
            isSettled = true
            resolve(data)
          }

          capability.reject = function (reason) {
            isSettled = true
            reject(reason)
          }
        })
        return capability
      }

      const createObjectURL = (function createObjectURLClosure () {
        const digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        return function createObjectURL (data, contentType) {
          const forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false

          if (!forceDataSchema && URL.createObjectURL) {
            const blob = new Blob([data], {
              type: contentType
            })
            return URL.createObjectURL(blob)
          }

          let buffer = 'data:'.concat(contentType, ';base64,')

          for (let i = 0, ii = data.length; i < ii; i += 3) {
            const b1 = data[i] & 0xff
            const b2 = data[i + 1] & 0xff
            const b3 = data[i + 2] & 0xff
            const d1 = b1 >> 2
            const d2 = (b1 & 3) << 4 | b2 >> 4
            const d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64
            const d4 = i + 2 < ii ? b3 & 0x3f : 64
            buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4]
          }

          return buffer
        }
      }())

      exports.createObjectURL = createObjectURL
      /***/ },
    /* 2 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      if (typeof globalThis === 'undefined' || !globalThis._pdfjsCompatibilityChecked) {
        if (typeof globalThis === 'undefined' || globalThis.Math !== Math) {
          globalThis = __w_pdfjs_require__(3)
        }

        globalThis._pdfjsCompatibilityChecked = true

        const _require = __w_pdfjs_require__(48)
        const isNodeJS = _require.isNodeJS

        const hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object'
        const userAgent = typeof navigator !== 'undefined' && navigator.userAgent || ''
        const isIE = /Trident/.test(userAgent);

        (function checkNodeBtoa () {
          if (globalThis.btoa || !isNodeJS) {
            return
          }

          globalThis.btoa = function (chars) {
            return Buffer.from(chars, 'binary').toString('base64')
          }
        })();

        (function checkNodeAtob () {
          if (globalThis.atob || !isNodeJS) {
            return
          }

          globalThis.atob = function (input) {
            return Buffer.from(input, 'base64').toString('binary')
          }
        })();

        (function checkChildNodeRemove () {
          if (!hasDOM) {
            return
          }

          if (typeof Element.prototype.remove !== 'undefined') {
            return
          }

          Element.prototype.remove = function () {
            if (this.parentNode) {
              this.parentNode.removeChild(this)
            }
          }
        })();

        (function checkDOMTokenListAddRemove () {
          if (!hasDOM || isNodeJS) {
            return
          }

          const div = document.createElement('div')
          div.classList.add('testOne', 'testTwo')

          if (div.classList.contains('testOne') === true && div.classList.contains('testTwo') === true) {
            return
          }

          const OriginalDOMTokenListAdd = DOMTokenList.prototype.add
          const OriginalDOMTokenListRemove = DOMTokenList.prototype.remove

          DOMTokenList.prototype.add = function () {
            for (var _len = arguments.length, tokens = new Array(_len), _key = 0; _key < _len; _key++) {
              tokens[_key] = arguments[_key]
            }

            for (let _i = 0, _tokens = tokens; _i < _tokens.length; _i++) {
              const token = _tokens[_i]
              OriginalDOMTokenListAdd.call(this, token)
            }
          }

          DOMTokenList.prototype.remove = function () {
            for (var _len2 = arguments.length, tokens = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              tokens[_key2] = arguments[_key2]
            }

            for (let _i2 = 0, _tokens2 = tokens; _i2 < _tokens2.length; _i2++) {
              const token = _tokens2[_i2]
              OriginalDOMTokenListRemove.call(this, token)
            }
          }
        })();

        (function checkDOMTokenListToggle () {
          if (!hasDOM || isNodeJS) {
            return
          }

          const div = document.createElement('div')

          if (div.classList.toggle('test', 0) === false) {
            return
          }

          DOMTokenList.prototype.toggle = function (token) {
            const force = arguments.length > 1 ? !!arguments[1] : !this.contains(token)
            return this[force ? 'add' : 'remove'](token), force
          }
        })();

        (function checkWindowHistoryPushStateReplaceState () {
          if (!hasDOM || !isIE) {
            return
          }

          const OriginalPushState = window.history.pushState
          const OriginalReplaceState = window.history.replaceState

          window.history.pushState = function (state, title, url) {
            const args = url === undefined ? [state, title] : [state, title, url]
            OriginalPushState.apply(this, args)
          }

          window.history.replaceState = function (state, title, url) {
            const args = url === undefined ? [state, title] : [state, title, url]
            OriginalReplaceState.apply(this, args)
          }
        })();

        (function checkStringStartsWith () {
          if (String.prototype.startsWith) {
            return
          }

          __w_pdfjs_require__(49)
        })();

        (function checkStringEndsWith () {
          if (String.prototype.endsWith) {
            return
          }

          __w_pdfjs_require__(60)
        })();

        (function checkStringIncludes () {
          if (String.prototype.includes) {
            return
          }

          __w_pdfjs_require__(62)
        })();

        (function checkArrayIncludes () {
          if (Array.prototype.includes) {
            return
          }

          __w_pdfjs_require__(64)
        })();

        (function checkArrayFrom () {
          if (Array.from) {
            return
          }

          __w_pdfjs_require__(72)
        })();

        (function checkObjectAssign () {
          if (Object.assign) {
            return
          }

          __w_pdfjs_require__(94)
        })();

        (function checkMathLog2 () {
          if (Math.log2) {
            return
          }

          Math.log2 = __w_pdfjs_require__(97)
        })();

        (function checkNumberIsNaN () {
          if (Number.isNaN) {
            return
          }

          Number.isNaN = __w_pdfjs_require__(99)
        })();

        (function checkNumberIsInteger () {
          if (Number.isInteger) {
            return
          }

          Number.isInteger = __w_pdfjs_require__(101)
        })();

        (function checkPromise () {
          if (globalThis.Promise && globalThis.Promise.allSettled) {
            return
          }

          globalThis.Promise = __w_pdfjs_require__(104)
        })();

        (function checkURL () {
          globalThis.URL = __w_pdfjs_require__(128)
        })();

        (function checkReadableStream () {
          let isReadableStreamSupported = false

          if (typeof ReadableStream !== 'undefined') {
            try {
              new ReadableStream({
                start: function start (controller) {
                  controller.close()
                }
              })
              isReadableStreamSupported = true
            } catch (e) {}
          }

          if (isReadableStreamSupported) {
            return
          }

          globalThis.ReadableStream = __w_pdfjs_require__(135).ReadableStream
        })();

        (function checkMapEntries () {
          if (globalThis.Map && globalThis.Map.prototype.entries) {
            return
          }

          globalThis.Map = __w_pdfjs_require__(136)
        })();

        (function checkSetEntries () {
          if (globalThis.Set && globalThis.Set.prototype.entries) {
            return
          }

          globalThis.Set = __w_pdfjs_require__(143)
        })();

        (function checkWeakMap () {
          if (globalThis.WeakMap) {
            return
          }

          globalThis.WeakMap = __w_pdfjs_require__(145)
        })();

        (function checkWeakSet () {
          if (globalThis.WeakSet) {
            return
          }

          globalThis.WeakSet = __w_pdfjs_require__(151)
        })();

        (function checkStringCodePointAt () {
          if (String.prototype.codePointAt) {
            return
          }

          __w_pdfjs_require__(153)
        })();

        (function checkStringFromCodePoint () {
          if (String.fromCodePoint) {
            return
          }

          String.fromCodePoint = __w_pdfjs_require__(155)
        })();

        (function checkSymbol () {
          if (globalThis.Symbol) {
            return
          }

          __w_pdfjs_require__(157)
        })();

        (function checkStringPadStart () {
          if (String.prototype.padStart) {
            return
          }

          __w_pdfjs_require__(180)
        })();

        (function checkStringPadEnd () {
          if (String.prototype.padEnd) {
            return
          }

          __w_pdfjs_require__(185)
        })();

        (function checkObjectValues () {
          if (Object.values) {
            return
          }

          Object.values = __w_pdfjs_require__(187)
        })()
      }
      /***/ },
    /* 3 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(4)
      module.exports = __w_pdfjs_require__(6)
      /***/ },
    /* 4 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const $ = __w_pdfjs_require__(5)
      const global = __w_pdfjs_require__(6)
      $({ global: true }, { globalThis: global })
      /***/ },
    /* 5 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const getOwnPropertyDescriptor = __w_pdfjs_require__(7).f
      const createNonEnumerableProperty = __w_pdfjs_require__(21)
      const redefine = __w_pdfjs_require__(24)
      const setGlobal = __w_pdfjs_require__(25)
      const copyConstructorProperties = __w_pdfjs_require__(35)
      const isForced = __w_pdfjs_require__(47)
      module.exports = function (options, source) {
        const TARGET = options.target
        const GLOBAL = options.global
        const STATIC = options.stat
        let FORCED, target, key, targetProperty, sourceProperty, descriptor
        if (GLOBAL) {
          target = global
        } else if (STATIC) {
          target = global[TARGET] || setGlobal(TARGET, {})
        } else {
          target = (global[TARGET] || {}).prototype
        }
        if (target) {
          for (key in source) {
            sourceProperty = source[key]
            if (options.noTargetGet) {
              descriptor = getOwnPropertyDescriptor(target, key)
              targetProperty = descriptor && descriptor.value
            } else { targetProperty = target[key] }
            FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced)
            if (!FORCED && targetProperty !== undefined) {
              if (typeof sourceProperty === typeof targetProperty) { continue }
              copyConstructorProperties(sourceProperty, targetProperty)
            }
            if (options.sham || targetProperty && targetProperty.sham) {
              createNonEnumerableProperty(sourceProperty, 'sham', true)
            }
            redefine(target, key, sourceProperty, options)
          }
        }
      }
      /***/ },
    /* 6 */
    /***/ function (module, exports) {
      const check = function (it) {
        return it && it.Math == Math && it
      }
      module.exports = check(typeof globalThis === 'object' && globalThis) || check(typeof window === 'object' && window) || check(typeof self === 'object' && self) || check(typeof global === 'object' && global) || Function('return this')()
      /***/ },
    /* 7 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const propertyIsEnumerableModule = __w_pdfjs_require__(10)
      const createPropertyDescriptor = __w_pdfjs_require__(11)
      const toIndexedObject = __w_pdfjs_require__(12)
      const toPrimitive = __w_pdfjs_require__(16)
      const has = __w_pdfjs_require__(18)
      const IE8_DOM_DEFINE = __w_pdfjs_require__(19)
      const nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor
      exports.f = DESCRIPTORS
        ? nativeGetOwnPropertyDescriptor
        : function getOwnPropertyDescriptor (O, P) {
          O = toIndexedObject(O)
          P = toPrimitive(P, true)
          if (IE8_DOM_DEFINE) {
            try {
              return nativeGetOwnPropertyDescriptor(O, P)
            } catch (error) {
            }
          }
          if (has(O, P)) { return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]) }
        }
      /***/ },
    /* 8 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const fails = __w_pdfjs_require__(9)
      module.exports = !fails(function () {
        return Object.defineProperty({}, 1, {
          get: function () {
            return 7
          }
        })[1] != 7
      })
      /***/ },
    /* 9 */
    /***/ function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec()
        } catch (error) {
          return true
        }
      }
      /***/ },
    /* 10 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const nativePropertyIsEnumerable = {}.propertyIsEnumerable
      const getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor
      const NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1)
      exports.f = NASHORN_BUG
        ? function propertyIsEnumerable (V) {
          const descriptor = getOwnPropertyDescriptor(this, V)
          return !!descriptor && descriptor.enumerable
        }
        : nativePropertyIsEnumerable
      /***/ },
    /* 11 */
    /***/ function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        }
      }
      /***/ },
    /* 12 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const IndexedObject = __w_pdfjs_require__(13)
      const requireObjectCoercible = __w_pdfjs_require__(15)
      module.exports = function (it) {
        return IndexedObject(requireObjectCoercible(it))
      }
      /***/ },
    /* 13 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const fails = __w_pdfjs_require__(9)
      const classof = __w_pdfjs_require__(14)
      const split = ''.split
      module.exports = fails(function () {
        return !Object('z').propertyIsEnumerable(0)
      })
        ? function (it) {
          return classof(it) == 'String' ? split.call(it, '') : Object(it)
        }
        : Object
      /***/ },
    /* 14 */
    /***/ function (module, exports) {
      const toString = {}.toString
      module.exports = function (it) {
        return toString.call(it).slice(8, -1)
      }
      /***/ },
    /* 15 */
    /***/ function (module, exports) {
      module.exports = function (it) {
        if (it == undefined) { throw TypeError("Can't call method on " + it) }
        return it
      }
      /***/ },
    /* 16 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const isObject = __w_pdfjs_require__(17)
      module.exports = function (input, PREFERRED_STRING) {
        if (!isObject(input)) { return input }
        let fn, val
        if (PREFERRED_STRING && typeof (fn = input.toString) === 'function' && !isObject(val = fn.call(input))) { return val }
        if (typeof (fn = input.valueOf) === 'function' && !isObject(val = fn.call(input))) { return val }
        if (!PREFERRED_STRING && typeof (fn = input.toString) === 'function' && !isObject(val = fn.call(input))) { return val }
        throw TypeError("Can't convert object to primitive value")
      }
      /***/ },
    /* 17 */
    /***/ function (module, exports) {
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function'
      }
      /***/ },
    /* 18 */
    /***/ function (module, exports) {
      const hasOwnProperty = {}.hasOwnProperty
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key)
      }
      /***/ },
    /* 19 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const fails = __w_pdfjs_require__(9)
      const createElement = __w_pdfjs_require__(20)
      module.exports = !DESCRIPTORS && !fails(function () {
        return Object.defineProperty(createElement('div'), 'a', {
          get: function () {
            return 7
          }
        }).a != 7
      })
      /***/ },
    /* 20 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const isObject = __w_pdfjs_require__(17)
      const document = global.document
      const EXISTS = isObject(document) && isObject(document.createElement)
      module.exports = function (it) {
        return EXISTS ? document.createElement(it) : {}
      }
      /***/ },
    /* 21 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const definePropertyModule = __w_pdfjs_require__(22)
      const createPropertyDescriptor = __w_pdfjs_require__(11)
      module.exports = DESCRIPTORS
        ? function (object, key, value) {
          return definePropertyModule.f(object, key, createPropertyDescriptor(1, value))
        }
        : function (object, key, value) {
          object[key] = value
          return object
        }
      /***/ },
    /* 22 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const IE8_DOM_DEFINE = __w_pdfjs_require__(19)
      const anObject = __w_pdfjs_require__(23)
      const toPrimitive = __w_pdfjs_require__(16)
      const nativeDefineProperty = Object.defineProperty
      exports.f = DESCRIPTORS
        ? nativeDefineProperty
        : function defineProperty (O, P, Attributes) {
          anObject(O)
          P = toPrimitive(P, true)
          anObject(Attributes)
          if (IE8_DOM_DEFINE) {
            try {
              return nativeDefineProperty(O, P, Attributes)
            } catch (error) {
            }
          }
          if ('get' in Attributes || 'set' in Attributes) { throw TypeError('Accessors not supported') }
          if ('value' in Attributes) { O[P] = Attributes.value }
          return O
        }
      /***/ },
    /* 23 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const isObject = __w_pdfjs_require__(17)
      module.exports = function (it) {
        if (!isObject(it)) {
          throw TypeError(String(it) + ' is not an object')
        }
        return it
      }
      /***/ },
    /* 24 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const createNonEnumerableProperty = __w_pdfjs_require__(21)
      const has = __w_pdfjs_require__(18)
      const setGlobal = __w_pdfjs_require__(25)
      const inspectSource = __w_pdfjs_require__(26)
      const InternalStateModule = __w_pdfjs_require__(28)
      const getInternalState = InternalStateModule.get
      const enforceInternalState = InternalStateModule.enforce
      const TEMPLATE = String(String).split('String');
      (module.exports = function (O, key, value, options) {
        const unsafe = options ? !!options.unsafe : false
        let simple = options ? !!options.enumerable : false
        const noTargetGet = options ? !!options.noTargetGet : false
        if (typeof value === 'function') {
          if (typeof key === 'string' && !has(value, 'name')) { createNonEnumerableProperty(value, 'name', key) }
          enforceInternalState(value).source = TEMPLATE.join(typeof key === 'string' ? key : '')
        }
        if (O === global) {
          if (simple) { O[key] = value } else { setGlobal(key, value) }
          return
        } else if (!unsafe) {
          delete O[key]
        } else if (!noTargetGet && O[key]) {
          simple = true
        }
        if (simple) { O[key] = value } else { createNonEnumerableProperty(O, key, value) }
      })(Function.prototype, 'toString', function toString () {
        return typeof this === 'function' && getInternalState(this).source || inspectSource(this)
      })
      /***/ },
    /* 25 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const createNonEnumerableProperty = __w_pdfjs_require__(21)
      module.exports = function (key, value) {
        try {
          createNonEnumerableProperty(global, key, value)
        } catch (error) {
          global[key] = value
        }
        return value
      }
      /***/ },
    /* 26 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const store = __w_pdfjs_require__(27)
      const functionToString = Function.toString
      if (typeof store.inspectSource !== 'function') {
        store.inspectSource = function (it) {
          return functionToString.call(it)
        }
      }
      module.exports = store.inspectSource
      /***/ },
    /* 27 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const setGlobal = __w_pdfjs_require__(25)
      const SHARED = '__core-js_shared__'
      const store = global[SHARED] || setGlobal(SHARED, {})
      module.exports = store
      /***/ },
    /* 28 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const NATIVE_WEAK_MAP = __w_pdfjs_require__(29)
      const global = __w_pdfjs_require__(6)
      const isObject = __w_pdfjs_require__(17)
      const createNonEnumerableProperty = __w_pdfjs_require__(21)
      const objectHas = __w_pdfjs_require__(18)
      const sharedKey = __w_pdfjs_require__(30)
      const hiddenKeys = __w_pdfjs_require__(34)
      const WeakMap = global.WeakMap
      let set, get, has
      const enforce = function (it) {
        return has(it) ? get(it) : set(it, {})
      }
      const getterFor = function (TYPE) {
        return function (it) {
          let state
          if (!isObject(it) || (state = get(it)).type !== TYPE) {
            throw TypeError('Incompatible receiver, ' + TYPE + ' required')
          }
          return state
        }
      }
      if (NATIVE_WEAK_MAP) {
        const store = new WeakMap()
        const wmget = store.get
        const wmhas = store.has
        const wmset = store.set
        set = function (it, metadata) {
          wmset.call(store, it, metadata)
          return metadata
        }
        get = function (it) {
          return wmget.call(store, it) || {}
        }
        has = function (it) {
          return wmhas.call(store, it)
        }
      } else {
        const STATE = sharedKey('state')
        hiddenKeys[STATE] = true
        set = function (it, metadata) {
          createNonEnumerableProperty(it, STATE, metadata)
          return metadata
        }
        get = function (it) {
          return objectHas(it, STATE) ? it[STATE] : {}
        }
        has = function (it) {
          return objectHas(it, STATE)
        }
      }
      module.exports = {
        set: set,
        get: get,
        has: has,
        enforce: enforce,
        getterFor: getterFor
      }
      /***/ },
    /* 29 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const inspectSource = __w_pdfjs_require__(26)
      const WeakMap = global.WeakMap
      module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap))
      /***/ },
    /* 30 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const shared = __w_pdfjs_require__(31)
      const uid = __w_pdfjs_require__(33)
      const keys = shared('keys')
      module.exports = function (key) {
        return keys[key] || (keys[key] = uid(key))
      }
      /***/ },
    /* 31 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const IS_PURE = __w_pdfjs_require__(32)
      const store = __w_pdfjs_require__(27);
      (module.exports = function (key, value) {
        return store[key] || (store[key] = value !== undefined ? value : {})
      })('versions', []).push({
        version: '3.6.4',
        mode: IS_PURE ? 'pure' : 'global',
        copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
      })
      /***/ },
    /* 32 */
    /***/ function (module, exports) {
      module.exports = false
      /***/ },
    /* 33 */
    /***/ function (module, exports) {
      let id = 0
      const postfix = Math.random()
      module.exports = function (key) {
        return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36)
      }
      /***/ },
    /* 34 */
    /***/ function (module, exports) {
      module.exports = {}
      /***/ },
    /* 35 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const has = __w_pdfjs_require__(18)
      const ownKeys = __w_pdfjs_require__(36)
      const getOwnPropertyDescriptorModule = __w_pdfjs_require__(7)
      const definePropertyModule = __w_pdfjs_require__(22)
      module.exports = function (target, source) {
        const keys = ownKeys(source)
        const defineProperty = definePropertyModule.f
        const getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          if (!has(target, key)) { defineProperty(target, key, getOwnPropertyDescriptor(source, key)) }
        }
      }
      /***/ },
    /* 36 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const getBuiltIn = __w_pdfjs_require__(37)
      const getOwnPropertyNamesModule = __w_pdfjs_require__(39)
      const getOwnPropertySymbolsModule = __w_pdfjs_require__(46)
      const anObject = __w_pdfjs_require__(23)
      module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys (it) {
        const keys = getOwnPropertyNamesModule.f(anObject(it))
        const getOwnPropertySymbols = getOwnPropertySymbolsModule.f
        return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys
      }
      /***/ },
    /* 37 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const path = __w_pdfjs_require__(38)
      const global = __w_pdfjs_require__(6)
      const aFunction = function (variable) {
        return typeof variable === 'function' ? variable : undefined
      }
      module.exports = function (namespace, method) {
        return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method]
      }
      /***/ },
    /* 38 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      module.exports = global
      /***/ },
    /* 39 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const internalObjectKeys = __w_pdfjs_require__(40)
      const enumBugKeys = __w_pdfjs_require__(45)
      const hiddenKeys = enumBugKeys.concat('length', 'prototype')
      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames (O) {
        return internalObjectKeys(O, hiddenKeys)
      }
      /***/ },
    /* 40 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const has = __w_pdfjs_require__(18)
      const toIndexedObject = __w_pdfjs_require__(12)
      const indexOf = __w_pdfjs_require__(41).indexOf
      const hiddenKeys = __w_pdfjs_require__(34)
      module.exports = function (object, names) {
        const O = toIndexedObject(object)
        let i = 0
        const result = []
        let key
        for (key in O) { !has(hiddenKeys, key) && has(O, key) && result.push(key) }
        while (names.length > i) {
          if (has(O, key = names[i++])) {
            ~indexOf(result, key) || result.push(key)
          }
        }
        return result
      }
      /***/ },
    /* 41 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const toIndexedObject = __w_pdfjs_require__(12)
      const toLength = __w_pdfjs_require__(42)
      const toAbsoluteIndex = __w_pdfjs_require__(44)
      const createMethod = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          const O = toIndexedObject($this)
          const length = toLength(O.length)
          let index = toAbsoluteIndex(fromIndex, length)
          let value
          if (IS_INCLUDES && el != el) {
            while (length > index) {
              value = O[index++]
              if (value != value) { return true }
            }
          } else {
            for (; length > index; index++) {
              if ((IS_INCLUDES || index in O) && O[index] === el) { return IS_INCLUDES || index || 0 }
            }
          }
          return !IS_INCLUDES && -1
        }
      }
      module.exports = {
        includes: createMethod(true),
        indexOf: createMethod(false)
      }
      /***/ },
    /* 42 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const toInteger = __w_pdfjs_require__(43)
      const min = Math.min
      module.exports = function (argument) {
        return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0
      }
      /***/ },
    /* 43 */
    /***/ function (module, exports) {
      const ceil = Math.ceil
      const floor = Math.floor
      module.exports = function (argument) {
        return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument)
      }
      /***/ },
    /* 44 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const toInteger = __w_pdfjs_require__(43)
      const max = Math.max
      const min = Math.min
      module.exports = function (index, length) {
        const integer = toInteger(index)
        return integer < 0 ? max(integer + length, 0) : min(integer, length)
      }
      /***/ },
    /* 45 */
    /***/ function (module, exports) {
      module.exports = [
        'constructor',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'toLocaleString',
        'toString',
        'valueOf'
      ]
      /***/ },
    /* 46 */
    /***/ function (module, exports) {
      exports.f = Object.getOwnPropertySymbols
      /***/ },
    /* 47 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const fails = __w_pdfjs_require__(9)
      const replacement = /#|\.prototype\./
      const isForced = function (feature, detection) {
        const value = data[normalize(feature)]
        return value == POLYFILL ? true : value == NATIVE ? false : typeof detection === 'function' ? fails(detection) : !!detection
      }
      var normalize = isForced.normalize = function (string) {
        return String(string).replace(replacement, '.').toLowerCase()
      }
      var data = isForced.data = {}
      var NATIVE = isForced.NATIVE = 'N'
      var POLYFILL = isForced.POLYFILL = 'P'
      module.exports = isForced
      /***/ },
    /* 48 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.isNodeJS = void 0

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      const isNodeJS = (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]' && !process.versions.nw && !process.versions.electron
      exports.isNodeJS = isNodeJS
      /***/ },
    /* 49 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(50)
      const entryUnbind = __w_pdfjs_require__(57)
      module.exports = entryUnbind('String', 'startsWith')
      /***/ },
    /* 50 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const getOwnPropertyDescriptor = __w_pdfjs_require__(7).f
      const toLength = __w_pdfjs_require__(42)
      const notARegExp = __w_pdfjs_require__(51)
      const requireObjectCoercible = __w_pdfjs_require__(15)
      const correctIsRegExpLogic = __w_pdfjs_require__(56)
      const IS_PURE = __w_pdfjs_require__(32)
      const nativeStartsWith = ''.startsWith
      const min = Math.min
      const CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith')
      const MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!(function () {
        const descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith')
        return descriptor && !descriptor.writable
      }())
      $({
        target: 'String',
        proto: true,
        forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
      }, {
        startsWith: function startsWith (searchString) {
          const that = String(requireObjectCoercible(this))
          notARegExp(searchString)
          const index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length))
          const search = String(searchString)
          return nativeStartsWith ? nativeStartsWith.call(that, search, index) : that.slice(index, index + search.length) === search
        }
      })
      /***/ },
    /* 51 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const isRegExp = __w_pdfjs_require__(52)
      module.exports = function (it) {
        if (isRegExp(it)) {
          throw TypeError("The method doesn't accept regular expressions")
        }
        return it
      }
      /***/ },
    /* 52 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const isObject = __w_pdfjs_require__(17)
      const classof = __w_pdfjs_require__(14)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const MATCH = wellKnownSymbol('match')
      module.exports = function (it) {
        let isRegExp
        return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp')
      }
      /***/ },
    /* 53 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const shared = __w_pdfjs_require__(31)
      const has = __w_pdfjs_require__(18)
      const uid = __w_pdfjs_require__(33)
      const NATIVE_SYMBOL = __w_pdfjs_require__(54)
      const USE_SYMBOL_AS_UID = __w_pdfjs_require__(55)
      const WellKnownSymbolsStore = shared('wks')
      const Symbol = global.Symbol
      const createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid
      module.exports = function (name) {
        if (!has(WellKnownSymbolsStore, name)) {
          if (NATIVE_SYMBOL && has(Symbol, name)) { WellKnownSymbolsStore[name] = Symbol[name] } else { WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name) }
        }
        return WellKnownSymbolsStore[name]
      }
      /***/ },
    /* 54 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const fails = __w_pdfjs_require__(9)
      module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
        return !String(Symbol())
      })
      /***/ },
    /* 55 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const NATIVE_SYMBOL = __w_pdfjs_require__(54)
      module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator === 'symbol'
      /***/ },
    /* 56 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const MATCH = wellKnownSymbol('match')
      module.exports = function (METHOD_NAME) {
        const regexp = /./
        try {
          '/./'[METHOD_NAME](regexp)
        } catch (e) {
          try {
            regexp[MATCH] = false
            return '/./'[METHOD_NAME](regexp)
          } catch (f) {
          }
        }
        return false
      }
      /***/ },
    /* 57 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const bind = __w_pdfjs_require__(58)
      const call = Function.call
      module.exports = function (CONSTRUCTOR, METHOD, length) {
        return bind(call, global[CONSTRUCTOR].prototype[METHOD], length)
      }
      /***/ },
    /* 58 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const aFunction = __w_pdfjs_require__(59)
      module.exports = function (fn, that, length) {
        aFunction(fn)
        if (that === undefined) { return fn }
        switch (length) {
          case 0:
            return function () {
              return fn.call(that)
            }
          case 1:
            return function (a) {
              return fn.call(that, a)
            }
          case 2:
            return function (a, b) {
              return fn.call(that, a, b)
            }
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c)
            }
        }
        return function () {
          return fn.apply(that, arguments)
        }
      }
      /***/ },
    /* 59 */
    /***/ function (module, exports) {
      module.exports = function (it) {
        if (typeof it !== 'function') {
          throw TypeError(String(it) + ' is not a function')
        }
        return it
      }
      /***/ },
    /* 60 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(61)
      const entryUnbind = __w_pdfjs_require__(57)
      module.exports = entryUnbind('String', 'endsWith')
      /***/ },
    /* 61 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const getOwnPropertyDescriptor = __w_pdfjs_require__(7).f
      const toLength = __w_pdfjs_require__(42)
      const notARegExp = __w_pdfjs_require__(51)
      const requireObjectCoercible = __w_pdfjs_require__(15)
      const correctIsRegExpLogic = __w_pdfjs_require__(56)
      const IS_PURE = __w_pdfjs_require__(32)
      const nativeEndsWith = ''.endsWith
      const min = Math.min
      const CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith')
      const MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!(function () {
        const descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith')
        return descriptor && !descriptor.writable
      }())
      $({
        target: 'String',
        proto: true,
        forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
      }, {
        endsWith: function endsWith (searchString) {
          const that = String(requireObjectCoercible(this))
          notARegExp(searchString)
          const endPosition = arguments.length > 1 ? arguments[1] : undefined
          const len = toLength(that.length)
          const end = endPosition === undefined ? len : min(toLength(endPosition), len)
          const search = String(searchString)
          return nativeEndsWith ? nativeEndsWith.call(that, search, end) : that.slice(end - search.length, end) === search
        }
      })
      /***/ },
    /* 62 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(63)
      const entryUnbind = __w_pdfjs_require__(57)
      module.exports = entryUnbind('String', 'includes')
      /***/ },
    /* 63 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const notARegExp = __w_pdfjs_require__(51)
      const requireObjectCoercible = __w_pdfjs_require__(15)
      const correctIsRegExpLogic = __w_pdfjs_require__(56)
      $({
        target: 'String',
        proto: true,
        forced: !correctIsRegExpLogic('includes')
      }, {
        includes: function includes (searchString) {
          return !!~String(requireObjectCoercible(this)).indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined)
        }
      })
      /***/ },
    /* 64 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(65)
      const entryUnbind = __w_pdfjs_require__(57)
      module.exports = entryUnbind('Array', 'includes')
      /***/ },
    /* 65 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const $includes = __w_pdfjs_require__(41).includes
      const addToUnscopables = __w_pdfjs_require__(66)
      const arrayMethodUsesToLength = __w_pdfjs_require__(71)
      const USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', {
        ACCESSORS: true,
        1: 0
      })
      $({
        target: 'Array',
        proto: true,
        forced: !USES_TO_LENGTH
      }, {
        includes: function includes (el) {
          return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined)
        }
      })
      addToUnscopables('includes')
      /***/ },
    /* 66 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const create = __w_pdfjs_require__(67)
      const definePropertyModule = __w_pdfjs_require__(22)
      const UNSCOPABLES = wellKnownSymbol('unscopables')
      const ArrayPrototype = Array.prototype
      if (ArrayPrototype[UNSCOPABLES] == undefined) {
        definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
          configurable: true,
          value: create(null)
        })
      }
      module.exports = function (key) {
        ArrayPrototype[UNSCOPABLES][key] = true
      }
      /***/ },
    /* 67 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const anObject = __w_pdfjs_require__(23)
      const defineProperties = __w_pdfjs_require__(68)
      const enumBugKeys = __w_pdfjs_require__(45)
      const hiddenKeys = __w_pdfjs_require__(34)
      const html = __w_pdfjs_require__(70)
      const documentCreateElement = __w_pdfjs_require__(20)
      const sharedKey = __w_pdfjs_require__(30)
      const GT = '>'
      const LT = '<'
      const PROTOTYPE = 'prototype'
      const SCRIPT = 'script'
      const IE_PROTO = sharedKey('IE_PROTO')
      const EmptyConstructor = function () {
      }
      const scriptTag = function (content) {
        return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT
      }
      const NullProtoObjectViaActiveX = function (activeXDocument) {
        activeXDocument.write(scriptTag(''))
        activeXDocument.close()
        const temp = activeXDocument.parentWindow.Object
        activeXDocument = null
        return temp
      }
      const NullProtoObjectViaIFrame = function () {
        const iframe = documentCreateElement('iframe')
        const JS = 'java' + SCRIPT + ':'
        let iframeDocument
        iframe.style.display = 'none'
        html.appendChild(iframe)
        iframe.src = String(JS)
        iframeDocument = iframe.contentWindow.document
        iframeDocument.open()
        iframeDocument.write(scriptTag('document.F=Object'))
        iframeDocument.close()
        return iframeDocument.F
      }
      let activeXDocument
      var NullProtoObject = function () {
        try {
          activeXDocument = document.domain && new ActiveXObject('htmlfile')
        } catch (error) {
        }
        NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame()
        let length = enumBugKeys.length
        while (length--) { delete NullProtoObject[PROTOTYPE][enumBugKeys[length]] }
        return NullProtoObject()
      }
      hiddenKeys[IE_PROTO] = true
      module.exports = Object.create || function create (O, Properties) {
        let result
        if (O !== null) {
          EmptyConstructor[PROTOTYPE] = anObject(O)
          result = new EmptyConstructor()
          EmptyConstructor[PROTOTYPE] = null
          result[IE_PROTO] = O
        } else { result = NullProtoObject() }
        return Properties === undefined ? result : defineProperties(result, Properties)
      }
      /***/ },
    /* 68 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const definePropertyModule = __w_pdfjs_require__(22)
      const anObject = __w_pdfjs_require__(23)
      const objectKeys = __w_pdfjs_require__(69)
      module.exports = DESCRIPTORS
        ? Object.defineProperties
        : function defineProperties (O, Properties) {
          anObject(O)
          const keys = objectKeys(Properties)
          const length = keys.length
          let index = 0
          let key
          while (length > index) { definePropertyModule.f(O, key = keys[index++], Properties[key]) }
          return O
        }
      /***/ },
    /* 69 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const internalObjectKeys = __w_pdfjs_require__(40)
      const enumBugKeys = __w_pdfjs_require__(45)
      module.exports = Object.keys || function keys (O) {
        return internalObjectKeys(O, enumBugKeys)
      }
      /***/ },
    /* 70 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const getBuiltIn = __w_pdfjs_require__(37)
      module.exports = getBuiltIn('document', 'documentElement')
      /***/ },
    /* 71 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const fails = __w_pdfjs_require__(9)
      const has = __w_pdfjs_require__(18)
      const defineProperty = Object.defineProperty
      const cache = {}
      const thrower = function (it) {
        throw it
      }
      module.exports = function (METHOD_NAME, options) {
        if (has(cache, METHOD_NAME)) { return cache[METHOD_NAME] }
        if (!options) { options = {} }
        const method = [][METHOD_NAME]
        const ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false
        const argument0 = has(options, 0) ? options[0] : thrower
        const argument1 = has(options, 1) ? options[1] : undefined
        return cache[METHOD_NAME] = !!method && !fails(function () {
          if (ACCESSORS && !DESCRIPTORS) { return true }
          const O = { length: -1 }
          if (ACCESSORS) {
            defineProperty(O, 1, {
              enumerable: true,
              get: thrower
            })
          } else { O[1] = 1 }
          method.call(O, argument0, argument1)
        })
      }
      /***/ },
    /* 72 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(73)
      __w_pdfjs_require__(85)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Array.from
      /***/ },
    /* 73 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const charAt = __w_pdfjs_require__(74).charAt
      const InternalStateModule = __w_pdfjs_require__(28)
      const defineIterator = __w_pdfjs_require__(75)
      const STRING_ITERATOR = 'String Iterator'
      const setInternalState = InternalStateModule.set
      const getInternalState = InternalStateModule.getterFor(STRING_ITERATOR)
      defineIterator(String, 'String', function (iterated) {
        setInternalState(this, {
          type: STRING_ITERATOR,
          string: String(iterated),
          index: 0
        })
      }, function next () {
        const state = getInternalState(this)
        const string = state.string
        const index = state.index
        let point
        if (index >= string.length) {
          return {
            value: undefined,
            done: true
          }
        }
        point = charAt(string, index)
        state.index += point.length
        return {
          value: point,
          done: false
        }
      })
      /***/ },
    /* 74 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const toInteger = __w_pdfjs_require__(43)
      const requireObjectCoercible = __w_pdfjs_require__(15)
      const createMethod = function (CONVERT_TO_STRING) {
        return function ($this, pos) {
          const S = String(requireObjectCoercible($this))
          const position = toInteger(pos)
          const size = S.length
          let first, second
          if (position < 0 || position >= size) { return CONVERT_TO_STRING ? '' : undefined }
          first = S.charCodeAt(position)
          return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000
        }
      }
      module.exports = {
        codeAt: createMethod(false),
        charAt: createMethod(true)
      }
      /***/ },
    /* 75 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const createIteratorConstructor = __w_pdfjs_require__(76)
      const getPrototypeOf = __w_pdfjs_require__(78)
      const setPrototypeOf = __w_pdfjs_require__(83)
      const setToStringTag = __w_pdfjs_require__(81)
      const createNonEnumerableProperty = __w_pdfjs_require__(21)
      const redefine = __w_pdfjs_require__(24)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const IS_PURE = __w_pdfjs_require__(32)
      const Iterators = __w_pdfjs_require__(82)
      const IteratorsCore = __w_pdfjs_require__(77)
      const IteratorPrototype = IteratorsCore.IteratorPrototype
      const BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS
      const ITERATOR = wellKnownSymbol('iterator')
      const KEYS = 'keys'
      const VALUES = 'values'
      const ENTRIES = 'entries'
      const returnThis = function () {
        return this
      }
      module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next)
        const getIterationMethod = function (KIND) {
          if (KIND === DEFAULT && defaultIterator) { return defaultIterator }
          if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) { return IterablePrototype[KIND] }
          switch (KIND) {
            case KEYS:
              return function keys () {
                return new IteratorConstructor(this, KIND)
              }
            case VALUES:
              return function values () {
                return new IteratorConstructor(this, KIND)
              }
            case ENTRIES:
              return function entries () {
                return new IteratorConstructor(this, KIND)
              }
          }
          return function () {
            return new IteratorConstructor(this)
          }
        }
        const TO_STRING_TAG = NAME + ' Iterator'
        let INCORRECT_VALUES_NAME = false
        var IterablePrototype = Iterable.prototype
        const nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT]
        var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT)
        const anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator
        let CurrentIteratorPrototype, methods, KEY
        if (anyNativeIterator) {
          CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()))
          if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
              if (setPrototypeOf) {
                setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype)
              } else if (typeof CurrentIteratorPrototype[ITERATOR] !== 'function') {
                createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis)
              }
            }
            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true)
            if (IS_PURE) { Iterators[TO_STRING_TAG] = returnThis }
          }
        }
        if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
          INCORRECT_VALUES_NAME = true
          defaultIterator = function values () {
            return nativeIterator.call(this)
          }
        }
        if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
          createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator)
        }
        Iterators[NAME] = defaultIterator
        if (DEFAULT) {
          methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
          }
          if (FORCED) {
            for (KEY in methods) {
              if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                redefine(IterablePrototype, KEY, methods[KEY])
              }
            }
          } else {
            $({
              target: NAME,
              proto: true,
              forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
            }, methods)
          }
        }
        return methods
      }
      /***/ },
    /* 76 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const IteratorPrototype = __w_pdfjs_require__(77).IteratorPrototype
      const create = __w_pdfjs_require__(67)
      const createPropertyDescriptor = __w_pdfjs_require__(11)
      const setToStringTag = __w_pdfjs_require__(81)
      const Iterators = __w_pdfjs_require__(82)
      const returnThis = function () {
        return this
      }
      module.exports = function (IteratorConstructor, NAME, next) {
        const TO_STRING_TAG = NAME + ' Iterator'
        IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) })
        setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true)
        Iterators[TO_STRING_TAG] = returnThis
        return IteratorConstructor
      }
      /***/ },
    /* 77 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const getPrototypeOf = __w_pdfjs_require__(78)
      const createNonEnumerableProperty = __w_pdfjs_require__(21)
      const has = __w_pdfjs_require__(18)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const IS_PURE = __w_pdfjs_require__(32)
      const ITERATOR = wellKnownSymbol('iterator')
      let BUGGY_SAFARI_ITERATORS = false
      const returnThis = function () {
        return this
      }
      let IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator
      if ([].keys) {
        arrayIterator = [].keys()
        if (!('next' in arrayIterator)) { BUGGY_SAFARI_ITERATORS = true } else {
          PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator))
          if (PrototypeOfArrayIteratorPrototype !== Object.prototype) { IteratorPrototype = PrototypeOfArrayIteratorPrototype }
        }
      }
      if (IteratorPrototype == undefined) { IteratorPrototype = {} }
      if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
        createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis)
      }
      module.exports = {
        IteratorPrototype: IteratorPrototype,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
      }
      /***/ },
    /* 78 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const has = __w_pdfjs_require__(18)
      const toObject = __w_pdfjs_require__(79)
      const sharedKey = __w_pdfjs_require__(30)
      const CORRECT_PROTOTYPE_GETTER = __w_pdfjs_require__(80)
      const IE_PROTO = sharedKey('IE_PROTO')
      const ObjectPrototype = Object.prototype
      module.exports = CORRECT_PROTOTYPE_GETTER
        ? Object.getPrototypeOf
        : function (O) {
          O = toObject(O)
          if (has(O, IE_PROTO)) { return O[IE_PROTO] }
          if (typeof O.constructor === 'function' && O instanceof O.constructor) {
            return O.constructor.prototype
          }
          return O instanceof Object ? ObjectPrototype : null
        }
      /***/ },
    /* 79 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const requireObjectCoercible = __w_pdfjs_require__(15)
      module.exports = function (argument) {
        return Object(requireObjectCoercible(argument))
      }
      /***/ },
    /* 80 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const fails = __w_pdfjs_require__(9)
      module.exports = !fails(function () {
        function F () {
        }
        F.prototype.constructor = null
        return Object.getPrototypeOf(new F()) !== F.prototype
      })
      /***/ },
    /* 81 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineProperty = __w_pdfjs_require__(22).f
      const has = __w_pdfjs_require__(18)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const TO_STRING_TAG = wellKnownSymbol('toStringTag')
      module.exports = function (it, TAG, STATIC) {
        if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
          defineProperty(it, TO_STRING_TAG, {
            configurable: true,
            value: TAG
          })
        }
      }
      /***/ },
    /* 82 */
    /***/ function (module, exports) {
      module.exports = {}
      /***/ },
    /* 83 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const anObject = __w_pdfjs_require__(23)
      const aPossiblePrototype = __w_pdfjs_require__(84)
      module.exports = Object.setPrototypeOf || ('__proto__' in {}
        ? (function () {
            let CORRECT_SETTER = false
            const test = {}
            let setter
            try {
              setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set
              setter.call(test, [])
              CORRECT_SETTER = test instanceof Array
            } catch (error) {
            }
            return function setPrototypeOf (O, proto) {
              anObject(O)
              aPossiblePrototype(proto)
              if (CORRECT_SETTER) { setter.call(O, proto) } else { O.__proto__ = proto }
              return O
            }
          }())
        : undefined)
      /***/ },
    /* 84 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const isObject = __w_pdfjs_require__(17)
      module.exports = function (it) {
        if (!isObject(it) && it !== null) {
          throw TypeError("Can't set " + String(it) + ' as a prototype')
        }
        return it
      }
      /***/ },
    /* 85 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const $ = __w_pdfjs_require__(5)
      const from = __w_pdfjs_require__(86)
      const checkCorrectnessOfIteration = __w_pdfjs_require__(93)
      const INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
        Array.from(iterable)
      })
      $({
        target: 'Array',
        stat: true,
        forced: INCORRECT_ITERATION
      }, { from: from })
      /***/ },
    /* 86 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const bind = __w_pdfjs_require__(58)
      const toObject = __w_pdfjs_require__(79)
      const callWithSafeIterationClosing = __w_pdfjs_require__(87)
      const isArrayIteratorMethod = __w_pdfjs_require__(88)
      const toLength = __w_pdfjs_require__(42)
      const createProperty = __w_pdfjs_require__(89)
      const getIteratorMethod = __w_pdfjs_require__(90)
      module.exports = function from (arrayLike) {
        const O = toObject(arrayLike)
        const C = typeof this === 'function' ? this : Array
        const argumentsLength = arguments.length
        let mapfn = argumentsLength > 1 ? arguments[1] : undefined
        const mapping = mapfn !== undefined
        const iteratorMethod = getIteratorMethod(O)
        let index = 0
        let length, result, step, iterator, next, value
        if (mapping) { mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2) }
        if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
          iterator = iteratorMethod.call(O)
          next = iterator.next
          result = new C()
          for (; !(step = next.call(iterator)).done; index++) {
            value = mapping
              ? callWithSafeIterationClosing(iterator, mapfn, [
                step.value,
                index
              ], true)
              : step.value
            createProperty(result, index, value)
          }
        } else {
          length = toLength(O.length)
          result = new C(length)
          for (; length > index; index++) {
            value = mapping ? mapfn(O[index], index) : O[index]
            createProperty(result, index, value)
          }
        }
        result.length = index
        return result
      }
      /***/ },
    /* 87 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const anObject = __w_pdfjs_require__(23)
      module.exports = function (iterator, fn, value, ENTRIES) {
        try {
          return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value)
        } catch (error) {
          const returnMethod = iterator.return
          if (returnMethod !== undefined) { anObject(returnMethod.call(iterator)) }
          throw error
        }
      }
      /***/ },
    /* 88 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const Iterators = __w_pdfjs_require__(82)
      const ITERATOR = wellKnownSymbol('iterator')
      const ArrayPrototype = Array.prototype
      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it)
      }
      /***/ },
    /* 89 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const toPrimitive = __w_pdfjs_require__(16)
      const definePropertyModule = __w_pdfjs_require__(22)
      const createPropertyDescriptor = __w_pdfjs_require__(11)
      module.exports = function (object, key, value) {
        const propertyKey = toPrimitive(key)
        if (propertyKey in object) { definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value)) } else { object[propertyKey] = value }
      }
      /***/ },
    /* 90 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const classof = __w_pdfjs_require__(91)
      const Iterators = __w_pdfjs_require__(82)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const ITERATOR = wellKnownSymbol('iterator')
      module.exports = function (it) {
        if (it != undefined) { return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)] }
      }
      /***/ },
    /* 91 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(92)
      const classofRaw = __w_pdfjs_require__(14)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const TO_STRING_TAG = wellKnownSymbol('toStringTag')
      const CORRECT_ARGUMENTS = classofRaw(function () {
        return arguments
      }()) == 'Arguments'
      const tryGet = function (it, key) {
        try {
          return it[key]
        } catch (error) {
        }
      }
      module.exports = TO_STRING_TAG_SUPPORT
        ? classofRaw
        : function (it) {
          let O, tag, result
          return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) === 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == 'Object' && typeof O.callee === 'function' ? 'Arguments' : result
        }
      /***/ },
    /* 92 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const TO_STRING_TAG = wellKnownSymbol('toStringTag')
      const test = {}
      test[TO_STRING_TAG] = 'z'
      module.exports = String(test) === '[object z]'
      /***/ },
    /* 93 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const ITERATOR = wellKnownSymbol('iterator')
      let SAFE_CLOSING = false
      try {
        let called = 0
        const iteratorWithReturn = {
          next: function () {
            return { done: !!called++ }
          },
          return: function () {
            SAFE_CLOSING = true
          }
        }
        iteratorWithReturn[ITERATOR] = function () {
          return this
        }
        Array.from(iteratorWithReturn, function () {
          throw 2
        })
      } catch (error) {
      }
      module.exports = function (exec, SKIP_CLOSING) {
        if (!SKIP_CLOSING && !SAFE_CLOSING) { return false }
        let ITERATION_SUPPORT = false
        try {
          const object = {}
          object[ITERATOR] = function () {
            return {
              next: function () {
                return { done: ITERATION_SUPPORT = true }
              }
            }
          }
          exec(object)
        } catch (error) {
        }
        return ITERATION_SUPPORT
      }
      /***/ },
    /* 94 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(95)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Object.assign
      /***/ },
    /* 95 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const $ = __w_pdfjs_require__(5)
      const assign = __w_pdfjs_require__(96)
      $({
        target: 'Object',
        stat: true,
        forced: Object.assign !== assign
      }, { assign: assign })
      /***/ },
    /* 96 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const DESCRIPTORS = __w_pdfjs_require__(8)
      const fails = __w_pdfjs_require__(9)
      const objectKeys = __w_pdfjs_require__(69)
      const getOwnPropertySymbolsModule = __w_pdfjs_require__(46)
      const propertyIsEnumerableModule = __w_pdfjs_require__(10)
      const toObject = __w_pdfjs_require__(79)
      const IndexedObject = __w_pdfjs_require__(13)
      const nativeAssign = Object.assign
      const defineProperty = Object.defineProperty
      module.exports = !nativeAssign || fails(function () {
        if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
          enumerable: true,
          get: function () {
            defineProperty(this, 'b', {
              value: 3,
              enumerable: false
            })
          }
        }), { b: 2 })).b !== 1) { return true }
        const A = {}
        const B = {}
        const symbol = Symbol()
        const alphabet = 'abcdefghijklmnopqrst'
        A[symbol] = 7
        alphabet.split('').forEach(function (chr) {
          B[chr] = chr
        })
        return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet
      })
        ? function assign (target, source) {
          const T = toObject(target)
          const argumentsLength = arguments.length
          let index = 1
          const getOwnPropertySymbols = getOwnPropertySymbolsModule.f
          const propertyIsEnumerable = propertyIsEnumerableModule.f
          while (argumentsLength > index) {
            const S = IndexedObject(arguments[index++])
            const keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S)
            const length = keys.length
            let j = 0
            var key
            while (length > j) {
              key = keys[j++]
              if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) { T[key] = S[key] }
            }
          }
          return T
        }
        : nativeAssign
      /***/ },
    /* 97 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(98)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Math.log2
      /***/ },
    /* 98 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const $ = __w_pdfjs_require__(5)
      const log = Math.log
      const LN2 = Math.LN2
      $({
        target: 'Math',
        stat: true
      }, {
        log2: function log2 (x) {
          return log(x) / LN2
        }
      })
      /***/ },
    /* 99 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(100)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Number.isNaN
      /***/ },
    /* 100 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const $ = __w_pdfjs_require__(5)
      $({
        target: 'Number',
        stat: true
      }, {
        isNaN: function isNaN (number) {
          return number != number
        }
      })
      /***/ },
    /* 101 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(102)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Number.isInteger
      /***/ },
    /* 102 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const $ = __w_pdfjs_require__(5)
      const isInteger = __w_pdfjs_require__(103)
      $({
        target: 'Number',
        stat: true
      }, { isInteger: isInteger })
      /***/ },
    /* 103 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const isObject = __w_pdfjs_require__(17)
      const floor = Math.floor
      module.exports = function isInteger (it) {
        return !isObject(it) && isFinite(it) && floor(it) === it
      }
      /***/ },
    /* 104 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(105)
      __w_pdfjs_require__(73)
      __w_pdfjs_require__(107)
      __w_pdfjs_require__(110)
      __w_pdfjs_require__(126)
      __w_pdfjs_require__(127)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Promise
      /***/ },
    /* 105 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(92)
      const redefine = __w_pdfjs_require__(24)
      const toString = __w_pdfjs_require__(106)
      if (!TO_STRING_TAG_SUPPORT) {
        redefine(Object.prototype, 'toString', toString, { unsafe: true })
      }
      /***/ },
    /* 106 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(92)
      const classof = __w_pdfjs_require__(91)
      module.exports = TO_STRING_TAG_SUPPORT
        ? {}.toString
        : function toString () {
          return '[object ' + classof(this) + ']'
        }
      /***/ },
    /* 107 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const DOMIterables = __w_pdfjs_require__(108)
      const ArrayIteratorMethods = __w_pdfjs_require__(109)
      const createNonEnumerableProperty = __w_pdfjs_require__(21)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const ITERATOR = wellKnownSymbol('iterator')
      const TO_STRING_TAG = wellKnownSymbol('toStringTag')
      const ArrayValues = ArrayIteratorMethods.values
      for (const COLLECTION_NAME in DOMIterables) {
        const Collection = global[COLLECTION_NAME]
        const CollectionPrototype = Collection && Collection.prototype
        if (CollectionPrototype) {
          if (CollectionPrototype[ITERATOR] !== ArrayValues) {
            try {
              createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues)
            } catch (error) {
              CollectionPrototype[ITERATOR] = ArrayValues
            }
          }
          if (!CollectionPrototype[TO_STRING_TAG]) {
            createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME)
          }
          if (DOMIterables[COLLECTION_NAME]) {
            for (const METHOD_NAME in ArrayIteratorMethods) {
              if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) {
                try {
                  createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME])
                } catch (error) {
                  CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME]
                }
              }
            }
          }
        }
      }
      /***/ },
    /* 108 */
    /***/ function (module, exports) {
      module.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
      }
      /***/ },
    /* 109 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const toIndexedObject = __w_pdfjs_require__(12)
      const addToUnscopables = __w_pdfjs_require__(66)
      const Iterators = __w_pdfjs_require__(82)
      const InternalStateModule = __w_pdfjs_require__(28)
      const defineIterator = __w_pdfjs_require__(75)
      const ARRAY_ITERATOR = 'Array Iterator'
      const setInternalState = InternalStateModule.set
      const getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR)
      module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
        setInternalState(this, {
          type: ARRAY_ITERATOR,
          target: toIndexedObject(iterated),
          index: 0,
          kind: kind
        })
      }, function () {
        const state = getInternalState(this)
        const target = state.target
        const kind = state.kind
        const index = state.index++
        if (!target || index >= target.length) {
          state.target = undefined
          return {
            value: undefined,
            done: true
          }
        }
        if (kind == 'keys') {
          return {
            value: index,
            done: false
          }
        }
        if (kind == 'values') {
          return {
            value: target[index],
            done: false
          }
        }
        return {
          value: [
            index,
            target[index]
          ],
          done: false
        }
      }, 'values')
      Iterators.Arguments = Iterators.Array
      addToUnscopables('keys')
      addToUnscopables('values')
      addToUnscopables('entries')
      /***/ },
    /* 110 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const IS_PURE = __w_pdfjs_require__(32)
      const global = __w_pdfjs_require__(6)
      const getBuiltIn = __w_pdfjs_require__(37)
      const NativePromise = __w_pdfjs_require__(111)
      const redefine = __w_pdfjs_require__(24)
      const redefineAll = __w_pdfjs_require__(112)
      const setToStringTag = __w_pdfjs_require__(81)
      const setSpecies = __w_pdfjs_require__(113)
      const isObject = __w_pdfjs_require__(17)
      const aFunction = __w_pdfjs_require__(59)
      const anInstance = __w_pdfjs_require__(114)
      const classof = __w_pdfjs_require__(14)
      const inspectSource = __w_pdfjs_require__(26)
      const iterate = __w_pdfjs_require__(115)
      const checkCorrectnessOfIteration = __w_pdfjs_require__(93)
      const speciesConstructor = __w_pdfjs_require__(116)
      const task = __w_pdfjs_require__(117).set
      const microtask = __w_pdfjs_require__(120)
      const promiseResolve = __w_pdfjs_require__(121)
      const hostReportErrors = __w_pdfjs_require__(123)
      const newPromiseCapabilityModule = __w_pdfjs_require__(122)
      const perform = __w_pdfjs_require__(124)
      const InternalStateModule = __w_pdfjs_require__(28)
      const isForced = __w_pdfjs_require__(47)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const V8_VERSION = __w_pdfjs_require__(125)
      const SPECIES = wellKnownSymbol('species')
      const PROMISE = 'Promise'
      const getInternalState = InternalStateModule.get
      const setInternalState = InternalStateModule.set
      const getInternalPromiseState = InternalStateModule.getterFor(PROMISE)
      let PromiseConstructor = NativePromise
      const TypeError = global.TypeError
      const document = global.document
      const process = global.process
      const $fetch = getBuiltIn('fetch')
      let newPromiseCapability = newPromiseCapabilityModule.f
      const newGenericPromiseCapability = newPromiseCapability
      const IS_NODE = classof(process) == 'process'
      const DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent)
      const UNHANDLED_REJECTION = 'unhandledrejection'
      const REJECTION_HANDLED = 'rejectionhandled'
      const PENDING = 0
      const FULFILLED = 1
      const REJECTED = 2
      const HANDLED = 1
      const UNHANDLED = 2
      let Internal, OwnPromiseCapability, PromiseWrapper, nativeThen
      const FORCED = isForced(PROMISE, function () {
        const GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor)
        if (!GLOBAL_CORE_JS_PROMISE) {
          if (V8_VERSION === 66) { return true }
          if (!IS_NODE && typeof PromiseRejectionEvent !== 'function') { return true }
        }
        if (IS_PURE && !PromiseConstructor.prototype.finally) { return true }
        if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) { return false }
        const promise = PromiseConstructor.resolve(1)
        const FakePromise = function (exec) {
          exec(function () {
          }, function () {
          })
        }
        const constructor = promise.constructor = {}
        constructor[SPECIES] = FakePromise
        return !(promise.then(function () {
        }) instanceof FakePromise)
      })
      const INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
        PromiseConstructor.all(iterable).catch(function () {
        })
      })
      const isThenable = function (it) {
        let then
        return isObject(it) && typeof (then = it.then) === 'function' ? then : false
      }
      const notify = function (promise, state, isReject) {
        if (state.notified) { return }
        state.notified = true
        const chain = state.reactions
        microtask(function () {
          const value = state.value
          const ok = state.state == FULFILLED
          let index = 0
          while (chain.length > index) {
            const reaction = chain[index++]
            const handler = ok ? reaction.ok : reaction.fail
            const resolve = reaction.resolve
            const reject = reaction.reject
            const domain = reaction.domain
            var result, then, exited
            try {
              if (handler) {
                if (!ok) {
                  if (state.rejection === UNHANDLED) { onHandleUnhandled(promise, state) }
                  state.rejection = HANDLED
                }
                if (handler === true) { result = value } else {
                  if (domain) { domain.enter() }
                  result = handler(value)
                  if (domain) {
                    domain.exit()
                    exited = true
                  }
                }
                if (result === reaction.promise) {
                  reject(TypeError('Promise-chain cycle'))
                } else if (then = isThenable(result)) {
                  then.call(result, resolve, reject)
                } else { resolve(result) }
              } else { reject(value) }
            } catch (error) {
              if (domain && !exited) { domain.exit() }
              reject(error)
            }
          }
          state.reactions = []
          state.notified = false
          if (isReject && !state.rejection) { onUnhandled(promise, state) }
        })
      }
      const dispatchEvent = function (name, promise, reason) {
        let event, handler
        if (DISPATCH_EVENT) {
          event = document.createEvent('Event')
          event.promise = promise
          event.reason = reason
          event.initEvent(name, false, true)
          global.dispatchEvent(event)
        } else {
          event = {
            promise: promise,
            reason: reason
          }
        }
        if (handler = global['on' + name]) { handler(event) } else if (name === UNHANDLED_REJECTION) { hostReportErrors('Unhandled promise rejection', reason) }
      }
      var onUnhandled = function (promise, state) {
        task.call(global, function () {
          const value = state.value
          const IS_UNHANDLED = isUnhandled(state)
          let result
          if (IS_UNHANDLED) {
            result = perform(function () {
              if (IS_NODE) {
                process.emit('unhandledRejection', value, promise)
              } else { dispatchEvent(UNHANDLED_REJECTION, promise, value) }
            })
            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED
            if (result.error) { throw result.value }
          }
        })
      }
      var isUnhandled = function (state) {
        return state.rejection !== HANDLED && !state.parent
      }
      var onHandleUnhandled = function (promise, state) {
        task.call(global, function () {
          if (IS_NODE) {
            process.emit('rejectionHandled', promise)
          } else { dispatchEvent(REJECTION_HANDLED, promise, state.value) }
        })
      }
      const bind = function (fn, promise, state, unwrap) {
        return function (value) {
          fn(promise, state, value, unwrap)
        }
      }
      const internalReject = function (promise, state, value, unwrap) {
        if (state.done) { return }
        state.done = true
        if (unwrap) { state = unwrap }
        state.value = value
        state.state = REJECTED
        notify(promise, state, true)
      }
      var internalResolve = function (promise, state, value, unwrap) {
        if (state.done) { return }
        state.done = true
        if (unwrap) { state = unwrap }
        try {
          if (promise === value) { throw TypeError("Promise can't be resolved itself") }
          const then = isThenable(value)
          if (then) {
            microtask(function () {
              const wrapper = { done: false }
              try {
                then.call(value, bind(internalResolve, promise, wrapper, state), bind(internalReject, promise, wrapper, state))
              } catch (error) {
                internalReject(promise, wrapper, error, state)
              }
            })
          } else {
            state.value = value
            state.state = FULFILLED
            notify(promise, state, false)
          }
        } catch (error) {
          internalReject(promise, { done: false }, error, state)
        }
      }
      if (FORCED) {
        PromiseConstructor = function Promise (executor) {
          anInstance(this, PromiseConstructor, PROMISE)
          aFunction(executor)
          Internal.call(this)
          const state = getInternalState(this)
          try {
            executor(bind(internalResolve, this, state), bind(internalReject, this, state))
          } catch (error) {
            internalReject(this, state, error)
          }
        }
        Internal = function Promise (executor) {
          setInternalState(this, {
            type: PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: [],
            rejection: false,
            state: PENDING,
            value: undefined
          })
        }
        Internal.prototype = redefineAll(PromiseConstructor.prototype, {
          then: function then (onFulfilled, onRejected) {
            const state = getInternalPromiseState(this)
            const reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor))
            reaction.ok = typeof onFulfilled === 'function' ? onFulfilled : true
            reaction.fail = typeof onRejected === 'function' && onRejected
            reaction.domain = IS_NODE ? process.domain : undefined
            state.parent = true
            state.reactions.push(reaction)
            if (state.state != PENDING) { notify(this, state, false) }
            return reaction.promise
          },
          catch: function (onRejected) {
            return this.then(undefined, onRejected)
          }
        })
        OwnPromiseCapability = function () {
          const promise = new Internal()
          const state = getInternalState(promise)
          this.promise = promise
          this.resolve = bind(internalResolve, promise, state)
          this.reject = bind(internalReject, promise, state)
        }
        newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
          return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C)
        }
        if (!IS_PURE && typeof NativePromise === 'function') {
          nativeThen = NativePromise.prototype.then
          redefine(NativePromise.prototype, 'then', function then (onFulfilled, onRejected) {
            const that = this
            return new PromiseConstructor(function (resolve, reject) {
              nativeThen.call(that, resolve, reject)
            }).then(onFulfilled, onRejected)
          }, { unsafe: true })
          if (typeof $fetch === 'function') {
            $({
              global: true,
              enumerable: true,
              forced: true
            }, {
              fetch: function fetch (input) {
                return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments))
              }
            })
          }
        }
      }
      $({
        global: true,
        wrap: true,
        forced: FORCED
      }, { Promise: PromiseConstructor })
      setToStringTag(PromiseConstructor, PROMISE, false, true)
      setSpecies(PROMISE)
      PromiseWrapper = getBuiltIn(PROMISE)
      $({
        target: PROMISE,
        stat: true,
        forced: FORCED
      }, {
        reject: function reject (r) {
          const capability = newPromiseCapability(this)
          capability.reject.call(undefined, r)
          return capability.promise
        }
      })
      $({
        target: PROMISE,
        stat: true,
        forced: IS_PURE || FORCED
      }, {
        resolve: function resolve (x) {
          return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x)
        }
      })
      $({
        target: PROMISE,
        stat: true,
        forced: INCORRECT_ITERATION
      }, {
        all: function all (iterable) {
          const C = this
          const capability = newPromiseCapability(C)
          const resolve = capability.resolve
          const reject = capability.reject
          const result = perform(function () {
            const $promiseResolve = aFunction(C.resolve)
            const values = []
            let counter = 0
            let remaining = 1
            iterate(iterable, function (promise) {
              const index = counter++
              let alreadyCalled = false
              values.push(undefined)
              remaining++
              $promiseResolve.call(C, promise).then(function (value) {
                if (alreadyCalled) { return }
                alreadyCalled = true
                values[index] = value
                --remaining || resolve(values)
              }, reject)
            })
            --remaining || resolve(values)
          })
          if (result.error) { reject(result.value) }
          return capability.promise
        },
        race: function race (iterable) {
          const C = this
          const capability = newPromiseCapability(C)
          const reject = capability.reject
          const result = perform(function () {
            const $promiseResolve = aFunction(C.resolve)
            iterate(iterable, function (promise) {
              $promiseResolve.call(C, promise).then(capability.resolve, reject)
            })
          })
          if (result.error) { reject(result.value) }
          return capability.promise
        }
      })
      /***/ },
    /* 111 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      module.exports = global.Promise
      /***/ },
    /* 112 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const redefine = __w_pdfjs_require__(24)
      module.exports = function (target, src, options) {
        for (const key in src) { redefine(target, key, src[key], options) }
        return target
      }
      /***/ },
    /* 113 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const getBuiltIn = __w_pdfjs_require__(37)
      const definePropertyModule = __w_pdfjs_require__(22)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const SPECIES = wellKnownSymbol('species')
      module.exports = function (CONSTRUCTOR_NAME) {
        const Constructor = getBuiltIn(CONSTRUCTOR_NAME)
        const defineProperty = definePropertyModule.f
        if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
          defineProperty(Constructor, SPECIES, {
            configurable: true,
            get: function () {
              return this
            }
          })
        }
      }
      /***/ },
    /* 114 */
    /***/ function (module, exports) {
      module.exports = function (it, Constructor, name) {
        if (!(it instanceof Constructor)) {
          throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation')
        }
        return it
      }
      /***/ },
    /* 115 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const anObject = __w_pdfjs_require__(23)
      const isArrayIteratorMethod = __w_pdfjs_require__(88)
      const toLength = __w_pdfjs_require__(42)
      const bind = __w_pdfjs_require__(58)
      const getIteratorMethod = __w_pdfjs_require__(90)
      const callWithSafeIterationClosing = __w_pdfjs_require__(87)
      const Result = function (stopped, result) {
        this.stopped = stopped
        this.result = result
      }
      const iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
        const boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1)
        let iterator, iterFn, index, length, result, next, step
        if (IS_ITERATOR) {
          iterator = iterable
        } else {
          iterFn = getIteratorMethod(iterable)
          if (typeof iterFn !== 'function') { throw TypeError('Target is not iterable') }
          if (isArrayIteratorMethod(iterFn)) {
            for (index = 0, length = toLength(iterable.length); length > index; index++) {
              result = AS_ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index])
              if (result && result instanceof Result) { return result }
            }
            return new Result(false)
          }
          iterator = iterFn.call(iterable)
        }
        next = iterator.next
        while (!(step = next.call(iterator)).done) {
          result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES)
          if (typeof result === 'object' && result && result instanceof Result) { return result }
        }
        return new Result(false)
      }
      iterate.stop = function (result) {
        return new Result(true, result)
      }
      /***/ },
    /* 116 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const anObject = __w_pdfjs_require__(23)
      const aFunction = __w_pdfjs_require__(59)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const SPECIES = wellKnownSymbol('species')
      module.exports = function (O, defaultConstructor) {
        const C = anObject(O).constructor
        let S
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S)
      }
      /***/ },
    /* 117 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const fails = __w_pdfjs_require__(9)
      const classof = __w_pdfjs_require__(14)
      const bind = __w_pdfjs_require__(58)
      const html = __w_pdfjs_require__(70)
      const createElement = __w_pdfjs_require__(20)
      const IS_IOS = __w_pdfjs_require__(118)
      const location = global.location
      let set = global.setImmediate
      let clear = global.clearImmediate
      const process = global.process
      const MessageChannel = global.MessageChannel
      const Dispatch = global.Dispatch
      let counter = 0
      const queue = {}
      const ONREADYSTATECHANGE = 'onreadystatechange'
      let defer, channel, port
      const run = function (id) {
        if (queue.hasOwnProperty(id)) {
          const fn = queue[id]
          delete queue[id]
          fn()
        }
      }
      const runner = function (id) {
        return function () {
          run(id)
        }
      }
      const listener = function (event) {
        run(event.data)
      }
      const post = function (id) {
        global.postMessage(id + '', location.protocol + '//' + location.host)
      }
      if (!set || !clear) {
        set = function setImmediate (fn) {
          const args = []
          let i = 1
          while (arguments.length > i) { args.push(arguments[i++]) }
          queue[++counter] = function () {
            (typeof fn === 'function' ? fn : Function(fn)).apply(undefined, args)
          }
          defer(counter)
          return counter
        }
        clear = function clearImmediate (id) {
          delete queue[id]
        }
        if (classof(process) == 'process') {
          defer = function (id) {
            process.nextTick(runner(id))
          }
        } else if (Dispatch && Dispatch.now) {
          defer = function (id) {
            Dispatch.now(runner(id))
          }
        } else if (MessageChannel && !IS_IOS) {
          channel = new MessageChannel()
          port = channel.port2
          channel.port1.onmessage = listener
          defer = bind(port.postMessage, port, 1)
        } else if (global.addEventListener && typeof postMessage === 'function' && !global.importScripts && !fails(post)) {
          defer = post
          global.addEventListener('message', listener, false)
        } else if (ONREADYSTATECHANGE in createElement('script')) {
          defer = function (id) {
            html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this)
              run(id)
            }
          }
        } else {
          defer = function (id) {
            setTimeout(runner(id), 0)
          }
        }
      }
      module.exports = {
        set: set,
        clear: clear
      }
      /***/ },
    /* 118 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const userAgent = __w_pdfjs_require__(119)
      module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent)
      /***/ },
    /* 119 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const getBuiltIn = __w_pdfjs_require__(37)
      module.exports = getBuiltIn('navigator', 'userAgent') || ''
      /***/ },
    /* 120 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const getOwnPropertyDescriptor = __w_pdfjs_require__(7).f
      const classof = __w_pdfjs_require__(14)
      const macrotask = __w_pdfjs_require__(117).set
      const IS_IOS = __w_pdfjs_require__(118)
      const MutationObserver = global.MutationObserver || global.WebKitMutationObserver
      const process = global.process
      const Promise = global.Promise
      const IS_NODE = classof(process) == 'process'
      const queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask')
      const queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value
      let flush, head, last, notify, toggle, node, promise, then
      if (!queueMicrotask) {
        flush = function () {
          let parent, fn
          if (IS_NODE && (parent = process.domain)) { parent.exit() }
          while (head) {
            fn = head.fn
            head = head.next
            try {
              fn()
            } catch (error) {
              if (head) { notify() } else { last = undefined }
              throw error
            }
          }
          last = undefined
          if (parent) { parent.enter() }
        }
        if (IS_NODE) {
          notify = function () {
            process.nextTick(flush)
          }
        } else if (MutationObserver && !IS_IOS) {
          toggle = true
          node = document.createTextNode('')
          new MutationObserver(flush).observe(node, { characterData: true })
          notify = function () {
            node.data = toggle = !toggle
          }
        } else if (Promise && Promise.resolve) {
          promise = Promise.resolve(undefined)
          then = promise.then
          notify = function () {
            then.call(promise, flush)
          }
        } else {
          notify = function () {
            macrotask.call(global, flush)
          }
        }
      }
      module.exports = queueMicrotask || function (fn) {
        const task = {
          fn: fn,
          next: undefined
        }
        if (last) { last.next = task }
        if (!head) {
          head = task
          notify()
        }
        last = task
      }
      /***/ },
    /* 121 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const anObject = __w_pdfjs_require__(23)
      const isObject = __w_pdfjs_require__(17)
      const newPromiseCapability = __w_pdfjs_require__(122)
      module.exports = function (C, x) {
        anObject(C)
        if (isObject(x) && x.constructor === C) { return x }
        const promiseCapability = newPromiseCapability.f(C)
        const resolve = promiseCapability.resolve
        resolve(x)
        return promiseCapability.promise
      }
      /***/ },
    /* 122 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const aFunction = __w_pdfjs_require__(59)
      const PromiseCapability = function (C) {
        let resolve, reject
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined) { throw TypeError('Bad Promise constructor') }
          resolve = $$resolve
          reject = $$reject
        })
        this.resolve = aFunction(resolve)
        this.reject = aFunction(reject)
      }
      module.exports.f = function (C) {
        return new PromiseCapability(C)
      }
      /***/ },
    /* 123 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      module.exports = function (a, b) {
        const console = global.console
        if (console && console.error) {
          arguments.length === 1 ? console.error(a) : console.error(a, b)
        }
      }
      /***/ },
    /* 124 */
    /***/ function (module, exports) {
      module.exports = function (exec) {
        try {
          return {
            error: false,
            value: exec()
          }
        } catch (error) {
          return {
            error: true,
            value: error
          }
        }
      }
      /***/ },
    /* 125 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const userAgent = __w_pdfjs_require__(119)
      const process = global.process
      const versions = process && process.versions
      const v8 = versions && versions.v8
      let match, version
      if (v8) {
        match = v8.split('.')
        version = match[0] + match[1]
      } else if (userAgent) {
        match = userAgent.match(/Edge\/(\d+)/)
        if (!match || match[1] >= 74) {
          match = userAgent.match(/Chrome\/(\d+)/)
          if (match) { version = match[1] }
        }
      }
      module.exports = version && +version
      /***/ },
    /* 126 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const aFunction = __w_pdfjs_require__(59)
      const newPromiseCapabilityModule = __w_pdfjs_require__(122)
      const perform = __w_pdfjs_require__(124)
      const iterate = __w_pdfjs_require__(115)
      $({
        target: 'Promise',
        stat: true
      }, {
        allSettled: function allSettled (iterable) {
          const C = this
          const capability = newPromiseCapabilityModule.f(C)
          const resolve = capability.resolve
          const reject = capability.reject
          const result = perform(function () {
            const promiseResolve = aFunction(C.resolve)
            const values = []
            let counter = 0
            let remaining = 1
            iterate(iterable, function (promise) {
              const index = counter++
              let alreadyCalled = false
              values.push(undefined)
              remaining++
              promiseResolve.call(C, promise).then(function (value) {
                if (alreadyCalled) { return }
                alreadyCalled = true
                values[index] = {
                  status: 'fulfilled',
                  value: value
                }
                --remaining || resolve(values)
              }, function (e) {
                if (alreadyCalled) { return }
                alreadyCalled = true
                values[index] = {
                  status: 'rejected',
                  reason: e
                }
                --remaining || resolve(values)
              })
            })
            --remaining || resolve(values)
          })
          if (result.error) { reject(result.value) }
          return capability.promise
        }
      })
      /***/ },
    /* 127 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const IS_PURE = __w_pdfjs_require__(32)
      const NativePromise = __w_pdfjs_require__(111)
      const fails = __w_pdfjs_require__(9)
      const getBuiltIn = __w_pdfjs_require__(37)
      const speciesConstructor = __w_pdfjs_require__(116)
      const promiseResolve = __w_pdfjs_require__(121)
      const redefine = __w_pdfjs_require__(24)
      const NON_GENERIC = !!NativePromise && fails(function () {
        NativePromise.prototype.finally.call({
          then: function () {
          }
        }, function () {
        })
      })
      $({
        target: 'Promise',
        proto: true,
        real: true,
        forced: NON_GENERIC
      }, {
        finally: function (onFinally) {
          const C = speciesConstructor(this, getBuiltIn('Promise'))
          const isFunction = typeof onFinally === 'function'
          return this.then(isFunction
            ? function (x) {
              return promiseResolve(C, onFinally()).then(function () {
                return x
              })
            }
            : onFinally, isFunction
            ? function (e) {
              return promiseResolve(C, onFinally()).then(function () {
                throw e
              })
            }
            : onFinally)
        }
      })
      if (!IS_PURE && typeof NativePromise === 'function' && !NativePromise.prototype.finally) {
        redefine(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype.finally)
      }
      /***/ },
    /* 128 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(129)
      __w_pdfjs_require__(134)
      __w_pdfjs_require__(132)
      const path = __w_pdfjs_require__(38)
      module.exports = path.URL
      /***/ },
    /* 129 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      __w_pdfjs_require__(73)
      const $ = __w_pdfjs_require__(5)
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const USE_NATIVE_URL = __w_pdfjs_require__(130)
      const global = __w_pdfjs_require__(6)
      const defineProperties = __w_pdfjs_require__(68)
      const redefine = __w_pdfjs_require__(24)
      const anInstance = __w_pdfjs_require__(114)
      const has = __w_pdfjs_require__(18)
      const assign = __w_pdfjs_require__(96)
      const arrayFrom = __w_pdfjs_require__(86)
      const codeAt = __w_pdfjs_require__(74).codeAt
      const toASCII = __w_pdfjs_require__(131)
      const setToStringTag = __w_pdfjs_require__(81)
      const URLSearchParamsModule = __w_pdfjs_require__(132)
      const InternalStateModule = __w_pdfjs_require__(28)
      const NativeURL = global.URL
      const URLSearchParams = URLSearchParamsModule.URLSearchParams
      const getInternalSearchParamsState = URLSearchParamsModule.getState
      const setInternalState = InternalStateModule.set
      const getInternalURLState = InternalStateModule.getterFor('URL')
      const floor = Math.floor
      const pow = Math.pow
      const INVALID_AUTHORITY = 'Invalid authority'
      const INVALID_SCHEME = 'Invalid scheme'
      const INVALID_HOST = 'Invalid host'
      const INVALID_PORT = 'Invalid port'
      const ALPHA = /[A-Za-z]/
      const ALPHANUMERIC = /[\d+\-.A-Za-z]/
      const DIGIT = /\d/
      const HEX_START = /^(0x|0X)/
      const OCT = /^[0-7]+$/
      const DEC = /^\d+$/
      const HEX = /^[\dA-Fa-f]+$/
      const FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/
      const FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/
      const LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g
      const TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g
      let EOF
      const parseHost = function (url, input) {
        let result, codePoints, index
        if (input.charAt(0) == '[') {
          if (input.charAt(input.length - 1) != ']') { return INVALID_HOST }
          result = parseIPv6(input.slice(1, -1))
          if (!result) { return INVALID_HOST }
          url.host = result
        } else if (!isSpecial(url)) {
          if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) { return INVALID_HOST }
          result = ''
          codePoints = arrayFrom(input)
          for (index = 0; index < codePoints.length; index++) {
            result += percentEncode(codePoints[index], C0ControlPercentEncodeSet)
          }
          url.host = result
        } else {
          input = toASCII(input)
          if (FORBIDDEN_HOST_CODE_POINT.test(input)) { return INVALID_HOST }
          result = parseIPv4(input)
          if (result === null) { return INVALID_HOST }
          url.host = result
        }
      }
      var parseIPv4 = function (input) {
        const parts = input.split('.')
        let partsLength, numbers, index, part, radix, number, ipv4
        if (parts.length && parts[parts.length - 1] == '') {
          parts.pop()
        }
        partsLength = parts.length
        if (partsLength > 4) { return input }
        numbers = []
        for (index = 0; index < partsLength; index++) {
          part = parts[index]
          if (part == '') { return input }
          radix = 10
          if (part.length > 1 && part.charAt(0) == '0') {
            radix = HEX_START.test(part) ? 16 : 8
            part = part.slice(radix == 8 ? 1 : 2)
          }
          if (part === '') {
            number = 0
          } else {
            if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) { return input }
            number = parseInt(part, radix)
          }
          numbers.push(number)
        }
        for (index = 0; index < partsLength; index++) {
          number = numbers[index]
          if (index == partsLength - 1) {
            if (number >= pow(256, 5 - partsLength)) { return null }
          } else if (number > 255) { return null }
        }
        ipv4 = numbers.pop()
        for (index = 0; index < numbers.length; index++) {
          ipv4 += numbers[index] * pow(256, 3 - index)
        }
        return ipv4
      }
      var parseIPv6 = function (input) {
        const address = [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]
        let pieceIndex = 0
        let compress = null
        let pointer = 0
        let value, length, numbersSeen, ipv4Piece, number, swaps, swap
        const char = function () {
          return input.charAt(pointer)
        }
        if (char() == ':') {
          if (input.charAt(1) != ':') { return }
          pointer += 2
          pieceIndex++
          compress = pieceIndex
        }
        while (char()) {
          if (pieceIndex == 8) { return }
          if (char() == ':') {
            if (compress !== null) { return }
            pointer++
            pieceIndex++
            compress = pieceIndex
            continue
          }
          value = length = 0
          while (length < 4 && HEX.test(char())) {
            value = value * 16 + parseInt(char(), 16)
            pointer++
            length++
          }
          if (char() == '.') {
            if (length == 0) { return }
            pointer -= length
            if (pieceIndex > 6) { return }
            numbersSeen = 0
            while (char()) {
              ipv4Piece = null
              if (numbersSeen > 0) {
                if (char() == '.' && numbersSeen < 4) { pointer++ } else { return }
              }
              if (!DIGIT.test(char())) { return }
              while (DIGIT.test(char())) {
                number = parseInt(char(), 10)
                if (ipv4Piece === null) { ipv4Piece = number } else if (ipv4Piece == 0) { return } else { ipv4Piece = ipv4Piece * 10 + number }
                if (ipv4Piece > 255) { return }
                pointer++
              }
              address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece
              numbersSeen++
              if (numbersSeen == 2 || numbersSeen == 4) { pieceIndex++ }
            }
            if (numbersSeen != 4) { return }
            break
          } else if (char() == ':') {
            pointer++
            if (!char()) { return }
          } else if (char()) { return }
          address[pieceIndex++] = value
        }
        if (compress !== null) {
          swaps = pieceIndex - compress
          pieceIndex = 7
          while (pieceIndex != 0 && swaps > 0) {
            swap = address[pieceIndex]
            address[pieceIndex--] = address[compress + swaps - 1]
            address[compress + --swaps] = swap
          }
        } else if (pieceIndex != 8) { return }
        return address
      }
      const findLongestZeroSequence = function (ipv6) {
        let maxIndex = null
        let maxLength = 1
        let currStart = null
        let currLength = 0
        let index = 0
        for (; index < 8; index++) {
          if (ipv6[index] !== 0) {
            if (currLength > maxLength) {
              maxIndex = currStart
              maxLength = currLength
            }
            currStart = null
            currLength = 0
          } else {
            if (currStart === null) { currStart = index }
            ++currLength
          }
        }
        if (currLength > maxLength) {
          maxIndex = currStart
          maxLength = currLength
        }
        return maxIndex
      }
      const serializeHost = function (host) {
        let result, index, compress, ignore0
        if (typeof host === 'number') {
          result = []
          for (index = 0; index < 4; index++) {
            result.unshift(host % 256)
            host = floor(host / 256)
          }
          return result.join('.')
        } else if (typeof host === 'object') {
          result = ''
          compress = findLongestZeroSequence(host)
          for (index = 0; index < 8; index++) {
            if (ignore0 && host[index] === 0) { continue }
            if (ignore0) { ignore0 = false }
            if (compress === index) {
              result += index ? ':' : '::'
              ignore0 = true
            } else {
              result += host[index].toString(16)
              if (index < 7) { result += ':' }
            }
          }
          return '[' + result + ']'
        }
        return host
      }
      var C0ControlPercentEncodeSet = {}
      const fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
        ' ': 1,
        '"': 1,
        '<': 1,
        '>': 1,
        '`': 1
      })
      const pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
        '#': 1,
        '?': 1,
        '{': 1,
        '}': 1
      })
      const userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
        '/': 1,
        ':': 1,
        ';': 1,
        '=': 1,
        '@': 1,
        '[': 1,
        '\\': 1,
        ']': 1,
        '^': 1,
        '|': 1
      })
      var percentEncode = function (char, set) {
        const code = codeAt(char, 0)
        return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char)
      }
      const specialSchemes = {
        ftp: 21,
        file: null,
        http: 80,
        https: 443,
        ws: 80,
        wss: 443
      }
      var isSpecial = function (url) {
        return has(specialSchemes, url.scheme)
      }
      const includesCredentials = function (url) {
        return url.username != '' || url.password != ''
      }
      const cannotHaveUsernamePasswordPort = function (url) {
        return !url.host || url.cannotBeABaseURL || url.scheme == 'file'
      }
      const isWindowsDriveLetter = function (string, normalized) {
        let second
        return string.length == 2 && ALPHA.test(string.charAt(0)) && ((second = string.charAt(1)) == ':' || !normalized && second == '|')
      }
      const startsWithWindowsDriveLetter = function (string) {
        let third
        return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (string.length == 2 || ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#'))
      }
      const shortenURLsPath = function (url) {
        const path = url.path
        const pathSize = path.length
        if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
          path.pop()
        }
      }
      const isSingleDot = function (segment) {
        return segment === '.' || segment.toLowerCase() === '%2e'
      }
      const isDoubleDot = function (segment) {
        segment = segment.toLowerCase()
        return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e'
      }
      const SCHEME_START = {}
      const SCHEME = {}
      const NO_SCHEME = {}
      const SPECIAL_RELATIVE_OR_AUTHORITY = {}
      const PATH_OR_AUTHORITY = {}
      const RELATIVE = {}
      const RELATIVE_SLASH = {}
      const SPECIAL_AUTHORITY_SLASHES = {}
      const SPECIAL_AUTHORITY_IGNORE_SLASHES = {}
      const AUTHORITY = {}
      const HOST = {}
      const HOSTNAME = {}
      const PORT = {}
      const FILE = {}
      const FILE_SLASH = {}
      const FILE_HOST = {}
      const PATH_START = {}
      const PATH = {}
      const CANNOT_BE_A_BASE_URL_PATH = {}
      const QUERY = {}
      const FRAGMENT = {}
      const parseURL = function (url, input, stateOverride, base) {
        let state = stateOverride || SCHEME_START
        let pointer = 0
        let buffer = ''
        let seenAt = false
        let seenBracket = false
        let seenPasswordToken = false
        let codePoints, char, bufferCodePoints, failure
        if (!stateOverride) {
          url.scheme = ''
          url.username = ''
          url.password = ''
          url.host = null
          url.port = null
          url.path = []
          url.query = null
          url.fragment = null
          url.cannotBeABaseURL = false
          input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '')
        }
        input = input.replace(TAB_AND_NEW_LINE, '')
        codePoints = arrayFrom(input)
        while (pointer <= codePoints.length) {
          char = codePoints[pointer]
          switch (state) {
            case SCHEME_START:
              if (char && ALPHA.test(char)) {
                buffer += char.toLowerCase()
                state = SCHEME
              } else if (!stateOverride) {
                state = NO_SCHEME
                continue
              } else { return INVALID_SCHEME }
              break
            case SCHEME:
              if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
                buffer += char.toLowerCase()
              } else if (char == ':') {
                if (stateOverride && (isSpecial(url) != has(specialSchemes, buffer) || buffer == 'file' && (includesCredentials(url) || url.port !== null) || url.scheme == 'file' && !url.host)) { return }
                url.scheme = buffer
                if (stateOverride) {
                  if (isSpecial(url) && specialSchemes[url.scheme] == url.port) { url.port = null }
                  return
                }
                buffer = ''
                if (url.scheme == 'file') {
                  state = FILE
                } else if (isSpecial(url) && base && base.scheme == url.scheme) {
                  state = SPECIAL_RELATIVE_OR_AUTHORITY
                } else if (isSpecial(url)) {
                  state = SPECIAL_AUTHORITY_SLASHES
                } else if (codePoints[pointer + 1] == '/') {
                  state = PATH_OR_AUTHORITY
                  pointer++
                } else {
                  url.cannotBeABaseURL = true
                  url.path.push('')
                  state = CANNOT_BE_A_BASE_URL_PATH
                }
              } else if (!stateOverride) {
                buffer = ''
                state = NO_SCHEME
                pointer = 0
                continue
              } else { return INVALID_SCHEME }
              break
            case NO_SCHEME:
              if (!base || base.cannotBeABaseURL && char != '#') { return INVALID_SCHEME }
              if (base.cannotBeABaseURL && char == '#') {
                url.scheme = base.scheme
                url.path = base.path.slice()
                url.query = base.query
                url.fragment = ''
                url.cannotBeABaseURL = true
                state = FRAGMENT
                break
              }
              state = base.scheme == 'file' ? FILE : RELATIVE
              continue
            case SPECIAL_RELATIVE_OR_AUTHORITY:
              if (char == '/' && codePoints[pointer + 1] == '/') {
                state = SPECIAL_AUTHORITY_IGNORE_SLASHES
                pointer++
              } else {
                state = RELATIVE
                continue
              }
              break
            case PATH_OR_AUTHORITY:
              if (char == '/') {
                state = AUTHORITY
                break
              } else {
                state = PATH
                continue
              }
            case RELATIVE:
              url.scheme = base.scheme
              if (char == EOF) {
                url.username = base.username
                url.password = base.password
                url.host = base.host
                url.port = base.port
                url.path = base.path.slice()
                url.query = base.query
              } else if (char == '/' || char == '\\' && isSpecial(url)) {
                state = RELATIVE_SLASH
              } else if (char == '?') {
                url.username = base.username
                url.password = base.password
                url.host = base.host
                url.port = base.port
                url.path = base.path.slice()
                url.query = ''
                state = QUERY
              } else if (char == '#') {
                url.username = base.username
                url.password = base.password
                url.host = base.host
                url.port = base.port
                url.path = base.path.slice()
                url.query = base.query
                url.fragment = ''
                state = FRAGMENT
              } else {
                url.username = base.username
                url.password = base.password
                url.host = base.host
                url.port = base.port
                url.path = base.path.slice()
                url.path.pop()
                state = PATH
                continue
              }
              break
            case RELATIVE_SLASH:
              if (isSpecial(url) && (char == '/' || char == '\\')) {
                state = SPECIAL_AUTHORITY_IGNORE_SLASHES
              } else if (char == '/') {
                state = AUTHORITY
              } else {
                url.username = base.username
                url.password = base.password
                url.host = base.host
                url.port = base.port
                state = PATH
                continue
              }
              break
            case SPECIAL_AUTHORITY_SLASHES:
              state = SPECIAL_AUTHORITY_IGNORE_SLASHES
              if (char != '/' || buffer.charAt(pointer + 1) != '/') { continue }
              pointer++
              break
            case SPECIAL_AUTHORITY_IGNORE_SLASHES:
              if (char != '/' && char != '\\') {
                state = AUTHORITY
                continue
              }
              break
            case AUTHORITY:
              if (char == '@') {
                if (seenAt) { buffer = '%40' + buffer }
                seenAt = true
                bufferCodePoints = arrayFrom(buffer)
                for (let i = 0; i < bufferCodePoints.length; i++) {
                  const codePoint = bufferCodePoints[i]
                  if (codePoint == ':' && !seenPasswordToken) {
                    seenPasswordToken = true
                    continue
                  }
                  const encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet)
                  if (seenPasswordToken) { url.password += encodedCodePoints } else { url.username += encodedCodePoints }
                }
                buffer = ''
              } else if (char == EOF || char == '/' || char == '?' || char == '#' || char == '\\' && isSpecial(url)) {
                if (seenAt && buffer == '') { return INVALID_AUTHORITY }
                pointer -= arrayFrom(buffer).length + 1
                buffer = ''
                state = HOST
              } else { buffer += char }
              break
            case HOST:
            case HOSTNAME:
              if (stateOverride && url.scheme == 'file') {
                state = FILE_HOST
                continue
              } else if (char == ':' && !seenBracket) {
                if (buffer == '') { return INVALID_HOST }
                failure = parseHost(url, buffer)
                if (failure) { return failure }
                buffer = ''
                state = PORT
                if (stateOverride == HOSTNAME) { return }
              } else if (char == EOF || char == '/' || char == '?' || char == '#' || char == '\\' && isSpecial(url)) {
                if (isSpecial(url) && buffer == '') { return INVALID_HOST }
                if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) { return }
                failure = parseHost(url, buffer)
                if (failure) { return failure }
                buffer = ''
                state = PATH_START
                if (stateOverride) { return }
                continue
              } else {
                if (char == '[') { seenBracket = true } else if (char == ']') { seenBracket = false }
                buffer += char
              }
              break
            case PORT:
              if (DIGIT.test(char)) {
                buffer += char
              } else if (char == EOF || char == '/' || char == '?' || char == '#' || char == '\\' && isSpecial(url) || stateOverride) {
                if (buffer != '') {
                  const port = parseInt(buffer, 10)
                  if (port > 0xFFFF) { return INVALID_PORT }
                  url.port = isSpecial(url) && port === specialSchemes[url.scheme] ? null : port
                  buffer = ''
                }
                if (stateOverride) { return }
                state = PATH_START
                continue
              } else { return INVALID_PORT }
              break
            case FILE:
              url.scheme = 'file'
              if (char == '/' || char == '\\') { state = FILE_SLASH } else if (base && base.scheme == 'file') {
                if (char == EOF) {
                  url.host = base.host
                  url.path = base.path.slice()
                  url.query = base.query
                } else if (char == '?') {
                  url.host = base.host
                  url.path = base.path.slice()
                  url.query = ''
                  state = QUERY
                } else if (char == '#') {
                  url.host = base.host
                  url.path = base.path.slice()
                  url.query = base.query
                  url.fragment = ''
                  state = FRAGMENT
                } else {
                  if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
                    url.host = base.host
                    url.path = base.path.slice()
                    shortenURLsPath(url)
                  }
                  state = PATH
                  continue
                }
              } else {
                state = PATH
                continue
              }
              break
            case FILE_SLASH:
              if (char == '/' || char == '\\') {
                state = FILE_HOST
                break
              }
              if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
                if (isWindowsDriveLetter(base.path[0], true)) { url.path.push(base.path[0]) } else { url.host = base.host }
              }
              state = PATH
              continue
            case FILE_HOST:
              if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
                if (!stateOverride && isWindowsDriveLetter(buffer)) {
                  state = PATH
                } else if (buffer == '') {
                  url.host = ''
                  if (stateOverride) { return }
                  state = PATH_START
                } else {
                  failure = parseHost(url, buffer)
                  if (failure) { return failure }
                  if (url.host == 'localhost') { url.host = '' }
                  if (stateOverride) { return }
                  buffer = ''
                  state = PATH_START
                }
                continue
              } else { buffer += char }
              break
            case PATH_START:
              if (isSpecial(url)) {
                state = PATH
                if (char != '/' && char != '\\') { continue }
              } else if (!stateOverride && char == '?') {
                url.query = ''
                state = QUERY
              } else if (!stateOverride && char == '#') {
                url.fragment = ''
                state = FRAGMENT
              } else if (char != EOF) {
                state = PATH
                if (char != '/') { continue }
              }
              break
            case PATH:
              if (char == EOF || char == '/' || char == '\\' && isSpecial(url) || !stateOverride && (char == '?' || char == '#')) {
                if (isDoubleDot(buffer)) {
                  shortenURLsPath(url)
                  if (char != '/' && !(char == '\\' && isSpecial(url))) {
                    url.path.push('')
                  }
                } else if (isSingleDot(buffer)) {
                  if (char != '/' && !(char == '\\' && isSpecial(url))) {
                    url.path.push('')
                  }
                } else {
                  if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                    if (url.host) { url.host = '' }
                    buffer = buffer.charAt(0) + ':'
                  }
                  url.path.push(buffer)
                }
                buffer = ''
                if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
                  while (url.path.length > 1 && url.path[0] === '') {
                    url.path.shift()
                  }
                }
                if (char == '?') {
                  url.query = ''
                  state = QUERY
                } else if (char == '#') {
                  url.fragment = ''
                  state = FRAGMENT
                }
              } else {
                buffer += percentEncode(char, pathPercentEncodeSet)
              }
              break
            case CANNOT_BE_A_BASE_URL_PATH:
              if (char == '?') {
                url.query = ''
                state = QUERY
              } else if (char == '#') {
                url.fragment = ''
                state = FRAGMENT
              } else if (char != EOF) {
                url.path[0] += percentEncode(char, C0ControlPercentEncodeSet)
              }
              break
            case QUERY:
              if (!stateOverride && char == '#') {
                url.fragment = ''
                state = FRAGMENT
              } else if (char != EOF) {
                if (char == "'" && isSpecial(url)) { url.query += '%27' } else if (char == '#') { url.query += '%23' } else { url.query += percentEncode(char, C0ControlPercentEncodeSet) }
              }
              break
            case FRAGMENT:
              if (char != EOF) { url.fragment += percentEncode(char, fragmentPercentEncodeSet) }
              break
          }
          pointer++
        }
      }
      var URLConstructor = function URL (url) {
        const that = anInstance(this, URLConstructor, 'URL')
        const base = arguments.length > 1 ? arguments[1] : undefined
        const urlString = String(url)
        const state = setInternalState(that, { type: 'URL' })
        let baseState, failure
        if (base !== undefined) {
          if (base instanceof URLConstructor) { baseState = getInternalURLState(base) } else {
            failure = parseURL(baseState = {}, String(base))
            if (failure) { throw TypeError(failure) }
          }
        }
        failure = parseURL(state, urlString, null, baseState)
        if (failure) { throw TypeError(failure) }
        const searchParams = state.searchParams = new URLSearchParams()
        const searchParamsState = getInternalSearchParamsState(searchParams)
        searchParamsState.updateSearchParams(state.query)
        searchParamsState.updateURL = function () {
          state.query = String(searchParams) || null
        }
        if (!DESCRIPTORS) {
          that.href = serializeURL.call(that)
          that.origin = getOrigin.call(that)
          that.protocol = getProtocol.call(that)
          that.username = getUsername.call(that)
          that.password = getPassword.call(that)
          that.host = getHost.call(that)
          that.hostname = getHostname.call(that)
          that.port = getPort.call(that)
          that.pathname = getPathname.call(that)
          that.search = getSearch.call(that)
          that.searchParams = getSearchParams.call(that)
          that.hash = getHash.call(that)
        }
      }
      const URLPrototype = URLConstructor.prototype
      var serializeURL = function () {
        const url = getInternalURLState(this)
        const scheme = url.scheme
        const username = url.username
        const password = url.password
        const host = url.host
        const port = url.port
        const path = url.path
        const query = url.query
        const fragment = url.fragment
        let output = scheme + ':'
        if (host !== null) {
          output += '//'
          if (includesCredentials(url)) {
            output += username + (password ? ':' + password : '') + '@'
          }
          output += serializeHost(host)
          if (port !== null) { output += ':' + port }
        } else if (scheme == 'file') { output += '//' }
        output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : ''
        if (query !== null) { output += '?' + query }
        if (fragment !== null) { output += '#' + fragment }
        return output
      }
      var getOrigin = function () {
        const url = getInternalURLState(this)
        const scheme = url.scheme
        const port = url.port
        if (scheme == 'blob') {
          try {
            return new URL(scheme.path[0]).origin
          } catch (error) {
            return 'null'
          }
        }
        if (scheme == 'file' || !isSpecial(url)) { return 'null' }
        return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '')
      }
      var getProtocol = function () {
        return getInternalURLState(this).scheme + ':'
      }
      var getUsername = function () {
        return getInternalURLState(this).username
      }
      var getPassword = function () {
        return getInternalURLState(this).password
      }
      var getHost = function () {
        const url = getInternalURLState(this)
        const host = url.host
        const port = url.port
        return host === null ? '' : port === null ? serializeHost(host) : serializeHost(host) + ':' + port
      }
      var getHostname = function () {
        const host = getInternalURLState(this).host
        return host === null ? '' : serializeHost(host)
      }
      var getPort = function () {
        const port = getInternalURLState(this).port
        return port === null ? '' : String(port)
      }
      var getPathname = function () {
        const url = getInternalURLState(this)
        const path = url.path
        return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : ''
      }
      var getSearch = function () {
        const query = getInternalURLState(this).query
        return query ? '?' + query : ''
      }
      var getSearchParams = function () {
        return getInternalURLState(this).searchParams
      }
      var getHash = function () {
        const fragment = getInternalURLState(this).fragment
        return fragment ? '#' + fragment : ''
      }
      const accessorDescriptor = function (getter, setter) {
        return {
          get: getter,
          set: setter,
          configurable: true,
          enumerable: true
        }
      }
      if (DESCRIPTORS) {
        defineProperties(URLPrototype, {
          href: accessorDescriptor(serializeURL, function (href) {
            const url = getInternalURLState(this)
            const urlString = String(href)
            const failure = parseURL(url, urlString)
            if (failure) { throw TypeError(failure) }
            getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query)
          }),
          origin: accessorDescriptor(getOrigin),
          protocol: accessorDescriptor(getProtocol, function (protocol) {
            const url = getInternalURLState(this)
            parseURL(url, String(protocol) + ':', SCHEME_START)
          }),
          username: accessorDescriptor(getUsername, function (username) {
            const url = getInternalURLState(this)
            const codePoints = arrayFrom(String(username))
            if (cannotHaveUsernamePasswordPort(url)) { return }
            url.username = ''
            for (let i = 0; i < codePoints.length; i++) {
              url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet)
            }
          }),
          password: accessorDescriptor(getPassword, function (password) {
            const url = getInternalURLState(this)
            const codePoints = arrayFrom(String(password))
            if (cannotHaveUsernamePasswordPort(url)) { return }
            url.password = ''
            for (let i = 0; i < codePoints.length; i++) {
              url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet)
            }
          }),
          host: accessorDescriptor(getHost, function (host) {
            const url = getInternalURLState(this)
            if (url.cannotBeABaseURL) { return }
            parseURL(url, String(host), HOST)
          }),
          hostname: accessorDescriptor(getHostname, function (hostname) {
            const url = getInternalURLState(this)
            if (url.cannotBeABaseURL) { return }
            parseURL(url, String(hostname), HOSTNAME)
          }),
          port: accessorDescriptor(getPort, function (port) {
            const url = getInternalURLState(this)
            if (cannotHaveUsernamePasswordPort(url)) { return }
            port = String(port)
            if (port == '') { url.port = null } else { parseURL(url, port, PORT) }
          }),
          pathname: accessorDescriptor(getPathname, function (pathname) {
            const url = getInternalURLState(this)
            if (url.cannotBeABaseURL) { return }
            url.path = []
            parseURL(url, pathname + '', PATH_START)
          }),
          search: accessorDescriptor(getSearch, function (search) {
            const url = getInternalURLState(this)
            search = String(search)
            if (search == '') {
              url.query = null
            } else {
              if (search.charAt(0) == '?') { search = search.slice(1) }
              url.query = ''
              parseURL(url, search, QUERY)
            }
            getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query)
          }),
          searchParams: accessorDescriptor(getSearchParams),
          hash: accessorDescriptor(getHash, function (hash) {
            const url = getInternalURLState(this)
            hash = String(hash)
            if (hash == '') {
              url.fragment = null
              return
            }
            if (hash.charAt(0) == '#') { hash = hash.slice(1) }
            url.fragment = ''
            parseURL(url, hash, FRAGMENT)
          })
        })
      }
      redefine(URLPrototype, 'toJSON', function toJSON () {
        return serializeURL.call(this)
      }, { enumerable: true })
      redefine(URLPrototype, 'toString', function toString () {
        return serializeURL.call(this)
      }, { enumerable: true })
      if (NativeURL) {
        const nativeCreateObjectURL = NativeURL.createObjectURL
        const nativeRevokeObjectURL = NativeURL.revokeObjectURL
        if (nativeCreateObjectURL) {
          redefine(URLConstructor, 'createObjectURL', function createObjectURL (blob) {
            return nativeCreateObjectURL.apply(NativeURL, arguments)
          })
        }
        if (nativeRevokeObjectURL) {
          redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL (url) {
            return nativeRevokeObjectURL.apply(NativeURL, arguments)
          })
        }
      }
      setToStringTag(URLConstructor, 'URL')
      $({
        global: true,
        forced: !USE_NATIVE_URL,
        sham: !DESCRIPTORS
      }, { URL: URLConstructor })
      /***/ },
    /* 130 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const fails = __w_pdfjs_require__(9)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const IS_PURE = __w_pdfjs_require__(32)
      const ITERATOR = wellKnownSymbol('iterator')
      module.exports = !fails(function () {
        const url = new URL('b?a=1&b=2&c=3', 'http://a')
        const searchParams = url.searchParams
        let result = ''
        url.pathname = 'c%20d'
        searchParams.forEach(function (value, key) {
          searchParams.delete('b')
          result += key + value
        })
        return IS_PURE && !url.toJSON || !searchParams.sort || url.href !== 'http://a/c%20d?a=1&c=3' || searchParams.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !searchParams[ITERATOR] || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' || new URL('http://тест').host !== 'xn--e1aybc' || new URL('http://a#б').hash !== '#%D0%B1' || result !== 'a1c3' || new URL('http://x', undefined).host !== 'x'
      })
      /***/ },
    /* 131 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const maxInt = 2147483647
      const base = 36
      const tMin = 1
      const tMax = 26
      const skew = 38
      const damp = 700
      const initialBias = 72
      const initialN = 128
      const delimiter = '-'
      const regexNonASCII = /[^\0-\u007E]/
      const regexSeparators = /[.\u3002\uFF0E\uFF61]/g
      const OVERFLOW_ERROR = 'Overflow: input needs wider integers to process'
      const baseMinusTMin = base - tMin
      const floor = Math.floor
      const stringFromCharCode = String.fromCharCode
      const ucs2decode = function (string) {
        const output = []
        let counter = 0
        const length = string.length
        while (counter < length) {
          const value = string.charCodeAt(counter++)
          if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            const extra = string.charCodeAt(counter++)
            if ((extra & 0xFC00) == 0xDC00) {
              output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000)
            } else {
              output.push(value)
              counter--
            }
          } else {
            output.push(value)
          }
        }
        return output
      }
      const digitToBasic = function (digit) {
        return digit + 22 + 75 * (digit < 26)
      }
      const adapt = function (delta, numPoints, firstTime) {
        let k = 0
        delta = firstTime ? floor(delta / damp) : delta >> 1
        delta += floor(delta / numPoints)
        for (; delta > baseMinusTMin * tMax >> 1; k += base) {
          delta = floor(delta / baseMinusTMin)
        }
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew))
      }
      const encode = function (input) {
        const output = []
        input = ucs2decode(input)
        const inputLength = input.length
        let n = initialN
        let delta = 0
        let bias = initialBias
        let i, currentValue
        for (i = 0; i < input.length; i++) {
          currentValue = input[i]
          if (currentValue < 0x80) {
            output.push(stringFromCharCode(currentValue))
          }
        }
        const basicLength = output.length
        let handledCPCount = basicLength
        if (basicLength) {
          output.push(delimiter)
        }
        while (handledCPCount < inputLength) {
          let m = maxInt
          for (i = 0; i < input.length; i++) {
            currentValue = input[i]
            if (currentValue >= n && currentValue < m) {
              m = currentValue
            }
          }
          const handledCPCountPlusOne = handledCPCount + 1
          if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
            throw RangeError(OVERFLOW_ERROR)
          }
          delta += (m - n) * handledCPCountPlusOne
          n = m
          for (i = 0; i < input.length; i++) {
            currentValue = input[i]
            if (currentValue < n && ++delta > maxInt) {
              throw RangeError(OVERFLOW_ERROR)
            }
            if (currentValue == n) {
              let q = delta
              for (let k = base; ; k += base) {
                const t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias
                if (q < t) { break }
                const qMinusT = q - t
                const baseMinusT = base - t
                output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)))
                q = floor(qMinusT / baseMinusT)
              }
              output.push(stringFromCharCode(digitToBasic(q)))
              bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength)
              delta = 0
              ++handledCPCount
            }
          }
          ++delta
          ++n
        }
        return output.join('')
      }
      module.exports = function (input) {
        const encoded = []
        const labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.')
        let i, label
        for (i = 0; i < labels.length; i++) {
          label = labels[i]
          encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label)
        }
        return encoded.join('.')
      }
      /***/ },
    /* 132 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      __w_pdfjs_require__(109)
      const $ = __w_pdfjs_require__(5)
      const getBuiltIn = __w_pdfjs_require__(37)
      const USE_NATIVE_URL = __w_pdfjs_require__(130)
      const redefine = __w_pdfjs_require__(24)
      const redefineAll = __w_pdfjs_require__(112)
      const setToStringTag = __w_pdfjs_require__(81)
      const createIteratorConstructor = __w_pdfjs_require__(76)
      const InternalStateModule = __w_pdfjs_require__(28)
      const anInstance = __w_pdfjs_require__(114)
      const hasOwn = __w_pdfjs_require__(18)
      const bind = __w_pdfjs_require__(58)
      const classof = __w_pdfjs_require__(91)
      const anObject = __w_pdfjs_require__(23)
      const isObject = __w_pdfjs_require__(17)
      const create = __w_pdfjs_require__(67)
      const createPropertyDescriptor = __w_pdfjs_require__(11)
      const getIterator = __w_pdfjs_require__(133)
      const getIteratorMethod = __w_pdfjs_require__(90)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const $fetch = getBuiltIn('fetch')
      const Headers = getBuiltIn('Headers')
      const ITERATOR = wellKnownSymbol('iterator')
      const URL_SEARCH_PARAMS = 'URLSearchParams'
      const URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator'
      const setInternalState = InternalStateModule.set
      const getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS)
      const getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR)
      const plus = /\+/g
      const sequences = Array(4)
      const percentSequence = function (bytes) {
        return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'))
      }
      const percentDecode = function (sequence) {
        try {
          return decodeURIComponent(sequence)
        } catch (error) {
          return sequence
        }
      }
      const deserialize = function (it) {
        let result = it.replace(plus, ' ')
        let bytes = 4
        try {
          return decodeURIComponent(result)
        } catch (error) {
          while (bytes) {
            result = result.replace(percentSequence(bytes--), percentDecode)
          }
          return result
        }
      }
      const find = /[!'()~]|%20/g
      const replace = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
      }
      const replacer = function (match) {
        return replace[match]
      }
      const serialize = function (it) {
        return encodeURIComponent(it).replace(find, replacer)
      }
      const parseSearchParams = function (result, query) {
        if (query) {
          const attributes = query.split('&')
          let index = 0
          let attribute, entry
          while (index < attributes.length) {
            attribute = attributes[index++]
            if (attribute.length) {
              entry = attribute.split('=')
              result.push({
                key: deserialize(entry.shift()),
                value: deserialize(entry.join('='))
              })
            }
          }
        }
      }
      const updateSearchParams = function (query) {
        this.entries.length = 0
        parseSearchParams(this.entries, query)
      }
      const validateArgumentsLength = function (passed, required) {
        if (passed < required) { throw TypeError('Not enough arguments') }
      }
      const URLSearchParamsIterator = createIteratorConstructor(function Iterator (params, kind) {
        setInternalState(this, {
          type: URL_SEARCH_PARAMS_ITERATOR,
          iterator: getIterator(getInternalParamsState(params).entries),
          kind: kind
        })
      }, 'Iterator', function next () {
        const state = getInternalIteratorState(this)
        const kind = state.kind
        const step = state.iterator.next()
        const entry = step.value
        if (!step.done) {
          step.value = kind === 'keys'
            ? entry.key
            : kind === 'values'
              ? entry.value
              : [
                  entry.key,
                  entry.value
                ]
        }
        return step
      })
      var URLSearchParamsConstructor = function URLSearchParams () {
        anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS)
        const init = arguments.length > 0 ? arguments[0] : undefined
        const that = this
        const entries = []
        let iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key
        setInternalState(that, {
          type: URL_SEARCH_PARAMS,
          entries: entries,
          updateURL: function () {
          },
          updateSearchParams: updateSearchParams
        })
        if (init !== undefined) {
          if (isObject(init)) {
            iteratorMethod = getIteratorMethod(init)
            if (typeof iteratorMethod === 'function') {
              iterator = iteratorMethod.call(init)
              next = iterator.next
              while (!(step = next.call(iterator)).done) {
                entryIterator = getIterator(anObject(step.value))
                entryNext = entryIterator.next
                if ((first = entryNext.call(entryIterator)).done || (second = entryNext.call(entryIterator)).done || !entryNext.call(entryIterator).done) { throw TypeError('Expected sequence with length 2') }
                entries.push({
                  key: first.value + '',
                  value: second.value + ''
                })
              }
            } else {
              for (key in init) {
                if (hasOwn(init, key)) {
                  entries.push({
                    key: key,
                    value: init[key] + ''
                  })
                }
              }
            }
          } else {
            parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '')
          }
        }
      }
      const URLSearchParamsPrototype = URLSearchParamsConstructor.prototype
      redefineAll(URLSearchParamsPrototype, {
        append: function append (name, value) {
          validateArgumentsLength(arguments.length, 2)
          const state = getInternalParamsState(this)
          state.entries.push({
            key: name + '',
            value: value + ''
          })
          state.updateURL()
        },
        delete: function (name) {
          validateArgumentsLength(arguments.length, 1)
          const state = getInternalParamsState(this)
          const entries = state.entries
          const key = name + ''
          let index = 0
          while (index < entries.length) {
            if (entries[index].key === key) { entries.splice(index, 1) } else { index++ }
          }
          state.updateURL()
        },
        get: function get (name) {
          validateArgumentsLength(arguments.length, 1)
          const entries = getInternalParamsState(this).entries
          const key = name + ''
          let index = 0
          for (; index < entries.length; index++) {
            if (entries[index].key === key) { return entries[index].value }
          }
          return null
        },
        getAll: function getAll (name) {
          validateArgumentsLength(arguments.length, 1)
          const entries = getInternalParamsState(this).entries
          const key = name + ''
          const result = []
          let index = 0
          for (; index < entries.length; index++) {
            if (entries[index].key === key) { result.push(entries[index].value) }
          }
          return result
        },
        has: function has (name) {
          validateArgumentsLength(arguments.length, 1)
          const entries = getInternalParamsState(this).entries
          const key = name + ''
          let index = 0
          while (index < entries.length) {
            if (entries[index++].key === key) { return true }
          }
          return false
        },
        set: function set (name, value) {
          validateArgumentsLength(arguments.length, 1)
          const state = getInternalParamsState(this)
          const entries = state.entries
          let found = false
          const key = name + ''
          const val = value + ''
          let index = 0
          let entry
          for (; index < entries.length; index++) {
            entry = entries[index]
            if (entry.key === key) {
              if (found) { entries.splice(index--, 1) } else {
                found = true
                entry.value = val
              }
            }
          }
          if (!found) {
            entries.push({
              key: key,
              value: val
            })
          }
          state.updateURL()
        },
        sort: function sort () {
          const state = getInternalParamsState(this)
          const entries = state.entries
          const slice = entries.slice()
          let entry, entriesIndex, sliceIndex
          entries.length = 0
          for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
            entry = slice[sliceIndex]
            for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
              if (entries[entriesIndex].key > entry.key) {
                entries.splice(entriesIndex, 0, entry)
                break
              }
            }
            if (entriesIndex === sliceIndex) { entries.push(entry) }
          }
          state.updateURL()
        },
        forEach: function forEach (callback) {
          const entries = getInternalParamsState(this).entries
          const boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3)
          let index = 0
          let entry
          while (index < entries.length) {
            entry = entries[index++]
            boundFunction(entry.value, entry.key, this)
          }
        },
        keys: function keys () {
          return new URLSearchParamsIterator(this, 'keys')
        },
        values: function values () {
          return new URLSearchParamsIterator(this, 'values')
        },
        entries: function entries () {
          return new URLSearchParamsIterator(this, 'entries')
        }
      }, { enumerable: true })
      redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries)
      redefine(URLSearchParamsPrototype, 'toString', function toString () {
        const entries = getInternalParamsState(this).entries
        const result = []
        let index = 0
        let entry
        while (index < entries.length) {
          entry = entries[index++]
          result.push(serialize(entry.key) + '=' + serialize(entry.value))
        }
        return result.join('&')
      }, { enumerable: true })
      setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS)
      $({
        global: true,
        forced: !USE_NATIVE_URL
      }, { URLSearchParams: URLSearchParamsConstructor })
      if (!USE_NATIVE_URL && typeof $fetch === 'function' && typeof Headers === 'function') {
        $({
          global: true,
          enumerable: true,
          forced: true
        }, {
          fetch: function fetch (input) {
            const args = [input]
            let init, body, headers
            if (arguments.length > 1) {
              init = arguments[1]
              if (isObject(init)) {
                body = init.body
                if (classof(body) === URL_SEARCH_PARAMS) {
                  headers = init.headers ? new Headers(init.headers) : new Headers()
                  if (!headers.has('content-type')) {
                    headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
                  }
                  init = create(init, {
                    body: createPropertyDescriptor(0, String(body)),
                    headers: createPropertyDescriptor(0, headers)
                  })
                }
              }
              args.push(init)
            }
            return $fetch.apply(this, args)
          }
        })
      }
      module.exports = {
        URLSearchParams: URLSearchParamsConstructor,
        getState: getInternalParamsState
      }
      /***/ },
    /* 133 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const anObject = __w_pdfjs_require__(23)
      const getIteratorMethod = __w_pdfjs_require__(90)
      module.exports = function (it) {
        const iteratorMethod = getIteratorMethod(it)
        if (typeof iteratorMethod !== 'function') {
          throw TypeError(String(it) + ' is not iterable')
        }
        return anObject(iteratorMethod.call(it))
      }
      /***/ },
    /* 134 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      $({
        target: 'URL',
        proto: true,
        enumerable: true
      }, {
        toJSON: function toJSON () {
          return URL.prototype.toString.call(this)
        }
      })
      /***/ },
    /* 135 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      (function (global, factory) {
        true ? factory(exports) : undefined
      }(this, function (exports) {
        'use strict'
        const SymbolPolyfill = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
          ? Symbol
          : function (description) {
            return 'Symbol(' + description + ')'
          }
        function noop () {
        }
        const NumberIsNaN = Number.isNaN || function (x) {
          return x !== x
        }
        const rethrowAssertionErrorRejection = noop
        function typeIsObject (x) {
          return typeof x === 'object' && x !== null || typeof x === 'function'
        }
        function createArrayFromList (elements) {
          return elements.slice()
        }
        function ArrayBufferCopy (dest, destOffset, src, srcOffset, n) {
          new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset)
        }
        function IsFiniteNonNegativeNumber (v) {
          if (IsNonNegativeNumber(v) === false) {
            return false
          }
          if (v === Infinity) {
            return false
          }
          return true
        }
        function IsNonNegativeNumber (v) {
          if (typeof v !== 'number') {
            return false
          }
          if (NumberIsNaN(v)) {
            return false
          }
          if (v < 0) {
            return false
          }
          return true
        }
        function Call (F, V, args) {
          if (typeof F !== 'function') {
            throw new TypeError('Argument is not a function')
          }
          return Function.prototype.apply.call(F, V, args)
        }
        function CreateAlgorithmFromUnderlyingMethod (underlyingObject, methodName, algoArgCount, extraArgs) {
          const method = underlyingObject[methodName]
          if (method !== undefined) {
            if (typeof method !== 'function') {
              throw new TypeError(method + ' is not a method')
            }
            switch (algoArgCount) {
              case 0: {
                return function () {
                  return PromiseCall(method, underlyingObject, extraArgs)
                }
              }
              case 1: {
                return function (arg) {
                  const fullArgs = [arg].concat(extraArgs)
                  return PromiseCall(method, underlyingObject, fullArgs)
                }
              }
            }
          }
          return function () {
            return promiseResolvedWith(undefined)
          }
        }
        function InvokeOrNoop (O, P, args) {
          const method = O[P]
          if (method === undefined) {
            return undefined
          }
          return Call(method, O, args)
        }
        function PromiseCall (F, V, args) {
          try {
            return promiseResolvedWith(Call(F, V, args))
          } catch (value) {
            return promiseRejectedWith(value)
          }
        }
        function TransferArrayBuffer (O) {
          return O
        }
        function IsDetachedBuffer (O) {
          return false
        }
        function ValidateAndNormalizeHighWaterMark (highWaterMark) {
          highWaterMark = Number(highWaterMark)
          if (NumberIsNaN(highWaterMark) || highWaterMark < 0) {
            throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN')
          }
          return highWaterMark
        }
        function MakeSizeAlgorithmFromSizeFunction (size) {
          if (size === undefined) {
            return function () {
              return 1
            }
          }
          if (typeof size !== 'function') {
            throw new TypeError('size property of a queuing strategy must be a function')
          }
          return function (chunk) {
            return size(chunk)
          }
        }
        const originalPromise = Promise
        const originalPromiseThen = Promise.prototype.then
        const originalPromiseResolve = Promise.resolve.bind(originalPromise)
        const originalPromiseReject = Promise.reject.bind(originalPromise)
        function newPromise (executor) {
          return new originalPromise(executor)
        }
        function promiseResolvedWith (value) {
          return originalPromiseResolve(value)
        }
        function promiseRejectedWith (reason) {
          return originalPromiseReject(reason)
        }
        function PerformPromiseThen (promise, onFulfilled, onRejected) {
          return originalPromiseThen.call(promise, onFulfilled, onRejected)
        }
        function uponPromise (promise, onFulfilled, onRejected) {
          PerformPromiseThen(PerformPromiseThen(promise, onFulfilled, onRejected), undefined, rethrowAssertionErrorRejection)
        }
        function uponFulfillment (promise, onFulfilled) {
          uponPromise(promise, onFulfilled)
        }
        function uponRejection (promise, onRejected) {
          uponPromise(promise, undefined, onRejected)
        }
        function transformPromiseWith (promise, fulfillmentHandler, rejectionHandler) {
          return PerformPromiseThen(promise, fulfillmentHandler, rejectionHandler)
        }
        function setPromiseIsHandledToTrue (promise) {
          PerformPromiseThen(promise, undefined, rethrowAssertionErrorRejection)
        }
        const QUEUE_MAX_ARRAY_SIZE = 16384
        const SimpleQueue = (function () {
          function SimpleQueue () {
            this._cursor = 0
            this._size = 0
            this._front = {
              _elements: [],
              _next: undefined
            }
            this._back = this._front
            this._cursor = 0
            this._size = 0
          }
          Object.defineProperty(SimpleQueue.prototype, 'length', {
            get: function () {
              return this._size
            },
            enumerable: true,
            configurable: true
          })
          SimpleQueue.prototype.push = function (element) {
            const oldBack = this._back
            let newBack = oldBack
            if (oldBack._elements.length === QUEUE_MAX_ARRAY_SIZE - 1) {
              newBack = {
                _elements: [],
                _next: undefined
              }
            }
            oldBack._elements.push(element)
            if (newBack !== oldBack) {
              this._back = newBack
              oldBack._next = newBack
            }
            ++this._size
          }
          SimpleQueue.prototype.shift = function () {
            const oldFront = this._front
            let newFront = oldFront
            const oldCursor = this._cursor
            let newCursor = oldCursor + 1
            const elements = oldFront._elements
            const element = elements[oldCursor]
            if (newCursor === QUEUE_MAX_ARRAY_SIZE) {
              newFront = oldFront._next
              newCursor = 0
            }
            --this._size
            this._cursor = newCursor
            if (oldFront !== newFront) {
              this._front = newFront
            }
            elements[oldCursor] = undefined
            return element
          }
          SimpleQueue.prototype.forEach = function (callback) {
            let i = this._cursor
            let node = this._front
            let elements = node._elements
            while (i !== elements.length || node._next !== undefined) {
              if (i === elements.length) {
                node = node._next
                elements = node._elements
                i = 0
                if (elements.length === 0) {
                  break
                }
              }
              callback(elements[i])
              ++i
            }
          }
          SimpleQueue.prototype.peek = function () {
            const front = this._front
            const cursor = this._cursor
            return front._elements[cursor]
          }
          return SimpleQueue
        }())
        function ReadableStreamCreateReadResult (value, done, forAuthorCode) {
          let prototype = null
          if (forAuthorCode === true) {
            prototype = Object.prototype
          }
          const obj = Object.create(prototype)
          obj.value = value
          obj.done = done
          return obj
        }
        function ReadableStreamReaderGenericInitialize (reader, stream) {
          reader._forAuthorCode = true
          reader._ownerReadableStream = stream
          stream._reader = reader
          if (stream._state === 'readable') {
            defaultReaderClosedPromiseInitialize(reader)
          } else if (stream._state === 'closed') {
            defaultReaderClosedPromiseInitializeAsResolved(reader)
          } else {
            defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError)
          }
        }
        function ReadableStreamReaderGenericCancel (reader, reason) {
          const stream = reader._ownerReadableStream
          return ReadableStreamCancel(stream, reason)
        }
        function ReadableStreamReaderGenericRelease (reader) {
          if (reader._ownerReadableStream._state === 'readable') {
            defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'))
          } else {
            defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'))
          }
          reader._ownerReadableStream._reader = undefined
          reader._ownerReadableStream = undefined
        }
        function readerLockException (name) {
          return new TypeError('Cannot ' + name + ' a stream using a released reader')
        }
        function defaultReaderClosedPromiseInitialize (reader) {
          reader._closedPromise = newPromise(function (resolve, reject) {
            reader._closedPromise_resolve = resolve
            reader._closedPromise_reject = reject
          })
        }
        function defaultReaderClosedPromiseInitializeAsRejected (reader, reason) {
          defaultReaderClosedPromiseInitialize(reader)
          defaultReaderClosedPromiseReject(reader, reason)
        }
        function defaultReaderClosedPromiseInitializeAsResolved (reader) {
          defaultReaderClosedPromiseInitialize(reader)
          defaultReaderClosedPromiseResolve(reader)
        }
        function defaultReaderClosedPromiseReject (reader, reason) {
          setPromiseIsHandledToTrue(reader._closedPromise)
          reader._closedPromise_reject(reason)
          reader._closedPromise_resolve = undefined
          reader._closedPromise_reject = undefined
        }
        function defaultReaderClosedPromiseResetToRejected (reader, reason) {
          defaultReaderClosedPromiseInitializeAsRejected(reader, reason)
        }
        function defaultReaderClosedPromiseResolve (reader) {
          reader._closedPromise_resolve(undefined)
          reader._closedPromise_resolve = undefined
          reader._closedPromise_reject = undefined
        }
        const CancelSteps = SymbolPolyfill('[[CancelSteps]]')
        const PullSteps = SymbolPolyfill('[[PullSteps]]')
        function AcquireReadableStreamDefaultReader (stream, forAuthorCode) {
          if (forAuthorCode === void 0) {
            forAuthorCode = false
          }
          const reader = new ReadableStreamDefaultReader(stream)
          reader._forAuthorCode = forAuthorCode
          return reader
        }
        function ReadableStreamAddReadRequest (stream) {
          const promise = newPromise(function (resolve, reject) {
            const readRequest = {
              _resolve: resolve,
              _reject: reject
            }
            stream._reader._readRequests.push(readRequest)
          })
          return promise
        }
        function ReadableStreamFulfillReadRequest (stream, chunk, done) {
          const reader = stream._reader
          const readRequest = reader._readRequests.shift()
          readRequest._resolve(ReadableStreamCreateReadResult(chunk, done, reader._forAuthorCode))
        }
        function ReadableStreamGetNumReadRequests (stream) {
          return stream._reader._readRequests.length
        }
        function ReadableStreamHasDefaultReader (stream) {
          const reader = stream._reader
          if (reader === undefined) {
            return false
          }
          if (!IsReadableStreamDefaultReader(reader)) {
            return false
          }
          return true
        }
        var ReadableStreamDefaultReader = (function () {
          function ReadableStreamDefaultReader (stream) {
            if (IsReadableStream(stream) === false) {
              throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance')
            }
            if (IsReadableStreamLocked(stream) === true) {
              throw new TypeError('This stream has already been locked for exclusive reading by another reader')
            }
            ReadableStreamReaderGenericInitialize(this, stream)
            this._readRequests = new SimpleQueue()
          }
          Object.defineProperty(ReadableStreamDefaultReader.prototype, 'closed', {
            get: function () {
              if (!IsReadableStreamDefaultReader(this)) {
                return promiseRejectedWith(defaultReaderBrandCheckException('closed'))
              }
              return this._closedPromise
            },
            enumerable: true,
            configurable: true
          })
          ReadableStreamDefaultReader.prototype.cancel = function (reason) {
            if (!IsReadableStreamDefaultReader(this)) {
              return promiseRejectedWith(defaultReaderBrandCheckException('cancel'))
            }
            if (this._ownerReadableStream === undefined) {
              return promiseRejectedWith(readerLockException('cancel'))
            }
            return ReadableStreamReaderGenericCancel(this, reason)
          }
          ReadableStreamDefaultReader.prototype.read = function () {
            if (!IsReadableStreamDefaultReader(this)) {
              return promiseRejectedWith(defaultReaderBrandCheckException('read'))
            }
            if (this._ownerReadableStream === undefined) {
              return promiseRejectedWith(readerLockException('read from'))
            }
            return ReadableStreamDefaultReaderRead(this)
          }
          ReadableStreamDefaultReader.prototype.releaseLock = function () {
            if (!IsReadableStreamDefaultReader(this)) {
              throw defaultReaderBrandCheckException('releaseLock')
            }
            if (this._ownerReadableStream === undefined) {
              return
            }
            if (this._readRequests.length > 0) {
              throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled')
            }
            ReadableStreamReaderGenericRelease(this)
          }
          return ReadableStreamDefaultReader
        }())
        function IsReadableStreamDefaultReader (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
            return false
          }
          return true
        }
        function ReadableStreamDefaultReaderRead (reader) {
          const stream = reader._ownerReadableStream
          stream._disturbed = true
          if (stream._state === 'closed') {
            return promiseResolvedWith(ReadableStreamCreateReadResult(undefined, true, reader._forAuthorCode))
          }
          if (stream._state === 'errored') {
            return promiseRejectedWith(stream._storedError)
          }
          return stream._readableStreamController[PullSteps]()
        }
        function defaultReaderBrandCheckException (name) {
          return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader')
        }
        let _a
        let AsyncIteratorPrototype
        if (typeof SymbolPolyfill.asyncIterator === 'symbol') {
          AsyncIteratorPrototype = (_a = {}, _a[SymbolPolyfill.asyncIterator] = function () {
            return this
          }, _a)
          Object.defineProperty(AsyncIteratorPrototype, SymbolPolyfill.asyncIterator, { enumerable: false })
        }
        const ReadableStreamAsyncIteratorPrototype = {
          next: function () {
            if (IsReadableStreamAsyncIterator(this) === false) {
              return promiseRejectedWith(streamAsyncIteratorBrandCheckException('next'))
            }
            const reader = this._asyncIteratorReader
            if (reader._ownerReadableStream === undefined) {
              return promiseRejectedWith(readerLockException('iterate'))
            }
            return transformPromiseWith(ReadableStreamDefaultReaderRead(reader), function (result) {
              const done = result.done
              if (done) {
                ReadableStreamReaderGenericRelease(reader)
              }
              const value = result.value
              return ReadableStreamCreateReadResult(value, done, true)
            })
          },
          return: function (value) {
            if (IsReadableStreamAsyncIterator(this) === false) {
              return promiseRejectedWith(streamAsyncIteratorBrandCheckException('next'))
            }
            const reader = this._asyncIteratorReader
            if (reader._ownerReadableStream === undefined) {
              return promiseRejectedWith(readerLockException('finish iterating'))
            }
            if (reader._readRequests.length > 0) {
              return promiseRejectedWith(new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled'))
            }
            if (this._preventCancel === false) {
              const result = ReadableStreamReaderGenericCancel(reader, value)
              ReadableStreamReaderGenericRelease(reader)
              return transformPromiseWith(result, function () {
                return ReadableStreamCreateReadResult(value, true, true)
              })
            }
            ReadableStreamReaderGenericRelease(reader)
            return promiseResolvedWith(ReadableStreamCreateReadResult(value, true, true))
          }
        }
        if (AsyncIteratorPrototype !== undefined) {
          Object.setPrototypeOf(ReadableStreamAsyncIteratorPrototype, AsyncIteratorPrototype)
        }
        Object.defineProperty(ReadableStreamAsyncIteratorPrototype, 'next', { enumerable: false })
        Object.defineProperty(ReadableStreamAsyncIteratorPrototype, 'return', { enumerable: false })
        function AcquireReadableStreamAsyncIterator (stream, preventCancel) {
          if (preventCancel === void 0) {
            preventCancel = false
          }
          const reader = AcquireReadableStreamDefaultReader(stream)
          const iterator = Object.create(ReadableStreamAsyncIteratorPrototype)
          iterator._asyncIteratorReader = reader
          iterator._preventCancel = Boolean(preventCancel)
          return iterator
        }
        function IsReadableStreamAsyncIterator (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_asyncIteratorReader')) {
            return false
          }
          return true
        }
        function streamAsyncIteratorBrandCheckException (name) {
          return new TypeError('ReadableStreamAsyncIterator.' + name + ' can only be used on a ReadableSteamAsyncIterator')
        }
        function DequeueValue (container) {
          const pair = container._queue.shift()
          container._queueTotalSize -= pair.size
          if (container._queueTotalSize < 0) {
            container._queueTotalSize = 0
          }
          return pair.value
        }
        function EnqueueValueWithSize (container, value, size) {
          size = Number(size)
          if (!IsFiniteNonNegativeNumber(size)) {
            throw new RangeError('Size must be a finite, non-NaN, non-negative number.')
          }
          container._queue.push({
            value: value,
            size: size
          })
          container._queueTotalSize += size
        }
        function PeekQueueValue (container) {
          const pair = container._queue.peek()
          return pair.value
        }
        function ResetQueue (container) {
          container._queue = new SimpleQueue()
          container._queueTotalSize = 0
        }
        const AbortSteps = SymbolPolyfill('[[AbortSteps]]')
        const ErrorSteps = SymbolPolyfill('[[ErrorSteps]]')
        const WritableStream = (function () {
          function WritableStream (underlyingSink, strategy) {
            if (underlyingSink === void 0) {
              underlyingSink = {}
            }
            if (strategy === void 0) {
              strategy = {}
            }
            InitializeWritableStream(this)
            const size = strategy.size
            let highWaterMark = strategy.highWaterMark
            const type = underlyingSink.type
            if (type !== undefined) {
              throw new RangeError('Invalid type is specified')
            }
            const sizeAlgorithm = MakeSizeAlgorithmFromSizeFunction(size)
            if (highWaterMark === undefined) {
              highWaterMark = 1
            }
            highWaterMark = ValidateAndNormalizeHighWaterMark(highWaterMark)
            SetUpWritableStreamDefaultControllerFromUnderlyingSink(this, underlyingSink, highWaterMark, sizeAlgorithm)
          }
          Object.defineProperty(WritableStream.prototype, 'locked', {
            get: function () {
              if (IsWritableStream(this) === false) {
                throw streamBrandCheckException('locked')
              }
              return IsWritableStreamLocked(this)
            },
            enumerable: true,
            configurable: true
          })
          WritableStream.prototype.abort = function (reason) {
            if (IsWritableStream(this) === false) {
              return promiseRejectedWith(streamBrandCheckException('abort'))
            }
            if (IsWritableStreamLocked(this) === true) {
              return promiseRejectedWith(new TypeError('Cannot abort a stream that already has a writer'))
            }
            return WritableStreamAbort(this, reason)
          }
          WritableStream.prototype.close = function () {
            if (IsWritableStream(this) === false) {
              return promiseRejectedWith(streamBrandCheckException('close'))
            }
            if (IsWritableStreamLocked(this) === true) {
              return promiseRejectedWith(new TypeError('Cannot close a stream that already has a writer'))
            }
            if (WritableStreamCloseQueuedOrInFlight(this) === true) {
              return promiseRejectedWith(new TypeError('Cannot close an already-closing stream'))
            }
            return WritableStreamClose(this)
          }
          WritableStream.prototype.getWriter = function () {
            if (IsWritableStream(this) === false) {
              throw streamBrandCheckException('getWriter')
            }
            return AcquireWritableStreamDefaultWriter(this)
          }
          return WritableStream
        }())
        function AcquireWritableStreamDefaultWriter (stream) {
          return new WritableStreamDefaultWriter(stream)
        }
        function CreateWritableStream (startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
          if (highWaterMark === void 0) {
            highWaterMark = 1
          }
          if (sizeAlgorithm === void 0) {
            sizeAlgorithm = function () {
              return 1
            }
          }
          const stream = Object.create(WritableStream.prototype)
          InitializeWritableStream(stream)
          const controller = Object.create(WritableStreamDefaultController.prototype)
          SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm)
          return stream
        }
        function InitializeWritableStream (stream) {
          stream._state = 'writable'
          stream._storedError = undefined
          stream._writer = undefined
          stream._writableStreamController = undefined
          stream._writeRequests = new SimpleQueue()
          stream._inFlightWriteRequest = undefined
          stream._closeRequest = undefined
          stream._inFlightCloseRequest = undefined
          stream._pendingAbortRequest = undefined
          stream._backpressure = false
        }
        function IsWritableStream (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
            return false
          }
          return true
        }
        function IsWritableStreamLocked (stream) {
          if (stream._writer === undefined) {
            return false
          }
          return true
        }
        function WritableStreamAbort (stream, reason) {
          const state = stream._state
          if (state === 'closed' || state === 'errored') {
            return promiseResolvedWith(undefined)
          }
          if (stream._pendingAbortRequest !== undefined) {
            return stream._pendingAbortRequest._promise
          }
          let wasAlreadyErroring = false
          if (state === 'erroring') {
            wasAlreadyErroring = true
            reason = undefined
          }
          const promise = newPromise(function (resolve, reject) {
            stream._pendingAbortRequest = {
              _promise: undefined,
              _resolve: resolve,
              _reject: reject,
              _reason: reason,
              _wasAlreadyErroring: wasAlreadyErroring
            }
          })
          stream._pendingAbortRequest._promise = promise
          if (wasAlreadyErroring === false) {
            WritableStreamStartErroring(stream, reason)
          }
          return promise
        }
        function WritableStreamClose (stream) {
          const state = stream._state
          if (state === 'closed' || state === 'errored') {
            return promiseRejectedWith(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'))
          }
          const promise = newPromise(function (resolve, reject) {
            const closeRequest = {
              _resolve: resolve,
              _reject: reject
            }
            stream._closeRequest = closeRequest
          })
          const writer = stream._writer
          if (writer !== undefined && stream._backpressure === true && state === 'writable') {
            defaultWriterReadyPromiseResolve(writer)
          }
          WritableStreamDefaultControllerClose(stream._writableStreamController)
          return promise
        }
        function WritableStreamAddWriteRequest (stream) {
          const promise = newPromise(function (resolve, reject) {
            const writeRequest = {
              _resolve: resolve,
              _reject: reject
            }
            stream._writeRequests.push(writeRequest)
          })
          return promise
        }
        function WritableStreamDealWithRejection (stream, error) {
          const state = stream._state
          if (state === 'writable') {
            WritableStreamStartErroring(stream, error)
            return
          }
          WritableStreamFinishErroring(stream)
        }
        function WritableStreamStartErroring (stream, reason) {
          const controller = stream._writableStreamController
          stream._state = 'erroring'
          stream._storedError = reason
          const writer = stream._writer
          if (writer !== undefined) {
            WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason)
          }
          if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
            WritableStreamFinishErroring(stream)
          }
        }
        function WritableStreamFinishErroring (stream) {
          stream._state = 'errored'
          stream._writableStreamController[ErrorSteps]()
          const storedError = stream._storedError
          stream._writeRequests.forEach(function (writeRequest) {
            writeRequest._reject(storedError)
          })
          stream._writeRequests = new SimpleQueue()
          if (stream._pendingAbortRequest === undefined) {
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream)
            return
          }
          const abortRequest = stream._pendingAbortRequest
          stream._pendingAbortRequest = undefined
          if (abortRequest._wasAlreadyErroring === true) {
            abortRequest._reject(storedError)
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream)
            return
          }
          const promise = stream._writableStreamController[AbortSteps](abortRequest._reason)
          uponPromise(promise, function () {
            abortRequest._resolve()
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream)
          }, function (reason) {
            abortRequest._reject(reason)
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream)
          })
        }
        function WritableStreamFinishInFlightWrite (stream) {
          stream._inFlightWriteRequest._resolve(undefined)
          stream._inFlightWriteRequest = undefined
        }
        function WritableStreamFinishInFlightWriteWithError (stream, error) {
          stream._inFlightWriteRequest._reject(error)
          stream._inFlightWriteRequest = undefined
          WritableStreamDealWithRejection(stream, error)
        }
        function WritableStreamFinishInFlightClose (stream) {
          stream._inFlightCloseRequest._resolve(undefined)
          stream._inFlightCloseRequest = undefined
          const state = stream._state
          if (state === 'erroring') {
            stream._storedError = undefined
            if (stream._pendingAbortRequest !== undefined) {
              stream._pendingAbortRequest._resolve()
              stream._pendingAbortRequest = undefined
            }
          }
          stream._state = 'closed'
          const writer = stream._writer
          if (writer !== undefined) {
            defaultWriterClosedPromiseResolve(writer)
          }
        }
        function WritableStreamFinishInFlightCloseWithError (stream, error) {
          stream._inFlightCloseRequest._reject(error)
          stream._inFlightCloseRequest = undefined
          if (stream._pendingAbortRequest !== undefined) {
            stream._pendingAbortRequest._reject(error)
            stream._pendingAbortRequest = undefined
          }
          WritableStreamDealWithRejection(stream, error)
        }
        function WritableStreamCloseQueuedOrInFlight (stream) {
          if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
            return false
          }
          return true
        }
        function WritableStreamHasOperationMarkedInFlight (stream) {
          if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
            return false
          }
          return true
        }
        function WritableStreamMarkCloseRequestInFlight (stream) {
          stream._inFlightCloseRequest = stream._closeRequest
          stream._closeRequest = undefined
        }
        function WritableStreamMarkFirstWriteRequestInFlight (stream) {
          stream._inFlightWriteRequest = stream._writeRequests.shift()
        }
        function WritableStreamRejectCloseAndClosedPromiseIfNeeded (stream) {
          if (stream._closeRequest !== undefined) {
            stream._closeRequest._reject(stream._storedError)
            stream._closeRequest = undefined
          }
          const writer = stream._writer
          if (writer !== undefined) {
            defaultWriterClosedPromiseReject(writer, stream._storedError)
          }
        }
        function WritableStreamUpdateBackpressure (stream, backpressure) {
          const writer = stream._writer
          if (writer !== undefined && backpressure !== stream._backpressure) {
            if (backpressure === true) {
              defaultWriterReadyPromiseReset(writer)
            } else {
              defaultWriterReadyPromiseResolve(writer)
            }
          }
          stream._backpressure = backpressure
        }
        var WritableStreamDefaultWriter = (function () {
          function WritableStreamDefaultWriter (stream) {
            if (IsWritableStream(stream) === false) {
              throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance')
            }
            if (IsWritableStreamLocked(stream) === true) {
              throw new TypeError('This stream has already been locked for exclusive writing by another writer')
            }
            this._ownerWritableStream = stream
            stream._writer = this
            const state = stream._state
            if (state === 'writable') {
              if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
                defaultWriterReadyPromiseInitialize(this)
              } else {
                defaultWriterReadyPromiseInitializeAsResolved(this)
              }
              defaultWriterClosedPromiseInitialize(this)
            } else if (state === 'erroring') {
              defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError)
              defaultWriterClosedPromiseInitialize(this)
            } else if (state === 'closed') {
              defaultWriterReadyPromiseInitializeAsResolved(this)
              defaultWriterClosedPromiseInitializeAsResolved(this)
            } else {
              const storedError = stream._storedError
              defaultWriterReadyPromiseInitializeAsRejected(this, storedError)
              defaultWriterClosedPromiseInitializeAsRejected(this, storedError)
            }
          }
          Object.defineProperty(WritableStreamDefaultWriter.prototype, 'closed', {
            get: function () {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return promiseRejectedWith(defaultWriterBrandCheckException('closed'))
              }
              return this._closedPromise
            },
            enumerable: true,
            configurable: true
          })
          Object.defineProperty(WritableStreamDefaultWriter.prototype, 'desiredSize', {
            get: function () {
              if (IsWritableStreamDefaultWriter(this) === false) {
                throw defaultWriterBrandCheckException('desiredSize')
              }
              if (this._ownerWritableStream === undefined) {
                throw defaultWriterLockException('desiredSize')
              }
              return WritableStreamDefaultWriterGetDesiredSize(this)
            },
            enumerable: true,
            configurable: true
          })
          Object.defineProperty(WritableStreamDefaultWriter.prototype, 'ready', {
            get: function () {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return promiseRejectedWith(defaultWriterBrandCheckException('ready'))
              }
              return this._readyPromise
            },
            enumerable: true,
            configurable: true
          })
          WritableStreamDefaultWriter.prototype.abort = function (reason) {
            if (IsWritableStreamDefaultWriter(this) === false) {
              return promiseRejectedWith(defaultWriterBrandCheckException('abort'))
            }
            if (this._ownerWritableStream === undefined) {
              return promiseRejectedWith(defaultWriterLockException('abort'))
            }
            return WritableStreamDefaultWriterAbort(this, reason)
          }
          WritableStreamDefaultWriter.prototype.close = function () {
            if (IsWritableStreamDefaultWriter(this) === false) {
              return promiseRejectedWith(defaultWriterBrandCheckException('close'))
            }
            const stream = this._ownerWritableStream
            if (stream === undefined) {
              return promiseRejectedWith(defaultWriterLockException('close'))
            }
            if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
              return promiseRejectedWith(new TypeError('Cannot close an already-closing stream'))
            }
            return WritableStreamDefaultWriterClose(this)
          }
          WritableStreamDefaultWriter.prototype.releaseLock = function () {
            if (IsWritableStreamDefaultWriter(this) === false) {
              throw defaultWriterBrandCheckException('releaseLock')
            }
            const stream = this._ownerWritableStream
            if (stream === undefined) {
              return
            }
            WritableStreamDefaultWriterRelease(this)
          }
          WritableStreamDefaultWriter.prototype.write = function (chunk) {
            if (IsWritableStreamDefaultWriter(this) === false) {
              return promiseRejectedWith(defaultWriterBrandCheckException('write'))
            }
            if (this._ownerWritableStream === undefined) {
              return promiseRejectedWith(defaultWriterLockException('write to'))
            }
            return WritableStreamDefaultWriterWrite(this, chunk)
          }
          return WritableStreamDefaultWriter
        }())
        function IsWritableStreamDefaultWriter (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
            return false
          }
          return true
        }
        function WritableStreamDefaultWriterAbort (writer, reason) {
          const stream = writer._ownerWritableStream
          return WritableStreamAbort(stream, reason)
        }
        function WritableStreamDefaultWriterClose (writer) {
          const stream = writer._ownerWritableStream
          return WritableStreamClose(stream)
        }
        function WritableStreamDefaultWriterCloseWithErrorPropagation (writer) {
          const stream = writer._ownerWritableStream
          const state = stream._state
          if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
            return promiseResolvedWith(undefined)
          }
          if (state === 'errored') {
            return promiseRejectedWith(stream._storedError)
          }
          return WritableStreamDefaultWriterClose(writer)
        }
        function WritableStreamDefaultWriterEnsureClosedPromiseRejected (writer, error) {
          if (writer._closedPromiseState === 'pending') {
            defaultWriterClosedPromiseReject(writer, error)
          } else {
            defaultWriterClosedPromiseResetToRejected(writer, error)
          }
        }
        function WritableStreamDefaultWriterEnsureReadyPromiseRejected (writer, error) {
          if (writer._readyPromiseState === 'pending') {
            defaultWriterReadyPromiseReject(writer, error)
          } else {
            defaultWriterReadyPromiseResetToRejected(writer, error)
          }
        }
        function WritableStreamDefaultWriterGetDesiredSize (writer) {
          const stream = writer._ownerWritableStream
          const state = stream._state
          if (state === 'errored' || state === 'erroring') {
            return null
          }
          if (state === 'closed') {
            return 0
          }
          return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController)
        }
        function WritableStreamDefaultWriterRelease (writer) {
          const stream = writer._ownerWritableStream
          const releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness')
          WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError)
          WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError)
          stream._writer = undefined
          writer._ownerWritableStream = undefined
        }
        function WritableStreamDefaultWriterWrite (writer, chunk) {
          const stream = writer._ownerWritableStream
          const controller = stream._writableStreamController
          const chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk)
          if (stream !== writer._ownerWritableStream) {
            return promiseRejectedWith(defaultWriterLockException('write to'))
          }
          const state = stream._state
          if (state === 'errored') {
            return promiseRejectedWith(stream._storedError)
          }
          if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
            return promiseRejectedWith(new TypeError('The stream is closing or closed and cannot be written to'))
          }
          if (state === 'erroring') {
            return promiseRejectedWith(stream._storedError)
          }
          const promise = WritableStreamAddWriteRequest(stream)
          WritableStreamDefaultControllerWrite(controller, chunk, chunkSize)
          return promise
        }
        var WritableStreamDefaultController = (function () {
          function WritableStreamDefaultController () {
            throw new TypeError('WritableStreamDefaultController cannot be constructed explicitly')
          }
          WritableStreamDefaultController.prototype.error = function (e) {
            if (IsWritableStreamDefaultController(this) === false) {
              throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController')
            }
            const state = this._controlledWritableStream._state
            if (state !== 'writable') {
              return
            }
            WritableStreamDefaultControllerError(this, e)
          }
          WritableStreamDefaultController.prototype[AbortSteps] = function (reason) {
            const result = this._abortAlgorithm(reason)
            WritableStreamDefaultControllerClearAlgorithms(this)
            return result
          }
          WritableStreamDefaultController.prototype[ErrorSteps] = function () {
            ResetQueue(this)
          }
          return WritableStreamDefaultController
        }())
        function IsWritableStreamDefaultController (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_controlledWritableStream')) {
            return false
          }
          return true
        }
        function SetUpWritableStreamDefaultController (stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
          controller._controlledWritableStream = stream
          stream._writableStreamController = controller
          controller._queue = undefined
          controller._queueTotalSize = undefined
          ResetQueue(controller)
          controller._started = false
          controller._strategySizeAlgorithm = sizeAlgorithm
          controller._strategyHWM = highWaterMark
          controller._writeAlgorithm = writeAlgorithm
          controller._closeAlgorithm = closeAlgorithm
          controller._abortAlgorithm = abortAlgorithm
          const backpressure = WritableStreamDefaultControllerGetBackpressure(controller)
          WritableStreamUpdateBackpressure(stream, backpressure)
          const startResult = startAlgorithm()
          const startPromise = promiseResolvedWith(startResult)
          uponPromise(startPromise, function () {
            controller._started = true
            WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller)
          }, function (r) {
            controller._started = true
            WritableStreamDealWithRejection(stream, r)
          })
        }
        function SetUpWritableStreamDefaultControllerFromUnderlyingSink (stream, underlyingSink, highWaterMark, sizeAlgorithm) {
          const controller = Object.create(WritableStreamDefaultController.prototype)
          function startAlgorithm () {
            return InvokeOrNoop(underlyingSink, 'start', [controller])
          }
          const writeAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSink, 'write', 1, [controller])
          const closeAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSink, 'close', 0, [])
          const abortAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSink, 'abort', 1, [])
          SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm)
        }
        function WritableStreamDefaultControllerClearAlgorithms (controller) {
          controller._writeAlgorithm = undefined
          controller._closeAlgorithm = undefined
          controller._abortAlgorithm = undefined
          controller._strategySizeAlgorithm = undefined
        }
        function WritableStreamDefaultControllerClose (controller) {
          EnqueueValueWithSize(controller, 'close', 0)
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller)
        }
        function WritableStreamDefaultControllerGetChunkSize (controller, chunk) {
          try {
            return controller._strategySizeAlgorithm(chunk)
          } catch (chunkSizeE) {
            WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE)
            return 1
          }
        }
        function WritableStreamDefaultControllerGetDesiredSize (controller) {
          return controller._strategyHWM - controller._queueTotalSize
        }
        function WritableStreamDefaultControllerWrite (controller, chunk, chunkSize) {
          const writeRecord = { chunk: chunk }
          try {
            EnqueueValueWithSize(controller, writeRecord, chunkSize)
          } catch (enqueueE) {
            WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE)
            return
          }
          const stream = controller._controlledWritableStream
          if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
            const backpressure = WritableStreamDefaultControllerGetBackpressure(controller)
            WritableStreamUpdateBackpressure(stream, backpressure)
          }
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller)
        }
        function WritableStreamDefaultControllerAdvanceQueueIfNeeded (controller) {
          const stream = controller._controlledWritableStream
          if (controller._started === false) {
            return
          }
          if (stream._inFlightWriteRequest !== undefined) {
            return
          }
          const state = stream._state
          if (state === 'erroring') {
            WritableStreamFinishErroring(stream)
            return
          }
          if (controller._queue.length === 0) {
            return
          }
          const writeRecord = PeekQueueValue(controller)
          if (writeRecord === 'close') {
            WritableStreamDefaultControllerProcessClose(controller)
          } else {
            WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk)
          }
        }
        function WritableStreamDefaultControllerErrorIfNeeded (controller, error) {
          if (controller._controlledWritableStream._state === 'writable') {
            WritableStreamDefaultControllerError(controller, error)
          }
        }
        function WritableStreamDefaultControllerProcessClose (controller) {
          const stream = controller._controlledWritableStream
          WritableStreamMarkCloseRequestInFlight(stream)
          DequeueValue(controller)
          const sinkClosePromise = controller._closeAlgorithm()
          WritableStreamDefaultControllerClearAlgorithms(controller)
          uponPromise(sinkClosePromise, function () {
            WritableStreamFinishInFlightClose(stream)
          }, function (reason) {
            WritableStreamFinishInFlightCloseWithError(stream, reason)
          })
        }
        function WritableStreamDefaultControllerProcessWrite (controller, chunk) {
          const stream = controller._controlledWritableStream
          WritableStreamMarkFirstWriteRequestInFlight(stream)
          const sinkWritePromise = controller._writeAlgorithm(chunk)
          uponPromise(sinkWritePromise, function () {
            WritableStreamFinishInFlightWrite(stream)
            const state = stream._state
            DequeueValue(controller)
            if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
              const backpressure = WritableStreamDefaultControllerGetBackpressure(controller)
              WritableStreamUpdateBackpressure(stream, backpressure)
            }
            WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller)
          }, function (reason) {
            if (stream._state === 'writable') {
              WritableStreamDefaultControllerClearAlgorithms(controller)
            }
            WritableStreamFinishInFlightWriteWithError(stream, reason)
          })
        }
        function WritableStreamDefaultControllerGetBackpressure (controller) {
          const desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller)
          return desiredSize <= 0
        }
        function WritableStreamDefaultControllerError (controller, error) {
          const stream = controller._controlledWritableStream
          WritableStreamDefaultControllerClearAlgorithms(controller)
          WritableStreamStartErroring(stream, error)
        }
        function streamBrandCheckException (name) {
          return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream')
        }
        function defaultWriterBrandCheckException (name) {
          return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter')
        }
        function defaultWriterLockException (name) {
          return new TypeError('Cannot ' + name + ' a stream using a released writer')
        }
        function defaultWriterClosedPromiseInitialize (writer) {
          writer._closedPromise = newPromise(function (resolve, reject) {
            writer._closedPromise_resolve = resolve
            writer._closedPromise_reject = reject
            writer._closedPromiseState = 'pending'
          })
        }
        function defaultWriterClosedPromiseInitializeAsRejected (writer, reason) {
          defaultWriterClosedPromiseInitialize(writer)
          defaultWriterClosedPromiseReject(writer, reason)
        }
        function defaultWriterClosedPromiseInitializeAsResolved (writer) {
          defaultWriterClosedPromiseInitialize(writer)
          defaultWriterClosedPromiseResolve(writer)
        }
        function defaultWriterClosedPromiseReject (writer, reason) {
          setPromiseIsHandledToTrue(writer._closedPromise)
          writer._closedPromise_reject(reason)
          writer._closedPromise_resolve = undefined
          writer._closedPromise_reject = undefined
          writer._closedPromiseState = 'rejected'
        }
        function defaultWriterClosedPromiseResetToRejected (writer, reason) {
          defaultWriterClosedPromiseInitializeAsRejected(writer, reason)
        }
        function defaultWriterClosedPromiseResolve (writer) {
          writer._closedPromise_resolve(undefined)
          writer._closedPromise_resolve = undefined
          writer._closedPromise_reject = undefined
          writer._closedPromiseState = 'resolved'
        }
        function defaultWriterReadyPromiseInitialize (writer) {
          writer._readyPromise = newPromise(function (resolve, reject) {
            writer._readyPromise_resolve = resolve
            writer._readyPromise_reject = reject
          })
          writer._readyPromiseState = 'pending'
        }
        function defaultWriterReadyPromiseInitializeAsRejected (writer, reason) {
          defaultWriterReadyPromiseInitialize(writer)
          defaultWriterReadyPromiseReject(writer, reason)
        }
        function defaultWriterReadyPromiseInitializeAsResolved (writer) {
          defaultWriterReadyPromiseInitialize(writer)
          defaultWriterReadyPromiseResolve(writer)
        }
        function defaultWriterReadyPromiseReject (writer, reason) {
          setPromiseIsHandledToTrue(writer._readyPromise)
          writer._readyPromise_reject(reason)
          writer._readyPromise_resolve = undefined
          writer._readyPromise_reject = undefined
          writer._readyPromiseState = 'rejected'
        }
        function defaultWriterReadyPromiseReset (writer) {
          defaultWriterReadyPromiseInitialize(writer)
        }
        function defaultWriterReadyPromiseResetToRejected (writer, reason) {
          defaultWriterReadyPromiseInitializeAsRejected(writer, reason)
        }
        function defaultWriterReadyPromiseResolve (writer) {
          writer._readyPromise_resolve(undefined)
          writer._readyPromise_resolve = undefined
          writer._readyPromise_reject = undefined
          writer._readyPromiseState = 'fulfilled'
        }
        function isAbortSignal (value) {
          if (typeof value !== 'object' || value === null) {
            return false
          }
          try {
            return typeof value.aborted === 'boolean'
          } catch (_a) {
            return false
          }
        }
        const NativeDOMException = typeof DOMException !== 'undefined' ? DOMException : undefined
        function isDOMExceptionConstructor (ctor) {
          if (!(typeof ctor === 'function' || typeof ctor === 'object')) {
            return false
          }
          try {
            new ctor()
            return true
          } catch (_a) {
            return false
          }
        }
        function createDOMExceptionPolyfill () {
          const ctor = function DOMException (message, name) {
            this.message = message || ''
            this.name = name || 'Error'
            if (Error.captureStackTrace) {
              Error.captureStackTrace(this, this.constructor)
            }
          }
          ctor.prototype = Object.create(Error.prototype)
          Object.defineProperty(ctor.prototype, 'constructor', {
            value: ctor,
            writable: true,
            configurable: true
          })
          return ctor
        }
        const DOMException$1 = isDOMExceptionConstructor(NativeDOMException) ? NativeDOMException : createDOMExceptionPolyfill()
        function ReadableStreamPipeTo (source, dest, preventClose, preventAbort, preventCancel, signal) {
          const reader = AcquireReadableStreamDefaultReader(source)
          const writer = AcquireWritableStreamDefaultWriter(dest)
          source._disturbed = true
          let shuttingDown = false
          let currentWrite = promiseResolvedWith(undefined)
          return newPromise(function (resolve, reject) {
            let abortAlgorithm
            if (signal !== undefined) {
              abortAlgorithm = function () {
                const error = new DOMException$1('Aborted', 'AbortError')
                const actions = []
                if (preventAbort === false) {
                  actions.push(function () {
                    if (dest._state === 'writable') {
                      return WritableStreamAbort(dest, error)
                    }
                    return promiseResolvedWith(undefined)
                  })
                }
                if (preventCancel === false) {
                  actions.push(function () {
                    if (source._state === 'readable') {
                      return ReadableStreamCancel(source, error)
                    }
                    return promiseResolvedWith(undefined)
                  })
                }
                shutdownWithAction(function () {
                  return Promise.all(actions.map(function (action) {
                    return action()
                  }))
                }, true, error)
              }
              if (signal.aborted === true) {
                abortAlgorithm()
                return
              }
              signal.addEventListener('abort', abortAlgorithm)
            }
            function pipeLoop () {
              return newPromise(function (resolveLoop, rejectLoop) {
                function next (done) {
                  if (done) {
                    resolveLoop()
                  } else {
                    PerformPromiseThen(pipeStep(), next, rejectLoop)
                  }
                }
                next(false)
              })
            }
            function pipeStep () {
              if (shuttingDown === true) {
                return promiseResolvedWith(true)
              }
              return PerformPromiseThen(writer._readyPromise, function () {
                return PerformPromiseThen(ReadableStreamDefaultReaderRead(reader), function (_a) {
                  const value = _a.value; const done = _a.done
                  if (done === true) {
                    return true
                  }
                  currentWrite = PerformPromiseThen(WritableStreamDefaultWriterWrite(writer, value), undefined, noop)
                  return false
                })
              })
            }
            isOrBecomesErrored(source, reader._closedPromise, function (storedError) {
              if (preventAbort === false) {
                shutdownWithAction(function () {
                  return WritableStreamAbort(dest, storedError)
                }, true, storedError)
              } else {
                shutdown(true, storedError)
              }
            })
            isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
              if (preventCancel === false) {
                shutdownWithAction(function () {
                  return ReadableStreamCancel(source, storedError)
                }, true, storedError)
              } else {
                shutdown(true, storedError)
              }
            })
            isOrBecomesClosed(source, reader._closedPromise, function () {
              if (preventClose === false) {
                shutdownWithAction(function () {
                  return WritableStreamDefaultWriterCloseWithErrorPropagation(writer)
                })
              } else {
                shutdown()
              }
            })
            if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
              const destClosed_1 = new TypeError('the destination writable stream closed before all data could be piped to it')
              if (preventCancel === false) {
                shutdownWithAction(function () {
                  return ReadableStreamCancel(source, destClosed_1)
                }, true, destClosed_1)
              } else {
                shutdown(true, destClosed_1)
              }
            }
            setPromiseIsHandledToTrue(pipeLoop())
            function waitForWritesToFinish () {
              const oldCurrentWrite = currentWrite
              return PerformPromiseThen(currentWrite, function () {
                return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined
              })
            }
            function isOrBecomesErrored (stream, promise, action) {
              if (stream._state === 'errored') {
                action(stream._storedError)
              } else {
                uponRejection(promise, action)
              }
            }
            function isOrBecomesClosed (stream, promise, action) {
              if (stream._state === 'closed') {
                action()
              } else {
                uponFulfillment(promise, action)
              }
            }
            function shutdownWithAction (action, originalIsError, originalError) {
              if (shuttingDown === true) {
                return
              }
              shuttingDown = true
              if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
                uponFulfillment(waitForWritesToFinish(), doTheRest)
              } else {
                doTheRest()
              }
              function doTheRest () {
                uponPromise(action(), function () {
                  return finalize(originalIsError, originalError)
                }, function (newError) {
                  return finalize(true, newError)
                })
              }
            }
            function shutdown (isError, error) {
              if (shuttingDown === true) {
                return
              }
              shuttingDown = true
              if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
                uponFulfillment(waitForWritesToFinish(), function () {
                  return finalize(isError, error)
                })
              } else {
                finalize(isError, error)
              }
            }
            function finalize (isError, error) {
              WritableStreamDefaultWriterRelease(writer)
              ReadableStreamReaderGenericRelease(reader)
              if (signal !== undefined) {
                signal.removeEventListener('abort', abortAlgorithm)
              }
              if (isError) {
                reject(error)
              } else {
                resolve(undefined)
              }
            }
          })
        }
        const ReadableStreamDefaultController = (function () {
          function ReadableStreamDefaultController () {
            throw new TypeError()
          }
          Object.defineProperty(ReadableStreamDefaultController.prototype, 'desiredSize', {
            get: function () {
              if (IsReadableStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException('desiredSize')
              }
              return ReadableStreamDefaultControllerGetDesiredSize(this)
            },
            enumerable: true,
            configurable: true
          })
          ReadableStreamDefaultController.prototype.close = function () {
            if (IsReadableStreamDefaultController(this) === false) {
              throw defaultControllerBrandCheckException('close')
            }
            if (ReadableStreamDefaultControllerCanCloseOrEnqueue(this) === false) {
              throw new TypeError('The stream is not in a state that permits close')
            }
            ReadableStreamDefaultControllerClose(this)
          }
          ReadableStreamDefaultController.prototype.enqueue = function (chunk) {
            if (IsReadableStreamDefaultController(this) === false) {
              throw defaultControllerBrandCheckException('enqueue')
            }
            if (ReadableStreamDefaultControllerCanCloseOrEnqueue(this) === false) {
              throw new TypeError('The stream is not in a state that permits enqueue')
            }
            return ReadableStreamDefaultControllerEnqueue(this, chunk)
          }
          ReadableStreamDefaultController.prototype.error = function (e) {
            if (IsReadableStreamDefaultController(this) === false) {
              throw defaultControllerBrandCheckException('error')
            }
            ReadableStreamDefaultControllerError(this, e)
          }
          ReadableStreamDefaultController.prototype[CancelSteps] = function (reason) {
            ResetQueue(this)
            const result = this._cancelAlgorithm(reason)
            ReadableStreamDefaultControllerClearAlgorithms(this)
            return result
          }
          ReadableStreamDefaultController.prototype[PullSteps] = function () {
            const stream = this._controlledReadableStream
            if (this._queue.length > 0) {
              const chunk = DequeueValue(this)
              if (this._closeRequested === true && this._queue.length === 0) {
                ReadableStreamDefaultControllerClearAlgorithms(this)
                ReadableStreamClose(stream)
              } else {
                ReadableStreamDefaultControllerCallPullIfNeeded(this)
              }
              return promiseResolvedWith(ReadableStreamCreateReadResult(chunk, false, stream._reader._forAuthorCode))
            }
            const pendingPromise = ReadableStreamAddReadRequest(stream)
            ReadableStreamDefaultControllerCallPullIfNeeded(this)
            return pendingPromise
          }
          return ReadableStreamDefaultController
        }())
        function IsReadableStreamDefaultController (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_controlledReadableStream')) {
            return false
          }
          return true
        }
        function ReadableStreamDefaultControllerCallPullIfNeeded (controller) {
          const shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller)
          if (shouldPull === false) {
            return
          }
          if (controller._pulling === true) {
            controller._pullAgain = true
            return
          }
          controller._pulling = true
          const pullPromise = controller._pullAlgorithm()
          uponPromise(pullPromise, function () {
            controller._pulling = false
            if (controller._pullAgain === true) {
              controller._pullAgain = false
              ReadableStreamDefaultControllerCallPullIfNeeded(controller)
            }
          }, function (e) {
            ReadableStreamDefaultControllerError(controller, e)
          })
        }
        function ReadableStreamDefaultControllerShouldCallPull (controller) {
          const stream = controller._controlledReadableStream
          if (ReadableStreamDefaultControllerCanCloseOrEnqueue(controller) === false) {
            return false
          }
          if (controller._started === false) {
            return false
          }
          if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
            return true
          }
          const desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller)
          if (desiredSize > 0) {
            return true
          }
          return false
        }
        function ReadableStreamDefaultControllerClearAlgorithms (controller) {
          controller._pullAlgorithm = undefined
          controller._cancelAlgorithm = undefined
          controller._strategySizeAlgorithm = undefined
        }
        function ReadableStreamDefaultControllerClose (controller) {
          const stream = controller._controlledReadableStream
          controller._closeRequested = true
          if (controller._queue.length === 0) {
            ReadableStreamDefaultControllerClearAlgorithms(controller)
            ReadableStreamClose(stream)
          }
        }
        function ReadableStreamDefaultControllerEnqueue (controller, chunk) {
          const stream = controller._controlledReadableStream
          if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
            ReadableStreamFulfillReadRequest(stream, chunk, false)
          } else {
            let chunkSize = void 0
            try {
              chunkSize = controller._strategySizeAlgorithm(chunk)
            } catch (chunkSizeE) {
              ReadableStreamDefaultControllerError(controller, chunkSizeE)
              throw chunkSizeE
            }
            try {
              EnqueueValueWithSize(controller, chunk, chunkSize)
            } catch (enqueueE) {
              ReadableStreamDefaultControllerError(controller, enqueueE)
              throw enqueueE
            }
          }
          ReadableStreamDefaultControllerCallPullIfNeeded(controller)
        }
        function ReadableStreamDefaultControllerError (controller, e) {
          const stream = controller._controlledReadableStream
          if (stream._state !== 'readable') {
            return
          }
          ResetQueue(controller)
          ReadableStreamDefaultControllerClearAlgorithms(controller)
          ReadableStreamError(stream, e)
        }
        function ReadableStreamDefaultControllerGetDesiredSize (controller) {
          const stream = controller._controlledReadableStream
          const state = stream._state
          if (state === 'errored') {
            return null
          }
          if (state === 'closed') {
            return 0
          }
          return controller._strategyHWM - controller._queueTotalSize
        }
        function ReadableStreamDefaultControllerHasBackpressure (controller) {
          if (ReadableStreamDefaultControllerShouldCallPull(controller) === true) {
            return false
          }
          return true
        }
        function ReadableStreamDefaultControllerCanCloseOrEnqueue (controller) {
          const state = controller._controlledReadableStream._state
          if (controller._closeRequested === false && state === 'readable') {
            return true
          }
          return false
        }
        function SetUpReadableStreamDefaultController (stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
          controller._controlledReadableStream = stream
          controller._queue = undefined
          controller._queueTotalSize = undefined
          ResetQueue(controller)
          controller._started = false
          controller._closeRequested = false
          controller._pullAgain = false
          controller._pulling = false
          controller._strategySizeAlgorithm = sizeAlgorithm
          controller._strategyHWM = highWaterMark
          controller._pullAlgorithm = pullAlgorithm
          controller._cancelAlgorithm = cancelAlgorithm
          stream._readableStreamController = controller
          const startResult = startAlgorithm()
          uponPromise(promiseResolvedWith(startResult), function () {
            controller._started = true
            ReadableStreamDefaultControllerCallPullIfNeeded(controller)
          }, function (r) {
            ReadableStreamDefaultControllerError(controller, r)
          })
        }
        function SetUpReadableStreamDefaultControllerFromUnderlyingSource (stream, underlyingSource, highWaterMark, sizeAlgorithm) {
          const controller = Object.create(ReadableStreamDefaultController.prototype)
          function startAlgorithm () {
            return InvokeOrNoop(underlyingSource, 'start', [controller])
          }
          const pullAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSource, 'pull', 0, [controller])
          const cancelAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSource, 'cancel', 1, [])
          SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm)
        }
        function defaultControllerBrandCheckException (name) {
          return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController')
        }
        function ReadableStreamTee (stream, cloneForBranch2) {
          const reader = AcquireReadableStreamDefaultReader(stream)
          let reading = false
          let canceled1 = false
          let canceled2 = false
          let reason1
          let reason2
          let branch1
          let branch2
          let resolveCancelPromise
          const cancelPromise = newPromise(function (resolve) {
            resolveCancelPromise = resolve
          })
          function pullAlgorithm () {
            if (reading === true) {
              return promiseResolvedWith(undefined)
            }
            reading = true
            const readPromise = transformPromiseWith(ReadableStreamDefaultReaderRead(reader), function (result) {
              reading = false
              const done = result.done
              if (done === true) {
                if (canceled1 === false) {
                  ReadableStreamDefaultControllerClose(branch1._readableStreamController)
                }
                if (canceled2 === false) {
                  ReadableStreamDefaultControllerClose(branch2._readableStreamController)
                }
                return
              }
              const value = result.value
              const value1 = value
              const value2 = value
              if (canceled1 === false) {
                ReadableStreamDefaultControllerEnqueue(branch1._readableStreamController, value1)
              }
              if (canceled2 === false) {
                ReadableStreamDefaultControllerEnqueue(branch2._readableStreamController, value2)
              }
            })
            setPromiseIsHandledToTrue(readPromise)
            return promiseResolvedWith(undefined)
          }
          function cancel1Algorithm (reason) {
            canceled1 = true
            reason1 = reason
            if (canceled2 === true) {
              const compositeReason = createArrayFromList([
                reason1,
                reason2
              ])
              const cancelResult = ReadableStreamCancel(stream, compositeReason)
              resolveCancelPromise(cancelResult)
            }
            return cancelPromise
          }
          function cancel2Algorithm (reason) {
            canceled2 = true
            reason2 = reason
            if (canceled1 === true) {
              const compositeReason = createArrayFromList([
                reason1,
                reason2
              ])
              const cancelResult = ReadableStreamCancel(stream, compositeReason)
              resolveCancelPromise(cancelResult)
            }
            return cancelPromise
          }
          function startAlgorithm () {
          }
          branch1 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel1Algorithm)
          branch2 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel2Algorithm)
          uponRejection(reader._closedPromise, function (r) {
            ReadableStreamDefaultControllerError(branch1._readableStreamController, r)
            ReadableStreamDefaultControllerError(branch2._readableStreamController, r)
          })
          return [
            branch1,
            branch2
          ]
        }
        const NumberIsInteger = Number.isInteger || function (value) {
          return typeof value === 'number' && isFinite(value) && Math.floor(value) === value
        }
        const ReadableStreamBYOBRequest = (function () {
          function ReadableStreamBYOBRequest () {
            throw new TypeError('ReadableStreamBYOBRequest cannot be used directly')
          }
          Object.defineProperty(ReadableStreamBYOBRequest.prototype, 'view', {
            get: function () {
              if (IsReadableStreamBYOBRequest(this) === false) {
                throw byobRequestBrandCheckException('view')
              }
              return this._view
            },
            enumerable: true,
            configurable: true
          })
          ReadableStreamBYOBRequest.prototype.respond = function (bytesWritten) {
            if (IsReadableStreamBYOBRequest(this) === false) {
              throw byobRequestBrandCheckException('respond')
            }
            if (this._associatedReadableByteStreamController === undefined) {
              throw new TypeError('This BYOB request has been invalidated')
            }
            if (IsDetachedBuffer(this._view.buffer) === true);
            ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten)
          }
          ReadableStreamBYOBRequest.prototype.respondWithNewView = function (view) {
            if (IsReadableStreamBYOBRequest(this) === false) {
              throw byobRequestBrandCheckException('respond')
            }
            if (this._associatedReadableByteStreamController === undefined) {
              throw new TypeError('This BYOB request has been invalidated')
            }
            if (!ArrayBuffer.isView(view)) {
              throw new TypeError('You can only respond with array buffer views')
            }
            if (IsDetachedBuffer(view.buffer) === true);
            ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view)
          }
          return ReadableStreamBYOBRequest
        }())
        const ReadableByteStreamController = (function () {
          function ReadableByteStreamController () {
            throw new TypeError('ReadableByteStreamController constructor cannot be used directly')
          }
          Object.defineProperty(ReadableByteStreamController.prototype, 'byobRequest', {
            get: function () {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException('byobRequest')
              }
              if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
                const firstDescriptor = this._pendingPullIntos.peek()
                const view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled)
                const byobRequest = Object.create(ReadableStreamBYOBRequest.prototype)
                SetUpReadableStreamBYOBRequest(byobRequest, this, view)
                this._byobRequest = byobRequest
              }
              return this._byobRequest
            },
            enumerable: true,
            configurable: true
          })
          Object.defineProperty(ReadableByteStreamController.prototype, 'desiredSize', {
            get: function () {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException('desiredSize')
              }
              return ReadableByteStreamControllerGetDesiredSize(this)
            },
            enumerable: true,
            configurable: true
          })
          ReadableByteStreamController.prototype.close = function () {
            if (IsReadableByteStreamController(this) === false) {
              throw byteStreamControllerBrandCheckException('close')
            }
            if (this._closeRequested === true) {
              throw new TypeError('The stream has already been closed; do not close it again!')
            }
            const state = this._controlledReadableByteStream._state
            if (state !== 'readable') {
              throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed')
            }
            ReadableByteStreamControllerClose(this)
          }
          ReadableByteStreamController.prototype.enqueue = function (chunk) {
            if (IsReadableByteStreamController(this) === false) {
              throw byteStreamControllerBrandCheckException('enqueue')
            }
            if (this._closeRequested === true) {
              throw new TypeError('stream is closed or draining')
            }
            const state = this._controlledReadableByteStream._state
            if (state !== 'readable') {
              throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to')
            }
            if (!ArrayBuffer.isView(chunk)) {
              throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController')
            }
            if (IsDetachedBuffer(chunk.buffer) === true);
            ReadableByteStreamControllerEnqueue(this, chunk)
          }
          ReadableByteStreamController.prototype.error = function (e) {
            if (IsReadableByteStreamController(this) === false) {
              throw byteStreamControllerBrandCheckException('error')
            }
            ReadableByteStreamControllerError(this, e)
          }
          ReadableByteStreamController.prototype[CancelSteps] = function (reason) {
            if (this._pendingPullIntos.length > 0) {
              const firstDescriptor = this._pendingPullIntos.peek()
              firstDescriptor.bytesFilled = 0
            }
            ResetQueue(this)
            const result = this._cancelAlgorithm(reason)
            ReadableByteStreamControllerClearAlgorithms(this)
            return result
          }
          ReadableByteStreamController.prototype[PullSteps] = function () {
            const stream = this._controlledReadableByteStream
            if (this._queueTotalSize > 0) {
              const entry = this._queue.shift()
              this._queueTotalSize -= entry.byteLength
              ReadableByteStreamControllerHandleQueueDrain(this)
              let view = void 0
              try {
                view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength)
              } catch (viewE) {
                return promiseRejectedWith(viewE)
              }
              return promiseResolvedWith(ReadableStreamCreateReadResult(view, false, stream._reader._forAuthorCode))
            }
            const autoAllocateChunkSize = this._autoAllocateChunkSize
            if (autoAllocateChunkSize !== undefined) {
              let buffer = void 0
              try {
                buffer = new ArrayBuffer(autoAllocateChunkSize)
              } catch (bufferE) {
                return promiseRejectedWith(bufferE)
              }
              const pullIntoDescriptor = {
                buffer: buffer,
                byteOffset: 0,
                byteLength: autoAllocateChunkSize,
                bytesFilled: 0,
                elementSize: 1,
                ctor: Uint8Array,
                readerType: 'default'
              }
              this._pendingPullIntos.push(pullIntoDescriptor)
            }
            const promise = ReadableStreamAddReadRequest(stream)
            ReadableByteStreamControllerCallPullIfNeeded(this)
            return promise
          }
          return ReadableByteStreamController
        }())
        function IsReadableByteStreamController (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_controlledReadableByteStream')) {
            return false
          }
          return true
        }
        function IsReadableStreamBYOBRequest (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
            return false
          }
          return true
        }
        function ReadableByteStreamControllerCallPullIfNeeded (controller) {
          const shouldPull = ReadableByteStreamControllerShouldCallPull(controller)
          if (shouldPull === false) {
            return
          }
          if (controller._pulling === true) {
            controller._pullAgain = true
            return
          }
          controller._pulling = true
          const pullPromise = controller._pullAlgorithm()
          uponPromise(pullPromise, function () {
            controller._pulling = false
            if (controller._pullAgain === true) {
              controller._pullAgain = false
              ReadableByteStreamControllerCallPullIfNeeded(controller)
            }
          }, function (e) {
            ReadableByteStreamControllerError(controller, e)
          })
        }
        function ReadableByteStreamControllerClearPendingPullIntos (controller) {
          ReadableByteStreamControllerInvalidateBYOBRequest(controller)
          controller._pendingPullIntos = new SimpleQueue()
        }
        function ReadableByteStreamControllerCommitPullIntoDescriptor (stream, pullIntoDescriptor) {
          let done = false
          if (stream._state === 'closed') {
            done = true
          }
          const filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor)
          if (pullIntoDescriptor.readerType === 'default') {
            ReadableStreamFulfillReadRequest(stream, filledView, done)
          } else {
            ReadableStreamFulfillReadIntoRequest(stream, filledView, done)
          }
        }
        function ReadableByteStreamControllerConvertPullIntoDescriptor (pullIntoDescriptor) {
          const bytesFilled = pullIntoDescriptor.bytesFilled
          const elementSize = pullIntoDescriptor.elementSize
          return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize)
        }
        function ReadableByteStreamControllerEnqueueChunkToQueue (controller, buffer, byteOffset, byteLength) {
          controller._queue.push({
            buffer: buffer,
            byteOffset: byteOffset,
            byteLength: byteLength
          })
          controller._queueTotalSize += byteLength
        }
        function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue (controller, pullIntoDescriptor) {
          const elementSize = pullIntoDescriptor.elementSize
          const currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize
          const maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled)
          const maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy
          const maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize
          let totalBytesToCopyRemaining = maxBytesToCopy
          let ready = false
          if (maxAlignedBytes > currentAlignedBytes) {
            totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled
            ready = true
          }
          const queue = controller._queue
          while (totalBytesToCopyRemaining > 0) {
            const headOfQueue = queue.peek()
            const bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength)
            const destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled
            ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy)
            if (headOfQueue.byteLength === bytesToCopy) {
              queue.shift()
            } else {
              headOfQueue.byteOffset += bytesToCopy
              headOfQueue.byteLength -= bytesToCopy
            }
            controller._queueTotalSize -= bytesToCopy
            ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor)
            totalBytesToCopyRemaining -= bytesToCopy
          }
          return ready
        }
        function ReadableByteStreamControllerFillHeadPullIntoDescriptor (controller, size, pullIntoDescriptor) {
          ReadableByteStreamControllerInvalidateBYOBRequest(controller)
          pullIntoDescriptor.bytesFilled += size
        }
        function ReadableByteStreamControllerHandleQueueDrain (controller) {
          if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
            ReadableByteStreamControllerClearAlgorithms(controller)
            ReadableStreamClose(controller._controlledReadableByteStream)
          } else {
            ReadableByteStreamControllerCallPullIfNeeded(controller)
          }
        }
        function ReadableByteStreamControllerInvalidateBYOBRequest (controller) {
          if (controller._byobRequest === undefined) {
            return
          }
          controller._byobRequest._associatedReadableByteStreamController = undefined
          controller._byobRequest._view = undefined
          controller._byobRequest = undefined
        }
        function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue (controller) {
          while (controller._pendingPullIntos.length > 0) {
            if (controller._queueTotalSize === 0) {
              return
            }
            const pullIntoDescriptor = controller._pendingPullIntos.peek()
            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
              ReadableByteStreamControllerShiftPendingPullInto(controller)
              ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor)
            }
          }
        }
        function ReadableByteStreamControllerPullInto (controller, view) {
          const stream = controller._controlledReadableByteStream
          let elementSize = 1
          if (view.constructor !== DataView) {
            elementSize = view.constructor.BYTES_PER_ELEMENT
          }
          const ctor = view.constructor
          const buffer = TransferArrayBuffer(view.buffer)
          const pullIntoDescriptor = {
            buffer: buffer,
            byteOffset: view.byteOffset,
            byteLength: view.byteLength,
            bytesFilled: 0,
            elementSize: elementSize,
            ctor: ctor,
            readerType: 'byob'
          }
          if (controller._pendingPullIntos.length > 0) {
            controller._pendingPullIntos.push(pullIntoDescriptor)
            return ReadableStreamAddReadIntoRequest(stream)
          }
          if (stream._state === 'closed') {
            const emptyView = new ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0)
            return promiseResolvedWith(ReadableStreamCreateReadResult(emptyView, true, stream._reader._forAuthorCode))
          }
          if (controller._queueTotalSize > 0) {
            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
              const filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor)
              ReadableByteStreamControllerHandleQueueDrain(controller)
              return promiseResolvedWith(ReadableStreamCreateReadResult(filledView, false, stream._reader._forAuthorCode))
            }
            if (controller._closeRequested === true) {
              const e = new TypeError('Insufficient bytes to fill elements in the given buffer')
              ReadableByteStreamControllerError(controller, e)
              return promiseRejectedWith(e)
            }
          }
          controller._pendingPullIntos.push(pullIntoDescriptor)
          const promise = ReadableStreamAddReadIntoRequest(stream)
          ReadableByteStreamControllerCallPullIfNeeded(controller)
          return promise
        }
        function ReadableByteStreamControllerRespondInClosedState (controller, firstDescriptor) {
          firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer)
          const stream = controller._controlledReadableByteStream
          if (ReadableStreamHasBYOBReader(stream) === true) {
            while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
              const pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller)
              ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor)
            }
          }
        }
        function ReadableByteStreamControllerRespondInReadableState (controller, bytesWritten, pullIntoDescriptor) {
          if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
            throw new RangeError('bytesWritten out of range')
          }
          ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor)
          if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
            return
          }
          ReadableByteStreamControllerShiftPendingPullInto(controller)
          const remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize
          if (remainderSize > 0) {
            const end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled
            const remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end)
            ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength)
          }
          pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer)
          pullIntoDescriptor.bytesFilled -= remainderSize
          ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor)
          ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller)
        }
        function ReadableByteStreamControllerRespondInternal (controller, bytesWritten) {
          const firstDescriptor = controller._pendingPullIntos.peek()
          const stream = controller._controlledReadableByteStream
          if (stream._state === 'closed') {
            if (bytesWritten !== 0) {
              throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream')
            }
            ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor)
          } else {
            ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor)
          }
          ReadableByteStreamControllerCallPullIfNeeded(controller)
        }
        function ReadableByteStreamControllerShiftPendingPullInto (controller) {
          const descriptor = controller._pendingPullIntos.shift()
          ReadableByteStreamControllerInvalidateBYOBRequest(controller)
          return descriptor
        }
        function ReadableByteStreamControllerShouldCallPull (controller) {
          const stream = controller._controlledReadableByteStream
          if (stream._state !== 'readable') {
            return false
          }
          if (controller._closeRequested === true) {
            return false
          }
          if (controller._started === false) {
            return false
          }
          if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
            return true
          }
          if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
            return true
          }
          const desiredSize = ReadableByteStreamControllerGetDesiredSize(controller)
          if (desiredSize > 0) {
            return true
          }
          return false
        }
        function ReadableByteStreamControllerClearAlgorithms (controller) {
          controller._pullAlgorithm = undefined
          controller._cancelAlgorithm = undefined
        }
        function ReadableByteStreamControllerClose (controller) {
          const stream = controller._controlledReadableByteStream
          if (controller._queueTotalSize > 0) {
            controller._closeRequested = true
            return
          }
          if (controller._pendingPullIntos.length > 0) {
            const firstPendingPullInto = controller._pendingPullIntos.peek()
            if (firstPendingPullInto.bytesFilled > 0) {
              const e = new TypeError('Insufficient bytes to fill elements in the given buffer')
              ReadableByteStreamControllerError(controller, e)
              throw e
            }
          }
          ReadableByteStreamControllerClearAlgorithms(controller)
          ReadableStreamClose(stream)
        }
        function ReadableByteStreamControllerEnqueue (controller, chunk) {
          const stream = controller._controlledReadableByteStream
          const buffer = chunk.buffer
          const byteOffset = chunk.byteOffset
          const byteLength = chunk.byteLength
          const transferredBuffer = TransferArrayBuffer(buffer)
          if (ReadableStreamHasDefaultReader(stream) === true) {
            if (ReadableStreamGetNumReadRequests(stream) === 0) {
              ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength)
            } else {
              const transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength)
              ReadableStreamFulfillReadRequest(stream, transferredView, false)
            }
          } else if (ReadableStreamHasBYOBReader(stream) === true) {
            ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength)
            ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller)
          } else {
            ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength)
          }
          ReadableByteStreamControllerCallPullIfNeeded(controller)
        }
        function ReadableByteStreamControllerError (controller, e) {
          const stream = controller._controlledReadableByteStream
          if (stream._state !== 'readable') {
            return
          }
          ReadableByteStreamControllerClearPendingPullIntos(controller)
          ResetQueue(controller)
          ReadableByteStreamControllerClearAlgorithms(controller)
          ReadableStreamError(stream, e)
        }
        function ReadableByteStreamControllerGetDesiredSize (controller) {
          const stream = controller._controlledReadableByteStream
          const state = stream._state
          if (state === 'errored') {
            return null
          }
          if (state === 'closed') {
            return 0
          }
          return controller._strategyHWM - controller._queueTotalSize
        }
        function ReadableByteStreamControllerRespond (controller, bytesWritten) {
          bytesWritten = Number(bytesWritten)
          if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
            throw new RangeError('bytesWritten must be a finite')
          }
          ReadableByteStreamControllerRespondInternal(controller, bytesWritten)
        }
        function ReadableByteStreamControllerRespondWithNewView (controller, view) {
          const firstDescriptor = controller._pendingPullIntos.peek()
          if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
            throw new RangeError('The region specified by view does not match byobRequest')
          }
          if (firstDescriptor.byteLength !== view.byteLength) {
            throw new RangeError('The buffer of view has different capacity than byobRequest')
          }
          firstDescriptor.buffer = view.buffer
          ReadableByteStreamControllerRespondInternal(controller, view.byteLength)
        }
        function SetUpReadableByteStreamController (stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize) {
          controller._controlledReadableByteStream = stream
          controller._pullAgain = false
          controller._pulling = false
          controller._byobRequest = undefined
          controller._queue = controller._queueTotalSize = undefined
          ResetQueue(controller)
          controller._closeRequested = false
          controller._started = false
          controller._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark)
          controller._pullAlgorithm = pullAlgorithm
          controller._cancelAlgorithm = cancelAlgorithm
          controller._autoAllocateChunkSize = autoAllocateChunkSize
          controller._pendingPullIntos = new SimpleQueue()
          stream._readableStreamController = controller
          const startResult = startAlgorithm()
          uponPromise(promiseResolvedWith(startResult), function () {
            controller._started = true
            ReadableByteStreamControllerCallPullIfNeeded(controller)
          }, function (r) {
            ReadableByteStreamControllerError(controller, r)
          })
        }
        function SetUpReadableByteStreamControllerFromUnderlyingSource (stream, underlyingByteSource, highWaterMark) {
          const controller = Object.create(ReadableByteStreamController.prototype)
          function startAlgorithm () {
            return InvokeOrNoop(underlyingByteSource, 'start', [controller])
          }
          const pullAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingByteSource, 'pull', 0, [controller])
          const cancelAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingByteSource, 'cancel', 1, [])
          let autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize
          if (autoAllocateChunkSize !== undefined) {
            autoAllocateChunkSize = Number(autoAllocateChunkSize)
            if (NumberIsInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
              throw new RangeError('autoAllocateChunkSize must be a positive integer')
            }
          }
          SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize)
        }
        function SetUpReadableStreamBYOBRequest (request, controller, view) {
          request._associatedReadableByteStreamController = controller
          request._view = view
        }
        function byobRequestBrandCheckException (name) {
          return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest')
        }
        function byteStreamControllerBrandCheckException (name) {
          return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController')
        }
        function AcquireReadableStreamBYOBReader (stream, forAuthorCode) {
          if (forAuthorCode === void 0) {
            forAuthorCode = false
          }
          const reader = new ReadableStreamBYOBReader(stream)
          reader._forAuthorCode = forAuthorCode
          return reader
        }
        function ReadableStreamAddReadIntoRequest (stream) {
          const promise = newPromise(function (resolve, reject) {
            const readIntoRequest = {
              _resolve: resolve,
              _reject: reject
            }
            stream._reader._readIntoRequests.push(readIntoRequest)
          })
          return promise
        }
        function ReadableStreamFulfillReadIntoRequest (stream, chunk, done) {
          const reader = stream._reader
          const readIntoRequest = reader._readIntoRequests.shift()
          readIntoRequest._resolve(ReadableStreamCreateReadResult(chunk, done, reader._forAuthorCode))
        }
        function ReadableStreamGetNumReadIntoRequests (stream) {
          return stream._reader._readIntoRequests.length
        }
        function ReadableStreamHasBYOBReader (stream) {
          const reader = stream._reader
          if (reader === undefined) {
            return false
          }
          if (!IsReadableStreamBYOBReader(reader)) {
            return false
          }
          return true
        }
        var ReadableStreamBYOBReader = (function () {
          function ReadableStreamBYOBReader (stream) {
            if (!IsReadableStream(stream)) {
              throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source')
            }
            if (IsReadableByteStreamController(stream._readableStreamController) === false) {
              throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source')
            }
            if (IsReadableStreamLocked(stream)) {
              throw new TypeError('This stream has already been locked for exclusive reading by another reader')
            }
            ReadableStreamReaderGenericInitialize(this, stream)
            this._readIntoRequests = new SimpleQueue()
          }
          Object.defineProperty(ReadableStreamBYOBReader.prototype, 'closed', {
            get: function () {
              if (!IsReadableStreamBYOBReader(this)) {
                return promiseRejectedWith(byobReaderBrandCheckException('closed'))
              }
              return this._closedPromise
            },
            enumerable: true,
            configurable: true
          })
          ReadableStreamBYOBReader.prototype.cancel = function (reason) {
            if (!IsReadableStreamBYOBReader(this)) {
              return promiseRejectedWith(byobReaderBrandCheckException('cancel'))
            }
            if (this._ownerReadableStream === undefined) {
              return promiseRejectedWith(readerLockException('cancel'))
            }
            return ReadableStreamReaderGenericCancel(this, reason)
          }
          ReadableStreamBYOBReader.prototype.read = function (view) {
            if (!IsReadableStreamBYOBReader(this)) {
              return promiseRejectedWith(byobReaderBrandCheckException('read'))
            }
            if (this._ownerReadableStream === undefined) {
              return promiseRejectedWith(readerLockException('read from'))
            }
            if (!ArrayBuffer.isView(view)) {
              return promiseRejectedWith(new TypeError('view must be an array buffer view'))
            }
            if (IsDetachedBuffer(view.buffer) === true);
            if (view.byteLength === 0) {
              return promiseRejectedWith(new TypeError('view must have non-zero byteLength'))
            }
            return ReadableStreamBYOBReaderRead(this, view)
          }
          ReadableStreamBYOBReader.prototype.releaseLock = function () {
            if (!IsReadableStreamBYOBReader(this)) {
              throw byobReaderBrandCheckException('releaseLock')
            }
            if (this._ownerReadableStream === undefined) {
              return
            }
            if (this._readIntoRequests.length > 0) {
              throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled')
            }
            ReadableStreamReaderGenericRelease(this)
          }
          return ReadableStreamBYOBReader
        }())
        function IsReadableStreamBYOBReader (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
            return false
          }
          return true
        }
        function ReadableStreamBYOBReaderRead (reader, view) {
          const stream = reader._ownerReadableStream
          stream._disturbed = true
          if (stream._state === 'errored') {
            return promiseRejectedWith(stream._storedError)
          }
          return ReadableByteStreamControllerPullInto(stream._readableStreamController, view)
        }
        function byobReaderBrandCheckException (name) {
          return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader')
        }
        const ReadableStream = (function () {
          function ReadableStream (underlyingSource, strategy) {
            if (underlyingSource === void 0) {
              underlyingSource = {}
            }
            if (strategy === void 0) {
              strategy = {}
            }
            InitializeReadableStream(this)
            const size = strategy.size
            let highWaterMark = strategy.highWaterMark
            const type = underlyingSource.type
            const typeString = String(type)
            if (typeString === 'bytes') {
              if (size !== undefined) {
                throw new RangeError('The strategy for a byte stream cannot have a size function')
              }
              if (highWaterMark === undefined) {
                highWaterMark = 0
              }
              highWaterMark = ValidateAndNormalizeHighWaterMark(highWaterMark)
              SetUpReadableByteStreamControllerFromUnderlyingSource(this, underlyingSource, highWaterMark)
            } else if (type === undefined) {
              const sizeAlgorithm = MakeSizeAlgorithmFromSizeFunction(size)
              if (highWaterMark === undefined) {
                highWaterMark = 1
              }
              highWaterMark = ValidateAndNormalizeHighWaterMark(highWaterMark)
              SetUpReadableStreamDefaultControllerFromUnderlyingSource(this, underlyingSource, highWaterMark, sizeAlgorithm)
            } else {
              throw new RangeError('Invalid type is specified')
            }
          }
          Object.defineProperty(ReadableStream.prototype, 'locked', {
            get: function () {
              if (IsReadableStream(this) === false) {
                throw streamBrandCheckException$1('locked')
              }
              return IsReadableStreamLocked(this)
            },
            enumerable: true,
            configurable: true
          })
          ReadableStream.prototype.cancel = function (reason) {
            if (IsReadableStream(this) === false) {
              return promiseRejectedWith(streamBrandCheckException$1('cancel'))
            }
            if (IsReadableStreamLocked(this) === true) {
              return promiseRejectedWith(new TypeError('Cannot cancel a stream that already has a reader'))
            }
            return ReadableStreamCancel(this, reason)
          }
          ReadableStream.prototype.getReader = function (_a) {
            let mode = (_a === void 0 ? {} : _a).mode
            if (IsReadableStream(this) === false) {
              throw streamBrandCheckException$1('getReader')
            }
            if (mode === undefined) {
              return AcquireReadableStreamDefaultReader(this, true)
            }
            mode = String(mode)
            if (mode === 'byob') {
              return AcquireReadableStreamBYOBReader(this, true)
            }
            throw new RangeError('Invalid mode is specified')
          }
          ReadableStream.prototype.pipeThrough = function (_a, _b) {
            const writable = _a.writable; const readable = _a.readable
            const _c = _b === void 0 ? {} : _b; let preventClose = _c.preventClose; let preventAbort = _c.preventAbort; let preventCancel = _c.preventCancel; const signal = _c.signal
            if (IsReadableStream(this) === false) {
              throw streamBrandCheckException$1('pipeThrough')
            }
            if (IsWritableStream(writable) === false) {
              throw new TypeError('writable argument to pipeThrough must be a WritableStream')
            }
            if (IsReadableStream(readable) === false) {
              throw new TypeError('readable argument to pipeThrough must be a ReadableStream')
            }
            preventClose = Boolean(preventClose)
            preventAbort = Boolean(preventAbort)
            preventCancel = Boolean(preventCancel)
            if (signal !== undefined && !isAbortSignal(signal)) {
              throw new TypeError('ReadableStream.prototype.pipeThrough\'s signal option must be an AbortSignal')
            }
            if (IsReadableStreamLocked(this) === true) {
              throw new TypeError('ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream')
            }
            if (IsWritableStreamLocked(writable) === true) {
              throw new TypeError('ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream')
            }
            const promise = ReadableStreamPipeTo(this, writable, preventClose, preventAbort, preventCancel, signal)
            setPromiseIsHandledToTrue(promise)
            return readable
          }
          ReadableStream.prototype.pipeTo = function (dest, _a) {
            const _b = _a === void 0 ? {} : _a; let preventClose = _b.preventClose; let preventAbort = _b.preventAbort; let preventCancel = _b.preventCancel; const signal = _b.signal
            if (IsReadableStream(this) === false) {
              return promiseRejectedWith(streamBrandCheckException$1('pipeTo'))
            }
            if (IsWritableStream(dest) === false) {
              return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'))
            }
            preventClose = Boolean(preventClose)
            preventAbort = Boolean(preventAbort)
            preventCancel = Boolean(preventCancel)
            if (signal !== undefined && !isAbortSignal(signal)) {
              return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo\'s signal option must be an AbortSignal'))
            }
            if (IsReadableStreamLocked(this) === true) {
              return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'))
            }
            if (IsWritableStreamLocked(dest) === true) {
              return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'))
            }
            return ReadableStreamPipeTo(this, dest, preventClose, preventAbort, preventCancel, signal)
          }
          ReadableStream.prototype.tee = function () {
            if (IsReadableStream(this) === false) {
              throw streamBrandCheckException$1('tee')
            }
            const branches = ReadableStreamTee(this)
            return createArrayFromList(branches)
          }
          ReadableStream.prototype.getIterator = function (_a) {
            const _b = (_a === void 0 ? {} : _a).preventCancel; const preventCancel = _b === void 0 ? false : _b
            if (IsReadableStream(this) === false) {
              throw streamBrandCheckException$1('getIterator')
            }
            return AcquireReadableStreamAsyncIterator(this, preventCancel)
          }
          return ReadableStream
        }())
        if (typeof SymbolPolyfill.asyncIterator === 'symbol') {
          Object.defineProperty(ReadableStream.prototype, SymbolPolyfill.asyncIterator, {
            value: ReadableStream.prototype.getIterator,
            enumerable: false,
            writable: true,
            configurable: true
          })
        }
        function CreateReadableStream (startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
          if (highWaterMark === void 0) {
            highWaterMark = 1
          }
          if (sizeAlgorithm === void 0) {
            sizeAlgorithm = function () {
              return 1
            }
          }
          const stream = Object.create(ReadableStream.prototype)
          InitializeReadableStream(stream)
          const controller = Object.create(ReadableStreamDefaultController.prototype)
          SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm)
          return stream
        }
        function InitializeReadableStream (stream) {
          stream._state = 'readable'
          stream._reader = undefined
          stream._storedError = undefined
          stream._disturbed = false
        }
        function IsReadableStream (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
            return false
          }
          return true
        }
        function IsReadableStreamLocked (stream) {
          if (stream._reader === undefined) {
            return false
          }
          return true
        }
        function ReadableStreamCancel (stream, reason) {
          stream._disturbed = true
          if (stream._state === 'closed') {
            return promiseResolvedWith(undefined)
          }
          if (stream._state === 'errored') {
            return promiseRejectedWith(stream._storedError)
          }
          ReadableStreamClose(stream)
          const sourceCancelPromise = stream._readableStreamController[CancelSteps](reason)
          return transformPromiseWith(sourceCancelPromise, noop)
        }
        function ReadableStreamClose (stream) {
          stream._state = 'closed'
          const reader = stream._reader
          if (reader === undefined) {
            return
          }
          if (IsReadableStreamDefaultReader(reader)) {
            reader._readRequests.forEach(function (readRequest) {
              readRequest._resolve(ReadableStreamCreateReadResult(undefined, true, reader._forAuthorCode))
            })
            reader._readRequests = new SimpleQueue()
          }
          defaultReaderClosedPromiseResolve(reader)
        }
        function ReadableStreamError (stream, e) {
          stream._state = 'errored'
          stream._storedError = e
          const reader = stream._reader
          if (reader === undefined) {
            return
          }
          if (IsReadableStreamDefaultReader(reader)) {
            reader._readRequests.forEach(function (readRequest) {
              readRequest._reject(e)
            })
            reader._readRequests = new SimpleQueue()
          } else {
            reader._readIntoRequests.forEach(function (readIntoRequest) {
              readIntoRequest._reject(e)
            })
            reader._readIntoRequests = new SimpleQueue()
          }
          defaultReaderClosedPromiseReject(reader, e)
        }
        function streamBrandCheckException$1 (name) {
          return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream')
        }
        const ByteLengthQueuingStrategy = (function () {
          function ByteLengthQueuingStrategy (_a) {
            const highWaterMark = _a.highWaterMark
            this.highWaterMark = highWaterMark
          }
          ByteLengthQueuingStrategy.prototype.size = function (chunk) {
            return chunk.byteLength
          }
          return ByteLengthQueuingStrategy
        }())
        const CountQueuingStrategy = (function () {
          function CountQueuingStrategy (_a) {
            const highWaterMark = _a.highWaterMark
            this.highWaterMark = highWaterMark
          }
          CountQueuingStrategy.prototype.size = function () {
            return 1
          }
          return CountQueuingStrategy
        }())
        const TransformStream = (function () {
          function TransformStream (transformer, writableStrategy, readableStrategy) {
            if (transformer === void 0) {
              transformer = {}
            }
            if (writableStrategy === void 0) {
              writableStrategy = {}
            }
            if (readableStrategy === void 0) {
              readableStrategy = {}
            }
            const writableSizeFunction = writableStrategy.size
            let writableHighWaterMark = writableStrategy.highWaterMark
            const readableSizeFunction = readableStrategy.size
            let readableHighWaterMark = readableStrategy.highWaterMark
            const writableType = transformer.writableType
            if (writableType !== undefined) {
              throw new RangeError('Invalid writable type specified')
            }
            const writableSizeAlgorithm = MakeSizeAlgorithmFromSizeFunction(writableSizeFunction)
            if (writableHighWaterMark === undefined) {
              writableHighWaterMark = 1
            }
            writableHighWaterMark = ValidateAndNormalizeHighWaterMark(writableHighWaterMark)
            const readableType = transformer.readableType
            if (readableType !== undefined) {
              throw new RangeError('Invalid readable type specified')
            }
            const readableSizeAlgorithm = MakeSizeAlgorithmFromSizeFunction(readableSizeFunction)
            if (readableHighWaterMark === undefined) {
              readableHighWaterMark = 0
            }
            readableHighWaterMark = ValidateAndNormalizeHighWaterMark(readableHighWaterMark)
            let startPromise_resolve
            const startPromise = newPromise(function (resolve) {
              startPromise_resolve = resolve
            })
            InitializeTransformStream(this, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm)
            SetUpTransformStreamDefaultControllerFromTransformer(this, transformer)
            const startResult = InvokeOrNoop(transformer, 'start', [this._transformStreamController])
            startPromise_resolve(startResult)
          }
          Object.defineProperty(TransformStream.prototype, 'readable', {
            get: function () {
              if (IsTransformStream(this) === false) {
                throw streamBrandCheckException$2('readable')
              }
              return this._readable
            },
            enumerable: true,
            configurable: true
          })
          Object.defineProperty(TransformStream.prototype, 'writable', {
            get: function () {
              if (IsTransformStream(this) === false) {
                throw streamBrandCheckException$2('writable')
              }
              return this._writable
            },
            enumerable: true,
            configurable: true
          })
          return TransformStream
        }())
        function InitializeTransformStream (stream, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm) {
          function startAlgorithm () {
            return startPromise
          }
          function writeAlgorithm (chunk) {
            return TransformStreamDefaultSinkWriteAlgorithm(stream, chunk)
          }
          function abortAlgorithm (reason) {
            return TransformStreamDefaultSinkAbortAlgorithm(stream, reason)
          }
          function closeAlgorithm () {
            return TransformStreamDefaultSinkCloseAlgorithm(stream)
          }
          stream._writable = CreateWritableStream(startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, writableHighWaterMark, writableSizeAlgorithm)
          function pullAlgorithm () {
            return TransformStreamDefaultSourcePullAlgorithm(stream)
          }
          function cancelAlgorithm (reason) {
            TransformStreamErrorWritableAndUnblockWrite(stream, reason)
            return promiseResolvedWith(undefined)
          }
          stream._readable = CreateReadableStream(startAlgorithm, pullAlgorithm, cancelAlgorithm, readableHighWaterMark, readableSizeAlgorithm)
          stream._backpressure = undefined
          stream._backpressureChangePromise = undefined
          stream._backpressureChangePromise_resolve = undefined
          TransformStreamSetBackpressure(stream, true)
          stream._transformStreamController = undefined
        }
        function IsTransformStream (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
            return false
          }
          return true
        }
        function TransformStreamError (stream, e) {
          ReadableStreamDefaultControllerError(stream._readable._readableStreamController, e)
          TransformStreamErrorWritableAndUnblockWrite(stream, e)
        }
        function TransformStreamErrorWritableAndUnblockWrite (stream, e) {
          TransformStreamDefaultControllerClearAlgorithms(stream._transformStreamController)
          WritableStreamDefaultControllerErrorIfNeeded(stream._writable._writableStreamController, e)
          if (stream._backpressure === true) {
            TransformStreamSetBackpressure(stream, false)
          }
        }
        function TransformStreamSetBackpressure (stream, backpressure) {
          if (stream._backpressureChangePromise !== undefined) {
            stream._backpressureChangePromise_resolve()
          }
          stream._backpressureChangePromise = newPromise(function (resolve) {
            stream._backpressureChangePromise_resolve = resolve
          })
          stream._backpressure = backpressure
        }
        const TransformStreamDefaultController = (function () {
          function TransformStreamDefaultController () {
            throw new TypeError('TransformStreamDefaultController instances cannot be created directly')
          }
          Object.defineProperty(TransformStreamDefaultController.prototype, 'desiredSize', {
            get: function () {
              if (IsTransformStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException$1('desiredSize')
              }
              const readableController = this._controlledTransformStream._readable._readableStreamController
              return ReadableStreamDefaultControllerGetDesiredSize(readableController)
            },
            enumerable: true,
            configurable: true
          })
          TransformStreamDefaultController.prototype.enqueue = function (chunk) {
            if (IsTransformStreamDefaultController(this) === false) {
              throw defaultControllerBrandCheckException$1('enqueue')
            }
            TransformStreamDefaultControllerEnqueue(this, chunk)
          }
          TransformStreamDefaultController.prototype.error = function (reason) {
            if (IsTransformStreamDefaultController(this) === false) {
              throw defaultControllerBrandCheckException$1('error')
            }
            TransformStreamDefaultControllerError(this, reason)
          }
          TransformStreamDefaultController.prototype.terminate = function () {
            if (IsTransformStreamDefaultController(this) === false) {
              throw defaultControllerBrandCheckException$1('terminate')
            }
            TransformStreamDefaultControllerTerminate(this)
          }
          return TransformStreamDefaultController
        }())
        function IsTransformStreamDefaultController (x) {
          if (!typeIsObject(x)) {
            return false
          }
          if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
            return false
          }
          return true
        }
        function SetUpTransformStreamDefaultController (stream, controller, transformAlgorithm, flushAlgorithm) {
          controller._controlledTransformStream = stream
          stream._transformStreamController = controller
          controller._transformAlgorithm = transformAlgorithm
          controller._flushAlgorithm = flushAlgorithm
        }
        function SetUpTransformStreamDefaultControllerFromTransformer (stream, transformer) {
          const controller = Object.create(TransformStreamDefaultController.prototype)
          let transformAlgorithm = function (chunk) {
            try {
              TransformStreamDefaultControllerEnqueue(controller, chunk)
              return promiseResolvedWith(undefined)
            } catch (transformResultE) {
              return promiseRejectedWith(transformResultE)
            }
          }
          const transformMethod = transformer.transform
          if (transformMethod !== undefined) {
            if (typeof transformMethod !== 'function') {
              throw new TypeError('transform is not a method')
            }
            transformAlgorithm = function (chunk) {
              return PromiseCall(transformMethod, transformer, [
                chunk,
                controller
              ])
            }
          }
          const flushAlgorithm = CreateAlgorithmFromUnderlyingMethod(transformer, 'flush', 0, [controller])
          SetUpTransformStreamDefaultController(stream, controller, transformAlgorithm, flushAlgorithm)
        }
        function TransformStreamDefaultControllerClearAlgorithms (controller) {
          controller._transformAlgorithm = undefined
          controller._flushAlgorithm = undefined
        }
        function TransformStreamDefaultControllerEnqueue (controller, chunk) {
          const stream = controller._controlledTransformStream
          const readableController = stream._readable._readableStreamController
          if (ReadableStreamDefaultControllerCanCloseOrEnqueue(readableController) === false) {
            throw new TypeError('Readable side is not in a state that permits enqueue')
          }
          try {
            ReadableStreamDefaultControllerEnqueue(readableController, chunk)
          } catch (e) {
            TransformStreamErrorWritableAndUnblockWrite(stream, e)
            throw stream._readable._storedError
          }
          const backpressure = ReadableStreamDefaultControllerHasBackpressure(readableController)
          if (backpressure !== stream._backpressure) {
            TransformStreamSetBackpressure(stream, true)
          }
        }
        function TransformStreamDefaultControllerError (controller, e) {
          TransformStreamError(controller._controlledTransformStream, e)
        }
        function TransformStreamDefaultControllerPerformTransform (controller, chunk) {
          const transformPromise = controller._transformAlgorithm(chunk)
          return transformPromiseWith(transformPromise, undefined, function (r) {
            TransformStreamError(controller._controlledTransformStream, r)
            throw r
          })
        }
        function TransformStreamDefaultControllerTerminate (controller) {
          const stream = controller._controlledTransformStream
          const readableController = stream._readable._readableStreamController
          if (ReadableStreamDefaultControllerCanCloseOrEnqueue(readableController) === true) {
            ReadableStreamDefaultControllerClose(readableController)
          }
          const error = new TypeError('TransformStream terminated')
          TransformStreamErrorWritableAndUnblockWrite(stream, error)
        }
        function TransformStreamDefaultSinkWriteAlgorithm (stream, chunk) {
          const controller = stream._transformStreamController
          if (stream._backpressure === true) {
            const backpressureChangePromise = stream._backpressureChangePromise
            return transformPromiseWith(backpressureChangePromise, function () {
              const writable = stream._writable
              const state = writable._state
              if (state === 'erroring') {
                throw writable._storedError
              }
              return TransformStreamDefaultControllerPerformTransform(controller, chunk)
            })
          }
          return TransformStreamDefaultControllerPerformTransform(controller, chunk)
        }
        function TransformStreamDefaultSinkAbortAlgorithm (stream, reason) {
          TransformStreamError(stream, reason)
          return promiseResolvedWith(undefined)
        }
        function TransformStreamDefaultSinkCloseAlgorithm (stream) {
          const readable = stream._readable
          const controller = stream._transformStreamController
          const flushPromise = controller._flushAlgorithm()
          TransformStreamDefaultControllerClearAlgorithms(controller)
          return transformPromiseWith(flushPromise, function () {
            if (readable._state === 'errored') {
              throw readable._storedError
            }
            const readableController = readable._readableStreamController
            if (ReadableStreamDefaultControllerCanCloseOrEnqueue(readableController) === true) {
              ReadableStreamDefaultControllerClose(readableController)
            }
          }, function (r) {
            TransformStreamError(stream, r)
            throw readable._storedError
          })
        }
        function TransformStreamDefaultSourcePullAlgorithm (stream) {
          TransformStreamSetBackpressure(stream, false)
          return stream._backpressureChangePromise
        }
        function defaultControllerBrandCheckException$1 (name) {
          return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController')
        }
        function streamBrandCheckException$2 (name) {
          return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream')
        }
        exports.ByteLengthQueuingStrategy = ByteLengthQueuingStrategy
        exports.CountQueuingStrategy = CountQueuingStrategy
        exports.ReadableStream = ReadableStream
        exports.TransformStream = TransformStream
        exports.WritableStream = WritableStream
        Object.defineProperty(exports, '__esModule', { value: true })
      }))
      /***/ },
    /* 136 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(137)
      __w_pdfjs_require__(105)
      __w_pdfjs_require__(73)
      __w_pdfjs_require__(107)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Map
      /***/ },
    /* 137 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const collection = __w_pdfjs_require__(138)
      const collectionStrong = __w_pdfjs_require__(142)
      module.exports = collection('Map', function (init) {
        return function Map () {
          return init(this, arguments.length ? arguments[0] : undefined)
        }
      }, collectionStrong)
      /***/ },
    /* 138 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const global = __w_pdfjs_require__(6)
      const isForced = __w_pdfjs_require__(47)
      const redefine = __w_pdfjs_require__(24)
      const InternalMetadataModule = __w_pdfjs_require__(139)
      const iterate = __w_pdfjs_require__(115)
      const anInstance = __w_pdfjs_require__(114)
      const isObject = __w_pdfjs_require__(17)
      const fails = __w_pdfjs_require__(9)
      const checkCorrectnessOfIteration = __w_pdfjs_require__(93)
      const setToStringTag = __w_pdfjs_require__(81)
      const inheritIfRequired = __w_pdfjs_require__(141)
      module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
        const IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1
        const IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1
        const ADDER = IS_MAP ? 'set' : 'add'
        const NativeConstructor = global[CONSTRUCTOR_NAME]
        const NativePrototype = NativeConstructor && NativeConstructor.prototype
        let Constructor = NativeConstructor
        const exported = {}
        const fixMethod = function (KEY) {
          const nativeMethod = NativePrototype[KEY]
          redefine(NativePrototype, KEY, KEY == 'add'
            ? function add (value) {
              nativeMethod.call(this, value === 0 ? 0 : value)
              return this
            }
            : KEY == 'delete'
              ? function (key) {
                return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key)
              }
              : KEY == 'get'
                ? function get (key) {
                  return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key)
                }
                : KEY == 'has'
                  ? function has (key) {
                    return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key)
                  }
                  : function set (key, value) {
                    nativeMethod.call(this, key === 0 ? 0 : key, value)
                    return this
                  })
        }
        if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor !== 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
          new NativeConstructor().entries().next()
        })))) {
          Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER)
          InternalMetadataModule.REQUIRED = true
        } else if (isForced(CONSTRUCTOR_NAME, true)) {
          const instance = new Constructor()
          const HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
          const THROWS_ON_PRIMITIVES = fails(function () {
            instance.has(1)
          })
          const ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) {
            new NativeConstructor(iterable)
          })
          const BUGGY_ZERO = !IS_WEAK && fails(function () {
            const $instance = new NativeConstructor()
            let index = 5
            while (index--) { $instance[ADDER](index, index) }
            return !$instance.has(-0)
          })
          if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function (dummy, iterable) {
              anInstance(dummy, Constructor, CONSTRUCTOR_NAME)
              const that = inheritIfRequired(new NativeConstructor(), dummy, Constructor)
              if (iterable != undefined) { iterate(iterable, that[ADDER], that, IS_MAP) }
              return that
            })
            Constructor.prototype = NativePrototype
            NativePrototype.constructor = Constructor
          }
          if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete')
            fixMethod('has')
            IS_MAP && fixMethod('get')
          }
          if (BUGGY_ZERO || HASNT_CHAINING) { fixMethod(ADDER) }
          if (IS_WEAK && NativePrototype.clear) { delete NativePrototype.clear }
        }
        exported[CONSTRUCTOR_NAME] = Constructor
        $({
          global: true,
          forced: Constructor != NativeConstructor
        }, exported)
        setToStringTag(Constructor, CONSTRUCTOR_NAME)
        if (!IS_WEAK) { common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP) }
        return Constructor
      }
      /***/ },
    /* 139 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const hiddenKeys = __w_pdfjs_require__(34)
      const isObject = __w_pdfjs_require__(17)
      const has = __w_pdfjs_require__(18)
      const defineProperty = __w_pdfjs_require__(22).f
      const uid = __w_pdfjs_require__(33)
      const FREEZING = __w_pdfjs_require__(140)
      const METADATA = uid('meta')
      let id = 0
      const isExtensible = Object.isExtensible || function () {
        return true
      }
      const setMetadata = function (it) {
        defineProperty(it, METADATA, {
          value: {
            objectID: 'O' + ++id,
            weakData: {}
          }
        })
      }
      const fastKey = function (it, create) {
        if (!isObject(it)) { return typeof it === 'symbol' ? it : (typeof it === 'string' ? 'S' : 'P') + it }
        if (!has(it, METADATA)) {
          if (!isExtensible(it)) { return 'F' }
          if (!create) { return 'E' }
          setMetadata(it)
        }
        return it[METADATA].objectID
      }
      const getWeakData = function (it, create) {
        if (!has(it, METADATA)) {
          if (!isExtensible(it)) { return true }
          if (!create) { return false }
          setMetadata(it)
        }
        return it[METADATA].weakData
      }
      const onFreeze = function (it) {
        if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) { setMetadata(it) }
        return it
      }
      var meta = module.exports = {
        REQUIRED: false,
        fastKey: fastKey,
        getWeakData: getWeakData,
        onFreeze: onFreeze
      }
      hiddenKeys[METADATA] = true
      /***/ },
    /* 140 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const fails = __w_pdfjs_require__(9)
      module.exports = !fails(function () {
        return Object.isExtensible(Object.preventExtensions({}))
      })
      /***/ },
    /* 141 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const isObject = __w_pdfjs_require__(17)
      const setPrototypeOf = __w_pdfjs_require__(83)
      module.exports = function ($this, dummy, Wrapper) {
        let NewTarget, NewTargetPrototype
        if (setPrototypeOf && typeof (NewTarget = dummy.constructor) === 'function' && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) { setPrototypeOf($this, NewTargetPrototype) }
        return $this
      }
      /***/ },
    /* 142 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const defineProperty = __w_pdfjs_require__(22).f
      const create = __w_pdfjs_require__(67)
      const redefineAll = __w_pdfjs_require__(112)
      const bind = __w_pdfjs_require__(58)
      const anInstance = __w_pdfjs_require__(114)
      const iterate = __w_pdfjs_require__(115)
      const defineIterator = __w_pdfjs_require__(75)
      const setSpecies = __w_pdfjs_require__(113)
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const fastKey = __w_pdfjs_require__(139).fastKey
      const InternalStateModule = __w_pdfjs_require__(28)
      const setInternalState = InternalStateModule.set
      const internalStateGetterFor = InternalStateModule.getterFor
      module.exports = {
        getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, CONSTRUCTOR_NAME)
            setInternalState(that, {
              type: CONSTRUCTOR_NAME,
              index: create(null),
              first: undefined,
              last: undefined,
              size: 0
            })
            if (!DESCRIPTORS) { that.size = 0 }
            if (iterable != undefined) { iterate(iterable, that[ADDER], that, IS_MAP) }
          })
          const getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME)
          const define = function (that, key, value) {
            const state = getInternalState(that)
            let entry = getEntry(that, key)
            let previous, index
            if (entry) {
              entry.value = value
            } else {
              state.last = entry = {
                index: index = fastKey(key, true),
                key: key,
                value: value,
                previous: previous = state.last,
                next: undefined,
                removed: false
              }
              if (!state.first) { state.first = entry }
              if (previous) { previous.next = entry }
              if (DESCRIPTORS) { state.size++ } else { that.size++ }
              if (index !== 'F') { state.index[index] = entry }
            }
            return that
          }
          var getEntry = function (that, key) {
            const state = getInternalState(that)
            const index = fastKey(key)
            let entry
            if (index !== 'F') { return state.index[index] }
            for (entry = state.first; entry; entry = entry.next) {
              if (entry.key == key) { return entry }
            }
          }
          redefineAll(C.prototype, {
            clear: function clear () {
              const that = this
              const state = getInternalState(that)
              const data = state.index
              let entry = state.first
              while (entry) {
                entry.removed = true
                if (entry.previous) { entry.previous = entry.previous.next = undefined }
                delete data[entry.index]
                entry = entry.next
              }
              state.first = state.last = undefined
              if (DESCRIPTORS) { state.size = 0 } else { that.size = 0 }
            },
            delete: function (key) {
              const that = this
              const state = getInternalState(that)
              const entry = getEntry(that, key)
              if (entry) {
                const next = entry.next
                const prev = entry.previous
                delete state.index[entry.index]
                entry.removed = true
                if (prev) { prev.next = next }
                if (next) { next.previous = prev }
                if (state.first == entry) { state.first = next }
                if (state.last == entry) { state.last = prev }
                if (DESCRIPTORS) { state.size-- } else { that.size-- }
              }
              return !!entry
            },
            forEach: function forEach (callbackfn) {
              const state = getInternalState(this)
              const boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
              let entry
              while (entry = entry ? entry.next : state.first) {
                boundFunction(entry.value, entry.key, this)
                while (entry && entry.removed) { entry = entry.previous }
              }
            },
            has: function has (key) {
              return !!getEntry(this, key)
            }
          })
          redefineAll(C.prototype, IS_MAP
            ? {
                get: function get (key) {
                  const entry = getEntry(this, key)
                  return entry && entry.value
                },
                set: function set (key, value) {
                  return define(this, key === 0 ? 0 : key, value)
                }
              }
            : {
                add: function add (value) {
                  return define(this, value = value === 0 ? 0 : value, value)
                }
              })
          if (DESCRIPTORS) {
            defineProperty(C.prototype, 'size', {
              get: function () {
                return getInternalState(this).size
              }
            })
          }
          return C
        },
        setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
          const ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator'
          const getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME)
          const getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME)
          defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
            setInternalState(this, {
              type: ITERATOR_NAME,
              target: iterated,
              state: getInternalCollectionState(iterated),
              kind: kind,
              last: undefined
            })
          }, function () {
            const state = getInternalIteratorState(this)
            const kind = state.kind
            let entry = state.last
            while (entry && entry.removed) { entry = entry.previous }
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
              state.target = undefined
              return {
                value: undefined,
                done: true
              }
            }
            if (kind == 'keys') {
              return {
                value: entry.key,
                done: false
              }
            }
            if (kind == 'values') {
              return {
                value: entry.value,
                done: false
              }
            }
            return {
              value: [
                entry.key,
                entry.value
              ],
              done: false
            }
          }, IS_MAP ? 'entries' : 'values', !IS_MAP, true)
          setSpecies(CONSTRUCTOR_NAME)
        }
      }
      /***/ },
    /* 143 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(144)
      __w_pdfjs_require__(105)
      __w_pdfjs_require__(73)
      __w_pdfjs_require__(107)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Set
      /***/ },
    /* 144 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const collection = __w_pdfjs_require__(138)
      const collectionStrong = __w_pdfjs_require__(142)
      module.exports = collection('Set', function (init) {
        return function Set () {
          return init(this, arguments.length ? arguments[0] : undefined)
        }
      }, collectionStrong)
      /***/ },
    /* 145 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(105)
      __w_pdfjs_require__(146)
      __w_pdfjs_require__(107)
      const path = __w_pdfjs_require__(38)
      module.exports = path.WeakMap
      /***/ },
    /* 146 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const global = __w_pdfjs_require__(6)
      const redefineAll = __w_pdfjs_require__(112)
      const InternalMetadataModule = __w_pdfjs_require__(139)
      const collection = __w_pdfjs_require__(138)
      const collectionWeak = __w_pdfjs_require__(147)
      const isObject = __w_pdfjs_require__(17)
      const enforceIternalState = __w_pdfjs_require__(28).enforce
      const NATIVE_WEAK_MAP = __w_pdfjs_require__(29)
      const IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global
      const isExtensible = Object.isExtensible
      let InternalWeakMap
      const wrapper = function (init) {
        return function WeakMap () {
          return init(this, arguments.length ? arguments[0] : undefined)
        }
      }
      const $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak)
      if (NATIVE_WEAK_MAP && IS_IE11) {
        InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true)
        InternalMetadataModule.REQUIRED = true
        const WeakMapPrototype = $WeakMap.prototype
        const nativeDelete = WeakMapPrototype.delete
        const nativeHas = WeakMapPrototype.has
        const nativeGet = WeakMapPrototype.get
        const nativeSet = WeakMapPrototype.set
        redefineAll(WeakMapPrototype, {
          delete: function (key) {
            if (isObject(key) && !isExtensible(key)) {
              const state = enforceIternalState(this)
              if (!state.frozen) { state.frozen = new InternalWeakMap() }
              return nativeDelete.call(this, key) || state.frozen.delete(key)
            }
            return nativeDelete.call(this, key)
          },
          has: function has (key) {
            if (isObject(key) && !isExtensible(key)) {
              const state = enforceIternalState(this)
              if (!state.frozen) { state.frozen = new InternalWeakMap() }
              return nativeHas.call(this, key) || state.frozen.has(key)
            }
            return nativeHas.call(this, key)
          },
          get: function get (key) {
            if (isObject(key) && !isExtensible(key)) {
              const state = enforceIternalState(this)
              if (!state.frozen) { state.frozen = new InternalWeakMap() }
              return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key)
            }
            return nativeGet.call(this, key)
          },
          set: function set (key, value) {
            if (isObject(key) && !isExtensible(key)) {
              const state = enforceIternalState(this)
              if (!state.frozen) { state.frozen = new InternalWeakMap() }
              nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value)
            } else { nativeSet.call(this, key, value) }
            return this
          }
        })
      }
      /***/ },
    /* 147 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const redefineAll = __w_pdfjs_require__(112)
      const getWeakData = __w_pdfjs_require__(139).getWeakData
      const anObject = __w_pdfjs_require__(23)
      const isObject = __w_pdfjs_require__(17)
      const anInstance = __w_pdfjs_require__(114)
      const iterate = __w_pdfjs_require__(115)
      const ArrayIterationModule = __w_pdfjs_require__(148)
      const $has = __w_pdfjs_require__(18)
      const InternalStateModule = __w_pdfjs_require__(28)
      const setInternalState = InternalStateModule.set
      const internalStateGetterFor = InternalStateModule.getterFor
      const find = ArrayIterationModule.find
      const findIndex = ArrayIterationModule.findIndex
      let id = 0
      const uncaughtFrozenStore = function (store) {
        return store.frozen || (store.frozen = new UncaughtFrozenStore())
      }
      var UncaughtFrozenStore = function () {
        this.entries = []
      }
      const findUncaughtFrozen = function (store, key) {
        return find(store.entries, function (it) {
          return it[0] === key
        })
      }
      UncaughtFrozenStore.prototype = {
        get: function (key) {
          const entry = findUncaughtFrozen(this, key)
          if (entry) { return entry[1] }
        },
        has: function (key) {
          return !!findUncaughtFrozen(this, key)
        },
        set: function (key, value) {
          const entry = findUncaughtFrozen(this, key)
          if (entry) { entry[1] = value } else {
            this.entries.push([
              key,
              value
            ])
          }
        },
        delete: function (key) {
          const index = findIndex(this.entries, function (it) {
            return it[0] === key
          })
          if (~index) { this.entries.splice(index, 1) }
          return !!~index
        }
      }
      module.exports = {
        getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, CONSTRUCTOR_NAME)
            setInternalState(that, {
              type: CONSTRUCTOR_NAME,
              id: id++,
              frozen: undefined
            })
            if (iterable != undefined) { iterate(iterable, that[ADDER], that, IS_MAP) }
          })
          const getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME)
          const define = function (that, key, value) {
            const state = getInternalState(that)
            const data = getWeakData(anObject(key), true)
            if (data === true) { uncaughtFrozenStore(state).set(key, value) } else { data[state.id] = value }
            return that
          }
          redefineAll(C.prototype, {
            delete: function (key) {
              const state = getInternalState(this)
              if (!isObject(key)) { return false }
              const data = getWeakData(key)
              if (data === true) { return uncaughtFrozenStore(state).delete(key) }
              return data && $has(data, state.id) && delete data[state.id]
            },
            has: function has (key) {
              const state = getInternalState(this)
              if (!isObject(key)) { return false }
              const data = getWeakData(key)
              if (data === true) { return uncaughtFrozenStore(state).has(key) }
              return data && $has(data, state.id)
            }
          })
          redefineAll(C.prototype, IS_MAP
            ? {
                get: function get (key) {
                  const state = getInternalState(this)
                  if (isObject(key)) {
                    const data = getWeakData(key)
                    if (data === true) { return uncaughtFrozenStore(state).get(key) }
                    return data ? data[state.id] : undefined
                  }
                },
                set: function set (key, value) {
                  return define(this, key, value)
                }
              }
            : {
                add: function add (value) {
                  return define(this, value, true)
                }
              })
          return C
        }
      }
      /***/ },
    /* 148 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const bind = __w_pdfjs_require__(58)
      const IndexedObject = __w_pdfjs_require__(13)
      const toObject = __w_pdfjs_require__(79)
      const toLength = __w_pdfjs_require__(42)
      const arraySpeciesCreate = __w_pdfjs_require__(149)
      const push = [].push
      const createMethod = function (TYPE) {
        const IS_MAP = TYPE == 1
        const IS_FILTER = TYPE == 2
        const IS_SOME = TYPE == 3
        const IS_EVERY = TYPE == 4
        const IS_FIND_INDEX = TYPE == 6
        const NO_HOLES = TYPE == 5 || IS_FIND_INDEX
        return function ($this, callbackfn, that, specificCreate) {
          const O = toObject($this)
          const self = IndexedObject(O)
          const boundFunction = bind(callbackfn, that, 3)
          const length = toLength(self.length)
          let index = 0
          const create = specificCreate || arraySpeciesCreate
          const target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
          let value, result
          for (; length > index; index++) {
            if (NO_HOLES || index in self) {
              value = self[index]
              result = boundFunction(value, index, O)
              if (TYPE) {
                if (IS_MAP) { target[index] = result } else if (result) {
                  switch (TYPE) {
                    case 3:
                      return true
                    case 5:
                      return value
                    case 6:
                      return index
                    case 2:
                      push.call(target, value)
                  }
                } else if (IS_EVERY) { return false }
              }
            }
          }
          return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target
        }
      }
      module.exports = {
        forEach: createMethod(0),
        map: createMethod(1),
        filter: createMethod(2),
        some: createMethod(3),
        every: createMethod(4),
        find: createMethod(5),
        findIndex: createMethod(6)
      }
      /***/ },
    /* 149 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const isObject = __w_pdfjs_require__(17)
      const isArray = __w_pdfjs_require__(150)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const SPECIES = wellKnownSymbol('species')
      module.exports = function (originalArray, length) {
        let C
        if (isArray(originalArray)) {
          C = originalArray.constructor
          if (typeof C === 'function' && (C === Array || isArray(C.prototype))) { C = undefined } else if (isObject(C)) {
            C = C[SPECIES]
            if (C === null) { C = undefined }
          }
        }
        return new (C === undefined ? Array : C)(length === 0 ? 0 : length)
      }
      /***/ },
    /* 150 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const classof = __w_pdfjs_require__(14)
      module.exports = Array.isArray || function isArray (arg) {
        return classof(arg) == 'Array'
      }
      /***/ },
    /* 151 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(105)
      __w_pdfjs_require__(152)
      __w_pdfjs_require__(107)
      const path = __w_pdfjs_require__(38)
      module.exports = path.WeakSet
      /***/ },
    /* 152 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const collection = __w_pdfjs_require__(138)
      const collectionWeak = __w_pdfjs_require__(147)
      collection('WeakSet', function (init) {
        return function WeakSet () {
          return init(this, arguments.length ? arguments[0] : undefined)
        }
      }, collectionWeak)
      /***/ },
    /* 153 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(154)
      const entryUnbind = __w_pdfjs_require__(57)
      module.exports = entryUnbind('String', 'codePointAt')
      /***/ },
    /* 154 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const codeAt = __w_pdfjs_require__(74).codeAt
      $({
        target: 'String',
        proto: true
      }, {
        codePointAt: function codePointAt (pos) {
          return codeAt(this, pos)
        }
      })
      /***/ },
    /* 155 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(156)
      const path = __w_pdfjs_require__(38)
      module.exports = path.String.fromCodePoint
      /***/ },
    /* 156 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const $ = __w_pdfjs_require__(5)
      const toAbsoluteIndex = __w_pdfjs_require__(44)
      const fromCharCode = String.fromCharCode
      const nativeFromCodePoint = String.fromCodePoint
      const INCORRECT_LENGTH = !!nativeFromCodePoint && nativeFromCodePoint.length != 1
      $({
        target: 'String',
        stat: true,
        forced: INCORRECT_LENGTH
      }, {
        fromCodePoint: function fromCodePoint (x) {
          const elements = []
          const length = arguments.length
          let i = 0
          let code
          while (length > i) {
            code = +arguments[i++]
            if (toAbsoluteIndex(code, 0x10FFFF) !== code) { throw RangeError(code + ' is not a valid code point') }
            elements.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00))
          }
          return elements.join('')
        }
      })
      /***/ },
    /* 157 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(158)
      __w_pdfjs_require__(105)
      __w_pdfjs_require__(160)
      __w_pdfjs_require__(164)
      __w_pdfjs_require__(165)
      __w_pdfjs_require__(166)
      __w_pdfjs_require__(167)
      __w_pdfjs_require__(168)
      __w_pdfjs_require__(169)
      __w_pdfjs_require__(170)
      __w_pdfjs_require__(171)
      __w_pdfjs_require__(172)
      __w_pdfjs_require__(173)
      __w_pdfjs_require__(174)
      __w_pdfjs_require__(175)
      __w_pdfjs_require__(176)
      __w_pdfjs_require__(177)
      __w_pdfjs_require__(178)
      __w_pdfjs_require__(179)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Symbol
      /***/ },
    /* 158 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const fails = __w_pdfjs_require__(9)
      const isArray = __w_pdfjs_require__(150)
      const isObject = __w_pdfjs_require__(17)
      const toObject = __w_pdfjs_require__(79)
      const toLength = __w_pdfjs_require__(42)
      const createProperty = __w_pdfjs_require__(89)
      const arraySpeciesCreate = __w_pdfjs_require__(149)
      const arrayMethodHasSpeciesSupport = __w_pdfjs_require__(159)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const V8_VERSION = __w_pdfjs_require__(125)
      const IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable')
      const MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF
      const MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded'
      const IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
        const array = []
        array[IS_CONCAT_SPREADABLE] = false
        return array.concat()[0] !== array
      })
      const SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat')
      const isConcatSpreadable = function (O) {
        if (!isObject(O)) { return false }
        const spreadable = O[IS_CONCAT_SPREADABLE]
        return spreadable !== undefined ? !!spreadable : isArray(O)
      }
      const FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT
      $({
        target: 'Array',
        proto: true,
        forced: FORCED
      }, {
        concat: function concat (arg) {
          const O = toObject(this)
          const A = arraySpeciesCreate(O, 0)
          let n = 0
          let i, k, length, len, E
          for (i = -1, length = arguments.length; i < length; i++) {
            E = i === -1 ? O : arguments[i]
            if (isConcatSpreadable(E)) {
              len = toLength(E.length)
              if (n + len > MAX_SAFE_INTEGER) { throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED) }
              for (k = 0; k < len; k++, n++) {
                if (k in E) { createProperty(A, n, E[k]) }
              }
            } else {
              if (n >= MAX_SAFE_INTEGER) { throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED) }
              createProperty(A, n++, E)
            }
          }
          A.length = n
          return A
        }
      })
      /***/ },
    /* 159 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const fails = __w_pdfjs_require__(9)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const V8_VERSION = __w_pdfjs_require__(125)
      const SPECIES = wellKnownSymbol('species')
      module.exports = function (METHOD_NAME) {
        return V8_VERSION >= 51 || !fails(function () {
          const array = []
          const constructor = array.constructor = {}
          constructor[SPECIES] = function () {
            return { foo: 1 }
          }
          return array[METHOD_NAME](Boolean).foo !== 1
        })
      }
      /***/ },
    /* 160 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const global = __w_pdfjs_require__(6)
      const getBuiltIn = __w_pdfjs_require__(37)
      const IS_PURE = __w_pdfjs_require__(32)
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const NATIVE_SYMBOL = __w_pdfjs_require__(54)
      const USE_SYMBOL_AS_UID = __w_pdfjs_require__(55)
      const fails = __w_pdfjs_require__(9)
      const has = __w_pdfjs_require__(18)
      const isArray = __w_pdfjs_require__(150)
      const isObject = __w_pdfjs_require__(17)
      const anObject = __w_pdfjs_require__(23)
      const toObject = __w_pdfjs_require__(79)
      const toIndexedObject = __w_pdfjs_require__(12)
      const toPrimitive = __w_pdfjs_require__(16)
      const createPropertyDescriptor = __w_pdfjs_require__(11)
      const nativeObjectCreate = __w_pdfjs_require__(67)
      const objectKeys = __w_pdfjs_require__(69)
      const getOwnPropertyNamesModule = __w_pdfjs_require__(39)
      const getOwnPropertyNamesExternal = __w_pdfjs_require__(161)
      const getOwnPropertySymbolsModule = __w_pdfjs_require__(46)
      const getOwnPropertyDescriptorModule = __w_pdfjs_require__(7)
      const definePropertyModule = __w_pdfjs_require__(22)
      const propertyIsEnumerableModule = __w_pdfjs_require__(10)
      const createNonEnumerableProperty = __w_pdfjs_require__(21)
      const redefine = __w_pdfjs_require__(24)
      const shared = __w_pdfjs_require__(31)
      const sharedKey = __w_pdfjs_require__(30)
      const hiddenKeys = __w_pdfjs_require__(34)
      const uid = __w_pdfjs_require__(33)
      const wellKnownSymbol = __w_pdfjs_require__(53)
      const wrappedWellKnownSymbolModule = __w_pdfjs_require__(162)
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      const setToStringTag = __w_pdfjs_require__(81)
      const InternalStateModule = __w_pdfjs_require__(28)
      const $forEach = __w_pdfjs_require__(148).forEach
      const HIDDEN = sharedKey('hidden')
      const SYMBOL = 'Symbol'
      const PROTOTYPE = 'prototype'
      const TO_PRIMITIVE = wellKnownSymbol('toPrimitive')
      const setInternalState = InternalStateModule.set
      const getInternalState = InternalStateModule.getterFor(SYMBOL)
      const ObjectPrototype = Object[PROTOTYPE]
      let $Symbol = global.Symbol
      const $stringify = getBuiltIn('JSON', 'stringify')
      const nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f
      const nativeDefineProperty = definePropertyModule.f
      const nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f
      const nativePropertyIsEnumerable = propertyIsEnumerableModule.f
      const AllSymbols = shared('symbols')
      const ObjectPrototypeSymbols = shared('op-symbols')
      const StringToSymbolRegistry = shared('string-to-symbol-registry')
      const SymbolToStringRegistry = shared('symbol-to-string-registry')
      const WellKnownSymbolsStore = shared('wks')
      const QObject = global.QObject
      let USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild
      const setSymbolDescriptor = DESCRIPTORS && fails(function () {
        return nativeObjectCreate(nativeDefineProperty({}, 'a', {
          get: function () {
            return nativeDefineProperty(this, 'a', { value: 7 }).a
          }
        })).a != 7
      })
        ? function (O, P, Attributes) {
          const ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P)
          if (ObjectPrototypeDescriptor) { delete ObjectPrototype[P] }
          nativeDefineProperty(O, P, Attributes)
          if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
            nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor)
          }
        }
        : nativeDefineProperty
      const wrap = function (tag, description) {
        const symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE])
        setInternalState(symbol, {
          type: SYMBOL,
          tag: tag,
          description: description
        })
        if (!DESCRIPTORS) { symbol.description = description }
        return symbol
      }
      const isSymbol = USE_SYMBOL_AS_UID
        ? function (it) {
          return typeof it === 'symbol'
        }
        : function (it) {
          return Object(it) instanceof $Symbol
        }
      var $defineProperty = function defineProperty (O, P, Attributes) {
        if (O === ObjectPrototype) { $defineProperty(ObjectPrototypeSymbols, P, Attributes) }
        anObject(O)
        const key = toPrimitive(P, true)
        anObject(Attributes)
        if (has(AllSymbols, key)) {
          if (!Attributes.enumerable) {
            if (!has(O, HIDDEN)) { nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {})) }
            O[HIDDEN][key] = true
          } else {
            if (has(O, HIDDEN) && O[HIDDEN][key]) { O[HIDDEN][key] = false }
            Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) })
          }
          return setSymbolDescriptor(O, key, Attributes)
        }
        return nativeDefineProperty(O, key, Attributes)
      }
      const $defineProperties = function defineProperties (O, Properties) {
        anObject(O)
        const properties = toIndexedObject(Properties)
        const keys = objectKeys(properties).concat($getOwnPropertySymbols(properties))
        $forEach(keys, function (key) {
          if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) { $defineProperty(O, key, properties[key]) }
        })
        return O
      }
      const $create = function create (O, Properties) {
        return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties)
      }
      var $propertyIsEnumerable = function propertyIsEnumerable (V) {
        const P = toPrimitive(V, true)
        const enumerable = nativePropertyIsEnumerable.call(this, P)
        if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) { return false }
        return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true
      }
      const $getOwnPropertyDescriptor = function getOwnPropertyDescriptor (O, P) {
        const it = toIndexedObject(O)
        const key = toPrimitive(P, true)
        if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) { return }
        const descriptor = nativeGetOwnPropertyDescriptor(it, key)
        if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
          descriptor.enumerable = true
        }
        return descriptor
      }
      const $getOwnPropertyNames = function getOwnPropertyNames (O) {
        const names = nativeGetOwnPropertyNames(toIndexedObject(O))
        const result = []
        $forEach(names, function (key) {
          if (!has(AllSymbols, key) && !has(hiddenKeys, key)) { result.push(key) }
        })
        return result
      }
      var $getOwnPropertySymbols = function getOwnPropertySymbols (O) {
        const IS_OBJECT_PROTOTYPE = O === ObjectPrototype
        const names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O))
        const result = []
        $forEach(names, function (key) {
          if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
            result.push(AllSymbols[key])
          }
        })
        return result
      }
      if (!NATIVE_SYMBOL) {
        $Symbol = function Symbol () {
          if (this instanceof $Symbol) { throw TypeError('Symbol is not a constructor') }
          const description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0])
          const tag = uid(description)
          var setter = function (value) {
            if (this === ObjectPrototype) { setter.call(ObjectPrototypeSymbols, value) }
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) { this[HIDDEN][tag] = false }
            setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value))
          }
          if (DESCRIPTORS && USE_SETTER) {
            setSymbolDescriptor(ObjectPrototype, tag, {
              configurable: true,
              set: setter
            })
          }
          return wrap(tag, description)
        }
        redefine($Symbol[PROTOTYPE], 'toString', function toString () {
          return getInternalState(this).tag
        })
        redefine($Symbol, 'withoutSetter', function (description) {
          return wrap(uid(description), description)
        })
        propertyIsEnumerableModule.f = $propertyIsEnumerable
        definePropertyModule.f = $defineProperty
        getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor
        getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames
        getOwnPropertySymbolsModule.f = $getOwnPropertySymbols
        wrappedWellKnownSymbolModule.f = function (name) {
          return wrap(wellKnownSymbol(name), name)
        }
        if (DESCRIPTORS) {
          nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
            configurable: true,
            get: function description () {
              return getInternalState(this).description
            }
          })
          if (!IS_PURE) {
            redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true })
          }
        }
      }
      $({
        global: true,
        wrap: true,
        forced: !NATIVE_SYMBOL,
        sham: !NATIVE_SYMBOL
      }, { Symbol: $Symbol })
      $forEach(objectKeys(WellKnownSymbolsStore), function (name) {
        defineWellKnownSymbol(name)
      })
      $({
        target: SYMBOL,
        stat: true,
        forced: !NATIVE_SYMBOL
      }, {
        for: function (key) {
          const string = String(key)
          if (has(StringToSymbolRegistry, string)) { return StringToSymbolRegistry[string] }
          const symbol = $Symbol(string)
          StringToSymbolRegistry[string] = symbol
          SymbolToStringRegistry[symbol] = string
          return symbol
        },
        keyFor: function keyFor (sym) {
          if (!isSymbol(sym)) { throw TypeError(sym + ' is not a symbol') }
          if (has(SymbolToStringRegistry, sym)) { return SymbolToStringRegistry[sym] }
        },
        useSetter: function () {
          USE_SETTER = true
        },
        useSimple: function () {
          USE_SETTER = false
        }
      })
      $({
        target: 'Object',
        stat: true,
        forced: !NATIVE_SYMBOL,
        sham: !DESCRIPTORS
      }, {
        create: $create,
        defineProperty: $defineProperty,
        defineProperties: $defineProperties,
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor
      })
      $({
        target: 'Object',
        stat: true,
        forced: !NATIVE_SYMBOL
      }, {
        getOwnPropertyNames: $getOwnPropertyNames,
        getOwnPropertySymbols: $getOwnPropertySymbols
      })
      $({
        target: 'Object',
        stat: true,
        forced: fails(function () {
          getOwnPropertySymbolsModule.f(1)
        })
      }, {
        getOwnPropertySymbols: function getOwnPropertySymbols (it) {
          return getOwnPropertySymbolsModule.f(toObject(it))
        }
      })
      if ($stringify) {
        const FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
          const symbol = $Symbol()
          return $stringify([symbol]) != '[null]' || $stringify({ a: symbol }) != '{}' || $stringify(Object(symbol)) != '{}'
        })
        $({
          target: 'JSON',
          stat: true,
          forced: FORCED_JSON_STRINGIFY
        }, {
          stringify: function stringify (it, replacer, space) {
            const args = [it]
            let index = 1
            let $replacer
            while (arguments.length > index) { args.push(arguments[index++]) }
            $replacer = replacer
            if (!isObject(replacer) && it === undefined || isSymbol(it)) { return }
            if (!isArray(replacer)) {
              replacer = function (key, value) {
                if (typeof $replacer === 'function') { value = $replacer.call(this, key, value) }
                if (!isSymbol(value)) { return value }
              }
            }
            args[1] = replacer
            return $stringify.apply(null, args)
          }
        })
      }
      if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
        createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf)
      }
      setToStringTag($Symbol, SYMBOL)
      hiddenKeys[HIDDEN] = true
      /***/ },
    /* 161 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const toIndexedObject = __w_pdfjs_require__(12)
      const nativeGetOwnPropertyNames = __w_pdfjs_require__(39).f
      const toString = {}.toString
      const windowNames = typeof window === 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : []
      const getWindowNames = function (it) {
        try {
          return nativeGetOwnPropertyNames(it)
        } catch (error) {
          return windowNames.slice()
        }
      }
      module.exports.f = function getOwnPropertyNames (it) {
        return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : nativeGetOwnPropertyNames(toIndexedObject(it))
      }
      /***/ },
    /* 162 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const wellKnownSymbol = __w_pdfjs_require__(53)
      exports.f = wellKnownSymbol
      /***/ },
    /* 163 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const path = __w_pdfjs_require__(38)
      const has = __w_pdfjs_require__(18)
      const wrappedWellKnownSymbolModule = __w_pdfjs_require__(162)
      const defineProperty = __w_pdfjs_require__(22).f
      module.exports = function (NAME) {
        const Symbol = path.Symbol || (path.Symbol = {})
        if (!has(Symbol, NAME)) { defineProperty(Symbol, NAME, { value: wrappedWellKnownSymbolModule.f(NAME) }) }
      }
      /***/ },
    /* 164 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('asyncIterator')
      /***/ },
    /* 165 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const global = __w_pdfjs_require__(6)
      const has = __w_pdfjs_require__(18)
      const isObject = __w_pdfjs_require__(17)
      const defineProperty = __w_pdfjs_require__(22).f
      const copyConstructorProperties = __w_pdfjs_require__(35)
      const NativeSymbol = global.Symbol
      if (DESCRIPTORS && typeof NativeSymbol === 'function' && (!('description' in NativeSymbol.prototype) || NativeSymbol().description !== undefined)) {
        const EmptyStringDescriptionStore = {}
        var SymbolWrapper = function Symbol () {
          const description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0])
          const result = this instanceof SymbolWrapper ? new NativeSymbol(description) : description === undefined ? NativeSymbol() : NativeSymbol(description)
          if (description === '') { EmptyStringDescriptionStore[result] = true }
          return result
        }
        copyConstructorProperties(SymbolWrapper, NativeSymbol)
        const symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype
        symbolPrototype.constructor = SymbolWrapper
        const symbolToString = symbolPrototype.toString
        const native = String(NativeSymbol('test')) == 'Symbol(test)'
        const regexp = /^Symbol\((.*)\)[^)]+$/
        defineProperty(symbolPrototype, 'description', {
          configurable: true,
          get: function description () {
            const symbol = isObject(this) ? this.valueOf() : this
            const string = symbolToString.call(symbol)
            if (has(EmptyStringDescriptionStore, symbol)) { return '' }
            const desc = native ? string.slice(7, -1) : string.replace(regexp, '$1')
            return desc === '' ? undefined : desc
          }
        })
        $({
          global: true,
          forced: true
        }, { Symbol: SymbolWrapper })
      }
      /***/ },
    /* 166 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('hasInstance')
      /***/ },
    /* 167 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('isConcatSpreadable')
      /***/ },
    /* 168 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('iterator')
      /***/ },
    /* 169 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('match')
      /***/ },
    /* 170 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('matchAll')
      /***/ },
    /* 171 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('replace')
      /***/ },
    /* 172 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('search')
      /***/ },
    /* 173 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('species')
      /***/ },
    /* 174 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('split')
      /***/ },
    /* 175 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('toPrimitive')
      /***/ },
    /* 176 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('toStringTag')
      /***/ },
    /* 177 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const defineWellKnownSymbol = __w_pdfjs_require__(163)
      defineWellKnownSymbol('unscopables')
      /***/ },
    /* 178 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const setToStringTag = __w_pdfjs_require__(81)
      setToStringTag(Math, 'Math', true)
      /***/ },
    /* 179 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const global = __w_pdfjs_require__(6)
      const setToStringTag = __w_pdfjs_require__(81)
      setToStringTag(global.JSON, 'JSON', true)
      /***/ },
    /* 180 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(181)
      const entryUnbind = __w_pdfjs_require__(57)
      module.exports = entryUnbind('String', 'padStart')
      /***/ },
    /* 181 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const $padStart = __w_pdfjs_require__(182).start
      const WEBKIT_BUG = __w_pdfjs_require__(184)
      $({
        target: 'String',
        proto: true,
        forced: WEBKIT_BUG
      }, {
        padStart: function padStart (maxLength) {
          return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined)
        }
      })
      /***/ },
    /* 182 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const toLength = __w_pdfjs_require__(42)
      const repeat = __w_pdfjs_require__(183)
      const requireObjectCoercible = __w_pdfjs_require__(15)
      const ceil = Math.ceil
      const createMethod = function (IS_END) {
        return function ($this, maxLength, fillString) {
          const S = String(requireObjectCoercible($this))
          const stringLength = S.length
          const fillStr = fillString === undefined ? ' ' : String(fillString)
          const intMaxLength = toLength(maxLength)
          let fillLen, stringFiller
          if (intMaxLength <= stringLength || fillStr == '') { return S }
          fillLen = intMaxLength - stringLength
          stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length))
          if (stringFiller.length > fillLen) { stringFiller = stringFiller.slice(0, fillLen) }
          return IS_END ? S + stringFiller : stringFiller + S
        }
      }
      module.exports = {
        start: createMethod(false),
        end: createMethod(true)
      }
      /***/ },
    /* 183 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const toInteger = __w_pdfjs_require__(43)
      const requireObjectCoercible = __w_pdfjs_require__(15)
      module.exports = ''.repeat || function repeat (count) {
        let str = String(requireObjectCoercible(this))
        let result = ''
        let n = toInteger(count)
        if (n < 0 || n == Infinity) { throw RangeError('Wrong number of repetitions') }
        for (; n > 0; (n >>>= 1) && (str += str)) {
          if (n & 1) { result += str }
        }
        return result
      }
      /***/ },
    /* 184 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const userAgent = __w_pdfjs_require__(119)
      module.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent)
      /***/ },
    /* 185 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(186)
      const entryUnbind = __w_pdfjs_require__(57)
      module.exports = entryUnbind('String', 'padEnd')
      /***/ },
    /* 186 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const $ = __w_pdfjs_require__(5)
      const $padEnd = __w_pdfjs_require__(182).end
      const WEBKIT_BUG = __w_pdfjs_require__(184)
      $({
        target: 'String',
        proto: true,
        forced: WEBKIT_BUG
      }, {
        padEnd: function padEnd (maxLength) {
          return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined)
        }
      })
      /***/ },
    /* 187 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      __w_pdfjs_require__(188)
      const path = __w_pdfjs_require__(38)
      module.exports = path.Object.values
      /***/ },
    /* 188 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const $ = __w_pdfjs_require__(5)
      const $values = __w_pdfjs_require__(189).values
      $({
        target: 'Object',
        stat: true
      }, {
        values: function values (O) {
          return $values(O)
        }
      })
      /***/ },
    /* 189 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      const DESCRIPTORS = __w_pdfjs_require__(8)
      const objectKeys = __w_pdfjs_require__(69)
      const toIndexedObject = __w_pdfjs_require__(12)
      const propertyIsEnumerable = __w_pdfjs_require__(10).f
      const createMethod = function (TO_ENTRIES) {
        return function (it) {
          const O = toIndexedObject(it)
          const keys = objectKeys(O)
          const length = keys.length
          let i = 0
          const result = []
          let key
          while (length > i) {
            key = keys[i++]
            if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
              result.push(TO_ENTRIES
                ? [
                    key,
                    O[key]
                  ]
                : O[key])
            }
          }
          return result
        }
      }
      module.exports = {
        entries: createMethod(true),
        values: createMethod(false)
      }
      /***/ },
    /* 190 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.getDocument = getDocument
      exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory
      exports.build = exports.version = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = void 0

      const _regenerator = _interopRequireDefault(__w_pdfjs_require__(191))

      const _util = __w_pdfjs_require__(1)

      const _display_utils = __w_pdfjs_require__(194)

      const _font_loader = __w_pdfjs_require__(195)

      const _api_compatibility = __w_pdfjs_require__(196)

      const _canvas = __w_pdfjs_require__(197)

      const _worker_options = __w_pdfjs_require__(199)

      const _is_node = __w_pdfjs_require__(48)

      const _message_handler = __w_pdfjs_require__(200)

      const _metadata = __w_pdfjs_require__(201)

      const _transport_stream = __w_pdfjs_require__(203)

      const _webgl = __w_pdfjs_require__(204)

      function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

      function _slicedToArray (arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest() }

      function _nonIterableRest () { throw new TypeError('Invalid attempt to destructure non-iterable instance') }

      function _iterableToArrayLimit (arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === '[object Arguments]')) { return } const _arr = []; let _n = true; let _d = false; let _e; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break } } catch (err) { _d = true; _e = err } finally { try { if (!_n && _i.return != null) _i.return() } finally { if (_d) throw _e } } return _arr }

      function _arrayWithHoles (arr) { if (Array.isArray(arr)) return arr }

      function asyncGeneratorStep (gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value } catch (error) { reject(error); return } if (info.done) { resolve(value) } else { Promise.resolve(value).then(_next, _throw) } }

      function _asyncToGenerator (fn) { return function () { const self = this; const args = arguments; return new Promise(function (resolve, reject) { const gen = fn.apply(self, args); function _next (value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value) } function _throw (err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err) } _next(undefined) }) } }

      function _toConsumableArray (arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread() }

      function _nonIterableSpread () { throw new TypeError('Invalid attempt to spread non-iterable instance') }

      function _iterableToArray (iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === '[object Arguments]') return Array.from(iter) }

      function _arrayWithoutHoles (arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i] } return arr2 } }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      const DEFAULT_RANGE_CHUNK_SIZE = 65536
      const RENDERING_CANCELLED_TIMEOUT = 100
      let createPDFNetworkStream

      function setPDFNetworkStreamFactory (pdfNetworkStreamFactory) {
        createPDFNetworkStream = pdfNetworkStreamFactory
      }

      function getDocument (src) {
        const task = new PDFDocumentLoadingTask()
        let source

        if (typeof src === 'string') {
          source = {
            url: src
          }
        } else if ((0, _util.isArrayBuffer)(src)) {
          source = {
            data: src
          }
        } else if (src instanceof PDFDataRangeTransport) {
          source = {
            range: src
          }
        } else {
          if (_typeof(src) !== 'object') {
            throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object')
          }

          if (!src.url && !src.data && !src.range) {
            throw new Error('Invalid parameter object: need either .data, .range or .url')
          }

          source = src
        }

        const params = Object.create(null)
        let rangeTransport = null
        let worker = null

        for (const key in source) {
          if (key === 'url' && typeof window !== 'undefined') {
            params[key] = new URL(source[key], window.location).href
            continue
          } else if (key === 'range') {
            rangeTransport = source[key]
            continue
          } else if (key === 'worker') {
            worker = source[key]
            continue
          } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
            const pdfBytes = source[key]

            if (typeof pdfBytes === 'string') {
              params[key] = (0, _util.stringToBytes)(pdfBytes)
            } else if (_typeof(pdfBytes) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
              params[key] = new Uint8Array(pdfBytes)
            } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
              params[key] = new Uint8Array(pdfBytes)
            } else {
              throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.')
            }

            continue
          }

          params[key] = source[key]
        }

        params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE
        params.CMapReaderFactory = params.CMapReaderFactory || _display_utils.DOMCMapReaderFactory
        params.ignoreErrors = params.stopAtErrors !== true
        params.pdfBug = params.pdfBug === true
        const NativeImageDecoderValues = Object.values(_util.NativeImageDecoding)

        if (params.nativeImageDecoderSupport === undefined || !NativeImageDecoderValues.includes(params.nativeImageDecoderSupport)) {
          params.nativeImageDecoderSupport = _api_compatibility.apiCompatibilityParams.nativeImageDecoderSupport || _util.NativeImageDecoding.DECODE
        }

        if (!Number.isInteger(params.maxImageSize)) {
          params.maxImageSize = -1
        }

        if (typeof params.isEvalSupported !== 'boolean') {
          params.isEvalSupported = true
        }

        if (typeof params.disableFontFace !== 'boolean') {
          params.disableFontFace = _api_compatibility.apiCompatibilityParams.disableFontFace || false
        }

        if (typeof params.disableRange !== 'boolean') {
          params.disableRange = false
        }

        if (typeof params.disableStream !== 'boolean') {
          params.disableStream = false
        }

        if (typeof params.disableAutoFetch !== 'boolean') {
          params.disableAutoFetch = false
        }

        if (typeof params.disableCreateObjectURL !== 'boolean') {
          params.disableCreateObjectURL = _api_compatibility.apiCompatibilityParams.disableCreateObjectURL || false
        }

        (0, _util.setVerbosityLevel)(params.verbosity)

        if (!worker) {
          const workerParams = {
            verbosity: params.verbosity,
            port: _worker_options.GlobalWorkerOptions.workerPort
          }
          worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams)
          task._worker = worker
        }

        const docId = task.docId
        worker.promise.then(function () {
          if (task.destroyed) {
            throw new Error('Loading aborted')
          }

          return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
            if (task.destroyed) {
              throw new Error('Loading aborted')
            }

            let networkStream

            if (rangeTransport) {
              networkStream = new _transport_stream.PDFDataTransportStream({
                length: params.length,
                initialData: params.initialData,
                progressiveDone: params.progressiveDone,
                disableRange: params.disableRange,
                disableStream: params.disableStream
              }, rangeTransport)
            } else if (!params.data) {
              networkStream = createPDFNetworkStream({
                url: params.url,
                length: params.length,
                httpHeaders: params.httpHeaders,
                withCredentials: params.withCredentials,
                rangeChunkSize: params.rangeChunkSize,
                disableRange: params.disableRange,
                disableStream: params.disableStream
              })
            }

            const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port)
            messageHandler.postMessageTransfers = worker.postMessageTransfers
            const transport = new WorkerTransport(messageHandler, task, networkStream, params)
            task._transport = transport
            messageHandler.send('Ready', null)
          })
        }).catch(task._capability.reject)
        return task
      }

      function _fetchDocument (worker, source, pdfDataRangeTransport, docId) {
        if (worker.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'))
        }

        if (pdfDataRangeTransport) {
          source.length = pdfDataRangeTransport.length
          source.initialData = pdfDataRangeTransport.initialData
          source.progressiveDone = pdfDataRangeTransport.progressiveDone
        }

        return worker.messageHandler.sendWithPromise('GetDocRequest', {
          docId: docId,
          apiVersion: '2.4.456',
          source: {
            data: source.data,
            url: source.url,
            password: source.password,
            disableAutoFetch: source.disableAutoFetch,
            rangeChunkSize: source.rangeChunkSize,
            length: source.length
          },
          maxImageSize: source.maxImageSize,
          disableFontFace: source.disableFontFace,
          disableCreateObjectURL: source.disableCreateObjectURL,
          postMessageTransfers: worker.postMessageTransfers,
          docBaseUrl: source.docBaseUrl,
          nativeImageDecoderSupport: source.nativeImageDecoderSupport,
          ignoreErrors: source.ignoreErrors,
          isEvalSupported: source.isEvalSupported
        }).then(function (workerId) {
          if (worker.destroyed) {
            throw new Error('Worker was destroyed')
          }

          return workerId
        })
      }

      var PDFDocumentLoadingTask = (function PDFDocumentLoadingTaskClosure () {
        let nextDocumentId = 0

        const PDFDocumentLoadingTask = /* #__PURE__ */(function () {
          function PDFDocumentLoadingTask () {
            _classCallCheck(this, PDFDocumentLoadingTask)

            this._capability = (0, _util.createPromiseCapability)()
            this._transport = null
            this._worker = null
            this.docId = 'd' + nextDocumentId++
            this.destroyed = false
            this.onPassword = null
            this.onProgress = null
            this.onUnsupportedFeature = null
          }

          _createClass(PDFDocumentLoadingTask, [{
            key: 'destroy',
            value: function destroy () {
              const _this = this

              this.destroyed = true
              const transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy()
              return transportDestroyed.then(function () {
                _this._transport = null

                if (_this._worker) {
                  _this._worker.destroy()

                  _this._worker = null
                }
              })
            }
          }, {
            key: 'then',
            value: function then (onFulfilled, onRejected) {
              throw new Error('Removed API method: ' + 'PDFDocumentLoadingTask.then, use the `promise` getter instead.')
            }
          }, {
            key: 'promise',
            get: function get () {
              return this._capability.promise
            }
          }])

          return PDFDocumentLoadingTask
        }())

        return PDFDocumentLoadingTask
      }())

      var PDFDataRangeTransport = /* #__PURE__ */(function () {
        function PDFDataRangeTransport (length, initialData) {
          const progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false

          _classCallCheck(this, PDFDataRangeTransport)

          this.length = length
          this.initialData = initialData
          this.progressiveDone = progressiveDone
          this._rangeListeners = []
          this._progressListeners = []
          this._progressiveReadListeners = []
          this._progressiveDoneListeners = []
          this._readyCapability = (0, _util.createPromiseCapability)()
        }

        _createClass(PDFDataRangeTransport, [{
          key: 'addRangeListener',
          value: function addRangeListener (listener) {
            this._rangeListeners.push(listener)
          }
        }, {
          key: 'addProgressListener',
          value: function addProgressListener (listener) {
            this._progressListeners.push(listener)
          }
        }, {
          key: 'addProgressiveReadListener',
          value: function addProgressiveReadListener (listener) {
            this._progressiveReadListeners.push(listener)
          }
        }, {
          key: 'addProgressiveDoneListener',
          value: function addProgressiveDoneListener (listener) {
            this._progressiveDoneListeners.push(listener)
          }
        }, {
          key: 'onDataRange',
          value: function onDataRange (begin, chunk) {
            let _iteratorNormalCompletion = true
            let _didIteratorError = false
            let _iteratorError

            try {
              for (var _iterator = this._rangeListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                const listener = _step.value
                listener(begin, chunk)
              }
            } catch (err) {
              _didIteratorError = true
              _iteratorError = err
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return()
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError
                }
              }
            }
          }
        }, {
          key: 'onDataProgress',
          value: function onDataProgress (loaded, total) {
            const _this2 = this

            this._readyCapability.promise.then(function () {
              let _iteratorNormalCompletion2 = true
              let _didIteratorError2 = false
              let _iteratorError2

              try {
                for (var _iterator2 = _this2._progressListeners[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  const listener = _step2.value
                  listener(loaded, total)
                }
              } catch (err) {
                _didIteratorError2 = true
                _iteratorError2 = err
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return()
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2
                  }
                }
              }
            })
          }
        }, {
          key: 'onDataProgressiveRead',
          value: function onDataProgressiveRead (chunk) {
            const _this3 = this

            this._readyCapability.promise.then(function () {
              let _iteratorNormalCompletion3 = true
              let _didIteratorError3 = false
              let _iteratorError3

              try {
                for (var _iterator3 = _this3._progressiveReadListeners[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  const listener = _step3.value
                  listener(chunk)
                }
              } catch (err) {
                _didIteratorError3 = true
                _iteratorError3 = err
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return()
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3
                  }
                }
              }
            })
          }
        }, {
          key: 'onDataProgressiveDone',
          value: function onDataProgressiveDone () {
            const _this4 = this

            this._readyCapability.promise.then(function () {
              let _iteratorNormalCompletion4 = true
              let _didIteratorError4 = false
              let _iteratorError4

              try {
                for (var _iterator4 = _this4._progressiveDoneListeners[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  const listener = _step4.value
                  listener()
                }
              } catch (err) {
                _didIteratorError4 = true
                _iteratorError4 = err
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return()
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4
                  }
                }
              }
            })
          }
        }, {
          key: 'transportReady',
          value: function transportReady () {
            this._readyCapability.resolve()
          }
        }, {
          key: 'requestDataRange',
          value: function requestDataRange (begin, end) {
            (0, _util.unreachable)('Abstract method PDFDataRangeTransport.requestDataRange')
          }
        }, {
          key: 'abort',
          value: function abort () {}
        }])

        return PDFDataRangeTransport
      }())

      exports.PDFDataRangeTransport = PDFDataRangeTransport

      const PDFDocumentProxy = /* #__PURE__ */(function () {
        function PDFDocumentProxy (pdfInfo, transport) {
          _classCallCheck(this, PDFDocumentProxy)

          this._pdfInfo = pdfInfo
          this._transport = transport
        }

        _createClass(PDFDocumentProxy, [{
          key: 'getPage',
          value: function getPage (pageNumber) {
            return this._transport.getPage(pageNumber)
          }
        }, {
          key: 'getPageIndex',
          value: function getPageIndex (ref) {
            return this._transport.getPageIndex(ref)
          }
        }, {
          key: 'getDestinations',
          value: function getDestinations () {
            return this._transport.getDestinations()
          }
        }, {
          key: 'getDestination',
          value: function getDestination (id) {
            return this._transport.getDestination(id)
          }
        }, {
          key: 'getPageLabels',
          value: function getPageLabels () {
            return this._transport.getPageLabels()
          }
        }, {
          key: 'getPageLayout',
          value: function getPageLayout () {
            return this._transport.getPageLayout()
          }
        }, {
          key: 'getPageMode',
          value: function getPageMode () {
            return this._transport.getPageMode()
          }
        }, {
          key: 'getViewerPreferences',
          value: function getViewerPreferences () {
            return this._transport.getViewerPreferences()
          }
        }, {
          key: 'getOpenAction',
          value: function getOpenAction () {
            return this._transport.getOpenAction()
          }
        }, {
          key: 'getOpenActionDestination',
          value: function getOpenActionDestination () {
            (0, _display_utils.deprecated)('getOpenActionDestination, use getOpenAction instead.')
            return this.getOpenAction().then(function (openAction) {
              return openAction && openAction.dest ? openAction.dest : null
            })
          }
        }, {
          key: 'getAttachments',
          value: function getAttachments () {
            return this._transport.getAttachments()
          }
        }, {
          key: 'getJavaScript',
          value: function getJavaScript () {
            return this._transport.getJavaScript()
          }
        }, {
          key: 'getOutline',
          value: function getOutline () {
            return this._transport.getOutline()
          }
        }, {
          key: 'getPermissions',
          value: function getPermissions () {
            return this._transport.getPermissions()
          }
        }, {
          key: 'getMetadata',
          value: function getMetadata () {
            return this._transport.getMetadata()
          }
        }, {
          key: 'getData',
          value: function getData () {
            return this._transport.getData()
          }
        }, {
          key: 'getDownloadInfo',
          value: function getDownloadInfo () {
            return this._transport.downloadInfoCapability.promise
          }
        }, {
          key: 'getStats',
          value: function getStats () {
            return this._transport.getStats()
          }
        }, {
          key: 'cleanup',
          value: function cleanup () {
            return this._transport.startCleanup()
          }
        }, {
          key: 'destroy',
          value: function destroy () {
            return this.loadingTask.destroy()
          }
        }, {
          key: 'numPages',
          get: function get () {
            return this._pdfInfo.numPages
          }
        }, {
          key: 'fingerprint',
          get: function get () {
            return this._pdfInfo.fingerprint
          }
        }, {
          key: 'loadingParams',
          get: function get () {
            return this._transport.loadingParams
          }
        }, {
          key: 'loadingTask',
          get: function get () {
            return this._transport.loadingTask
          }
        }])

        return PDFDocumentProxy
      }())

      exports.PDFDocumentProxy = PDFDocumentProxy

      const PDFPageProxy = /* #__PURE__ */(function () {
        function PDFPageProxy (pageIndex, pageInfo, transport) {
          const pdfBug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false

          _classCallCheck(this, PDFPageProxy)

          this._pageIndex = pageIndex
          this._pageInfo = pageInfo
          this._transport = transport
          this._stats = pdfBug ? new _display_utils.StatTimer() : null
          this._pdfBug = pdfBug
          this.commonObjs = transport.commonObjs
          this.objs = new PDFObjects()
          this.cleanupAfterRender = false
          this.pendingCleanup = false
          this.intentStates = Object.create(null)
          this.destroyed = false
        }

        _createClass(PDFPageProxy, [{
          key: 'getViewport',
          value: function getViewport () {
            const _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
            const scale = _ref.scale
            const _ref$rotation = _ref.rotation
            const rotation = _ref$rotation === void 0 ? this.rotate : _ref$rotation
            const _ref$offsetX = _ref.offsetX
            const offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX
            const _ref$offsetY = _ref.offsetY
            const offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY
            const _ref$dontFlip = _ref.dontFlip
            const dontFlip = _ref$dontFlip === void 0 ? false : _ref$dontFlip

            if (arguments.length > 1 || typeof arguments[0] === 'number') {
              throw new Error('PDFPageProxy.getViewport is called with obsolete arguments.')
            }

            return new _display_utils.PageViewport({
              viewBox: this.view,
              scale: scale,
              rotation: rotation,
              offsetX: offsetX,
              offsetY: offsetY,
              dontFlip: dontFlip
            })
          }
        }, {
          key: 'getAnnotations',
          value: function getAnnotations () {
            const _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
            const _ref2$intent = _ref2.intent
            const intent = _ref2$intent === void 0 ? null : _ref2$intent

            if (!this.annotationsPromise || this.annotationsIntent !== intent) {
              this.annotationsPromise = this._transport.getAnnotations(this._pageIndex, intent)
              this.annotationsIntent = intent
            }

            return this.annotationsPromise
          }
        }, {
          key: 'render',
          value: function render (_ref3) {
            const _this5 = this

            const canvasContext = _ref3.canvasContext
            const viewport = _ref3.viewport
            const _ref3$intent = _ref3.intent
            const intent = _ref3$intent === void 0 ? 'display' : _ref3$intent
            const _ref3$enableWebGL = _ref3.enableWebGL
            const enableWebGL = _ref3$enableWebGL === void 0 ? false : _ref3$enableWebGL
            const _ref3$renderInteracti = _ref3.renderInteractiveForms
            const renderInteractiveForms = _ref3$renderInteracti === void 0 ? false : _ref3$renderInteracti
            const _ref3$transform = _ref3.transform
            const transform = _ref3$transform === void 0 ? null : _ref3$transform
            const _ref3$imageLayer = _ref3.imageLayer
            const imageLayer = _ref3$imageLayer === void 0 ? null : _ref3$imageLayer
            const _ref3$canvasFactory = _ref3.canvasFactory
            const canvasFactory = _ref3$canvasFactory === void 0 ? null : _ref3$canvasFactory
            const _ref3$background = _ref3.background
            const background = _ref3$background === void 0 ? null : _ref3$background

            if (this._stats) {
              this._stats.time('Overall')
            }

            const renderingIntent = intent === 'print' ? 'print' : 'display'
            this.pendingCleanup = false

            if (!this.intentStates[renderingIntent]) {
              this.intentStates[renderingIntent] = Object.create(null)
            }

            const intentState = this.intentStates[renderingIntent]

            if (intentState.streamReaderCancelTimeout) {
              clearTimeout(intentState.streamReaderCancelTimeout)
              intentState.streamReaderCancelTimeout = null
            }

            const canvasFactoryInstance = canvasFactory || new _display_utils.DOMCanvasFactory()
            const webGLContext = new _webgl.WebGLContext({
              enable: enableWebGL
            })

            if (!intentState.displayReadyCapability) {
              intentState.displayReadyCapability = (0, _util.createPromiseCapability)()
              intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false
              }

              if (this._stats) {
                this._stats.time('Page Request')
              }

              this._pumpOperatorList({
                pageIndex: this._pageIndex,
                intent: renderingIntent,
                renderInteractiveForms: renderInteractiveForms === true
              })
            }

            const complete = function complete (error) {
              const i = intentState.renderTasks.indexOf(internalRenderTask)

              if (i >= 0) {
                intentState.renderTasks.splice(i, 1)
              }

              if (_this5.cleanupAfterRender || renderingIntent === 'print') {
                _this5.pendingCleanup = true
              }

              _this5._tryCleanup()

              if (error) {
                internalRenderTask.capability.reject(error)

                _this5._abortOperatorList({
                  intentState: intentState,
                  reason: error
                })
              } else {
                internalRenderTask.capability.resolve()
              }

              if (_this5._stats) {
                _this5._stats.timeEnd('Rendering')

                _this5._stats.timeEnd('Overall')
              }
            }

            var internalRenderTask = new InternalRenderTask({
              callback: complete,
              params: {
                canvasContext: canvasContext,
                viewport: viewport,
                transform: transform,
                imageLayer: imageLayer,
                background: background
              },
              objs: this.objs,
              commonObjs: this.commonObjs,
              operatorList: intentState.operatorList,
              pageIndex: this._pageIndex,
              canvasFactory: canvasFactoryInstance,
              webGLContext: webGLContext,
              useRequestAnimationFrame: renderingIntent !== 'print',
              pdfBug: this._pdfBug
            })

            if (!intentState.renderTasks) {
              intentState.renderTasks = []
            }

            intentState.renderTasks.push(internalRenderTask)
            const renderTask = internalRenderTask.task
            intentState.displayReadyCapability.promise.then(function (transparency) {
              if (_this5.pendingCleanup) {
                complete()
                return
              }

              if (_this5._stats) {
                _this5._stats.time('Rendering')
              }

              internalRenderTask.initializeGraphics(transparency)
              internalRenderTask.operatorListChanged()
            }).catch(complete)
            return renderTask
          }
        }, {
          key: 'getOperatorList',
          value: function getOperatorList () {
            function operatorListChanged () {
              if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList)
                const i = intentState.renderTasks.indexOf(opListTask)

                if (i >= 0) {
                  intentState.renderTasks.splice(i, 1)
                }
              }
            }

            const renderingIntent = 'oplist'

            if (!this.intentStates[renderingIntent]) {
              this.intentStates[renderingIntent] = Object.create(null)
            }

            var intentState = this.intentStates[renderingIntent]
            let opListTask

            if (!intentState.opListReadCapability) {
              opListTask = {}
              opListTask.operatorListChanged = operatorListChanged
              intentState.opListReadCapability = (0, _util.createPromiseCapability)()
              intentState.renderTasks = []
              intentState.renderTasks.push(opListTask)
              intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false
              }

              if (this._stats) {
                this._stats.time('Page Request')
              }

              this._pumpOperatorList({
                pageIndex: this._pageIndex,
                intent: renderingIntent
              })
            }

            return intentState.opListReadCapability.promise
          }
        }, {
          key: 'streamTextContent',
          value: function streamTextContent () {
            const _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
            const _ref4$normalizeWhites = _ref4.normalizeWhitespace
            const normalizeWhitespace = _ref4$normalizeWhites === void 0 ? false : _ref4$normalizeWhites
            const _ref4$disableCombineT = _ref4.disableCombineTextItems
            const disableCombineTextItems = _ref4$disableCombineT === void 0 ? false : _ref4$disableCombineT

            const TEXT_CONTENT_CHUNK_SIZE = 100
            return this._transport.messageHandler.sendWithStream('GetTextContent', {
              pageIndex: this._pageIndex,
              normalizeWhitespace: normalizeWhitespace === true,
              combineTextItems: disableCombineTextItems !== true
            }, {
              highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
              size: function size (textContent) {
                return textContent.items.length
              }
            })
          }
        }, {
          key: 'getTextContent',
          value: function getTextContent () {
            const params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
            const readableStream = this.streamTextContent(params)
            return new Promise(function (resolve, reject) {
              function pump () {
                reader.read().then(function (_ref5) {
                  let _textContent$items

                  const value = _ref5.value
                  const done = _ref5.done

                  if (done) {
                    resolve(textContent)
                    return
                  }

                  Object.assign(textContent.styles, value.styles);

                  (_textContent$items = textContent.items).push.apply(_textContent$items, _toConsumableArray(value.items))

                  pump()
                }, reject)
              }

              var reader = readableStream.getReader()
              var textContent = {
                items: [],
                styles: Object.create(null)
              }
              pump()
            })
          }
        }, {
          key: '_destroy',
          value: function _destroy () {
            const _this6 = this

            this.destroyed = true
            this._transport.pageCache[this._pageIndex] = null
            const waitOn = []
            Object.keys(this.intentStates).forEach(function (intent) {
              const intentState = _this6.intentStates[intent]

              _this6._abortOperatorList({
                intentState: intentState,
                reason: new Error('Page was destroyed.'),
                force: true
              })

              if (intent === 'oplist') {
                return
              }

              intentState.renderTasks.forEach(function (renderTask) {
                const renderCompleted = renderTask.capability.promise.catch(function () {})
                waitOn.push(renderCompleted)
                renderTask.cancel()
              })
            })
            this.objs.clear()
            this.annotationsPromise = null
            this.pendingCleanup = false
            return Promise.all(waitOn)
          }
        }, {
          key: 'cleanup',
          value: function cleanup () {
            const resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false
            this.pendingCleanup = true
            return this._tryCleanup(resetStats)
          }
        }, {
          key: '_tryCleanup',
          value: function _tryCleanup () {
            const _this7 = this

            const resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false

            if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
              const intentState = _this7.intentStates[intent]
              return intentState.renderTasks.length !== 0 || !intentState.operatorList.lastChunk
            })) {
              return false
            }

            Object.keys(this.intentStates).forEach(function (intent) {
              delete _this7.intentStates[intent]
            })
            this.objs.clear()
            this.annotationsPromise = null

            if (resetStats && this._stats) {
              this._stats = new _display_utils.StatTimer()
            }

            this.pendingCleanup = false
            return true
          }
        }, {
          key: '_startRenderPage',
          value: function _startRenderPage (transparency, intent) {
            const intentState = this.intentStates[intent]

            if (!intentState) {
              return
            }

            if (this._stats) {
              this._stats.timeEnd('Page Request')
            }

            if (intentState.displayReadyCapability) {
              intentState.displayReadyCapability.resolve(transparency)
            }
          }
        }, {
          key: '_renderPageChunk',
          value: function _renderPageChunk (operatorListChunk, intentState) {
            for (let i = 0, ii = operatorListChunk.length; i < ii; i++) {
              intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i])
              intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i])
            }

            intentState.operatorList.lastChunk = operatorListChunk.lastChunk

            for (let _i = 0; _i < intentState.renderTasks.length; _i++) {
              intentState.renderTasks[_i].operatorListChanged()
            }

            if (operatorListChunk.lastChunk) {
              this._tryCleanup()
            }
          }
        }, {
          key: '_pumpOperatorList',
          value: function _pumpOperatorList (args) {
            const _this8 = this;

            (0, _util.assert)(args.intent, 'PDFPageProxy._pumpOperatorList: Expected "intent" argument.')

            const readableStream = this._transport.messageHandler.sendWithStream('GetOperatorList', args)

            const reader = readableStream.getReader()
            const intentState = this.intentStates[args.intent]
            intentState.streamReader = reader

            const pump = function pump () {
              reader.read().then(function (_ref6) {
                const value = _ref6.value
                const done = _ref6.done

                if (done) {
                  intentState.streamReader = null
                  return
                }

                if (_this8._transport.destroyed) {
                  return
                }

                _this8._renderPageChunk(value, intentState)

                pump()
              }, function (reason) {
                intentState.streamReader = null

                if (_this8._transport.destroyed) {
                  return
                }

                if (intentState.operatorList) {
                  intentState.operatorList.lastChunk = true

                  for (let i = 0; i < intentState.renderTasks.length; i++) {
                    intentState.renderTasks[i].operatorListChanged()
                  }

                  _this8._tryCleanup()
                }

                if (intentState.displayReadyCapability) {
                  intentState.displayReadyCapability.reject(reason)
                } else if (intentState.opListReadCapability) {
                  intentState.opListReadCapability.reject(reason)
                } else {
                  throw reason
                }
              })
            }

            pump()
          }
        }, {
          key: '_abortOperatorList',
          value: function _abortOperatorList (_ref7) {
            const _this9 = this

            const intentState = _ref7.intentState
            const reason = _ref7.reason
            const _ref7$force = _ref7.force
            const force = _ref7$force === void 0 ? false : _ref7$force;
            (0, _util.assert)(reason instanceof Error || _typeof(reason) === 'object' && reason !== null, 'PDFPageProxy._abortOperatorList: Expected "reason" argument.')

            if (!intentState.streamReader) {
              return
            }

            if (!force) {
              if (intentState.renderTasks.length !== 0) {
                return
              }

              if (reason instanceof _display_utils.RenderingCancelledException) {
                intentState.streamReaderCancelTimeout = setTimeout(function () {
                  _this9._abortOperatorList({
                    intentState: intentState,
                    reason: reason,
                    force: true
                  })

                  intentState.streamReaderCancelTimeout = null
                }, RENDERING_CANCELLED_TIMEOUT)
                return
              }
            }

            intentState.streamReader.cancel(new _util.AbortException(reason && reason.message))
            intentState.streamReader = null

            if (this._transport.destroyed) {
              return
            }

            Object.keys(this.intentStates).some(function (intent) {
              if (_this9.intentStates[intent] === intentState) {
                delete _this9.intentStates[intent]
                return true
              }

              return false
            })
            this.cleanup()
          }
        }, {
          key: 'pageNumber',
          get: function get () {
            return this._pageIndex + 1
          }
        }, {
          key: 'rotate',
          get: function get () {
            return this._pageInfo.rotate
          }
        }, {
          key: 'ref',
          get: function get () {
            return this._pageInfo.ref
          }
        }, {
          key: 'userUnit',
          get: function get () {
            return this._pageInfo.userUnit
          }
        }, {
          key: 'view',
          get: function get () {
            return this._pageInfo.view
          }
        }, {
          key: 'stats',
          get: function get () {
            return this._stats
          }
        }])

        return PDFPageProxy
      }())

      exports.PDFPageProxy = PDFPageProxy

      const LoopbackPort = /* #__PURE__ */(function () {
        function LoopbackPort () {
          const defer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true

          _classCallCheck(this, LoopbackPort)

          this._listeners = []
          this._defer = defer
          this._deferred = Promise.resolve(undefined)
        }

        _createClass(LoopbackPort, [{
          key: 'postMessage',
          value: function postMessage (obj, transfers) {
            const _this10 = this

            function cloneValue (value) {
              if (_typeof(value) !== 'object' || value === null) {
                return value
              }

              if (cloned.has(value)) {
                return cloned.get(value)
              }

              let buffer, result

              if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
                const transferable = transfers && transfers.includes(buffer)

                if (transferable) {
                  result = new value.constructor(buffer, value.byteOffset, value.byteLength)
                } else {
                  result = new value.constructor(value)
                }

                cloned.set(value, result)
                return result
              }

              result = Array.isArray(value) ? [] : {}
              cloned.set(value, result)

              for (const i in value) {
                let desc = void 0
                let p = value

                while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
                  p = Object.getPrototypeOf(p)
                }

                if (typeof desc.value === 'undefined') {
                  continue
                }

                if (typeof desc.value === 'function') {
                  if (value.hasOwnProperty && value.hasOwnProperty(i)) {
                    throw new Error('LoopbackPort.postMessage - cannot clone: '.concat(value[i]))
                  }

                  continue
                }

                result[i] = cloneValue(desc.value)
              }

              return result
            }

            if (!this._defer) {
              this._listeners.forEach(function (listener) {
                listener.call(_this10, {
                  data: obj
                })
              })

              return
            }

            var cloned = new WeakMap()
            const e = {
              data: cloneValue(obj)
            }

            this._deferred.then(function () {
              _this10._listeners.forEach(function (listener) {
                listener.call(_this10, e)
              })
            })
          }
        }, {
          key: 'addEventListener',
          value: function addEventListener (name, listener) {
            this._listeners.push(listener)
          }
        }, {
          key: 'removeEventListener',
          value: function removeEventListener (name, listener) {
            const i = this._listeners.indexOf(listener)

            this._listeners.splice(i, 1)
          }
        }, {
          key: 'terminate',
          value: function terminate () {
            this._listeners.length = 0
          }
        }])

        return LoopbackPort
      }())

      exports.LoopbackPort = LoopbackPort

      var PDFWorker = (function PDFWorkerClosure () {
        const pdfWorkerPorts = new WeakMap()
        let isWorkerDisabled = false
        let fallbackWorkerSrc
        let nextFakeWorkerId = 0
        let fakeWorkerCapability

        if (_is_node.isNodeJS && typeof require === 'function') {
          isWorkerDisabled = true
          fallbackWorkerSrc = './pdf.worker.js'
        } else if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && 'currentScript' in document) {
          const pdfjsFilePath = document.currentScript && document.currentScript.src

          if (pdfjsFilePath) {
            fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2')
          }
        }

        function _getWorkerSrc () {
          if (_worker_options.GlobalWorkerOptions.workerSrc) {
            return _worker_options.GlobalWorkerOptions.workerSrc
          }

          if (typeof fallbackWorkerSrc !== 'undefined') {
            if (!_is_node.isNodeJS) {
              (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.')
            }

            return fallbackWorkerSrc
          }

          throw new Error('No "GlobalWorkerOptions.workerSrc" specified.')
        }

        function getMainThreadWorkerMessageHandler () {
          let mainWorkerMessageHandler

          try {
            mainWorkerMessageHandler = globalThis.pdfjsWorker && globalThis.pdfjsWorker.WorkerMessageHandler
          } catch (ex) {}

          return mainWorkerMessageHandler || null
        }

        function setupFakeWorkerGlobal () {
          if (fakeWorkerCapability) {
            return fakeWorkerCapability.promise
          }

          fakeWorkerCapability = (0, _util.createPromiseCapability)()

          const loader = /* #__PURE__ */(function () {
            const _ref8 = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee () {
              let mainWorkerMessageHandler, worker
              return _regenerator.default.wrap(function _callee$ (_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      mainWorkerMessageHandler = getMainThreadWorkerMessageHandler()

                      if (!mainWorkerMessageHandler) {
                        _context.next = 3
                        break
                      }

                      return _context.abrupt('return', mainWorkerMessageHandler)

                    case 3:
                      if (!(_is_node.isNodeJS && typeof require === 'function')) {
                        _context.next = 6
                        break
                      }

                      worker = eval('require')(_getWorkerSrc())
                      return _context.abrupt('return', worker.WorkerMessageHandler)

                    case 6:
                      _context.next = 8
                      return (0, _display_utils.loadScript)(_getWorkerSrc())

                    case 8:
                      return _context.abrupt('return', window.pdfjsWorker.WorkerMessageHandler)

                    case 9:
                    case 'end':
                      return _context.stop()
                  }
                }
              }, _callee)
            }))

            return function loader () {
              return _ref8.apply(this, arguments)
            }
          }())

          loader().then(fakeWorkerCapability.resolve, fakeWorkerCapability.reject)
          return fakeWorkerCapability.promise
        }

        function createCDNWrapper (url) {
          const wrapper = "importScripts('" + url + "');"
          return URL.createObjectURL(new Blob([wrapper]))
        }

        const PDFWorker = /* #__PURE__ */(function () {
          function PDFWorker () {
            const _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
            const _ref9$name = _ref9.name
            const name = _ref9$name === void 0 ? null : _ref9$name
            const _ref9$port = _ref9.port
            const port = _ref9$port === void 0 ? null : _ref9$port
            const _ref9$verbosity = _ref9.verbosity
            const verbosity = _ref9$verbosity === void 0 ? (0, _util.getVerbosityLevel)() : _ref9$verbosity

            _classCallCheck(this, PDFWorker)

            if (port && pdfWorkerPorts.has(port)) {
              throw new Error('Cannot use more than one PDFWorker per port')
            }

            this.name = name
            this.destroyed = false
            this.postMessageTransfers = true
            this.verbosity = verbosity
            this._readyCapability = (0, _util.createPromiseCapability)()
            this._port = null
            this._webWorker = null
            this._messageHandler = null

            if (port) {
              pdfWorkerPorts.set(port, this)

              this._initializeFromPort(port)

              return
            }

            this._initialize()
          }

          _createClass(PDFWorker, [{
            key: '_initializeFromPort',
            value: function _initializeFromPort (port) {
              this._port = port
              this._messageHandler = new _message_handler.MessageHandler('main', 'worker', port)

              this._messageHandler.on('ready', function () {})

              this._readyCapability.resolve()
            }
          }, {
            key: '_initialize',
            value: function _initialize () {
              const _this11 = this

              if (typeof Worker !== 'undefined' && !isWorkerDisabled && !getMainThreadWorkerMessageHandler()) {
                let workerSrc = _getWorkerSrc()

                try {
                  if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
                    workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href)
                  }

                  const worker = new Worker(workerSrc)
                  const messageHandler = new _message_handler.MessageHandler('main', 'worker', worker)

                  const terminateEarly = function terminateEarly () {
                    worker.removeEventListener('error', onWorkerError)
                    messageHandler.destroy()
                    worker.terminate()

                    if (_this11.destroyed) {
                      _this11._readyCapability.reject(new Error('Worker was destroyed'))
                    } else {
                      _this11._setupFakeWorker()
                    }
                  }

                  var onWorkerError = function onWorkerError () {
                    if (!_this11._webWorker) {
                      terminateEarly()
                    }
                  }

                  worker.addEventListener('error', onWorkerError)
                  messageHandler.on('test', function (data) {
                    worker.removeEventListener('error', onWorkerError)

                    if (_this11.destroyed) {
                      terminateEarly()
                      return
                    }

                    if (data) {
                      _this11._messageHandler = messageHandler
                      _this11._port = worker
                      _this11._webWorker = worker

                      if (!data.supportTransfers) {
                        _this11.postMessageTransfers = false
                      }

                      _this11._readyCapability.resolve()

                      messageHandler.send('configure', {
                        verbosity: _this11.verbosity
                      })
                    } else {
                      _this11._setupFakeWorker()

                      messageHandler.destroy()
                      worker.terminate()
                    }
                  })
                  messageHandler.on('ready', function (data) {
                    worker.removeEventListener('error', onWorkerError)

                    if (_this11.destroyed) {
                      terminateEarly()
                      return
                    }

                    try {
                      sendTest()
                    } catch (e) {
                      _this11._setupFakeWorker()
                    }
                  })

                  var sendTest = function sendTest () {
                    const testObj = new Uint8Array([_this11.postMessageTransfers ? 255 : 0])

                    try {
                      messageHandler.send('test', testObj, [testObj.buffer])
                    } catch (ex) {
                      (0, _util.warn)('Cannot use postMessage transfers.')
                      testObj[0] = 0
                      messageHandler.send('test', testObj)
                    }
                  }

                  sendTest()
                  return
                } catch (e) {
                  (0, _util.info)('The worker has been disabled.')
                }
              }

              this._setupFakeWorker()
            }
          }, {
            key: '_setupFakeWorker',
            value: function _setupFakeWorker () {
              const _this12 = this

              if (!isWorkerDisabled) {
                (0, _util.warn)('Setting up fake worker.')
                isWorkerDisabled = true
              }

              setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
                if (_this12.destroyed) {
                  _this12._readyCapability.reject(new Error('Worker was destroyed'))

                  return
                }

                const port = new LoopbackPort()
                _this12._port = port
                const id = 'fake' + nextFakeWorkerId++
                const workerHandler = new _message_handler.MessageHandler(id + '_worker', id, port)
                WorkerMessageHandler.setup(workerHandler, port)
                const messageHandler = new _message_handler.MessageHandler(id, id + '_worker', port)
                _this12._messageHandler = messageHandler

                _this12._readyCapability.resolve()

                messageHandler.send('configure', {
                  verbosity: _this12.verbosity
                })
              }).catch(function (reason) {
                _this12._readyCapability.reject(new Error('Setting up fake worker failed: "'.concat(reason.message, '".')))
              })
            }
          }, {
            key: 'destroy',
            value: function destroy () {
              this.destroyed = true

              if (this._webWorker) {
                this._webWorker.terminate()

                this._webWorker = null
              }

              pdfWorkerPorts.delete(this._port)
              this._port = null

              if (this._messageHandler) {
                this._messageHandler.destroy()

                this._messageHandler = null
              }
            }
          }, {
            key: 'promise',
            get: function get () {
              return this._readyCapability.promise
            }
          }, {
            key: 'port',
            get: function get () {
              return this._port
            }
          }, {
            key: 'messageHandler',
            get: function get () {
              return this._messageHandler
            }
          }], [{
            key: 'fromPort',
            value: function fromPort (params) {
              if (!params || !params.port) {
                throw new Error('PDFWorker.fromPort - invalid method signature.')
              }

              if (pdfWorkerPorts.has(params.port)) {
                return pdfWorkerPorts.get(params.port)
              }

              return new PDFWorker(params)
            }
          }, {
            key: 'getWorkerSrc',
            value: function getWorkerSrc () {
              return _getWorkerSrc()
            }
          }])

          return PDFWorker
        }())

        return PDFWorker
      }())

      exports.PDFWorker = PDFWorker

      var WorkerTransport = /* #__PURE__ */(function () {
        function WorkerTransport (messageHandler, loadingTask, networkStream, params) {
          _classCallCheck(this, WorkerTransport)

          this.messageHandler = messageHandler
          this.loadingTask = loadingTask
          this.commonObjs = new PDFObjects()
          this.fontLoader = new _font_loader.FontLoader({
            docId: loadingTask.docId,
            onUnsupportedFeature: this._onUnsupportedFeature.bind(this)
          })
          this._params = params
          this.CMapReaderFactory = new params.CMapReaderFactory({
            baseUrl: params.cMapUrl,
            isCompressed: params.cMapPacked
          })
          this.destroyed = false
          this.destroyCapability = null
          this._passwordCapability = null
          this._networkStream = networkStream
          this._fullReader = null
          this._lastProgress = null
          this.pageCache = []
          this.pagePromises = []
          this.downloadInfoCapability = (0, _util.createPromiseCapability)()
          this.setupMessageHandler()
        }

        _createClass(WorkerTransport, [{
          key: 'destroy',
          value: function destroy () {
            const _this13 = this

            if (this.destroyCapability) {
              return this.destroyCapability.promise
            }

            this.destroyed = true
            this.destroyCapability = (0, _util.createPromiseCapability)()

            if (this._passwordCapability) {
              this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'))
            }

            const waitOn = []
            this.pageCache.forEach(function (page) {
              if (page) {
                waitOn.push(page._destroy())
              }
            })
            this.pageCache.length = 0
            this.pagePromises.length = 0
            const terminated = this.messageHandler.sendWithPromise('Terminate', null)
            waitOn.push(terminated)
            Promise.all(waitOn).then(function () {
              _this13.fontLoader.clear()

              if (_this13._networkStream) {
                _this13._networkStream.cancelAllRequests(new _util.AbortException('Worker was terminated.'))
              }

              if (_this13.messageHandler) {
                _this13.messageHandler.destroy()

                _this13.messageHandler = null
              }

              _this13.destroyCapability.resolve()
            }, this.destroyCapability.reject)
            return this.destroyCapability.promise
          }
        }, {
          key: 'setupMessageHandler',
          value: function setupMessageHandler () {
            const _this14 = this

            const messageHandler = this.messageHandler
            const loadingTask = this.loadingTask
            messageHandler.on('GetReader', function (data, sink) {
              (0, _util.assert)(_this14._networkStream)
              _this14._fullReader = _this14._networkStream.getFullReader()

              _this14._fullReader.onProgress = function (evt) {
                _this14._lastProgress = {
                  loaded: evt.loaded,
                  total: evt.total
                }
              }

              sink.onPull = function () {
                _this14._fullReader.read().then(function (_ref10) {
                  const value = _ref10.value
                  const done = _ref10.done

                  if (done) {
                    sink.close()
                    return
                  }

                  (0, _util.assert)((0, _util.isArrayBuffer)(value))
                  sink.enqueue(new Uint8Array(value), 1, [value])
                }).catch(function (reason) {
                  sink.error(reason)
                })
              }

              sink.onCancel = function (reason) {
                _this14._fullReader.cancel(reason)
              }
            })
            messageHandler.on('ReaderHeadersReady', function (data) {
              const headersCapability = (0, _util.createPromiseCapability)()
              const fullReader = _this14._fullReader
              fullReader.headersReady.then(function () {
                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                  if (_this14._lastProgress && loadingTask.onProgress) {
                    loadingTask.onProgress(_this14._lastProgress)
                  }

                  fullReader.onProgress = function (evt) {
                    if (loadingTask.onProgress) {
                      loadingTask.onProgress({
                        loaded: evt.loaded,
                        total: evt.total
                      })
                    }
                  }
                }

                headersCapability.resolve({
                  isStreamingSupported: fullReader.isStreamingSupported,
                  isRangeSupported: fullReader.isRangeSupported,
                  contentLength: fullReader.contentLength
                })
              }, headersCapability.reject)
              return headersCapability.promise
            })
            messageHandler.on('GetRangeReader', function (data, sink) {
              (0, _util.assert)(_this14._networkStream)

              const rangeReader = _this14._networkStream.getRangeReader(data.begin, data.end)

              if (!rangeReader) {
                sink.close()
                return
              }

              sink.onPull = function () {
                rangeReader.read().then(function (_ref11) {
                  const value = _ref11.value
                  const done = _ref11.done

                  if (done) {
                    sink.close()
                    return
                  }

                  (0, _util.assert)((0, _util.isArrayBuffer)(value))
                  sink.enqueue(new Uint8Array(value), 1, [value])
                }).catch(function (reason) {
                  sink.error(reason)
                })
              }

              sink.onCancel = function (reason) {
                rangeReader.cancel(reason)
              }
            })
            messageHandler.on('GetDoc', function (_ref12) {
              const pdfInfo = _ref12.pdfInfo
              _this14._numPages = pdfInfo.numPages

              loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, _this14))
            })
            messageHandler.on('DocException', function (ex) {
              let reason

              switch (ex.name) {
                case 'PasswordException':
                  reason = new _util.PasswordException(ex.message, ex.code)
                  break

                case 'InvalidPDFException':
                  reason = new _util.InvalidPDFException(ex.message)
                  break

                case 'MissingPDFException':
                  reason = new _util.MissingPDFException(ex.message)
                  break

                case 'UnexpectedResponseException':
                  reason = new _util.UnexpectedResponseException(ex.message, ex.status)
                  break

                case 'UnknownErrorException':
                  reason = new _util.UnknownErrorException(ex.message, ex.details)
                  break
              }

              loadingTask._capability.reject(reason)
            })
            messageHandler.on('PasswordRequest', function (exception) {
              _this14._passwordCapability = (0, _util.createPromiseCapability)()

              if (loadingTask.onPassword) {
                const updatePassword = function updatePassword (password) {
                  _this14._passwordCapability.resolve({
                    password: password
                  })
                }

                try {
                  loadingTask.onPassword(updatePassword, exception.code)
                } catch (ex) {
                  _this14._passwordCapability.reject(ex)
                }
              } else {
                _this14._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code))
              }

              return _this14._passwordCapability.promise
            })
            messageHandler.on('DataLoaded', function (data) {
              if (loadingTask.onProgress) {
                loadingTask.onProgress({
                  loaded: data.length,
                  total: data.length
                })
              }

              _this14.downloadInfoCapability.resolve(data)
            })
            messageHandler.on('StartRenderPage', function (data) {
              if (_this14.destroyed) {
                return
              }

              const page = _this14.pageCache[data.pageIndex]

              page._startRenderPage(data.transparency, data.intent)
            })
            messageHandler.on('commonobj', function (data) {
              if (_this14.destroyed) {
                return
              }

              const _data = _slicedToArray(data, 3)
              const id = _data[0]
              const type = _data[1]
              const exportedData = _data[2]

              if (_this14.commonObjs.has(id)) {
                return
              }

              switch (type) {
                case 'Font':
                  var params = _this14._params

                  if ('error' in exportedData) {
                    const exportedError = exportedData.error;
                    (0, _util.warn)('Error during font loading: '.concat(exportedError))

                    _this14.commonObjs.resolve(id, exportedError)

                    break
                  }

                  var fontRegistry = null

                  if (params.pdfBug && globalThis.FontInspector && globalThis.FontInspector.enabled) {
                    fontRegistry = {
                      registerFont: function registerFont (font, url) {
                        globalThis.FontInspector.fontAdded(font, url)
                      }
                    }
                  }

                  var font = new _font_loader.FontFaceObject(exportedData, {
                    isEvalSupported: params.isEvalSupported,
                    disableFontFace: params.disableFontFace,
                    ignoreErrors: params.ignoreErrors,
                    onUnsupportedFeature: _this14._onUnsupportedFeature.bind(_this14),
                    fontRegistry: fontRegistry
                  })

                  _this14.fontLoader.bind(font).then(function () {
                    _this14.commonObjs.resolve(id, font)
                  }, function (reason) {
                    messageHandler.sendWithPromise('FontFallback', {
                      id: id
                    }).finally(function () {
                      _this14.commonObjs.resolve(id, font)
                    })
                  })

                  break

                case 'FontPath':
                case 'FontType3Res':
                  _this14.commonObjs.resolve(id, exportedData)

                  break

                default:
                  throw new Error('Got unknown common object type '.concat(type))
              }
            })
            messageHandler.on('obj', function (data) {
              if (_this14.destroyed) {
                return undefined
              }

              const _data2 = _slicedToArray(data, 4)
              const id = _data2[0]
              const pageIndex = _data2[1]
              const type = _data2[2]
              const imageData = _data2[3]

              const pageProxy = _this14.pageCache[pageIndex]

              if (pageProxy.objs.has(id)) {
                return undefined
              }

              switch (type) {
                case 'JpegStream':
                  return new Promise(function (resolve, reject) {
                    const img = new Image()

                    img.onload = function () {
                      resolve(img)
                    }

                    img.onerror = function () {
                      reject(new Error('Error during JPEG image loading'));
                      (0, _display_utils.releaseImageResources)(img)
                    }

                    img.src = imageData
                  }).then(function (img) {
                    pageProxy.objs.resolve(id, img)
                  })

                case 'Image':
                  pageProxy.objs.resolve(id, imageData)
                  var MAX_IMAGE_SIZE_TO_STORE = 8000000

                  if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
                    pageProxy.cleanupAfterRender = true
                  }

                  break

                default:
                  throw new Error('Got unknown object type '.concat(type))
              }

              return undefined
            })
            messageHandler.on('DocProgress', function (data) {
              if (_this14.destroyed) {
                return
              }

              if (loadingTask.onProgress) {
                loadingTask.onProgress({
                  loaded: data.loaded,
                  total: data.total
                })
              }
            })
            messageHandler.on('UnsupportedFeature', this._onUnsupportedFeature.bind(this))
            messageHandler.on('JpegDecode', function (data) {
              if (_this14.destroyed) {
                return Promise.reject(new Error('Worker was destroyed'))
              }

              if (typeof document === 'undefined') {
                return Promise.reject(new Error('"document" is not defined.'))
              }

              const _data3 = _slicedToArray(data, 2)
              const imageUrl = _data3[0]
              const components = _data3[1]

              if (components !== 3 && components !== 1) {
                return Promise.reject(new Error('Only 3 components or 1 component can be returned'))
              }

              return new Promise(function (resolve, reject) {
                const img = new Image()

                img.onload = function () {
                  const width = img.width
                  const height = img.height
                  const size = width * height
                  const rgbaLength = size * 4
                  const buf = new Uint8ClampedArray(size * components)
                  let tmpCanvas = document.createElement('canvas')
                  tmpCanvas.width = width
                  tmpCanvas.height = height
                  let tmpCtx = tmpCanvas.getContext('2d')
                  tmpCtx.drawImage(img, 0, 0)
                  const data = tmpCtx.getImageData(0, 0, width, height).data

                  if (components === 3) {
                    for (let i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
                      buf[j] = data[i]
                      buf[j + 1] = data[i + 1]
                      buf[j + 2] = data[i + 2]
                    }
                  } else if (components === 1) {
                    for (let _i2 = 0, _j = 0; _i2 < rgbaLength; _i2 += 4, _j++) {
                      buf[_j] = data[_i2]
                    }
                  }

                  resolve({
                    data: buf,
                    width: width,
                    height: height
                  });
                  (0, _display_utils.releaseImageResources)(img)
                  tmpCanvas.width = 0
                  tmpCanvas.height = 0
                  tmpCanvas = null
                  tmpCtx = null
                }

                img.onerror = function () {
                  reject(new Error('JpegDecode failed to load image'));
                  (0, _display_utils.releaseImageResources)(img)
                }

                img.src = imageUrl
              })
            })
            messageHandler.on('FetchBuiltInCMap', function (data, sink) {
              if (_this14.destroyed) {
                sink.error(new Error('Worker was destroyed'))
                return
              }

              let fetched = false

              sink.onPull = function () {
                if (fetched) {
                  sink.close()
                  return
                }

                fetched = true

                _this14.CMapReaderFactory.fetch(data).then(function (builtInCMap) {
                  sink.enqueue(builtInCMap, 1, [builtInCMap.cMapData.buffer])
                }).catch(function (reason) {
                  sink.error(reason)
                })
              }
            })
          }
        }, {
          key: '_onUnsupportedFeature',
          value: function _onUnsupportedFeature (_ref13) {
            const featureId = _ref13.featureId

            if (this.destroyed) {
              return
            }

            if (this.loadingTask.onUnsupportedFeature) {
              this.loadingTask.onUnsupportedFeature(featureId)
            }
          }
        }, {
          key: 'getData',
          value: function getData () {
            return this.messageHandler.sendWithPromise('GetData', null)
          }
        }, {
          key: 'getPage',
          value: function getPage (pageNumber) {
            const _this15 = this

            if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
              return Promise.reject(new Error('Invalid page request'))
            }

            const pageIndex = pageNumber - 1

            if (pageIndex in this.pagePromises) {
              return this.pagePromises[pageIndex]
            }

            const promise = this.messageHandler.sendWithPromise('GetPage', {
              pageIndex: pageIndex
            }).then(function (pageInfo) {
              if (_this15.destroyed) {
                throw new Error('Transport destroyed')
              }

              const page = new PDFPageProxy(pageIndex, pageInfo, _this15, _this15._params.pdfBug)
              _this15.pageCache[pageIndex] = page
              return page
            })
            this.pagePromises[pageIndex] = promise
            return promise
          }
        }, {
          key: 'getPageIndex',
          value: function getPageIndex (ref) {
            return this.messageHandler.sendWithPromise('GetPageIndex', {
              ref: ref
            }).catch(function (reason) {
              return Promise.reject(new Error(reason))
            })
          }
        }, {
          key: 'getAnnotations',
          value: function getAnnotations (pageIndex, intent) {
            return this.messageHandler.sendWithPromise('GetAnnotations', {
              pageIndex: pageIndex,
              intent: intent
            })
          }
        }, {
          key: 'getDestinations',
          value: function getDestinations () {
            return this.messageHandler.sendWithPromise('GetDestinations', null)
          }
        }, {
          key: 'getDestination',
          value: function getDestination (id) {
            if (typeof id !== 'string') {
              return Promise.reject(new Error('Invalid destination request.'))
            }

            return this.messageHandler.sendWithPromise('GetDestination', {
              id: id
            })
          }
        }, {
          key: 'getPageLabels',
          value: function getPageLabels () {
            return this.messageHandler.sendWithPromise('GetPageLabels', null)
          }
        }, {
          key: 'getPageLayout',
          value: function getPageLayout () {
            return this.messageHandler.sendWithPromise('GetPageLayout', null)
          }
        }, {
          key: 'getPageMode',
          value: function getPageMode () {
            return this.messageHandler.sendWithPromise('GetPageMode', null)
          }
        }, {
          key: 'getViewerPreferences',
          value: function getViewerPreferences () {
            return this.messageHandler.sendWithPromise('GetViewerPreferences', null)
          }
        }, {
          key: 'getOpenAction',
          value: function getOpenAction () {
            return this.messageHandler.sendWithPromise('GetOpenAction', null)
          }
        }, {
          key: 'getAttachments',
          value: function getAttachments () {
            return this.messageHandler.sendWithPromise('GetAttachments', null)
          }
        }, {
          key: 'getJavaScript',
          value: function getJavaScript () {
            return this.messageHandler.sendWithPromise('GetJavaScript', null)
          }
        }, {
          key: 'getOutline',
          value: function getOutline () {
            return this.messageHandler.sendWithPromise('GetOutline', null)
          }
        }, {
          key: 'getPermissions',
          value: function getPermissions () {
            return this.messageHandler.sendWithPromise('GetPermissions', null)
          }
        }, {
          key: 'getMetadata',
          value: function getMetadata () {
            const _this16 = this

            return this.messageHandler.sendWithPromise('GetMetadata', null).then(function (results) {
              return {
                info: results[0],
                metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                contentDispositionFilename: _this16._fullReader ? _this16._fullReader.filename : null
              }
            })
          }
        }, {
          key: 'getStats',
          value: function getStats () {
            return this.messageHandler.sendWithPromise('GetStats', null)
          }
        }, {
          key: 'startCleanup',
          value: function startCleanup () {
            const _this17 = this

            return this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
              for (let i = 0, ii = _this17.pageCache.length; i < ii; i++) {
                const page = _this17.pageCache[i]

                if (page) {
                  const cleanupSuccessful = page.cleanup()

                  if (!cleanupSuccessful) {
                    throw new Error('startCleanup: Page '.concat(i + 1, ' is currently rendering.'))
                  }
                }
              }

              _this17.commonObjs.clear()

              _this17.fontLoader.clear()
            })
          }
        }, {
          key: 'loadingParams',
          get: function get () {
            const params = this._params
            return (0, _util.shadow)(this, 'loadingParams', {
              disableAutoFetch: params.disableAutoFetch,
              disableCreateObjectURL: params.disableCreateObjectURL,
              disableFontFace: params.disableFontFace,
              nativeImageDecoderSupport: params.nativeImageDecoderSupport
            })
          }
        }])

        return WorkerTransport
      }())

      var PDFObjects = /* #__PURE__ */(function () {
        function PDFObjects () {
          _classCallCheck(this, PDFObjects)

          this._objs = Object.create(null)
        }

        _createClass(PDFObjects, [{
          key: '_ensureObj',
          value: function _ensureObj (objId) {
            if (this._objs[objId]) {
              return this._objs[objId]
            }

            return this._objs[objId] = {
              capability: (0, _util.createPromiseCapability)(),
              data: null,
              resolved: false
            }
          }
        }, {
          key: 'get',
          value: function get (objId) {
            const callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null

            if (callback) {
              this._ensureObj(objId).capability.promise.then(callback)

              return null
            }

            const obj = this._objs[objId]

            if (!obj || !obj.resolved) {
              throw new Error("Requesting object that isn't resolved yet ".concat(objId, '.'))
            }

            return obj.data
          }
        }, {
          key: 'has',
          value: function has (objId) {
            const obj = this._objs[objId]
            return obj ? obj.resolved : false
          }
        }, {
          key: 'resolve',
          value: function resolve (objId, data) {
            const obj = this._ensureObj(objId)

            obj.resolved = true
            obj.data = data
            obj.capability.resolve(data)
          }
        }, {
          key: 'clear',
          value: function clear () {
            for (const objId in this._objs) {
              const data = this._objs[objId].data

              if (typeof Image !== 'undefined' && data instanceof Image) {
                (0, _display_utils.releaseImageResources)(data)
              }
            }

            this._objs = Object.create(null)
          }
        }])

        return PDFObjects
      }())

      const RenderTask = /* #__PURE__ */(function () {
        function RenderTask (internalRenderTask) {
          _classCallCheck(this, RenderTask)

          this._internalRenderTask = internalRenderTask
          this.onContinue = null
        }

        _createClass(RenderTask, [{
          key: 'cancel',
          value: function cancel () {
            this._internalRenderTask.cancel()
          }
        }, {
          key: 'then',
          value: function then (onFulfilled, onRejected) {
            throw new Error('Removed API method: ' + 'RenderTask.then, use the `promise` getter instead.')
          }
        }, {
          key: 'promise',
          get: function get () {
            return this._internalRenderTask.capability.promise
          }
        }])

        return RenderTask
      }())

      var InternalRenderTask = (function InternalRenderTaskClosure () {
        const canvasInRendering = new WeakSet()

        const InternalRenderTask = /* #__PURE__ */(function () {
          function InternalRenderTask (_ref14) {
            const callback = _ref14.callback
            const params = _ref14.params
            const objs = _ref14.objs
            const commonObjs = _ref14.commonObjs
            const operatorList = _ref14.operatorList
            const pageIndex = _ref14.pageIndex
            const canvasFactory = _ref14.canvasFactory
            const webGLContext = _ref14.webGLContext
            const _ref14$useRequestAnim = _ref14.useRequestAnimationFrame
            const useRequestAnimationFrame = _ref14$useRequestAnim === void 0 ? false : _ref14$useRequestAnim
            const _ref14$pdfBug = _ref14.pdfBug
            const pdfBug = _ref14$pdfBug === void 0 ? false : _ref14$pdfBug

            _classCallCheck(this, InternalRenderTask)

            this.callback = callback
            this.params = params
            this.objs = objs
            this.commonObjs = commonObjs
            this.operatorListIdx = null
            this.operatorList = operatorList
            this._pageIndex = pageIndex
            this.canvasFactory = canvasFactory
            this.webGLContext = webGLContext
            this._pdfBug = pdfBug
            this.running = false
            this.graphicsReadyCallback = null
            this.graphicsReady = false
            this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== 'undefined'
            this.cancelled = false
            this.capability = (0, _util.createPromiseCapability)()
            this.task = new RenderTask(this)
            this._continueBound = this._continue.bind(this)
            this._scheduleNextBound = this._scheduleNext.bind(this)
            this._nextBound = this._next.bind(this)
            this._canvas = params.canvasContext.canvas
          }

          _createClass(InternalRenderTask, [{
            key: 'initializeGraphics',
            value: function initializeGraphics () {
              const transparency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false

              if (this.cancelled) {
                return
              }

              if (this._canvas) {
                if (canvasInRendering.has(this._canvas)) {
                  throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.')
                }

                canvasInRendering.add(this._canvas)
              }

              if (this._pdfBug && globalThis.StepperManager && globalThis.StepperManager.enabled) {
                this.stepper = globalThis.StepperManager.create(this._pageIndex)
                this.stepper.init(this.operatorList)
                this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint()
              }

              const _this$params = this.params
              const canvasContext = _this$params.canvasContext
              const viewport = _this$params.viewport
              const transform = _this$params.transform
              const imageLayer = _this$params.imageLayer
              const background = _this$params.background
              this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, imageLayer)
              this.gfx.beginDrawing({
                transform: transform,
                viewport: viewport,
                transparency: transparency,
                background: background
              })
              this.operatorListIdx = 0
              this.graphicsReady = true

              if (this.graphicsReadyCallback) {
                this.graphicsReadyCallback()
              }
            }
          }, {
            key: 'cancel',
            value: function cancel () {
              const error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null
              this.running = false
              this.cancelled = true

              if (this.gfx) {
                this.gfx.endDrawing()
              }

              if (this._canvas) {
                canvasInRendering.delete(this._canvas)
              }

              this.callback(error || new _display_utils.RenderingCancelledException('Rendering cancelled, page '.concat(this._pageIndex + 1), 'canvas'))
            }
          }, {
            key: 'operatorListChanged',
            value: function operatorListChanged () {
              if (!this.graphicsReady) {
                if (!this.graphicsReadyCallback) {
                  this.graphicsReadyCallback = this._continueBound
                }

                return
              }

              if (this.stepper) {
                this.stepper.updateOperatorList(this.operatorList)
              }

              if (this.running) {
                return
              }

              this._continue()
            }
          }, {
            key: '_continue',
            value: function _continue () {
              this.running = true

              if (this.cancelled) {
                return
              }

              if (this.task.onContinue) {
                this.task.onContinue(this._scheduleNextBound)
              } else {
                this._scheduleNext()
              }
            }
          }, {
            key: '_scheduleNext',
            value: function _scheduleNext () {
              const _this18 = this

              if (this._useRequestAnimationFrame) {
                window.requestAnimationFrame(function () {
                  _this18._nextBound().catch(_this18.cancel.bind(_this18))
                })
              } else {
                Promise.resolve().then(this._nextBound).catch(this.cancel.bind(this))
              }
            }
          }, {
            key: '_next',
            value: (function () {
              const _next2 = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee2 () {
                return _regenerator.default.wrap(function _callee2$ (_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!this.cancelled) {
                          _context2.next = 2
                          break
                        }

                        return _context2.abrupt('return')

                      case 2:
                        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper)

                        if (this.operatorListIdx === this.operatorList.argsArray.length) {
                          this.running = false

                          if (this.operatorList.lastChunk) {
                            this.gfx.endDrawing()

                            if (this._canvas) {
                              canvasInRendering.delete(this._canvas)
                            }

                            this.callback()
                          }
                        }

                      case 4:
                      case 'end':
                        return _context2.stop()
                    }
                  }
                }, _callee2, this)
              }))

              function _next () {
                return _next2.apply(this, arguments)
              }

              return _next
            }())
          }])

          return InternalRenderTask
        }())

        return InternalRenderTask
      }())

      const version = '2.4.456'
      exports.version = version
      const build = '228a591c'
      exports.build = build
      /***/ },
    /* 191 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      module.exports = __w_pdfjs_require__(192)
      /***/ },
    /* 192 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict';
      /* WEBPACK VAR INJECTION */(function (module) {
        function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

        const runtime = (function (exports) {
          'use strict'

          const Op = Object.prototype
          const hasOwn = Op.hasOwnProperty
          let undefined
          const $Symbol = typeof Symbol === 'function' ? Symbol : {}
          const iteratorSymbol = $Symbol.iterator || '@@iterator'
          const asyncIteratorSymbol = $Symbol.asyncIterator || '@@asyncIterator'
          const toStringTagSymbol = $Symbol.toStringTag || '@@toStringTag'

          function wrap (innerFn, outerFn, self, tryLocsList) {
            const protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator
            const generator = Object.create(protoGenerator.prototype)
            const context = new Context(tryLocsList || [])
            generator._invoke = makeInvokeMethod(innerFn, self, context)
            return generator
          }

          exports.wrap = wrap

          function tryCatch (fn, obj, arg) {
            try {
              return {
                type: 'normal',
                arg: fn.call(obj, arg)
              }
            } catch (err) {
              return {
                type: 'throw',
                arg: err
              }
            }
          }

          const GenStateSuspendedStart = 'suspendedStart'
          const GenStateSuspendedYield = 'suspendedYield'
          const GenStateExecuting = 'executing'
          const GenStateCompleted = 'completed'
          const ContinueSentinel = {}

          function Generator () {}

          function GeneratorFunction () {}

          function GeneratorFunctionPrototype () {}

          let IteratorPrototype = {}

          IteratorPrototype[iteratorSymbol] = function () {
            return this
          }

          const getProto = Object.getPrototypeOf
          const NativeIteratorPrototype = getProto && getProto(getProto(values([])))

          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            IteratorPrototype = NativeIteratorPrototype
          }

          const Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype)
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype
          GeneratorFunctionPrototype.constructor = GeneratorFunction
          GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = 'GeneratorFunction'

          function defineIteratorMethods (prototype) {
            ['next', 'throw', 'return'].forEach(function (method) {
              prototype[method] = function (arg) {
                return this._invoke(method, arg)
              }
            })
          }

          exports.isGeneratorFunction = function (genFun) {
            const ctor = typeof genFun === 'function' && genFun.constructor
            return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === 'GeneratorFunction' : false
          }

          exports.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype)
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype

              if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = 'GeneratorFunction'
              }
            }

            genFun.prototype = Object.create(Gp)
            return genFun
          }

          exports.awrap = function (arg) {
            return {
              __await: arg
            }
          }

          function AsyncIterator (generator, PromiseImpl) {
            function invoke (method, arg, resolve, reject) {
              const record = tryCatch(generator[method], generator, arg)

              if (record.type === 'throw') {
                reject(record.arg)
              } else {
                const result = record.arg
                const value = result.value

                if (value && _typeof(value) === 'object' && hasOwn.call(value, '__await')) {
                  return PromiseImpl.resolve(value.__await).then(function (value) {
                    invoke('next', value, resolve, reject)
                  }, function (err) {
                    invoke('throw', err, resolve, reject)
                  })
                }

                return PromiseImpl.resolve(value).then(function (unwrapped) {
                  result.value = unwrapped
                  resolve(result)
                }, function (error) {
                  return invoke('throw', error, resolve, reject)
                })
              }
            }

            let previousPromise

            function enqueue (method, arg) {
              function callInvokeWithMethodAndArg () {
                return new PromiseImpl(function (resolve, reject) {
                  invoke(method, arg, resolve, reject)
                })
              }

              return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg()
            }

            this._invoke = enqueue
          }

          defineIteratorMethods(AsyncIterator.prototype)

          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this
          }

          exports.AsyncIterator = AsyncIterator

          exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
            if (PromiseImpl === void 0) PromiseImpl = Promise
            const iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl)
            return exports.isGeneratorFunction(outerFn)
              ? iter
              : iter.next().then(function (result) {
                return result.done ? result.value : iter.next()
              })
          }

          function makeInvokeMethod (innerFn, self, context) {
            let state = GenStateSuspendedStart
            return function invoke (method, arg) {
              if (state === GenStateExecuting) {
                throw new Error('Generator is already running')
              }

              if (state === GenStateCompleted) {
                if (method === 'throw') {
                  throw arg
                }

                return doneResult()
              }

              context.method = method
              context.arg = arg

              while (true) {
                const delegate = context.delegate

                if (delegate) {
                  const delegateResult = maybeInvokeDelegate(delegate, context)

                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue
                    return delegateResult
                  }
                }

                if (context.method === 'next') {
                  context.sent = context._sent = context.arg
                } else if (context.method === 'throw') {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted
                    throw context.arg
                  }

                  context.dispatchException(context.arg)
                } else if (context.method === 'return') {
                  context.abrupt('return', context.arg)
                }

                state = GenStateExecuting
                const record = tryCatch(innerFn, self, context)

                if (record.type === 'normal') {
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield

                  if (record.arg === ContinueSentinel) {
                    continue
                  }

                  return {
                    value: record.arg,
                    done: context.done
                  }
                } else if (record.type === 'throw') {
                  state = GenStateCompleted
                  context.method = 'throw'
                  context.arg = record.arg
                }
              }
            }
          }

          function maybeInvokeDelegate (delegate, context) {
            const method = delegate.iterator[context.method]

            if (method === undefined) {
              context.delegate = null

              if (context.method === 'throw') {
                if (delegate.iterator.return) {
                  context.method = 'return'
                  context.arg = undefined
                  maybeInvokeDelegate(delegate, context)

                  if (context.method === 'throw') {
                    return ContinueSentinel
                  }
                }

                context.method = 'throw'
                context.arg = new TypeError("The iterator does not provide a 'throw' method")
              }

              return ContinueSentinel
            }

            const record = tryCatch(method, delegate.iterator, context.arg)

            if (record.type === 'throw') {
              context.method = 'throw'
              context.arg = record.arg
              context.delegate = null
              return ContinueSentinel
            }

            const info = record.arg

            if (!info) {
              context.method = 'throw'
              context.arg = new TypeError('iterator result is not an object')
              context.delegate = null
              return ContinueSentinel
            }

            if (info.done) {
              context[delegate.resultName] = info.value
              context.next = delegate.nextLoc

              if (context.method !== 'return') {
                context.method = 'next'
                context.arg = undefined
              }
            } else {
              return info
            }

            context.delegate = null
            return ContinueSentinel
          }

          defineIteratorMethods(Gp)
          Gp[toStringTagSymbol] = 'Generator'

          Gp[iteratorSymbol] = function () {
            return this
          }

          Gp.toString = function () {
            return '[object Generator]'
          }

          function pushTryEntry (locs) {
            const entry = {
              tryLoc: locs[0]
            }

            if (1 in locs) {
              entry.catchLoc = locs[1]
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2]
              entry.afterLoc = locs[3]
            }

            this.tryEntries.push(entry)
          }

          function resetTryEntry (entry) {
            const record = entry.completion || {}
            record.type = 'normal'
            delete record.arg
            entry.completion = record
          }

          function Context (tryLocsList) {
            this.tryEntries = [{
              tryLoc: 'root'
            }]
            tryLocsList.forEach(pushTryEntry, this)
            this.reset(true)
          }

          exports.keys = function (object) {
            const keys = []

            for (const key in object) {
              keys.push(key)
            }

            keys.reverse()
            return function next () {
              while (keys.length) {
                const key = keys.pop()

                if (key in object) {
                  next.value = key
                  next.done = false
                  return next
                }
              }

              next.done = true
              return next
            }
          }

          function values (iterable) {
            if (iterable) {
              const iteratorMethod = iterable[iteratorSymbol]

              if (iteratorMethod) {
                return iteratorMethod.call(iterable)
              }

              if (typeof iterable.next === 'function') {
                return iterable
              }

              if (!isNaN(iterable.length)) {
                let i = -1
                const next = function next () {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i]
                      next.done = false
                      return next
                    }
                  }

                  next.value = undefined
                  next.done = true
                  return next
                }

                return next.next = next
              }
            }

            return {
              next: doneResult
            }
          }

          exports.values = values

          function doneResult () {
            return {
              value: undefined,
              done: true
            }
          }

          Context.prototype = {
            constructor: Context,
            reset: function reset (skipTempReset) {
              this.prev = 0
              this.next = 0
              this.sent = this._sent = undefined
              this.done = false
              this.delegate = null
              this.method = 'next'
              this.arg = undefined
              this.tryEntries.forEach(resetTryEntry)

              if (!skipTempReset) {
                for (const name in this) {
                  if (name.charAt(0) === 't' && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined
                  }
                }
              }
            },
            stop: function stop () {
              this.done = true
              const rootEntry = this.tryEntries[0]
              const rootRecord = rootEntry.completion

              if (rootRecord.type === 'throw') {
                throw rootRecord.arg
              }

              return this.rval
            },
            dispatchException: function dispatchException (exception) {
              if (this.done) {
                throw exception
              }

              const context = this

              function handle (loc, caught) {
                record.type = 'throw'
                record.arg = exception
                context.next = loc

                if (caught) {
                  context.method = 'next'
                  context.arg = undefined
                }

                return !!caught
              }

              for (let i = this.tryEntries.length - 1; i >= 0; --i) {
                const entry = this.tryEntries[i]
                var record = entry.completion

                if (entry.tryLoc === 'root') {
                  return handle('end')
                }

                if (entry.tryLoc <= this.prev) {
                  const hasCatch = hasOwn.call(entry, 'catchLoc')
                  const hasFinally = hasOwn.call(entry, 'finallyLoc')

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true)
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc)
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true)
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc)
                    }
                  } else {
                    throw new Error('try statement without catch or finally')
                  }
                }
              }
            },
            abrupt: function abrupt (type, arg) {
              for (let i = this.tryEntries.length - 1; i >= 0; --i) {
                const entry = this.tryEntries[i]

                if (entry.tryLoc <= this.prev && hasOwn.call(entry, 'finallyLoc') && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry
                  break
                }
              }

              if (finallyEntry && (type === 'break' || type === 'continue') && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                finallyEntry = null
              }

              const record = finallyEntry ? finallyEntry.completion : {}
              record.type = type
              record.arg = arg

              if (finallyEntry) {
                this.method = 'next'
                this.next = finallyEntry.finallyLoc
                return ContinueSentinel
              }

              return this.complete(record)
            },
            complete: function complete (record, afterLoc) {
              if (record.type === 'throw') {
                throw record.arg
              }

              if (record.type === 'break' || record.type === 'continue') {
                this.next = record.arg
              } else if (record.type === 'return') {
                this.rval = this.arg = record.arg
                this.method = 'return'
                this.next = 'end'
              } else if (record.type === 'normal' && afterLoc) {
                this.next = afterLoc
              }

              return ContinueSentinel
            },
            finish: function finish (finallyLoc) {
              for (let i = this.tryEntries.length - 1; i >= 0; --i) {
                const entry = this.tryEntries[i]

                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc)
                  resetTryEntry(entry)
                  return ContinueSentinel
                }
              }
            },
            catch: function _catch (tryLoc) {
              for (let i = this.tryEntries.length - 1; i >= 0; --i) {
                const entry = this.tryEntries[i]

                if (entry.tryLoc === tryLoc) {
                  const record = entry.completion

                  if (record.type === 'throw') {
                    var thrown = record.arg
                    resetTryEntry(entry)
                  }

                  return thrown
                }
              }

              throw new Error('illegal catch attempt')
            },
            delegateYield: function delegateYield (iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              }

              if (this.method === 'next') {
                this.arg = undefined
              }

              return ContinueSentinel
            }
          }
          return exports
        }((false ? undefined : _typeof(module)) === 'object' ? module.exports : {}))

        try {
          regeneratorRuntime = runtime
        } catch (accidentalStrictMode) {
          Function('r', 'regeneratorRuntime = r')(runtime)
        }
        /* WEBPACK VAR INJECTION */ }.call(this, __w_pdfjs_require__(193)(module)))
      /***/ },
    /* 193 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      module.exports = function (module) {
        if (!module.webpackPolyfill) {
          module.deprecate = function () {}

          module.paths = []
          if (!module.children) module.children = []
          Object.defineProperty(module, 'loaded', {
            enumerable: true,
            get: function get () {
              return module.l
            }
          })
          Object.defineProperty(module, 'id', {
            enumerable: true,
            get: function get () {
              return module.i
            }
          })
          module.webpackPolyfill = 1
        }

        return module
      }
      /***/ },
    /* 194 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.addLinkAttributes = addLinkAttributes
      exports.getFilenameFromUrl = getFilenameFromUrl
      exports.isFetchSupported = isFetchSupported
      exports.isValidFetchUrl = isValidFetchUrl
      exports.loadScript = loadScript
      exports.deprecated = deprecated
      exports.releaseImageResources = releaseImageResources
      exports.PDFDateString = exports.StatTimer = exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.LinkTarget = exports.RenderingCancelledException = exports.PageViewport = void 0

      const _regenerator = _interopRequireDefault(__w_pdfjs_require__(191))

      const _util = __w_pdfjs_require__(1)

      function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      function _possibleConstructorReturn (self, call) { if (call && (_typeof(call) === 'object' || typeof call === 'function')) { return call } return _assertThisInitialized(self) }

      function _assertThisInitialized (self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called") } return self }

      function _getPrototypeOf (o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf (o) { return o.__proto__ || Object.getPrototypeOf(o) }; return _getPrototypeOf(o) }

      function _inherits (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function') } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass) }

      function _setPrototypeOf (o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf (o, p) { o.__proto__ = p; return o }; return _setPrototypeOf(o, p) }

      function asyncGeneratorStep (gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value } catch (error) { reject(error); return } if (info.done) { resolve(value) } else { Promise.resolve(value).then(_next, _throw) } }

      function _asyncToGenerator (fn) { return function () { const self = this; const args = arguments; return new Promise(function (resolve, reject) { const gen = fn.apply(self, args); function _next (value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value) } function _throw (err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err) } _next(undefined) }) } }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      const DEFAULT_LINK_REL = 'noopener noreferrer nofollow'
      exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL
      const SVG_NS = 'http://www.w3.org/2000/svg'

      const DOMCanvasFactory = /* #__PURE__ */(function () {
        function DOMCanvasFactory () {
          _classCallCheck(this, DOMCanvasFactory)
        }

        _createClass(DOMCanvasFactory, [{
          key: 'create',
          value: function create (width, height) {
            if (width <= 0 || height <= 0) {
              throw new Error('Invalid canvas size')
            }

            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            canvas.width = width
            canvas.height = height
            return {
              canvas: canvas,
              context: context
            }
          }
        }, {
          key: 'reset',
          value: function reset (canvasAndContext, width, height) {
            if (!canvasAndContext.canvas) {
              throw new Error('Canvas is not specified')
            }

            if (width <= 0 || height <= 0) {
              throw new Error('Invalid canvas size')
            }

            canvasAndContext.canvas.width = width
            canvasAndContext.canvas.height = height
          }
        }, {
          key: 'destroy',
          value: function destroy (canvasAndContext) {
            if (!canvasAndContext.canvas) {
              throw new Error('Canvas is not specified')
            }

            canvasAndContext.canvas.width = 0
            canvasAndContext.canvas.height = 0
            canvasAndContext.canvas = null
            canvasAndContext.context = null
          }
        }])

        return DOMCanvasFactory
      }())

      exports.DOMCanvasFactory = DOMCanvasFactory

      const DOMCMapReaderFactory = /* #__PURE__ */(function () {
        function DOMCMapReaderFactory (_ref) {
          const _ref$baseUrl = _ref.baseUrl
          const baseUrl = _ref$baseUrl === void 0 ? null : _ref$baseUrl
          const _ref$isCompressed = _ref.isCompressed
          const isCompressed = _ref$isCompressed === void 0 ? false : _ref$isCompressed

          _classCallCheck(this, DOMCMapReaderFactory)

          this.baseUrl = baseUrl
          this.isCompressed = isCompressed
        }

        _createClass(DOMCMapReaderFactory, [{
          key: 'fetch',
          value: (function (_fetch) {
            function fetch (_x) {
              return _fetch.apply(this, arguments)
            }

            fetch.toString = function () {
              return _fetch.toString()
            }

            return fetch
          }(/* #__PURE__ */function () {
            const _ref2 = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee2 (_ref3) {
              const _this = this

              let name, url, compressionType
              return _regenerator.default.wrap(function _callee2$ (_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      name = _ref3.name

                      if (this.baseUrl) {
                        _context2.next = 3
                        break
                      }

                      throw new Error('The CMap "baseUrl" parameter must be specified, ensure that ' + 'the "cMapUrl" and "cMapPacked" API parameters are provided.')

                    case 3:
                      if (name) {
                        _context2.next = 5
                        break
                      }

                      throw new Error('CMap name must be specified.')

                    case 5:
                      url = this.baseUrl + name + (this.isCompressed ? '.bcmap' : '')
                      compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE

                      if (!(isFetchSupported() && isValidFetchUrl(url, document.baseURI))) {
                        _context2.next = 9
                        break
                      }

                      return _context2.abrupt('return', fetch(url).then(/* #__PURE__ */function () {
                        const _ref4 = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee (response) {
                          let cMapData
                          return _regenerator.default.wrap(function _callee$ (_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  if (response.ok) {
                                    _context.next = 2
                                    break
                                  }

                                  throw new Error(response.statusText)

                                case 2:
                                  if (!_this.isCompressed) {
                                    _context.next = 10
                                    break
                                  }

                                  _context.t0 = Uint8Array
                                  _context.next = 6
                                  return response.arrayBuffer()

                                case 6:
                                  _context.t1 = _context.sent
                                  cMapData = new _context.t0(_context.t1)
                                  _context.next = 15
                                  break

                                case 10:
                                  _context.t2 = _util.stringToBytes
                                  _context.next = 13
                                  return response.text()

                                case 13:
                                  _context.t3 = _context.sent
                                  cMapData = (0, _context.t2)(_context.t3)

                                case 15:
                                  return _context.abrupt('return', {
                                    cMapData: cMapData,
                                    compressionType: compressionType
                                  })

                                case 16:
                                case 'end':
                                  return _context.stop()
                              }
                            }
                          }, _callee)
                        }))

                        return function (_x3) {
                          return _ref4.apply(this, arguments)
                        }
                      }()).catch(function (reason) {
                        throw new Error('Unable to load '.concat(_this.isCompressed ? 'binary ' : '') + 'CMap at: '.concat(url))
                      }))

                    case 9:
                      return _context2.abrupt('return', new Promise(function (resolve, reject) {
                        const request = new XMLHttpRequest()
                        request.open('GET', url, true)

                        if (_this.isCompressed) {
                          request.responseType = 'arraybuffer'
                        }

                        request.onreadystatechange = function () {
                          if (request.readyState !== XMLHttpRequest.DONE) {
                            return
                          }

                          if (request.status === 200 || request.status === 0) {
                            let cMapData

                            if (_this.isCompressed && request.response) {
                              cMapData = new Uint8Array(request.response)
                            } else if (!_this.isCompressed && request.responseText) {
                              cMapData = (0, _util.stringToBytes)(request.responseText)
                            }

                            if (cMapData) {
                              resolve({
                                cMapData: cMapData,
                                compressionType: compressionType
                              })
                              return
                            }
                          }

                          reject(new Error(request.statusText))
                        }

                        request.send(null)
                      }).catch(function (reason) {
                        throw new Error('Unable to load '.concat(_this.isCompressed ? 'binary ' : '') + 'CMap at: '.concat(url))
                      }))

                    case 10:
                    case 'end':
                      return _context2.stop()
                  }
                }
              }, _callee2, this)
            }))

            return function (_x2) {
              return _ref2.apply(this, arguments)
            }
          }()))
        }])

        return DOMCMapReaderFactory
      }())

      exports.DOMCMapReaderFactory = DOMCMapReaderFactory

      const DOMSVGFactory = /* #__PURE__ */(function () {
        function DOMSVGFactory () {
          _classCallCheck(this, DOMSVGFactory)
        }

        _createClass(DOMSVGFactory, [{
          key: 'create',
          value: function create (width, height) {
            (0, _util.assert)(width > 0 && height > 0, 'Invalid SVG dimensions')
            const svg = document.createElementNS(SVG_NS, 'svg:svg')
            svg.setAttribute('version', '1.1')
            svg.setAttribute('width', width + 'px')
            svg.setAttribute('height', height + 'px')
            svg.setAttribute('preserveAspectRatio', 'none')
            svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height)
            return svg
          }
        }, {
          key: 'createElement',
          value: function createElement (type) {
            (0, _util.assert)(typeof type === 'string', 'Invalid SVG element type')
            return document.createElementNS(SVG_NS, type)
          }
        }])

        return DOMSVGFactory
      }())

      exports.DOMSVGFactory = DOMSVGFactory

      const PageViewport = /* #__PURE__ */(function () {
        function PageViewport (_ref5) {
          const viewBox = _ref5.viewBox
          const scale = _ref5.scale
          let rotation = _ref5.rotation
          const _ref5$offsetX = _ref5.offsetX
          const offsetX = _ref5$offsetX === void 0 ? 0 : _ref5$offsetX
          const _ref5$offsetY = _ref5.offsetY
          const offsetY = _ref5$offsetY === void 0 ? 0 : _ref5$offsetY
          const _ref5$dontFlip = _ref5.dontFlip
          const dontFlip = _ref5$dontFlip === void 0 ? false : _ref5$dontFlip

          _classCallCheck(this, PageViewport)

          this.viewBox = viewBox
          this.scale = scale
          this.rotation = rotation
          this.offsetX = offsetX
          this.offsetY = offsetY
          const centerX = (viewBox[2] + viewBox[0]) / 2
          const centerY = (viewBox[3] + viewBox[1]) / 2
          let rotateA, rotateB, rotateC, rotateD
          rotation = rotation % 360
          rotation = rotation < 0 ? rotation + 360 : rotation

          switch (rotation) {
            case 180:
              rotateA = -1
              rotateB = 0
              rotateC = 0
              rotateD = 1
              break

            case 90:
              rotateA = 0
              rotateB = 1
              rotateC = 1
              rotateD = 0
              break

            case 270:
              rotateA = 0
              rotateB = -1
              rotateC = -1
              rotateD = 0
              break

            default:
              rotateA = 1
              rotateB = 0
              rotateC = 0
              rotateD = -1
              break
          }

          if (dontFlip) {
            rotateC = -rotateC
            rotateD = -rotateD
          }

          let offsetCanvasX, offsetCanvasY
          let width, height

          if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY
            width = Math.abs(viewBox[3] - viewBox[1]) * scale
            height = Math.abs(viewBox[2] - viewBox[0]) * scale
          } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY
            width = Math.abs(viewBox[2] - viewBox[0]) * scale
            height = Math.abs(viewBox[3] - viewBox[1]) * scale
          }

          this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY]
          this.width = width
          this.height = height
        }

        _createClass(PageViewport, [{
          key: 'clone',
          value: function clone () {
            const _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
            const _ref6$scale = _ref6.scale
            const scale = _ref6$scale === void 0 ? this.scale : _ref6$scale
            const _ref6$rotation = _ref6.rotation
            const rotation = _ref6$rotation === void 0 ? this.rotation : _ref6$rotation
            const _ref6$offsetX = _ref6.offsetX
            const offsetX = _ref6$offsetX === void 0 ? this.offsetX : _ref6$offsetX
            const _ref6$offsetY = _ref6.offsetY
            const offsetY = _ref6$offsetY === void 0 ? this.offsetY : _ref6$offsetY
            const _ref6$dontFlip = _ref6.dontFlip
            const dontFlip = _ref6$dontFlip === void 0 ? false : _ref6$dontFlip

            return new PageViewport({
              viewBox: this.viewBox.slice(),
              scale: scale,
              rotation: rotation,
              offsetX: offsetX,
              offsetY: offsetY,
              dontFlip: dontFlip
            })
          }
        }, {
          key: 'convertToViewportPoint',
          value: function convertToViewportPoint (x, y) {
            return _util.Util.applyTransform([x, y], this.transform)
          }
        }, {
          key: 'convertToViewportRectangle',
          value: function convertToViewportRectangle (rect) {
            const topLeft = _util.Util.applyTransform([rect[0], rect[1]], this.transform)

            const bottomRight = _util.Util.applyTransform([rect[2], rect[3]], this.transform)

            return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]]
          }
        }, {
          key: 'convertToPdfPoint',
          value: function convertToPdfPoint (x, y) {
            return _util.Util.applyInverseTransform([x, y], this.transform)
          }
        }])

        return PageViewport
      }())

      exports.PageViewport = PageViewport

      const RenderingCancelledException = /* #__PURE__ */(function (_BaseException) {
        _inherits(RenderingCancelledException, _BaseException)

        function RenderingCancelledException (msg, type) {
          let _this2

          _classCallCheck(this, RenderingCancelledException)

          _this2 = _possibleConstructorReturn(this, _getPrototypeOf(RenderingCancelledException).call(this, msg))
          _this2.type = type
          return _this2
        }

        return RenderingCancelledException
      }(_util.BaseException))

      exports.RenderingCancelledException = RenderingCancelledException
      const LinkTarget = {
        NONE: 0,
        SELF: 1,
        BLANK: 2,
        PARENT: 3,
        TOP: 4
      }
      exports.LinkTarget = LinkTarget

      function addLinkAttributes (link) {
        const _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
        const url = _ref7.url
        const target = _ref7.target
        const rel = _ref7.rel
        const _ref7$enabled = _ref7.enabled
        const enabled = _ref7$enabled === void 0 ? true : _ref7$enabled;

        (0, _util.assert)(url && typeof url === 'string', 'addLinkAttributes: A valid "url" parameter must provided.')
        const urlNullRemoved = (0, _util.removeNullCharacters)(url)

        if (enabled) {
          link.href = link.title = urlNullRemoved
        } else {
          link.href = ''
          link.title = 'Disabled: '.concat(urlNullRemoved)

          link.onclick = function () {
            return false
          }
        }

        let targetStr = ''

        switch (target) {
          case LinkTarget.NONE:
            break

          case LinkTarget.SELF:
            targetStr = '_self'
            break

          case LinkTarget.BLANK:
            targetStr = '_blank'
            break

          case LinkTarget.PARENT:
            targetStr = '_parent'
            break

          case LinkTarget.TOP:
            targetStr = '_top'
            break
        }

        link.target = targetStr
        link.rel = typeof rel === 'string' ? rel : DEFAULT_LINK_REL
      }

      function getFilenameFromUrl (url) {
        const anchor = url.indexOf('#')
        const query = url.indexOf('?')
        const end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length)
        return url.substring(url.lastIndexOf('/', end) + 1, end)
      }

      const StatTimer = /* #__PURE__ */(function () {
        function StatTimer () {
          _classCallCheck(this, StatTimer)

          this.started = Object.create(null)
          this.times = []
        }

        _createClass(StatTimer, [{
          key: 'time',
          value: function time (name) {
            if (name in this.started) {
              (0, _util.warn)('Timer is already running for '.concat(name))
            }

            this.started[name] = Date.now()
          }
        }, {
          key: 'timeEnd',
          value: function timeEnd (name) {
            if (!(name in this.started)) {
              (0, _util.warn)('Timer has not been started for '.concat(name))
            }

            this.times.push({
              name: name,
              start: this.started[name],
              end: Date.now()
            })
            delete this.started[name]
          }
        }, {
          key: 'toString',
          value: function toString () {
            const outBuf = []
            let longest = 0
            let _iteratorNormalCompletion = true
            let _didIteratorError = false
            let _iteratorError

            try {
              for (var _iterator = this.times[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                const time = _step.value
                const name = time.name

                if (name.length > longest) {
                  longest = name.length
                }
              }
            } catch (err) {
              _didIteratorError = true
              _iteratorError = err
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return()
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError
                }
              }
            }

            let _iteratorNormalCompletion2 = true
            let _didIteratorError2 = false
            let _iteratorError2

            try {
              for (var _iterator2 = this.times[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                const _time = _step2.value
                const duration = _time.end - _time.start
                outBuf.push(''.concat(_time.name.padEnd(longest), ' ').concat(duration, 'ms\n'))
              }
            } catch (err) {
              _didIteratorError2 = true
              _iteratorError2 = err
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return()
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2
                }
              }
            }

            return outBuf.join('')
          }
        }])

        return StatTimer
      }())

      exports.StatTimer = StatTimer

      function isFetchSupported () {
        return typeof fetch !== 'undefined' && typeof Response !== 'undefined' && 'body' in Response.prototype && typeof ReadableStream !== 'undefined'
      }

      function isValidFetchUrl (url, baseUrl) {
        try {
          const _ref8 = baseUrl ? new URL(url, baseUrl) : new URL(url)
          const protocol = _ref8.protocol

          return protocol === 'http:' || protocol === 'https:'
        } catch (ex) {
          return false
        }
      }

      function loadScript (src) {
        return new Promise(function (resolve, reject) {
          const script = document.createElement('script')
          script.src = src
          script.onload = resolve

          script.onerror = function () {
            reject(new Error('Cannot load script at: '.concat(script.src)))
          };

          (document.head || document.documentElement).appendChild(script)
        })
      }

      function deprecated (details) {
        console.log('Deprecated API usage: ' + details)
      }

      function releaseImageResources (img) {
        (0, _util.assert)(img instanceof Image, 'Invalid `img` parameter.')
        const url = img.src

        if (typeof url === 'string' && url.startsWith('blob:') && URL.revokeObjectURL) {
          URL.revokeObjectURL(url)
        }

        img.removeAttribute('src')
      }

      let pdfDateStringRegex

      const PDFDateString = /* #__PURE__ */(function () {
        function PDFDateString () {
          _classCallCheck(this, PDFDateString)
        }

        _createClass(PDFDateString, null, [{
          key: 'toDateObject',
          value: function toDateObject (input) {
            if (!input || !(0, _util.isString)(input)) {
              return null
            }

            if (!pdfDateStringRegex) {
              pdfDateStringRegex = new RegExp('^D:' + '(\\d{4})' + '(\\d{2})?' + '(\\d{2})?' + '(\\d{2})?' + '(\\d{2})?' + '(\\d{2})?' + '([Z|+|-])?' + '(\\d{2})?' + "'?" + '(\\d{2})?' + "'?")
            }

            const matches = pdfDateStringRegex.exec(input)

            if (!matches) {
              return null
            }

            const year = parseInt(matches[1], 10)
            let month = parseInt(matches[2], 10)
            month = month >= 1 && month <= 12 ? month - 1 : 0
            let day = parseInt(matches[3], 10)
            day = day >= 1 && day <= 31 ? day : 1
            let hour = parseInt(matches[4], 10)
            hour = hour >= 0 && hour <= 23 ? hour : 0
            let minute = parseInt(matches[5], 10)
            minute = minute >= 0 && minute <= 59 ? minute : 0
            let second = parseInt(matches[6], 10)
            second = second >= 0 && second <= 59 ? second : 0
            const universalTimeRelation = matches[7] || 'Z'
            let offsetHour = parseInt(matches[8], 10)
            offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0
            let offsetMinute = parseInt(matches[9], 10) || 0
            offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0

            if (universalTimeRelation === '-') {
              hour += offsetHour
              minute += offsetMinute
            } else if (universalTimeRelation === '+') {
              hour -= offsetHour
              minute -= offsetMinute
            }

            return new Date(Date.UTC(year, month, day, hour, minute, second))
          }
        }])

        return PDFDateString
      }())

      exports.PDFDateString = PDFDateString
      /***/ },
    /* 195 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.FontLoader = exports.FontFaceObject = void 0

      const _regenerator = _interopRequireDefault(__w_pdfjs_require__(191))

      const _util = __w_pdfjs_require__(1)

      function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      function _possibleConstructorReturn (self, call) { if (call && (_typeof(call) === 'object' || typeof call === 'function')) { return call } return _assertThisInitialized(self) }

      function _assertThisInitialized (self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called") } return self }

      function _getPrototypeOf (o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf (o) { return o.__proto__ || Object.getPrototypeOf(o) }; return _getPrototypeOf(o) }

      function _inherits (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function') } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass) }

      function _setPrototypeOf (o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf (o, p) { o.__proto__ = p; return o }; return _setPrototypeOf(o, p) }

      function asyncGeneratorStep (gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value } catch (error) { reject(error); return } if (info.done) { resolve(value) } else { Promise.resolve(value).then(_next, _throw) } }

      function _asyncToGenerator (fn) { return function () { const self = this; const args = arguments; return new Promise(function (resolve, reject) { const gen = fn.apply(self, args); function _next (value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value) } function _throw (err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err) } _next(undefined) }) } }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      const BaseFontLoader = /* #__PURE__ */(function () {
        function BaseFontLoader (_ref) {
          const docId = _ref.docId
          const onUnsupportedFeature = _ref.onUnsupportedFeature

          _classCallCheck(this, BaseFontLoader)

          if (this.constructor === BaseFontLoader) {
            (0, _util.unreachable)('Cannot initialize BaseFontLoader.')
          }

          this.docId = docId
          this._onUnsupportedFeature = onUnsupportedFeature
          this.nativeFontFaces = []
          this.styleElement = null
        }

        _createClass(BaseFontLoader, [{
          key: 'addNativeFontFace',
          value: function addNativeFontFace (nativeFontFace) {
            this.nativeFontFaces.push(nativeFontFace)
            document.fonts.add(nativeFontFace)
          }
        }, {
          key: 'insertRule',
          value: function insertRule (rule) {
            let styleElement = this.styleElement

            if (!styleElement) {
              styleElement = this.styleElement = document.createElement('style')
              styleElement.id = 'PDFJS_FONT_STYLE_TAG_'.concat(this.docId)
              document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement)
            }

            const styleSheet = styleElement.sheet
            styleSheet.insertRule(rule, styleSheet.cssRules.length)
          }
        }, {
          key: 'clear',
          value: function clear () {
            this.nativeFontFaces.forEach(function (nativeFontFace) {
              document.fonts.delete(nativeFontFace)
            })
            this.nativeFontFaces.length = 0

            if (this.styleElement) {
              this.styleElement.remove()
              this.styleElement = null
            }
          }
        }, {
          key: 'bind',
          value: (function () {
            const _bind = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee (font) {
              const _this = this

              let nativeFontFace, rule
              return _regenerator.default.wrap(function _callee$ (_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(font.attached || font.missingFile)) {
                        _context.next = 2
                        break
                      }

                      return _context.abrupt('return')

                    case 2:
                      font.attached = true

                      if (!this.isFontLoadingAPISupported) {
                        _context.next = 19
                        break
                      }

                      nativeFontFace = font.createNativeFontFace()

                      if (!nativeFontFace) {
                        _context.next = 18
                        break
                      }

                      this.addNativeFontFace(nativeFontFace)
                      _context.prev = 7
                      _context.next = 10
                      return nativeFontFace.loaded

                    case 10:
                      _context.next = 18
                      break

                    case 12:
                      _context.prev = 12
                      _context.t0 = _context.catch(7)

                      this._onUnsupportedFeature({
                        featureId: _util.UNSUPPORTED_FEATURES.font
                      });

                      (0, _util.warn)("Failed to load font '".concat(nativeFontFace.family, "': '").concat(_context.t0, "'."))
                      font.disableFontFace = true
                      throw _context.t0

                    case 18:
                      return _context.abrupt('return')

                    case 19:
                      rule = font.createFontFaceRule()

                      if (!rule) {
                        _context.next = 26
                        break
                      }

                      this.insertRule(rule)

                      if (!this.isSyncFontLoadingSupported) {
                        _context.next = 24
                        break
                      }

                      return _context.abrupt('return')

                    case 24:
                      _context.next = 26
                      return new Promise(function (resolve) {
                        const request = _this._queueLoadingCallback(resolve)

                        _this._prepareFontLoadEvent([rule], [font], request)
                      })

                    case 26:
                    case 'end':
                      return _context.stop()
                  }
                }
              }, _callee, this, [[7, 12]])
            }))

            function bind (_x) {
              return _bind.apply(this, arguments)
            }

            return bind
          }())
        }, {
          key: '_queueLoadingCallback',
          value: function _queueLoadingCallback (callback) {
            (0, _util.unreachable)('Abstract method `_queueLoadingCallback`.')
          }
        }, {
          key: '_prepareFontLoadEvent',
          value: function _prepareFontLoadEvent (rules, fontsToLoad, request) {
            (0, _util.unreachable)('Abstract method `_prepareFontLoadEvent`.')
          }
        }, {
          key: 'isFontLoadingAPISupported',
          get: function get () {
            const supported = typeof document !== 'undefined' && !!document.fonts
            return (0, _util.shadow)(this, 'isFontLoadingAPISupported', supported)
          }
        }, {
          key: 'isSyncFontLoadingSupported',
          get: function get () {
            (0, _util.unreachable)('Abstract method `isSyncFontLoadingSupported`.')
          }
        }, {
          key: '_loadTestFont',
          get: function get () {
            (0, _util.unreachable)('Abstract method `_loadTestFont`.')
          }
        }])

        return BaseFontLoader
      }())

      let FontLoader
      exports.FontLoader = FontLoader
      {
        exports.FontLoader = FontLoader = /* #__PURE__ */(function (_BaseFontLoader) {
          _inherits(GenericFontLoader, _BaseFontLoader)

          function GenericFontLoader (docId) {
            let _this2

            _classCallCheck(this, GenericFontLoader)

            _this2 = _possibleConstructorReturn(this, _getPrototypeOf(GenericFontLoader).call(this, docId))
            _this2.loadingContext = {
              requests: [],
              nextRequestId: 0
            }
            _this2.loadTestFontId = 0
            return _this2
          }

          _createClass(GenericFontLoader, [{
            key: '_queueLoadingCallback',
            value: function _queueLoadingCallback (callback) {
              function completeRequest () {
                (0, _util.assert)(!request.done, 'completeRequest() cannot be called twice.')
                request.done = true

                while (context.requests.length > 0 && context.requests[0].done) {
                  const otherRequest = context.requests.shift()
                  setTimeout(otherRequest.callback, 0)
                }
              }

              var context = this.loadingContext
              var request = {
                id: 'pdfjs-font-loading-'.concat(context.nextRequestId++),
                done: false,
                complete: completeRequest,
                callback: callback
              }
              context.requests.push(request)
              return request
            }
          }, {
            key: '_prepareFontLoadEvent',
            value: function _prepareFontLoadEvent (rules, fonts, request) {
              function int32 (data, offset) {
                return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff
              }

              function spliceString (s, offset, remove, insert) {
                const chunk1 = s.substring(0, offset)
                const chunk2 = s.substring(offset + remove)
                return chunk1 + insert + chunk2
              }

              let i, ii
              const canvas = document.createElement('canvas')
              canvas.width = 1
              canvas.height = 1
              const ctx = canvas.getContext('2d')
              let called = 0

              function isFontReady (name, callback) {
                called++

                if (called > 30) {
                  (0, _util.warn)('Load test font never loaded.')
                  callback()
                  return
                }

                ctx.font = '30px ' + name
                ctx.fillText('.', 0, 20)
                const imageData = ctx.getImageData(0, 0, 1, 1)

                if (imageData.data[3] > 0) {
                  callback()
                  return
                }

                setTimeout(isFontReady.bind(null, name, callback))
              }

              const loadTestFontId = 'lt'.concat(Date.now()).concat(this.loadTestFontId++)
              let data = this._loadTestFont
              const COMMENT_OFFSET = 976
              data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId)
              const CFF_CHECKSUM_OFFSET = 16
              const XXXX_VALUE = 0x58585858
              let checksum = int32(data, CFF_CHECKSUM_OFFSET)

              for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
                checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0
              }

              if (i < loadTestFontId.length) {
                checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0
              }

              data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum))
              const url = 'url(data:font/opentype;base64,'.concat(btoa(data), ');')
              const rule = '@font-face {font-family:"'.concat(loadTestFontId, '";src:').concat(url, '}')
              this.insertRule(rule)
              const names = []

              for (i = 0, ii = fonts.length; i < ii; i++) {
                names.push(fonts[i].loadedName)
              }

              names.push(loadTestFontId)
              const div = document.createElement('div')
              div.style.visibility = 'hidden'
              div.style.width = div.style.height = '10px'
              div.style.position = 'absolute'
              div.style.top = div.style.left = '0px'

              for (i = 0, ii = names.length; i < ii; ++i) {
                const span = document.createElement('span')
                span.textContent = 'Hi'
                span.style.fontFamily = names[i]
                div.appendChild(span)
              }

              document.body.appendChild(div)
              isFontReady(loadTestFontId, function () {
                document.body.removeChild(div)
                request.complete()
              })
            }
          }, {
            key: 'isSyncFontLoadingSupported',
            get: function get () {
              let supported = false

              if (typeof navigator === 'undefined') {
                supported = true
              } else {
                const m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent)

                if (m && m[1] >= 14) {
                  supported = true
                }
              }

              return (0, _util.shadow)(this, 'isSyncFontLoadingSupported', supported)
            }
          }, {
            key: '_loadTestFont',
            get: function get () {
              const getLoadTestFont = function getLoadTestFont () {
                return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQA' + 'FQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAA' + 'ALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgA' + 'AAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1' + 'AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD' + '6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACM' + 'AooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4D' + 'IP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAA' + 'AAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUA' + 'AQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgAB' + 'AAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABY' + 'AAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAA' + 'AC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAA' + 'AAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQAC' + 'AQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3' + 'Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTj' + 'FQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==')
              }

              return (0, _util.shadow)(this, '_loadTestFont', getLoadTestFont())
            }
          }])

          return GenericFontLoader
        }(BaseFontLoader))
      }

      const FontFaceObject = /* #__PURE__ */(function () {
        function FontFaceObject (translatedData, _ref2) {
          const _ref2$isEvalSupported = _ref2.isEvalSupported
          const isEvalSupported = _ref2$isEvalSupported === void 0 ? true : _ref2$isEvalSupported
          const _ref2$disableFontFace = _ref2.disableFontFace
          const disableFontFace = _ref2$disableFontFace === void 0 ? false : _ref2$disableFontFace
          const _ref2$ignoreErrors = _ref2.ignoreErrors
          const ignoreErrors = _ref2$ignoreErrors === void 0 ? false : _ref2$ignoreErrors
          const _ref2$onUnsupportedFe = _ref2.onUnsupportedFeature
          const onUnsupportedFeature = _ref2$onUnsupportedFe === void 0 ? null : _ref2$onUnsupportedFe
          const _ref2$fontRegistry = _ref2.fontRegistry
          const fontRegistry = _ref2$fontRegistry === void 0 ? null : _ref2$fontRegistry

          _classCallCheck(this, FontFaceObject)

          this.compiledGlyphs = Object.create(null)

          for (const i in translatedData) {
            this[i] = translatedData[i]
          }

          this.isEvalSupported = isEvalSupported !== false
          this.disableFontFace = disableFontFace === true
          this.ignoreErrors = ignoreErrors === true
          this._onUnsupportedFeature = onUnsupportedFeature
          this.fontRegistry = fontRegistry
        }

        _createClass(FontFaceObject, [{
          key: 'createNativeFontFace',
          value: function createNativeFontFace () {
            if (!this.data || this.disableFontFace) {
              return null
            }

            const nativeFontFace = new FontFace(this.loadedName, this.data, {})

            if (this.fontRegistry) {
              this.fontRegistry.registerFont(this)
            }

            return nativeFontFace
          }
        }, {
          key: 'createFontFaceRule',
          value: function createFontFaceRule () {
            if (!this.data || this.disableFontFace) {
              return null
            }

            const data = (0, _util.bytesToString)(new Uint8Array(this.data))
            const url = 'url(data:'.concat(this.mimetype, ';base64,').concat(btoa(data), ');')
            const rule = '@font-face {font-family:"'.concat(this.loadedName, '";src:').concat(url, '}')

            if (this.fontRegistry) {
              this.fontRegistry.registerFont(this, url)
            }

            return rule
          }
        }, {
          key: 'getPathGenerator',
          value: function getPathGenerator (objs, character) {
            if (this.compiledGlyphs[character] !== undefined) {
              return this.compiledGlyphs[character]
            }

            let cmds, current

            try {
              cmds = objs.get(this.loadedName + '_path_' + character)
            } catch (ex) {
              if (!this.ignoreErrors) {
                throw ex
              }

              if (this._onUnsupportedFeature) {
                this._onUnsupportedFeature({
                  featureId: _util.UNSUPPORTED_FEATURES.font
                })
              }

              (0, _util.warn)('getPathGenerator - ignoring character: "'.concat(ex, '".'))
              return this.compiledGlyphs[character] = function (c, size) {}
            }

            if (this.isEvalSupported && _util.IsEvalSupportedCached.value) {
              let args
              let js = ''

              for (let i = 0, ii = cmds.length; i < ii; i++) {
                current = cmds[i]

                if (current.args !== undefined) {
                  args = current.args.join(',')
                } else {
                  args = ''
                }

                js += 'c.' + current.cmd + '(' + args + ');\n'
              }

              return this.compiledGlyphs[character] = new Function('c', 'size', js)
            }

            return this.compiledGlyphs[character] = function (c, size) {
              for (let _i = 0, _ii = cmds.length; _i < _ii; _i++) {
                current = cmds[_i]

                if (current.cmd === 'scale') {
                  current.args = [size, -size]
                }

                c[current.cmd].apply(c, current.args)
              }
            }
          }
        }])

        return FontFaceObject
      }())

      exports.FontFaceObject = FontFaceObject
      /***/ },
    /* 196 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      const compatibilityParams = Object.create(null)
      {
        const _require = __w_pdfjs_require__(48)
        const isNodeJS = _require.isNodeJS

        const userAgent = typeof navigator !== 'undefined' && navigator.userAgent || ''
        const isIE = /Trident/.test(userAgent)
        const isIOSChrome = /CriOS/.test(userAgent);

        (function checkOnBlobSupport () {
          if (isIE || isIOSChrome) {
            compatibilityParams.disableCreateObjectURL = true
          }
        })();

        (function checkFontFaceAndImage () {
          if (isNodeJS) {
            compatibilityParams.disableFontFace = true
            compatibilityParams.nativeImageDecoderSupport = 'none'
          }
        })()
      }
      exports.apiCompatibilityParams = Object.freeze(compatibilityParams)
      /***/ },
    /* 197 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.CanvasGraphics = void 0

      const _util = __w_pdfjs_require__(1)

      const _pattern_helper = __w_pdfjs_require__(198)

      const MIN_FONT_SIZE = 16
      const MAX_FONT_SIZE = 100
      const MAX_GROUP_SIZE = 4096
      const MIN_WIDTH_FACTOR = 0.65
      const COMPILE_TYPE3_GLYPHS = true
      const MAX_SIZE_TO_COMPILE = 1000
      const FULL_CHUNK_HEIGHT = 16

      function addContextCurrentTransform (ctx) {
        if (!ctx.mozCurrentTransform) {
          ctx._originalSave = ctx.save
          ctx._originalRestore = ctx.restore
          ctx._originalRotate = ctx.rotate
          ctx._originalScale = ctx.scale
          ctx._originalTranslate = ctx.translate
          ctx._originalTransform = ctx.transform
          ctx._originalSetTransform = ctx.setTransform
          ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0]
          ctx._transformStack = []
          Object.defineProperty(ctx, 'mozCurrentTransform', {
            get: function getCurrentTransform () {
              return this._transformMatrix
            }
          })
          Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
            get: function getCurrentTransformInverse () {
              const m = this._transformMatrix
              const a = m[0]
              const b = m[1]
              const c = m[2]
              const d = m[3]
              const e = m[4]
              const f = m[5]
              const ad_bc = a * d - b * c
              const bc_ad = b * c - a * d
              return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc]
            }
          })

          ctx.save = function ctxSave () {
            const old = this._transformMatrix

            this._transformStack.push(old)

            this._transformMatrix = old.slice(0, 6)

            this._originalSave()
          }

          ctx.restore = function ctxRestore () {
            const prev = this._transformStack.pop()

            if (prev) {
              this._transformMatrix = prev

              this._originalRestore()
            }
          }

          ctx.translate = function ctxTranslate (x, y) {
            const m = this._transformMatrix
            m[4] = m[0] * x + m[2] * y + m[4]
            m[5] = m[1] * x + m[3] * y + m[5]

            this._originalTranslate(x, y)
          }

          ctx.scale = function ctxScale (x, y) {
            const m = this._transformMatrix
            m[0] = m[0] * x
            m[1] = m[1] * x
            m[2] = m[2] * y
            m[3] = m[3] * y

            this._originalScale(x, y)
          }

          ctx.transform = function ctxTransform (a, b, c, d, e, f) {
            const m = this._transformMatrix
            this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]]

            ctx._originalTransform(a, b, c, d, e, f)
          }

          ctx.setTransform = function ctxSetTransform (a, b, c, d, e, f) {
            this._transformMatrix = [a, b, c, d, e, f]

            ctx._originalSetTransform(a, b, c, d, e, f)
          }

          ctx.rotate = function ctxRotate (angle) {
            const cosValue = Math.cos(angle)
            const sinValue = Math.sin(angle)
            const m = this._transformMatrix
            this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]]

            this._originalRotate(angle)
          }
        }
      }

      const CachedCanvases = (function CachedCanvasesClosure () {
        function CachedCanvases (canvasFactory) {
          this.canvasFactory = canvasFactory
          this.cache = Object.create(null)
        }

        CachedCanvases.prototype = {
          getCanvas: function CachedCanvases_getCanvas (id, width, height, trackTransform) {
            let canvasEntry

            if (this.cache[id] !== undefined) {
              canvasEntry = this.cache[id]
              this.canvasFactory.reset(canvasEntry, width, height)
              canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0)
            } else {
              canvasEntry = this.canvasFactory.create(width, height)
              this.cache[id] = canvasEntry
            }

            if (trackTransform) {
              addContextCurrentTransform(canvasEntry.context)
            }

            return canvasEntry
          },
          clear: function clear () {
            for (const id in this.cache) {
              const canvasEntry = this.cache[id]
              this.canvasFactory.destroy(canvasEntry)
              delete this.cache[id]
            }
          }
        }
        return CachedCanvases
      }())

      function compileType3Glyph (imgData) {
        const POINT_TO_PROCESS_LIMIT = 1000
        const width = imgData.width
        const height = imgData.height
        let i
        let j
        let j0
        const width1 = width + 1
        const points = new Uint8Array(width1 * (height + 1))
        const POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0])
        const lineSize = width + 7 & ~7
        const data0 = imgData.data
        const data = new Uint8Array(lineSize * height)
        let pos = 0
        let ii

        for (i = 0, ii = data0.length; i < ii; i++) {
          let mask = 128
          const elem = data0[i]

          while (mask > 0) {
            data[pos++] = elem & mask ? 0 : 255
            mask >>= 1
          }
        }

        let count = 0
        pos = 0

        if (data[pos] !== 0) {
          points[0] = 1
          ++count
        }

        for (j = 1; j < width; j++) {
          if (data[pos] !== data[pos + 1]) {
            points[j] = data[pos] ? 2 : 1
            ++count
          }

          pos++
        }

        if (data[pos] !== 0) {
          points[j] = 2
          ++count
        }

        for (i = 1; i < height; i++) {
          pos = i * lineSize
          j0 = i * width1

          if (data[pos - lineSize] !== data[pos]) {
            points[j0] = data[pos] ? 1 : 8
            ++count
          }

          let sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0)

          for (j = 1; j < width; j++) {
            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0)

            if (POINT_TYPES[sum]) {
              points[j0 + j] = POINT_TYPES[sum]
              ++count
            }

            pos++
          }

          if (data[pos - lineSize] !== data[pos]) {
            points[j0 + j] = data[pos] ? 2 : 4
            ++count
          }

          if (count > POINT_TO_PROCESS_LIMIT) {
            return null
          }
        }

        pos = lineSize * (height - 1)
        j0 = i * width1

        if (data[pos] !== 0) {
          points[j0] = 8
          ++count
        }

        for (j = 1; j < width; j++) {
          if (data[pos] !== data[pos + 1]) {
            points[j0 + j] = data[pos] ? 4 : 8
            ++count
          }

          pos++
        }

        if (data[pos] !== 0) {
          points[j0 + j] = 4
          ++count
        }

        if (count > POINT_TO_PROCESS_LIMIT) {
          return null
        }

        const steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1])
        const outlines = []

        for (i = 0; count && i <= height; i++) {
          let p = i * width1
          const end = p + width

          while (p < end && !points[p]) {
            p++
          }

          if (p === end) {
            continue
          }

          const coords = [p % width1, i]
          let type = points[p]
          const p0 = p
          var pp

          do {
            const step = steps[type]

            do {
              p += step
            } while (!points[p])

            pp = points[p]

            if (pp !== 5 && pp !== 10) {
              type = pp
              points[p] = 0
            } else {
              type = pp & 0x33 * type >> 4
              points[p] &= type >> 2 | type << 2
            }

            coords.push(p % width1)
            coords.push(p / width1 | 0)

            if (!points[p]) {
              --count
            }
          } while (p0 !== p)

          outlines.push(coords)
          --i
        }

        const drawOutline = function drawOutline (c) {
          c.save()
          c.scale(1 / width, -1 / height)
          c.translate(0, -height)
          c.beginPath()

          for (let i = 0, ii = outlines.length; i < ii; i++) {
            const o = outlines[i]
            c.moveTo(o[0], o[1])

            for (let j = 2, jj = o.length; j < jj; j += 2) {
              c.lineTo(o[j], o[j + 1])
            }
          }

          c.fill()
          c.beginPath()
          c.restore()
        }

        return drawOutline
      }

      const CanvasExtraState = (function CanvasExtraStateClosure () {
        function CanvasExtraState () {
          this.alphaIsShape = false
          this.fontSize = 0
          this.fontSizeScale = 1
          this.textMatrix = _util.IDENTITY_MATRIX
          this.textMatrixScale = 1
          this.fontMatrix = _util.FONT_IDENTITY_MATRIX
          this.leading = 0
          this.x = 0
          this.y = 0
          this.lineX = 0
          this.lineY = 0
          this.charSpacing = 0
          this.wordSpacing = 0
          this.textHScale = 1
          this.textRenderingMode = _util.TextRenderingMode.FILL
          this.textRise = 0
          this.fillColor = '#000000'
          this.strokeColor = '#000000'
          this.patternFill = false
          this.fillAlpha = 1
          this.strokeAlpha = 1
          this.lineWidth = 1
          this.activeSMask = null
          this.resumeSMaskCtx = null
        }

        CanvasExtraState.prototype = {
          clone: function CanvasExtraState_clone () {
            return Object.create(this)
          },
          setCurrentPoint: function CanvasExtraState_setCurrentPoint (x, y) {
            this.x = x
            this.y = y
          }
        }
        return CanvasExtraState
      }())

      const CanvasGraphics = (function CanvasGraphicsClosure () {
        const EXECUTION_TIME = 15
        const EXECUTION_STEPS = 10

        function CanvasGraphics (canvasCtx, commonObjs, objs, canvasFactory, webGLContext, imageLayer) {
          this.ctx = canvasCtx
          this.current = new CanvasExtraState()
          this.stateStack = []
          this.pendingClip = null
          this.pendingEOFill = false
          this.res = null
          this.xobjs = null
          this.commonObjs = commonObjs
          this.objs = objs
          this.canvasFactory = canvasFactory
          this.webGLContext = webGLContext
          this.imageLayer = imageLayer
          this.groupStack = []
          this.processingType3 = null
          this.baseTransform = null
          this.baseTransformStack = []
          this.groupLevel = 0
          this.smaskStack = []
          this.smaskCounter = 0
          this.tempSMask = null
          this.cachedCanvases = new CachedCanvases(this.canvasFactory)

          if (canvasCtx) {
            addContextCurrentTransform(canvasCtx)
          }

          this._cachedGetSinglePixelWidth = null
        }

        function putBinaryImageData (ctx, imgData) {
          if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
            ctx.putImageData(imgData, 0, 0)
            return
          }

          const height = imgData.height
          const width = imgData.width
          const partialChunkHeight = height % FULL_CHUNK_HEIGHT
          const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT
          const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1
          const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT)
          let srcPos = 0
          let destPos
          const src = imgData.data
          const dest = chunkImgData.data
          let i, j, thisChunkHeight, elemsInThisChunk

          if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
            const srcLength = src.byteLength
            const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2)
            const dest32DataLength = dest32.length
            const fullSrcDiff = width + 7 >> 3
            const white = 0xffffffff
            const black = _util.IsLittleEndianCached.value ? 0xff000000 : 0x000000ff

            for (i = 0; i < totalChunks; i++) {
              thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight
              destPos = 0

              for (j = 0; j < thisChunkHeight; j++) {
                const srcDiff = srcLength - srcPos
                let k = 0
                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7
                const kEndUnrolled = kEnd & ~7
                let mask = 0
                let srcByte = 0

                for (; k < kEndUnrolled; k += 8) {
                  srcByte = src[srcPos++]
                  dest32[destPos++] = srcByte & 128 ? white : black
                  dest32[destPos++] = srcByte & 64 ? white : black
                  dest32[destPos++] = srcByte & 32 ? white : black
                  dest32[destPos++] = srcByte & 16 ? white : black
                  dest32[destPos++] = srcByte & 8 ? white : black
                  dest32[destPos++] = srcByte & 4 ? white : black
                  dest32[destPos++] = srcByte & 2 ? white : black
                  dest32[destPos++] = srcByte & 1 ? white : black
                }

                for (; k < kEnd; k++) {
                  if (mask === 0) {
                    srcByte = src[srcPos++]
                    mask = 128
                  }

                  dest32[destPos++] = srcByte & mask ? white : black
                  mask >>= 1
                }
              }

              while (destPos < dest32DataLength) {
                dest32[destPos++] = 0
              }

              ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT)
            }
          } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
            j = 0
            elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4

            for (i = 0; i < fullChunks; i++) {
              dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk))
              srcPos += elemsInThisChunk
              ctx.putImageData(chunkImgData, 0, j)
              j += FULL_CHUNK_HEIGHT
            }

            if (i < totalChunks) {
              elemsInThisChunk = width * partialChunkHeight * 4
              dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk))
              ctx.putImageData(chunkImgData, 0, j)
            }
          } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
            thisChunkHeight = FULL_CHUNK_HEIGHT
            elemsInThisChunk = width * thisChunkHeight

            for (i = 0; i < totalChunks; i++) {
              if (i >= fullChunks) {
                thisChunkHeight = partialChunkHeight
                elemsInThisChunk = width * thisChunkHeight
              }

              destPos = 0

              for (j = elemsInThisChunk; j--;) {
                dest[destPos++] = src[srcPos++]
                dest[destPos++] = src[srcPos++]
                dest[destPos++] = src[srcPos++]
                dest[destPos++] = 255
              }

              ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT)
            }
          } else {
            throw new Error('bad image kind: '.concat(imgData.kind))
          }
        }

        function putBinaryImageMask (ctx, imgData) {
          const height = imgData.height
          const width = imgData.width
          const partialChunkHeight = height % FULL_CHUNK_HEIGHT
          const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT
          const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1
          const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT)
          let srcPos = 0
          const src = imgData.data
          const dest = chunkImgData.data

          for (let i = 0; i < totalChunks; i++) {
            const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight
            let destPos = 3

            for (let j = 0; j < thisChunkHeight; j++) {
              let mask = 0

              for (let k = 0; k < width; k++) {
                if (!mask) {
                  var elem = src[srcPos++]
                  mask = 128
                }

                dest[destPos] = elem & mask ? 0 : 255
                destPos += 4
                mask >>= 1
              }
            }

            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT)
          }
        }

        function copyCtxState (sourceCtx, destCtx) {
          const properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font']

          for (let i = 0, ii = properties.length; i < ii; i++) {
            const property = properties[i]

            if (sourceCtx[property] !== undefined) {
              destCtx[property] = sourceCtx[property]
            }
          }

          if (sourceCtx.setLineDash !== undefined) {
            destCtx.setLineDash(sourceCtx.getLineDash())
            destCtx.lineDashOffset = sourceCtx.lineDashOffset
          }
        }

        function resetCtxToDefault (ctx) {
          ctx.strokeStyle = '#000000'
          ctx.fillStyle = '#000000'
          ctx.fillRule = 'nonzero'
          ctx.globalAlpha = 1
          ctx.lineWidth = 1
          ctx.lineCap = 'butt'
          ctx.lineJoin = 'miter'
          ctx.miterLimit = 10
          ctx.globalCompositeOperation = 'source-over'
          ctx.font = '10px sans-serif'

          if (ctx.setLineDash !== undefined) {
            ctx.setLineDash([])
            ctx.lineDashOffset = 0
          }
        }

        function composeSMaskBackdrop (bytes, r0, g0, b0) {
          const length = bytes.length

          for (let i = 3; i < length; i += 4) {
            const alpha = bytes[i]

            if (alpha === 0) {
              bytes[i - 3] = r0
              bytes[i - 2] = g0
              bytes[i - 1] = b0
            } else if (alpha < 255) {
              const alpha_ = 255 - alpha
              bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8
              bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8
              bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8
            }
          }
        }

        function composeSMaskAlpha (maskData, layerData, transferMap) {
          const length = maskData.length
          const scale = 1 / 255

          for (let i = 3; i < length; i += 4) {
            const alpha = transferMap ? transferMap[maskData[i]] : maskData[i]
            layerData[i] = layerData[i] * alpha * scale | 0
          }
        }

        function composeSMaskLuminosity (maskData, layerData, transferMap) {
          const length = maskData.length

          for (let i = 3; i < length; i += 4) {
            const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28
            layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16
          }
        }

        function genericComposeSMask (maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
          const hasBackdrop = !!backdrop
          const r0 = hasBackdrop ? backdrop[0] : 0
          const g0 = hasBackdrop ? backdrop[1] : 0
          const b0 = hasBackdrop ? backdrop[2] : 0
          let composeFn

          if (subtype === 'Luminosity') {
            composeFn = composeSMaskLuminosity
          } else {
            composeFn = composeSMaskAlpha
          }

          const PIXELS_TO_PROCESS = 1048576
          const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width))

          for (let row = 0; row < height; row += chunkSize) {
            const chunkHeight = Math.min(chunkSize, height - row)
            const maskData = maskCtx.getImageData(0, row, width, chunkHeight)
            const layerData = layerCtx.getImageData(0, row, width, chunkHeight)

            if (hasBackdrop) {
              composeSMaskBackdrop(maskData.data, r0, g0, b0)
            }

            composeFn(maskData.data, layerData.data, transferMap)
            maskCtx.putImageData(layerData, 0, row)
          }
        }

        function composeSMask (ctx, smask, layerCtx, webGLContext) {
          const mask = smask.canvas
          const maskCtx = smask.context
          ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY)
          const backdrop = smask.backdrop || null

          if (!smask.transferMap && webGLContext.isEnabled) {
            const composed = webGLContext.composeSMask({
              layer: layerCtx.canvas,
              mask: mask,
              properties: {
                subtype: smask.subtype,
                backdrop: backdrop
              }
            })
            ctx.setTransform(1, 0, 0, 1, 0, 0)
            ctx.drawImage(composed, smask.offsetX, smask.offsetY)
            return
          }

          genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap)
          ctx.drawImage(mask, 0, 0)
        }

        const LINE_CAP_STYLES = ['butt', 'round', 'square']
        const LINE_JOIN_STYLES = ['miter', 'round', 'bevel']
        const NORMAL_CLIP = {}
        const EO_CLIP = {}
        CanvasGraphics.prototype = {
          beginDrawing: function beginDrawing (_ref) {
            const transform = _ref.transform
            const viewport = _ref.viewport
            const _ref$transparency = _ref.transparency
            const transparency = _ref$transparency === void 0 ? false : _ref$transparency
            const _ref$background = _ref.background
            const background = _ref$background === void 0 ? null : _ref$background
            const width = this.ctx.canvas.width
            const height = this.ctx.canvas.height
            this.ctx.save()
            this.ctx.fillStyle = background || 'rgb(255, 255, 255)'
            this.ctx.fillRect(0, 0, width, height)
            this.ctx.restore()

            if (transparency) {
              const transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true)
              this.compositeCtx = this.ctx
              this.transparentCanvas = transparentCanvas.canvas
              this.ctx = transparentCanvas.context
              this.ctx.save()
              this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform)
            }

            this.ctx.save()
            resetCtxToDefault(this.ctx)

            if (transform) {
              this.ctx.transform.apply(this.ctx, transform)
            }

            this.ctx.transform.apply(this.ctx, viewport.transform)
            this.baseTransform = this.ctx.mozCurrentTransform.slice()

            if (this.imageLayer) {
              this.imageLayer.beginLayout()
            }
          },
          executeOperatorList: function CanvasGraphics_executeOperatorList (operatorList, executionStartIdx, continueCallback, stepper) {
            const argsArray = operatorList.argsArray
            const fnArray = operatorList.fnArray
            let i = executionStartIdx || 0
            const argsArrayLen = argsArray.length

            if (argsArrayLen === i) {
              return i
            }

            const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function'
            const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0
            let steps = 0
            const commonObjs = this.commonObjs
            const objs = this.objs
            let fnId

            while (true) {
              if (stepper !== undefined && i === stepper.nextBreakPoint) {
                stepper.breakIt(i, continueCallback)
                return i
              }

              fnId = fnArray[i]

              if (fnId !== _util.OPS.dependency) {
                this[fnId].apply(this, argsArray[i])
              } else {
                let _iteratorNormalCompletion = true
                let _didIteratorError = false
                let _iteratorError

                try {
                  for (var _iterator = argsArray[i][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    const depObjId = _step.value
                    const objsPool = depObjId.startsWith('g_') ? commonObjs : objs

                    if (!objsPool.has(depObjId)) {
                      objsPool.get(depObjId, continueCallback)
                      return i
                    }
                  }
                } catch (err) {
                  _didIteratorError = true
                  _iteratorError = err
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return()
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError
                    }
                  }
                }
              }

              i++

              if (i === argsArrayLen) {
                return i
              }

              if (chunkOperations && ++steps > EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                  continueCallback()
                  return i
                }

                steps = 0
              }
            }
          },
          endDrawing: function CanvasGraphics_endDrawing () {
            if (this.current.activeSMask !== null) {
              this.endSMaskGroup()
            }

            this.ctx.restore()

            if (this.transparentCanvas) {
              this.ctx = this.compositeCtx
              this.ctx.save()
              this.ctx.setTransform(1, 0, 0, 1, 0, 0)
              this.ctx.drawImage(this.transparentCanvas, 0, 0)
              this.ctx.restore()
              this.transparentCanvas = null
            }

            this.cachedCanvases.clear()
            this.webGLContext.clear()

            if (this.imageLayer) {
              this.imageLayer.endLayout()
            }
          },
          setLineWidth: function CanvasGraphics_setLineWidth (width) {
            this.current.lineWidth = width
            this.ctx.lineWidth = width
          },
          setLineCap: function CanvasGraphics_setLineCap (style) {
            this.ctx.lineCap = LINE_CAP_STYLES[style]
          },
          setLineJoin: function CanvasGraphics_setLineJoin (style) {
            this.ctx.lineJoin = LINE_JOIN_STYLES[style]
          },
          setMiterLimit: function CanvasGraphics_setMiterLimit (limit) {
            this.ctx.miterLimit = limit
          },
          setDash: function CanvasGraphics_setDash (dashArray, dashPhase) {
            const ctx = this.ctx

            if (ctx.setLineDash !== undefined) {
              ctx.setLineDash(dashArray)
              ctx.lineDashOffset = dashPhase
            }
          },
          setRenderingIntent: function setRenderingIntent (intent) {},
          setFlatness: function setFlatness (flatness) {},
          setGState: function CanvasGraphics_setGState (states) {
            for (let i = 0, ii = states.length; i < ii; i++) {
              const state = states[i]
              const key = state[0]
              const value = state[1]

              switch (key) {
                case 'LW':
                  this.setLineWidth(value)
                  break

                case 'LC':
                  this.setLineCap(value)
                  break

                case 'LJ':
                  this.setLineJoin(value)
                  break

                case 'ML':
                  this.setMiterLimit(value)
                  break

                case 'D':
                  this.setDash(value[0], value[1])
                  break

                case 'RI':
                  this.setRenderingIntent(value)
                  break

                case 'FL':
                  this.setFlatness(value)
                  break

                case 'Font':
                  this.setFont(value[0], value[1])
                  break

                case 'CA':
                  this.current.strokeAlpha = state[1]
                  break

                case 'ca':
                  this.current.fillAlpha = state[1]
                  this.ctx.globalAlpha = state[1]
                  break

                case 'BM':
                  this.ctx.globalCompositeOperation = value
                  break

                case 'SMask':
                  if (this.current.activeSMask) {
                    if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                      this.suspendSMaskGroup()
                    } else {
                      this.endSMaskGroup()
                    }
                  }

                  this.current.activeSMask = value ? this.tempSMask : null

                  if (this.current.activeSMask) {
                    this.beginSMaskGroup()
                  }

                  this.tempSMask = null
                  break
              }
            }
          },
          beginSMaskGroup: function CanvasGraphics_beginSMaskGroup () {
            const activeSMask = this.current.activeSMask
            const drawnWidth = activeSMask.canvas.width
            const drawnHeight = activeSMask.canvas.height
            const cacheId = 'smaskGroupAt' + this.groupLevel
            const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true)
            const currentCtx = this.ctx
            const currentTransform = currentCtx.mozCurrentTransform
            this.ctx.save()
            const groupCtx = scratchCanvas.context
            groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY)
            groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY)
            groupCtx.transform.apply(groupCtx, currentTransform)
            activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse
            copyCtxState(currentCtx, groupCtx)
            this.ctx = groupCtx
            this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]])
            this.groupStack.push(currentCtx)
            this.groupLevel++
          },
          suspendSMaskGroup: function CanvasGraphics_endSMaskGroup () {
            const groupCtx = this.ctx
            this.groupLevel--
            this.ctx = this.groupStack.pop()
            composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext)
            this.ctx.restore()
            this.ctx.save()
            copyCtxState(groupCtx, this.ctx)
            this.current.resumeSMaskCtx = groupCtx

            const deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform)

            this.ctx.transform.apply(this.ctx, deltaTransform)
            groupCtx.save()
            groupCtx.setTransform(1, 0, 0, 1, 0, 0)
            groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height)
            groupCtx.restore()
          },
          resumeSMaskGroup: function CanvasGraphics_endSMaskGroup () {
            const groupCtx = this.current.resumeSMaskCtx
            const currentCtx = this.ctx
            this.ctx = groupCtx
            this.groupStack.push(currentCtx)
            this.groupLevel++
          },
          endSMaskGroup: function CanvasGraphics_endSMaskGroup () {
            const groupCtx = this.ctx
            this.groupLevel--
            this.ctx = this.groupStack.pop()
            composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext)
            this.ctx.restore()
            copyCtxState(groupCtx, this.ctx)

            const deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform)

            this.ctx.transform.apply(this.ctx, deltaTransform)
          },
          save: function CanvasGraphics_save () {
            this.ctx.save()
            const old = this.current
            this.stateStack.push(old)
            this.current = old.clone()
            this.current.resumeSMaskCtx = null
          },
          restore: function CanvasGraphics_restore () {
            if (this.current.resumeSMaskCtx) {
              this.resumeSMaskGroup()
            }

            if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
              this.endSMaskGroup()
            }

            if (this.stateStack.length !== 0) {
              this.current = this.stateStack.pop()
              this.ctx.restore()
              this.pendingClip = null
              this._cachedGetSinglePixelWidth = null
            }
          },
          transform: function CanvasGraphics_transform (a, b, c, d, e, f) {
            this.ctx.transform(a, b, c, d, e, f)
            this._cachedGetSinglePixelWidth = null
          },
          constructPath: function CanvasGraphics_constructPath (ops, args) {
            const ctx = this.ctx
            const current = this.current
            let x = current.x
            let y = current.y

            for (let i = 0, j = 0, ii = ops.length; i < ii; i++) {
              switch (ops[i] | 0) {
                case _util.OPS.rectangle:
                  x = args[j++]
                  y = args[j++]
                  var width = args[j++]
                  var height = args[j++]

                  if (width === 0) {
                    width = this.getSinglePixelWidth()
                  }

                  if (height === 0) {
                    height = this.getSinglePixelWidth()
                  }

                  var xw = x + width
                  var yh = y + height
                  this.ctx.moveTo(x, y)
                  this.ctx.lineTo(xw, y)
                  this.ctx.lineTo(xw, yh)
                  this.ctx.lineTo(x, yh)
                  this.ctx.lineTo(x, y)
                  this.ctx.closePath()
                  break

                case _util.OPS.moveTo:
                  x = args[j++]
                  y = args[j++]
                  ctx.moveTo(x, y)
                  break

                case _util.OPS.lineTo:
                  x = args[j++]
                  y = args[j++]
                  ctx.lineTo(x, y)
                  break

                case _util.OPS.curveTo:
                  x = args[j + 4]
                  y = args[j + 5]
                  ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y)
                  j += 6
                  break

                case _util.OPS.curveTo2:
                  ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3])
                  x = args[j + 2]
                  y = args[j + 3]
                  j += 4
                  break

                case _util.OPS.curveTo3:
                  x = args[j + 2]
                  y = args[j + 3]
                  ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y)
                  j += 4
                  break

                case _util.OPS.closePath:
                  ctx.closePath()
                  break
              }
            }

            current.setCurrentPoint(x, y)
          },
          closePath: function CanvasGraphics_closePath () {
            this.ctx.closePath()
          },
          stroke: function CanvasGraphics_stroke (consumePath) {
            consumePath = typeof consumePath !== 'undefined' ? consumePath : true
            const ctx = this.ctx
            const strokeColor = this.current.strokeColor
            ctx.globalAlpha = this.current.strokeAlpha

            if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
              ctx.save()
              const transform = ctx.mozCurrentTransform

              const scale = _util.Util.singularValueDecompose2dScale(transform)[0]

              ctx.strokeStyle = strokeColor.getPattern(ctx, this)
              ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth * scale)
              ctx.stroke()
              ctx.restore()
            } else {
              ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth)
              ctx.stroke()
            }

            if (consumePath) {
              this.consumePath()
            }

            ctx.globalAlpha = this.current.fillAlpha
          },
          closeStroke: function CanvasGraphics_closeStroke () {
            this.closePath()
            this.stroke()
          },
          fill: function CanvasGraphics_fill (consumePath) {
            consumePath = typeof consumePath !== 'undefined' ? consumePath : true
            const ctx = this.ctx
            const fillColor = this.current.fillColor
            const isPatternFill = this.current.patternFill
            let needRestore = false

            if (isPatternFill) {
              ctx.save()

              if (this.baseTransform) {
                ctx.setTransform.apply(ctx, this.baseTransform)
              }

              ctx.fillStyle = fillColor.getPattern(ctx, this)
              needRestore = true
            }

            if (this.pendingEOFill) {
              ctx.fill('evenodd')
              this.pendingEOFill = false
            } else {
              ctx.fill()
            }

            if (needRestore) {
              ctx.restore()
            }

            if (consumePath) {
              this.consumePath()
            }
          },
          eoFill: function CanvasGraphics_eoFill () {
            this.pendingEOFill = true
            this.fill()
          },
          fillStroke: function CanvasGraphics_fillStroke () {
            this.fill(false)
            this.stroke(false)
            this.consumePath()
          },
          eoFillStroke: function CanvasGraphics_eoFillStroke () {
            this.pendingEOFill = true
            this.fillStroke()
          },
          closeFillStroke: function CanvasGraphics_closeFillStroke () {
            this.closePath()
            this.fillStroke()
          },
          closeEOFillStroke: function CanvasGraphics_closeEOFillStroke () {
            this.pendingEOFill = true
            this.closePath()
            this.fillStroke()
          },
          endPath: function CanvasGraphics_endPath () {
            this.consumePath()
          },
          clip: function CanvasGraphics_clip () {
            this.pendingClip = NORMAL_CLIP
          },
          eoClip: function CanvasGraphics_eoClip () {
            this.pendingClip = EO_CLIP
          },
          beginText: function CanvasGraphics_beginText () {
            this.current.textMatrix = _util.IDENTITY_MATRIX
            this.current.textMatrixScale = 1
            this.current.x = this.current.lineX = 0
            this.current.y = this.current.lineY = 0
          },
          endText: function CanvasGraphics_endText () {
            const paths = this.pendingTextPaths
            const ctx = this.ctx

            if (paths === undefined) {
              ctx.beginPath()
              return
            }

            ctx.save()
            ctx.beginPath()

            for (let i = 0; i < paths.length; i++) {
              const path = paths[i]
              ctx.setTransform.apply(ctx, path.transform)
              ctx.translate(path.x, path.y)
              path.addToPath(ctx, path.fontSize)
            }

            ctx.restore()
            ctx.clip()
            ctx.beginPath()
            delete this.pendingTextPaths
          },
          setCharSpacing: function CanvasGraphics_setCharSpacing (spacing) {
            this.current.charSpacing = spacing
          },
          setWordSpacing: function CanvasGraphics_setWordSpacing (spacing) {
            this.current.wordSpacing = spacing
          },
          setHScale: function CanvasGraphics_setHScale (scale) {
            this.current.textHScale = scale / 100
          },
          setLeading: function CanvasGraphics_setLeading (leading) {
            this.current.leading = -leading
          },
          setFont: function CanvasGraphics_setFont (fontRefName, size) {
            const fontObj = this.commonObjs.get(fontRefName)
            const current = this.current

            if (!fontObj) {
              throw new Error("Can't find font for ".concat(fontRefName))
            }

            current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX

            if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
              (0, _util.warn)('Invalid font matrix for font ' + fontRefName)
            }

            if (size < 0) {
              size = -size
              current.fontDirection = -1
            } else {
              current.fontDirection = 1
            }

            this.current.font = fontObj
            this.current.fontSize = size

            if (fontObj.isType3Font) {
              return
            }

            const name = fontObj.loadedName || 'sans-serif'
            let bold = 'normal'

            if (fontObj.black) {
              bold = '900'
            } else if (fontObj.bold) {
              bold = 'bold'
            }

            const italic = fontObj.italic ? 'italic' : 'normal'
            const typeface = '"'.concat(name, '", ').concat(fontObj.fallbackName)
            let browserFontSize = size

            if (size < MIN_FONT_SIZE) {
              browserFontSize = MIN_FONT_SIZE
            } else if (size > MAX_FONT_SIZE) {
              browserFontSize = MAX_FONT_SIZE
            }

            this.current.fontSizeScale = size / browserFontSize
            this.ctx.font = ''.concat(italic, ' ').concat(bold, ' ').concat(browserFontSize, 'px ').concat(typeface)
          },
          setTextRenderingMode: function CanvasGraphics_setTextRenderingMode (mode) {
            this.current.textRenderingMode = mode
          },
          setTextRise: function CanvasGraphics_setTextRise (rise) {
            this.current.textRise = rise
          },
          moveText: function CanvasGraphics_moveText (x, y) {
            this.current.x = this.current.lineX += x
            this.current.y = this.current.lineY += y
          },
          setLeadingMoveText: function CanvasGraphics_setLeadingMoveText (x, y) {
            this.setLeading(-y)
            this.moveText(x, y)
          },
          setTextMatrix: function CanvasGraphics_setTextMatrix (a, b, c, d, e, f) {
            this.current.textMatrix = [a, b, c, d, e, f]
            this.current.textMatrixScale = Math.sqrt(a * a + b * b)
            this.current.x = this.current.lineX = 0
            this.current.y = this.current.lineY = 0
          },
          nextLine: function CanvasGraphics_nextLine () {
            this.moveText(0, this.current.leading)
          },
          paintChar: function paintChar (character, x, y, patternTransform) {
            const ctx = this.ctx
            const current = this.current
            const font = current.font
            const textRenderingMode = current.textRenderingMode
            const fontSize = current.fontSize / current.fontSizeScale
            const fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK
            const isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG)
            const patternFill = current.patternFill && font.data
            let addToPath

            if (font.disableFontFace || isAddToPathSet || patternFill) {
              addToPath = font.getPathGenerator(this.commonObjs, character)
            }

            if (font.disableFontFace || patternFill) {
              ctx.save()
              ctx.translate(x, y)
              ctx.beginPath()
              addToPath(ctx, fontSize)

              if (patternTransform) {
                ctx.setTransform.apply(ctx, patternTransform)
              }

              if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.fill()
              }

              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.stroke()
              }

              ctx.restore()
            } else {
              if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.fillText(character, x, y)
              }

              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.strokeText(character, x, y)
              }
            }

            if (isAddToPathSet) {
              const paths = this.pendingTextPaths || (this.pendingTextPaths = [])
              paths.push({
                transform: ctx.mozCurrentTransform,
                x: x,
                y: y,
                fontSize: fontSize,
                addToPath: addToPath
              })
            }
          },

          get isFontSubpixelAAEnabled () {
            const _this$cachedCanvases$ = this.cachedCanvases.getCanvas('isFontSubpixelAAEnabled', 10, 10)
            const ctx = _this$cachedCanvases$.context

            ctx.scale(1.5, 1)
            ctx.fillText('I', 0, 10)
            const data = ctx.getImageData(0, 0, 10, 10).data
            let enabled = false

            for (let i = 3; i < data.length; i += 4) {
              if (data[i] > 0 && data[i] < 255) {
                enabled = true
                break
              }
            }

            return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled)
          },

          showText: function CanvasGraphics_showText (glyphs) {
            const current = this.current
            const font = current.font

            if (font.isType3Font) {
              return this.showType3Text(glyphs)
            }

            const fontSize = current.fontSize

            if (fontSize === 0) {
              return undefined
            }

            const ctx = this.ctx
            const fontSizeScale = current.fontSizeScale
            const charSpacing = current.charSpacing
            const wordSpacing = current.wordSpacing
            const fontDirection = current.fontDirection
            const textHScale = current.textHScale * fontDirection
            const glyphsLength = glyphs.length
            const vertical = font.vertical
            const spacingDir = vertical ? 1 : -1
            const defaultVMetrics = font.defaultVMetrics
            const widthAdvanceScale = fontSize * current.fontMatrix[0]
            const simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill
            ctx.save()
            let patternTransform

            if (current.patternFill) {
              ctx.save()
              const pattern = current.fillColor.getPattern(ctx, this)
              patternTransform = ctx.mozCurrentTransform
              ctx.restore()
              ctx.fillStyle = pattern
            }

            ctx.transform.apply(ctx, current.textMatrix)
            ctx.translate(current.x, current.y + current.textRise)

            if (fontDirection > 0) {
              ctx.scale(textHScale, -1)
            } else {
              ctx.scale(textHScale, 1)
            }

            let lineWidth = current.lineWidth
            const scale = current.textMatrixScale

            if (scale === 0 || lineWidth === 0) {
              const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK

              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                this._cachedGetSinglePixelWidth = null
                lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR
              }
            } else {
              lineWidth /= scale
            }

            if (fontSizeScale !== 1.0) {
              ctx.scale(fontSizeScale, fontSizeScale)
              lineWidth /= fontSizeScale
            }

            ctx.lineWidth = lineWidth
            let x = 0
            let i

            for (i = 0; i < glyphsLength; ++i) {
              const glyph = glyphs[i]

              if ((0, _util.isNum)(glyph)) {
                x += spacingDir * glyph * fontSize / 1000
                continue
              }

              let restoreNeeded = false
              const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing
              const character = glyph.fontChar
              const accent = glyph.accent
              var scaledX, scaledY, scaledAccentX, scaledAccentY
              let width = glyph.width

              if (vertical) {
                var vmetric, vx, vy
                vmetric = glyph.vmetric || defaultVMetrics
                vx = glyph.vmetric ? vmetric[1] : width * 0.5
                vx = -vx * widthAdvanceScale
                vy = vmetric[2] * widthAdvanceScale
                width = vmetric ? -vmetric[0] : width
                scaledX = vx / fontSizeScale
                scaledY = (x + vy) / fontSizeScale
              } else {
                scaledX = x / fontSizeScale
                scaledY = 0
              }

              if (font.remeasure && width > 0) {
                const measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale

                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                  const characterScaleX = width / measuredWidth
                  restoreNeeded = true
                  ctx.save()
                  ctx.scale(characterScaleX, 1)
                  scaledX /= characterScaleX
                } else if (width !== measuredWidth) {
                  scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale
                }
              }

              if (glyph.isInFont || font.missingFile) {
                if (simpleFillText && !accent) {
                  ctx.fillText(character, scaledX, scaledY)
                } else {
                  this.paintChar(character, scaledX, scaledY, patternTransform)

                  if (accent) {
                    scaledAccentX = scaledX + accent.offset.x / fontSizeScale
                    scaledAccentY = scaledY - accent.offset.y / fontSizeScale
                    this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform)
                  }
                }
              }

              var charWidth

              if (vertical) {
                charWidth = width * widthAdvanceScale - spacing * fontDirection
              } else {
                charWidth = width * widthAdvanceScale + spacing * fontDirection
              }

              x += charWidth

              if (restoreNeeded) {
                ctx.restore()
              }
            }

            if (vertical) {
              current.y -= x
            } else {
              current.x += x * textHScale
            }

            ctx.restore()
          },
          showType3Text: function CanvasGraphics_showType3Text (glyphs) {
            const ctx = this.ctx
            const current = this.current
            const font = current.font
            const fontSize = current.fontSize
            const fontDirection = current.fontDirection
            const spacingDir = font.vertical ? 1 : -1
            const charSpacing = current.charSpacing
            const wordSpacing = current.wordSpacing
            const textHScale = current.textHScale * fontDirection
            const fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX
            const glyphsLength = glyphs.length
            const isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE
            let i, glyph, width, spacingLength

            if (isTextInvisible || fontSize === 0) {
              return
            }

            this._cachedGetSinglePixelWidth = null
            ctx.save()
            ctx.transform.apply(ctx, current.textMatrix)
            ctx.translate(current.x, current.y)
            ctx.scale(textHScale, fontDirection)

            for (i = 0; i < glyphsLength; ++i) {
              glyph = glyphs[i]

              if ((0, _util.isNum)(glyph)) {
                spacingLength = spacingDir * glyph * fontSize / 1000
                this.ctx.translate(spacingLength, 0)
                current.x += spacingLength * textHScale
                continue
              }

              const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing
              const operatorList = font.charProcOperatorList[glyph.operatorListId]

              if (!operatorList) {
                (0, _util.warn)('Type3 character "'.concat(glyph.operatorListId, '" is not available.'))
                continue
              }

              this.processingType3 = glyph
              this.save()
              ctx.scale(fontSize, fontSize)
              ctx.transform.apply(ctx, fontMatrix)
              this.executeOperatorList(operatorList)
              this.restore()

              const transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix)

              width = transformed[0] * fontSize + spacing
              ctx.translate(width, 0)
              current.x += width * textHScale
            }

            ctx.restore()
            this.processingType3 = null
          },
          setCharWidth: function CanvasGraphics_setCharWidth (xWidth, yWidth) {},
          setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds (xWidth, yWidth, llx, lly, urx, ury) {
            this.ctx.rect(llx, lly, urx - llx, ury - lly)
            this.clip()
            this.endPath()
          },
          getColorN_Pattern: function CanvasGraphics_getColorN_Pattern (IR) {
            const _this = this

            let pattern

            if (IR[0] === 'TilingPattern') {
              const color = IR[1]
              const baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice()
              const canvasGraphicsFactory = {
                createCanvasGraphics: function createCanvasGraphics (ctx) {
                  return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.webGLContext)
                }
              }
              pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform)
            } else {
              pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR)
            }

            return pattern
          },
          setStrokeColorN: function CanvasGraphics_setStrokeColorN () {
            this.current.strokeColor = this.getColorN_Pattern(arguments)
          },
          setFillColorN: function CanvasGraphics_setFillColorN () {
            this.current.fillColor = this.getColorN_Pattern(arguments)
            this.current.patternFill = true
          },
          setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor (r, g, b) {
            const color = _util.Util.makeCssRgb(r, g, b)

            this.ctx.strokeStyle = color
            this.current.strokeColor = color
          },
          setFillRGBColor: function CanvasGraphics_setFillRGBColor (r, g, b) {
            const color = _util.Util.makeCssRgb(r, g, b)

            this.ctx.fillStyle = color
            this.current.fillColor = color
            this.current.patternFill = false
          },
          shadingFill: function CanvasGraphics_shadingFill (patternIR) {
            const ctx = this.ctx
            this.save()
            const pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR)
            ctx.fillStyle = pattern.getPattern(ctx, this, true)
            const inv = ctx.mozCurrentTransformInverse

            if (inv) {
              const canvas = ctx.canvas
              const width = canvas.width
              const height = canvas.height

              const bl = _util.Util.applyTransform([0, 0], inv)

              const br = _util.Util.applyTransform([0, height], inv)

              const ul = _util.Util.applyTransform([width, 0], inv)

              const ur = _util.Util.applyTransform([width, height], inv)

              const x0 = Math.min(bl[0], br[0], ul[0], ur[0])
              const y0 = Math.min(bl[1], br[1], ul[1], ur[1])
              const x1 = Math.max(bl[0], br[0], ul[0], ur[0])
              const y1 = Math.max(bl[1], br[1], ul[1], ur[1])
              this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0)
            } else {
              this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10)
            }

            this.restore()
          },
          beginInlineImage: function CanvasGraphics_beginInlineImage () {
            (0, _util.unreachable)('Should not call beginInlineImage')
          },
          beginImageData: function CanvasGraphics_beginImageData () {
            (0, _util.unreachable)('Should not call beginImageData')
          },
          paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin (matrix, bbox) {
            this.save()
            this.baseTransformStack.push(this.baseTransform)

            if (Array.isArray(matrix) && matrix.length === 6) {
              this.transform.apply(this, matrix)
            }

            this.baseTransform = this.ctx.mozCurrentTransform

            if (bbox) {
              const width = bbox[2] - bbox[0]
              const height = bbox[3] - bbox[1]
              this.ctx.rect(bbox[0], bbox[1], width, height)
              this.clip()
              this.endPath()
            }
          },
          paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd () {
            this.restore()
            this.baseTransform = this.baseTransformStack.pop()
          },
          beginGroup: function CanvasGraphics_beginGroup (group) {
            this.save()
            const currentCtx = this.ctx

            if (!group.isolated) {
              (0, _util.info)('TODO: Support non-isolated groups.')
            }

            if (group.knockout) {
              (0, _util.warn)('Knockout groups not supported.')
            }

            const currentTransform = currentCtx.mozCurrentTransform

            if (group.matrix) {
              currentCtx.transform.apply(currentCtx, group.matrix)
            }

            if (!group.bbox) {
              throw new Error('Bounding box is required.')
            }

            let bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform)

            const canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height]
            bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0]
            const offsetX = Math.floor(bounds[0])
            const offsetY = Math.floor(bounds[1])
            let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1)
            let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1)
            let scaleX = 1
            let scaleY = 1

            if (drawnWidth > MAX_GROUP_SIZE) {
              scaleX = drawnWidth / MAX_GROUP_SIZE
              drawnWidth = MAX_GROUP_SIZE
            }

            if (drawnHeight > MAX_GROUP_SIZE) {
              scaleY = drawnHeight / MAX_GROUP_SIZE
              drawnHeight = MAX_GROUP_SIZE
            }

            let cacheId = 'groupAt' + this.groupLevel

            if (group.smask) {
              cacheId += '_smask_' + this.smaskCounter++ % 2
            }

            const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true)
            const groupCtx = scratchCanvas.context
            groupCtx.scale(1 / scaleX, 1 / scaleY)
            groupCtx.translate(-offsetX, -offsetY)
            groupCtx.transform.apply(groupCtx, currentTransform)

            if (group.smask) {
              this.smaskStack.push({
                canvas: scratchCanvas.canvas,
                context: groupCtx,
                offsetX: offsetX,
                offsetY: offsetY,
                scaleX: scaleX,
                scaleY: scaleY,
                subtype: group.smask.subtype,
                backdrop: group.smask.backdrop,
                transferMap: group.smask.transferMap || null,
                startTransformInverse: null
              })
            } else {
              currentCtx.setTransform(1, 0, 0, 1, 0, 0)
              currentCtx.translate(offsetX, offsetY)
              currentCtx.scale(scaleX, scaleY)
            }

            copyCtxState(currentCtx, groupCtx)
            this.ctx = groupCtx
            this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]])
            this.groupStack.push(currentCtx)
            this.groupLevel++
            this.current.activeSMask = null
          },
          endGroup: function CanvasGraphics_endGroup (group) {
            this.groupLevel--
            const groupCtx = this.ctx
            this.ctx = this.groupStack.pop()

            if (this.ctx.imageSmoothingEnabled !== undefined) {
              this.ctx.imageSmoothingEnabled = false
            } else {
              this.ctx.mozImageSmoothingEnabled = false
            }

            if (group.smask) {
              this.tempSMask = this.smaskStack.pop()
            } else {
              this.ctx.drawImage(groupCtx.canvas, 0, 0)
            }

            this.restore()
          },
          beginAnnotations: function CanvasGraphics_beginAnnotations () {
            this.save()

            if (this.baseTransform) {
              this.ctx.setTransform.apply(this.ctx, this.baseTransform)
            }
          },
          endAnnotations: function CanvasGraphics_endAnnotations () {
            this.restore()
          },
          beginAnnotation: function CanvasGraphics_beginAnnotation (rect, transform, matrix) {
            this.save()
            resetCtxToDefault(this.ctx)
            this.current = new CanvasExtraState()

            if (Array.isArray(rect) && rect.length === 4) {
              const width = rect[2] - rect[0]
              const height = rect[3] - rect[1]
              this.ctx.rect(rect[0], rect[1], width, height)
              this.clip()
              this.endPath()
            }

            this.transform.apply(this, transform)
            this.transform.apply(this, matrix)
          },
          endAnnotation: function CanvasGraphics_endAnnotation () {
            this.restore()
          },
          paintJpegXObject: function CanvasGraphics_paintJpegXObject (objId, w, h) {
            const domImage = this.processingType3 ? this.commonObjs.get(objId) : this.objs.get(objId)

            if (!domImage) {
              (0, _util.warn)("Dependent image isn't ready yet")
              return
            }

            this.save()
            const ctx = this.ctx
            ctx.scale(1 / w, -1 / h)
            ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h)

            if (this.imageLayer) {
              const currentTransform = ctx.mozCurrentTransformInverse
              const position = this.getCanvasPosition(0, 0)
              this.imageLayer.appendImage({
                objId: objId,
                left: position[0],
                top: position[1],
                width: w / currentTransform[0],
                height: h / currentTransform[3]
              })
            }

            this.restore()
          },
          paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject (img) {
            const ctx = this.ctx
            const width = img.width
            const height = img.height
            const fillColor = this.current.fillColor
            const isPatternFill = this.current.patternFill
            const glyph = this.processingType3

            if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
              if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
                glyph.compiled = compileType3Glyph({
                  data: img.data,
                  width: width,
                  height: height
                })
              } else {
                glyph.compiled = null
              }
            }

            if (glyph && glyph.compiled) {
              glyph.compiled(ctx)
              return
            }

            const maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height)
            const maskCtx = maskCanvas.context
            maskCtx.save()
            putBinaryImageMask(maskCtx, img)
            maskCtx.globalCompositeOperation = 'source-in'
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor
            maskCtx.fillRect(0, 0, width, height)
            maskCtx.restore()
            this.paintInlineImageXObject(maskCanvas.canvas)
          },
          paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat (imgData, scaleX, scaleY, positions) {
            const width = imgData.width
            const height = imgData.height
            const fillColor = this.current.fillColor
            const isPatternFill = this.current.patternFill
            const maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height)
            const maskCtx = maskCanvas.context
            maskCtx.save()
            putBinaryImageMask(maskCtx, imgData)
            maskCtx.globalCompositeOperation = 'source-in'
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor
            maskCtx.fillRect(0, 0, width, height)
            maskCtx.restore()
            const ctx = this.ctx

            for (let i = 0, ii = positions.length; i < ii; i += 2) {
              ctx.save()
              ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1])
              ctx.scale(1, -1)
              ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1)
              ctx.restore()
            }
          },
          paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup (images) {
            const ctx = this.ctx
            const fillColor = this.current.fillColor
            const isPatternFill = this.current.patternFill

            for (let i = 0, ii = images.length; i < ii; i++) {
              const image = images[i]
              const width = image.width
              const height = image.height
              const maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height)
              const maskCtx = maskCanvas.context
              maskCtx.save()
              putBinaryImageMask(maskCtx, image)
              maskCtx.globalCompositeOperation = 'source-in'
              maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor
              maskCtx.fillRect(0, 0, width, height)
              maskCtx.restore()
              ctx.save()
              ctx.transform.apply(ctx, image.transform)
              ctx.scale(1, -1)
              ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1)
              ctx.restore()
            }
          },
          paintImageXObject: function CanvasGraphics_paintImageXObject (objId) {
            const imgData = this.processingType3 ? this.commonObjs.get(objId) : this.objs.get(objId)

            if (!imgData) {
              (0, _util.warn)("Dependent image isn't ready yet")
              return
            }

            this.paintInlineImageXObject(imgData)
          },
          paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat (objId, scaleX, scaleY, positions) {
            const imgData = this.processingType3 ? this.commonObjs.get(objId) : this.objs.get(objId)

            if (!imgData) {
              (0, _util.warn)("Dependent image isn't ready yet")
              return
            }

            const width = imgData.width
            const height = imgData.height
            const map = []

            for (let i = 0, ii = positions.length; i < ii; i += 2) {
              map.push({
                transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
                x: 0,
                y: 0,
                w: width,
                h: height
              })
            }

            this.paintInlineImageXObjectGroup(imgData, map)
          },
          paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject (imgData) {
            const width = imgData.width
            const height = imgData.height
            const ctx = this.ctx
            this.save()
            ctx.scale(1 / width, -1 / height)
            const currentTransform = ctx.mozCurrentTransformInverse
            const a = currentTransform[0]
            const b = currentTransform[1]
            let widthScale = Math.max(Math.sqrt(a * a + b * b), 1)
            const c = currentTransform[2]
            const d = currentTransform[3]
            let heightScale = Math.max(Math.sqrt(c * c + d * d), 1)
            let imgToPaint, tmpCanvas

            if (typeof HTMLElement === 'function' && imgData instanceof HTMLElement || !imgData.data) {
              imgToPaint = imgData
            } else {
              tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height)
              var tmpCtx = tmpCanvas.context
              putBinaryImageData(tmpCtx, imgData)
              imgToPaint = tmpCanvas.canvas
            }

            let paintWidth = width
            let paintHeight = height
            let tmpCanvasId = 'prescale1'

            while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
              let newWidth = paintWidth
              let newHeight = paintHeight

              if (widthScale > 2 && paintWidth > 1) {
                newWidth = Math.ceil(paintWidth / 2)
                widthScale /= paintWidth / newWidth
              }

              if (heightScale > 2 && paintHeight > 1) {
                newHeight = Math.ceil(paintHeight / 2)
                heightScale /= paintHeight / newHeight
              }

              tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight)
              tmpCtx = tmpCanvas.context
              tmpCtx.clearRect(0, 0, newWidth, newHeight)
              tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight)
              imgToPaint = tmpCanvas.canvas
              paintWidth = newWidth
              paintHeight = newHeight
              tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1'
            }

            ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height)

            if (this.imageLayer) {
              const position = this.getCanvasPosition(0, -height)
              this.imageLayer.appendImage({
                imgData: imgData,
                left: position[0],
                top: position[1],
                width: width / currentTransform[0],
                height: height / currentTransform[3]
              })
            }

            this.restore()
          },
          paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup (imgData, map) {
            const ctx = this.ctx
            const w = imgData.width
            const h = imgData.height
            const tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h)
            const tmpCtx = tmpCanvas.context
            putBinaryImageData(tmpCtx, imgData)

            for (let i = 0, ii = map.length; i < ii; i++) {
              const entry = map[i]
              ctx.save()
              ctx.transform.apply(ctx, entry.transform)
              ctx.scale(1, -1)
              ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1)

              if (this.imageLayer) {
                const position = this.getCanvasPosition(entry.x, entry.y)
                this.imageLayer.appendImage({
                  imgData: imgData,
                  left: position[0],
                  top: position[1],
                  width: w,
                  height: h
                })
              }

              ctx.restore()
            }
          },
          paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask () {
            this.ctx.fillRect(0, 0, 1, 1)
          },
          paintXObject: function CanvasGraphics_paintXObject () {
            (0, _util.warn)("Unsupported 'paintXObject' command.")
          },
          markPoint: function CanvasGraphics_markPoint (tag) {},
          markPointProps: function CanvasGraphics_markPointProps (tag, properties) {},
          beginMarkedContent: function CanvasGraphics_beginMarkedContent (tag) {},
          beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps (tag, properties) {},
          endMarkedContent: function CanvasGraphics_endMarkedContent () {},
          beginCompat: function CanvasGraphics_beginCompat () {},
          endCompat: function CanvasGraphics_endCompat () {},
          consumePath: function CanvasGraphics_consumePath () {
            const ctx = this.ctx

            if (this.pendingClip) {
              if (this.pendingClip === EO_CLIP) {
                ctx.clip('evenodd')
              } else {
                ctx.clip()
              }

              this.pendingClip = null
            }

            ctx.beginPath()
          },
          getSinglePixelWidth: function getSinglePixelWidth (scale) {
            if (this._cachedGetSinglePixelWidth === null) {
              const inverse = this.ctx.mozCurrentTransformInverse
              this._cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]))
            }

            return this._cachedGetSinglePixelWidth
          },
          getCanvasPosition: function CanvasGraphics_getCanvasPosition (x, y) {
            const transform = this.ctx.mozCurrentTransform
            return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]]
          }
        }

        for (const op in _util.OPS) {
          CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op]
        }

        return CanvasGraphics
      }())

      exports.CanvasGraphics = CanvasGraphics
      /***/ },
    /* 198 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.getShadingPatternFromIR = getShadingPatternFromIR
      exports.TilingPattern = void 0

      const _util = __w_pdfjs_require__(1)

      const ShadingIRs = {}

      function applyBoundingBox (ctx, bbox) {
        if (!bbox || typeof Path2D === 'undefined') {
          return
        }

        const width = bbox[2] - bbox[0]
        const height = bbox[3] - bbox[1]
        const region = new Path2D()
        region.rect(bbox[0], bbox[1], width, height)
        ctx.clip(region)
      }

      ShadingIRs.RadialAxial = {
        fromIR: function RadialAxial_fromIR (raw) {
          const type = raw[1]
          const bbox = raw[2]
          const colorStops = raw[3]
          const p0 = raw[4]
          const p1 = raw[5]
          const r0 = raw[6]
          const r1 = raw[7]
          return {
            type: 'Pattern',
            getPattern: function RadialAxial_getPattern (ctx) {
              applyBoundingBox(ctx, bbox)
              let grad

              if (type === 'axial') {
                grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1])
              } else if (type === 'radial') {
                grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1)
              }

              for (let i = 0, ii = colorStops.length; i < ii; ++i) {
                const c = colorStops[i]
                grad.addColorStop(c[0], c[1])
              }

              return grad
            }
          }
        }
      }

      const createMeshCanvas = (function createMeshCanvasClosure () {
        function drawTriangle (data, context, p1, p2, p3, c1, c2, c3) {
          const coords = context.coords
          const colors = context.colors
          const bytes = data.data
          const rowSize = data.width * 4
          let tmp

          if (coords[p1 + 1] > coords[p2 + 1]) {
            tmp = p1
            p1 = p2
            p2 = tmp
            tmp = c1
            c1 = c2
            c2 = tmp
          }

          if (coords[p2 + 1] > coords[p3 + 1]) {
            tmp = p2
            p2 = p3
            p3 = tmp
            tmp = c2
            c2 = c3
            c3 = tmp
          }

          if (coords[p1 + 1] > coords[p2 + 1]) {
            tmp = p1
            p1 = p2
            p2 = tmp
            tmp = c1
            c1 = c2
            c2 = tmp
          }

          const x1 = (coords[p1] + context.offsetX) * context.scaleX
          const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY
          const x2 = (coords[p2] + context.offsetX) * context.scaleX
          const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY
          const x3 = (coords[p3] + context.offsetX) * context.scaleX
          const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY

          if (y1 >= y3) {
            return
          }

          const c1r = colors[c1]
          const c1g = colors[c1 + 1]
          const c1b = colors[c1 + 2]
          const c2r = colors[c2]
          const c2g = colors[c2 + 1]
          const c2b = colors[c2 + 2]
          const c3r = colors[c3]
          const c3g = colors[c3 + 1]
          const c3b = colors[c3 + 2]
          const minY = Math.round(y1)
          const maxY = Math.round(y3)
          let xa, car, cag, cab
          let xb, cbr, cbg, cbb

          for (let y = minY; y <= maxY; y++) {
            if (y < y2) {
              let _k = void 0

              if (y < y1) {
                _k = 0
              } else if (y1 === y2) {
                _k = 1
              } else {
                _k = (y1 - y) / (y1 - y2)
              }

              xa = x1 - (x1 - x2) * _k
              car = c1r - (c1r - c2r) * _k
              cag = c1g - (c1g - c2g) * _k
              cab = c1b - (c1b - c2b) * _k
            } else {
              let _k2 = void 0

              if (y > y3) {
                _k2 = 1
              } else if (y2 === y3) {
                _k2 = 0
              } else {
                _k2 = (y2 - y) / (y2 - y3)
              }

              xa = x2 - (x2 - x3) * _k2
              car = c2r - (c2r - c3r) * _k2
              cag = c2g - (c2g - c3g) * _k2
              cab = c2b - (c2b - c3b) * _k2
            }

            let k = void 0

            if (y < y1) {
              k = 0
            } else if (y > y3) {
              k = 1
            } else {
              k = (y1 - y) / (y1 - y3)
            }

            xb = x1 - (x1 - x3) * k
            cbr = c1r - (c1r - c3r) * k
            cbg = c1g - (c1g - c3g) * k
            cbb = c1b - (c1b - c3b) * k
            const x1_ = Math.round(Math.min(xa, xb))
            const x2_ = Math.round(Math.max(xa, xb))
            let j = rowSize * y + x1_ * 4

            for (let x = x1_; x <= x2_; x++) {
              let _k3 = (xa - x) / (xa - xb)

              if (_k3 < 0) {
                _k3 = 0
              } else if (_k3 > 1) {
                _k3 = 1
              }

              bytes[j++] = car - (car - cbr) * _k3 | 0
              bytes[j++] = cag - (cag - cbg) * _k3 | 0
              bytes[j++] = cab - (cab - cbb) * _k3 | 0
              bytes[j++] = 255
            }
          }
        }

        function drawFigure (data, figure, context) {
          const ps = figure.coords
          const cs = figure.colors
          let i, ii

          switch (figure.type) {
            case 'lattice':
              var verticesPerRow = figure.verticesPerRow
              var rows = Math.floor(ps.length / verticesPerRow) - 1
              var cols = verticesPerRow - 1

              for (i = 0; i < rows; i++) {
                let q = i * verticesPerRow

                for (let j = 0; j < cols; j++, q++) {
                  drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow])
                  drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow])
                }
              }

              break

            case 'triangles':
              for (i = 0, ii = ps.length; i < ii; i += 3) {
                drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2])
              }

              break

            default:
              throw new Error('illegal figure')
          }
        }

        function createMeshCanvas (bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases, webGLContext) {
          const EXPECTED_SCALE = 1.1
          const MAX_PATTERN_SIZE = 3000
          const BORDER_SIZE = 2
          const offsetX = Math.floor(bounds[0])
          const offsetY = Math.floor(bounds[1])
          const boundsWidth = Math.ceil(bounds[2]) - offsetX
          const boundsHeight = Math.ceil(bounds[3]) - offsetY
          const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE)
          const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE)
          const scaleX = boundsWidth / width
          const scaleY = boundsHeight / height
          const context = {
            coords: coords,
            colors: colors,
            offsetX: -offsetX,
            offsetY: -offsetY,
            scaleX: 1 / scaleX,
            scaleY: 1 / scaleY
          }
          const paddedWidth = width + BORDER_SIZE * 2
          const paddedHeight = height + BORDER_SIZE * 2
          let canvas, tmpCanvas, i, ii

          if (webGLContext.isEnabled) {
            canvas = webGLContext.drawFigures({
              width: width,
              height: height,
              backgroundColor: backgroundColor,
              figures: figures,
              context: context
            })
            tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false)
            tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE)
            canvas = tmpCanvas.canvas
          } else {
            tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false)
            const tmpCtx = tmpCanvas.context
            const data = tmpCtx.createImageData(width, height)

            if (backgroundColor) {
              const bytes = data.data

              for (i = 0, ii = bytes.length; i < ii; i += 4) {
                bytes[i] = backgroundColor[0]
                bytes[i + 1] = backgroundColor[1]
                bytes[i + 2] = backgroundColor[2]
                bytes[i + 3] = 255
              }
            }

            for (i = 0; i < figures.length; i++) {
              drawFigure(data, figures[i], context)
            }

            tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE)
            canvas = tmpCanvas.canvas
          }

          return {
            canvas: canvas,
            offsetX: offsetX - BORDER_SIZE * scaleX,
            offsetY: offsetY - BORDER_SIZE * scaleY,
            scaleX: scaleX,
            scaleY: scaleY
          }
        }

        return createMeshCanvas
      }())

      ShadingIRs.Mesh = {
        fromIR: function Mesh_fromIR (raw) {
          const coords = raw[2]
          const colors = raw[3]
          const figures = raw[4]
          const bounds = raw[5]
          const matrix = raw[6]
          const bbox = raw[7]
          const background = raw[8]
          return {
            type: 'Pattern',
            getPattern: function Mesh_getPattern (ctx, owner, shadingFill) {
              applyBoundingBox(ctx, bbox)
              let scale

              if (shadingFill) {
                scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform)
              } else {
                scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform)

                if (matrix) {
                  const matrixScale = _util.Util.singularValueDecompose2dScale(matrix)

                  scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]]
                }
              }

              const temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases, owner.webGLContext)

              if (!shadingFill) {
                ctx.setTransform.apply(ctx, owner.baseTransform)

                if (matrix) {
                  ctx.transform.apply(ctx, matrix)
                }
              }

              ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY)
              ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY)
              return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat')
            }
          }
        }
      }
      ShadingIRs.Dummy = {
        fromIR: function Dummy_fromIR () {
          return {
            type: 'Pattern',
            getPattern: function Dummy_fromIR_getPattern () {
              return 'hotpink'
            }
          }
        }
      }

      function getShadingPatternFromIR (raw) {
        const shadingIR = ShadingIRs[raw[0]]

        if (!shadingIR) {
          throw new Error('Unknown IR type: '.concat(raw[0]))
        }

        return shadingIR.fromIR(raw)
      }

      const TilingPattern = (function TilingPatternClosure () {
        const PaintType = {
          COLORED: 1,
          UNCOLORED: 2
        }
        const MAX_PATTERN_SIZE = 3000

        function TilingPattern (IR, color, ctx, canvasGraphicsFactory, baseTransform) {
          this.operatorList = IR[2]
          this.matrix = IR[3] || [1, 0, 0, 1, 0, 0]
          this.bbox = IR[4]
          this.xstep = IR[5]
          this.ystep = IR[6]
          this.paintType = IR[7]
          this.tilingType = IR[8]
          this.color = color
          this.canvasGraphicsFactory = canvasGraphicsFactory
          this.baseTransform = baseTransform
          this.type = 'Pattern'
          this.ctx = ctx
        }

        TilingPattern.prototype = {
          createPatternCanvas: function TilinPattern_createPatternCanvas (owner) {
            const operatorList = this.operatorList
            const bbox = this.bbox
            const xstep = this.xstep
            const ystep = this.ystep
            const paintType = this.paintType
            const tilingType = this.tilingType
            const color = this.color
            const canvasGraphicsFactory = this.canvasGraphicsFactory;
            (0, _util.info)('TilingType: ' + tilingType)
            const x0 = bbox[0]
            const y0 = bbox[1]
            const x1 = bbox[2]
            const y1 = bbox[3]

            const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix)

            const curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform)

            const combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]]
            const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0])
            const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1])
            const tmpCanvas = owner.cachedCanvases.getCanvas('pattern', dimx.size, dimy.size, true)
            const tmpCtx = tmpCanvas.context
            const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx)
            graphics.groupLevel = owner.groupLevel
            this.setFillAndStrokeStyleToContext(graphics, paintType, color)
            graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0)
            graphics.transform(1, 0, 0, 1, -x0, -y0)
            this.clipBbox(graphics, bbox, x0, y0, x1, y1)
            graphics.executeOperatorList(operatorList)
            this.ctx.transform(1, 0, 0, 1, x0, y0)
            this.ctx.scale(1 / dimx.scale, 1 / dimy.scale)
            return tmpCanvas.canvas
          },
          getSizeAndScale: function TilingPattern_getSizeAndScale (step, realOutputSize, scale) {
            step = Math.abs(step)
            const maxSize = Math.max(MAX_PATTERN_SIZE, realOutputSize)
            let size = Math.ceil(step * scale)

            if (size >= maxSize) {
              size = maxSize
            } else {
              scale = size / step
            }

            return {
              scale: scale,
              size: size
            }
          },
          clipBbox: function clipBbox (graphics, bbox, x0, y0, x1, y1) {
            if (Array.isArray(bbox) && bbox.length === 4) {
              const bboxWidth = x1 - x0
              const bboxHeight = y1 - y0
              graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight)
              graphics.clip()
              graphics.endPath()
            }
          },
          setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext (graphics, paintType, color) {
            const context = graphics.ctx
            const current = graphics.current

            switch (paintType) {
              case PaintType.COLORED:
                var ctx = this.ctx
                context.fillStyle = ctx.fillStyle
                context.strokeStyle = ctx.strokeStyle
                current.fillColor = ctx.fillStyle
                current.strokeColor = ctx.strokeStyle
                break

              case PaintType.UNCOLORED:
                var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2])

                context.fillStyle = cssColor
                context.strokeStyle = cssColor
                current.fillColor = cssColor
                current.strokeColor = cssColor
                break

              default:
                throw new _util.FormatError('Unsupported paint type: '.concat(paintType))
            }
          },
          getPattern: function TilingPattern_getPattern (ctx, owner) {
            ctx = this.ctx
            ctx.setTransform.apply(ctx, this.baseTransform)
            ctx.transform.apply(ctx, this.matrix)
            const temporaryPatternCanvas = this.createPatternCanvas(owner)
            return ctx.createPattern(temporaryPatternCanvas, 'repeat')
          }
        }
        return TilingPattern
      }())

      exports.TilingPattern = TilingPattern
      /***/ },
    /* 199 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.GlobalWorkerOptions = void 0
      const GlobalWorkerOptions = Object.create(null)
      exports.GlobalWorkerOptions = GlobalWorkerOptions
      GlobalWorkerOptions.workerPort = GlobalWorkerOptions.workerPort === undefined ? null : GlobalWorkerOptions.workerPort
      GlobalWorkerOptions.workerSrc = GlobalWorkerOptions.workerSrc === undefined ? '' : GlobalWorkerOptions.workerSrc
      /***/ },
    /* 200 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.MessageHandler = void 0

      const _regenerator = _interopRequireDefault(__w_pdfjs_require__(191))

      const _util = __w_pdfjs_require__(1)

      function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

      function asyncGeneratorStep (gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value } catch (error) { reject(error); return } if (info.done) { resolve(value) } else { Promise.resolve(value).then(_next, _throw) } }

      function _asyncToGenerator (fn) { return function () { const self = this; const args = arguments; return new Promise(function (resolve, reject) { const gen = fn.apply(self, args); function _next (value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value) } function _throw (err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err) } _next(undefined) }) } }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      const CallbackKind = {
        UNKNOWN: 0,
        DATA: 1,
        ERROR: 2
      }
      const StreamKind = {
        UNKNOWN: 0,
        CANCEL: 1,
        CANCEL_COMPLETE: 2,
        CLOSE: 3,
        ENQUEUE: 4,
        ERROR: 5,
        PULL: 6,
        PULL_COMPLETE: 7,
        START_COMPLETE: 8
      }

      function wrapReason (reason) {
        if (_typeof(reason) !== 'object' || reason === null) {
          return reason
        }

        switch (reason.name) {
          case 'AbortException':
            return new _util.AbortException(reason.message)

          case 'MissingPDFException':
            return new _util.MissingPDFException(reason.message)

          case 'UnexpectedResponseException':
            return new _util.UnexpectedResponseException(reason.message, reason.status)

          case 'UnknownErrorException':
            return new _util.UnknownErrorException(reason.message, reason.details)

          default:
            return new _util.UnknownErrorException(reason.message, reason.toString())
        }
      }

      const MessageHandler = /* #__PURE__ */(function () {
        function MessageHandler (sourceName, targetName, comObj) {
          const _this = this

          _classCallCheck(this, MessageHandler)

          this.sourceName = sourceName
          this.targetName = targetName
          this.comObj = comObj
          this.callbackId = 1
          this.streamId = 1
          this.postMessageTransfers = true
          this.streamSinks = Object.create(null)
          this.streamControllers = Object.create(null)
          this.callbackCapabilities = Object.create(null)
          this.actionHandler = Object.create(null)

          this._onComObjOnMessage = function (event) {
            const data = event.data

            if (data.targetName !== _this.sourceName) {
              return
            }

            if (data.stream) {
              _this._processStreamMessage(data)

              return
            }

            if (data.callback) {
              const callbackId = data.callbackId
              const capability = _this.callbackCapabilities[callbackId]

              if (!capability) {
                throw new Error('Cannot resolve callback '.concat(callbackId))
              }

              delete _this.callbackCapabilities[callbackId]

              if (data.callback === CallbackKind.DATA) {
                capability.resolve(data.data)
              } else if (data.callback === CallbackKind.ERROR) {
                capability.reject(wrapReason(data.reason))
              } else {
                throw new Error('Unexpected callback case')
              }

              return
            }

            const action = _this.actionHandler[data.action]

            if (!action) {
              throw new Error('Unknown action from worker: '.concat(data.action))
            }

            if (data.callbackId) {
              const _sourceName = _this.sourceName
              const _targetName = data.sourceName
              new Promise(function (resolve) {
                resolve(action(data.data))
              }).then(function (result) {
                comObj.postMessage({
                  sourceName: _sourceName,
                  targetName: _targetName,
                  callback: CallbackKind.DATA,
                  callbackId: data.callbackId,
                  data: result
                })
              }, function (reason) {
                comObj.postMessage({
                  sourceName: _sourceName,
                  targetName: _targetName,
                  callback: CallbackKind.ERROR,
                  callbackId: data.callbackId,
                  reason: wrapReason(reason)
                })
              })
              return
            }

            if (data.streamId) {
              _this._createStreamSink(data)

              return
            }

            action(data.data)
          }

          comObj.addEventListener('message', this._onComObjOnMessage)
        }

        _createClass(MessageHandler, [{
          key: 'on',
          value: function on (actionName, handler) {
            const ah = this.actionHandler

            if (ah[actionName]) {
              throw new Error('There is already an actionName called "'.concat(actionName, '"'))
            }

            ah[actionName] = handler
          }
        }, {
          key: 'send',
          value: function send (actionName, data, transfers) {
            this._postMessage({
              sourceName: this.sourceName,
              targetName: this.targetName,
              action: actionName,
              data: data
            }, transfers)
          }
        }, {
          key: 'sendWithPromise',
          value: function sendWithPromise (actionName, data, transfers) {
            const callbackId = this.callbackId++
            const capability = (0, _util.createPromiseCapability)()
            this.callbackCapabilities[callbackId] = capability

            try {
              this._postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                callbackId: callbackId,
                data: data
              }, transfers)
            } catch (ex) {
              capability.reject(ex)
            }

            return capability.promise
          }
        }, {
          key: 'sendWithStream',
          value: function sendWithStream (actionName, data, queueingStrategy, transfers) {
            const _this2 = this

            const streamId = this.streamId++
            const sourceName = this.sourceName
            const targetName = this.targetName
            const comObj = this.comObj
            return new ReadableStream({
              start: function start (controller) {
                const startCapability = (0, _util.createPromiseCapability)()
                _this2.streamControllers[streamId] = {
                  controller: controller,
                  startCall: startCapability,
                  pullCall: null,
                  cancelCall: null,
                  isClosed: false
                }

                _this2._postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  action: actionName,
                  streamId: streamId,
                  data: data,
                  desiredSize: controller.desiredSize
                }, transfers)

                return startCapability.promise
              },
              pull: function pull (controller) {
                const pullCapability = (0, _util.createPromiseCapability)()
                _this2.streamControllers[streamId].pullCall = pullCapability
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.PULL,
                  streamId: streamId,
                  desiredSize: controller.desiredSize
                })
                return pullCapability.promise
              },
              cancel: function cancel (reason) {
                (0, _util.assert)(reason instanceof Error, 'cancel must have a valid reason')
                const cancelCapability = (0, _util.createPromiseCapability)()
                _this2.streamControllers[streamId].cancelCall = cancelCapability
                _this2.streamControllers[streamId].isClosed = true
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.CANCEL,
                  streamId: streamId,
                  reason: wrapReason(reason)
                })
                return cancelCapability.promise
              }
            }, queueingStrategy)
          }
        }, {
          key: '_createStreamSink',
          value: function _createStreamSink (data) {
            const self = this
            const action = this.actionHandler[data.action]
            const streamId = data.streamId
            const sourceName = this.sourceName
            const targetName = data.sourceName
            const comObj = this.comObj
            const streamSink = {
              enqueue: function enqueue (chunk) {
                const size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1
                const transfers = arguments.length > 2 ? arguments[2] : undefined

                if (this.isCancelled) {
                  return
                }

                const lastDesiredSize = this.desiredSize
                this.desiredSize -= size

                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                  this.sinkCapability = (0, _util.createPromiseCapability)()
                  this.ready = this.sinkCapability.promise
                }

                self._postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.ENQUEUE,
                  streamId: streamId,
                  chunk: chunk
                }, transfers)
              },
              close: function close () {
                if (this.isCancelled) {
                  return
                }

                this.isCancelled = true
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.CLOSE,
                  streamId: streamId
                })
                delete self.streamSinks[streamId]
              },
              error: function error (reason) {
                (0, _util.assert)(reason instanceof Error, 'error must have a valid reason')

                if (this.isCancelled) {
                  return
                }

                this.isCancelled = true
                comObj.postMessage({
                  sourceName: sourceName,
                  targetName: targetName,
                  stream: StreamKind.ERROR,
                  streamId: streamId,
                  reason: wrapReason(reason)
                })
              },
              sinkCapability: (0, _util.createPromiseCapability)(),
              onPull: null,
              onCancel: null,
              isCancelled: false,
              desiredSize: data.desiredSize,
              ready: null
            }
            streamSink.sinkCapability.resolve()
            streamSink.ready = streamSink.sinkCapability.promise
            this.streamSinks[streamId] = streamSink
            new Promise(function (resolve) {
              resolve(action(data.data, streamSink))
            }).then(function () {
              comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: StreamKind.START_COMPLETE,
                streamId: streamId,
                success: true
              })
            }, function (reason) {
              comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: StreamKind.START_COMPLETE,
                streamId: streamId,
                reason: wrapReason(reason)
              })
            })
          }
        }, {
          key: '_processStreamMessage',
          value: function _processStreamMessage (data) {
            const streamId = data.streamId
            const sourceName = this.sourceName
            const targetName = data.sourceName
            const comObj = this.comObj

            switch (data.stream) {
              case StreamKind.START_COMPLETE:
                if (data.success) {
                  this.streamControllers[streamId].startCall.resolve()
                } else {
                  this.streamControllers[streamId].startCall.reject(wrapReason(data.reason))
                }

                break

              case StreamKind.PULL_COMPLETE:
                if (data.success) {
                  this.streamControllers[streamId].pullCall.resolve()
                } else {
                  this.streamControllers[streamId].pullCall.reject(wrapReason(data.reason))
                }

                break

              case StreamKind.PULL:
                if (!this.streamSinks[streamId]) {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL_COMPLETE,
                    streamId: streamId,
                    success: true
                  })
                  break
                }

                if (this.streamSinks[streamId].desiredSize <= 0 && data.desiredSize > 0) {
                  this.streamSinks[streamId].sinkCapability.resolve()
                }

                this.streamSinks[streamId].desiredSize = data.desiredSize
                var onPull = this.streamSinks[data.streamId].onPull
                new Promise(function (resolve) {
                  resolve(onPull && onPull())
                }).then(function () {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL_COMPLETE,
                    streamId: streamId,
                    success: true
                  })
                }, function (reason) {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL_COMPLETE,
                    streamId: streamId,
                    reason: wrapReason(reason)
                  })
                })
                break

              case StreamKind.ENQUEUE:
                (0, _util.assert)(this.streamControllers[streamId], 'enqueue should have stream controller')

                if (this.streamControllers[streamId].isClosed) {
                  break
                }

                this.streamControllers[streamId].controller.enqueue(data.chunk)
                break

              case StreamKind.CLOSE:
                (0, _util.assert)(this.streamControllers[streamId], 'close should have stream controller')

                if (this.streamControllers[streamId].isClosed) {
                  break
                }

                this.streamControllers[streamId].isClosed = true
                this.streamControllers[streamId].controller.close()

                this._deleteStreamController(streamId)

                break

              case StreamKind.ERROR:
                (0, _util.assert)(this.streamControllers[streamId], 'error should have stream controller')
                this.streamControllers[streamId].controller.error(wrapReason(data.reason))

                this._deleteStreamController(streamId)

                break

              case StreamKind.CANCEL_COMPLETE:
                if (data.success) {
                  this.streamControllers[streamId].cancelCall.resolve()
                } else {
                  this.streamControllers[streamId].cancelCall.reject(wrapReason(data.reason))
                }

                this._deleteStreamController(streamId)

                break

              case StreamKind.CANCEL:
                if (!this.streamSinks[streamId]) {
                  break
                }

                var onCancel = this.streamSinks[data.streamId].onCancel
                new Promise(function (resolve) {
                  resolve(onCancel && onCancel(wrapReason(data.reason)))
                }).then(function () {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.CANCEL_COMPLETE,
                    streamId: streamId,
                    success: true
                  })
                }, function (reason) {
                  comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.CANCEL_COMPLETE,
                    streamId: streamId,
                    reason: wrapReason(reason)
                  })
                })
                this.streamSinks[streamId].sinkCapability.reject(wrapReason(data.reason))
                this.streamSinks[streamId].isCancelled = true
                delete this.streamSinks[streamId]
                break

              default:
                throw new Error('Unexpected stream case')
            }
          }
        }, {
          key: '_deleteStreamController',
          value: (function () {
            const _deleteStreamController2 = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee (streamId) {
              return _regenerator.default.wrap(function _callee$ (_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2
                      return Promise.allSettled([this.streamControllers[streamId].startCall, this.streamControllers[streamId].pullCall, this.streamControllers[streamId].cancelCall].map(function (capability) {
                        return capability && capability.promise
                      }))

                    case 2:
                      delete this.streamControllers[streamId]

                    case 3:
                    case 'end':
                      return _context.stop()
                  }
                }
              }, _callee, this)
            }))

            function _deleteStreamController (_x) {
              return _deleteStreamController2.apply(this, arguments)
            }

            return _deleteStreamController
          }())
        }, {
          key: '_postMessage',
          value: function _postMessage (message, transfers) {
            if (transfers && this.postMessageTransfers) {
              this.comObj.postMessage(message, transfers)
            } else {
              this.comObj.postMessage(message)
            }
          }
        }, {
          key: 'destroy',
          value: function destroy () {
            this.comObj.removeEventListener('message', this._onComObjOnMessage)
          }
        }])

        return MessageHandler
      }())

      exports.MessageHandler = MessageHandler
      /***/ },
    /* 201 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.Metadata = void 0

      const _util = __w_pdfjs_require__(1)

      const _xml_parser = __w_pdfjs_require__(202)

      function _slicedToArray (arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest() }

      function _nonIterableRest () { throw new TypeError('Invalid attempt to destructure non-iterable instance') }

      function _iterableToArrayLimit (arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === '[object Arguments]')) { return } const _arr = []; let _n = true; let _d = false; let _e; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break } } catch (err) { _d = true; _e = err } finally { try { if (!_n && _i.return != null) _i.return() } finally { if (_d) throw _e } } return _arr }

      function _arrayWithHoles (arr) { if (Array.isArray(arr)) return arr }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      const Metadata = /* #__PURE__ */(function () {
        function Metadata (data) {
          _classCallCheck(this, Metadata);

          (0, _util.assert)(typeof data === 'string', 'Metadata: input is not a string')
          data = this._repair(data)
          const parser = new _xml_parser.SimpleXMLParser()
          const xmlDocument = parser.parseFromString(data)
          this._metadataMap = new Map()

          if (xmlDocument) {
            this._parse(xmlDocument)
          }
        }

        _createClass(Metadata, [{
          key: '_repair',
          value: function _repair (data) {
            return data.replace(/^[^<]+/, '').replace(/>\\376\\377([^<]+)/g, function (all, codes) {
              const bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
                return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1)
              }).replace(/&(amp|apos|gt|lt|quot);/g, function (str, name) {
                switch (name) {
                  case 'amp':
                    return '&'

                  case 'apos':
                    return "'"

                  case 'gt':
                    return '>'

                  case 'lt':
                    return '<'

                  case 'quot':
                    return '"'
                }

                throw new Error('_repair: '.concat(name, " isn't defined."))
              })
              let chars = ''

              for (let i = 0, ii = bytes.length; i < ii; i += 2) {
                const code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1)

                if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
                  chars += String.fromCharCode(code)
                } else {
                  chars += '&#x' + (0x10000 + code).toString(16).substring(1) + ';'
                }
              }

              return '>' + chars
            })
          }
        }, {
          key: '_parse',
          value: function _parse (xmlDocument) {
            let rdf = xmlDocument.documentElement

            if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
              rdf = rdf.firstChild

              while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
                rdf = rdf.nextSibling
              }
            }

            const nodeName = rdf ? rdf.nodeName.toLowerCase() : null

            if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
              return
            }

            const children = rdf.childNodes

            for (let i = 0, ii = children.length; i < ii; i++) {
              const desc = children[i]

              if (desc.nodeName.toLowerCase() !== 'rdf:description') {
                continue
              }

              for (let j = 0, jj = desc.childNodes.length; j < jj; j++) {
                if (desc.childNodes[j].nodeName.toLowerCase() !== '#text') {
                  const entry = desc.childNodes[j]
                  const name = entry.nodeName.toLowerCase()

                  this._metadataMap.set(name, entry.textContent.trim())
                }
              }
            }
          }
        }, {
          key: 'get',
          value: function get (name) {
            return this._metadataMap.has(name) ? this._metadataMap.get(name) : null
          }
        }, {
          key: 'getAll',
          value: function getAll () {
            const obj = Object.create(null)
            let _iteratorNormalCompletion = true
            let _didIteratorError = false
            let _iteratorError

            try {
              for (var _iterator = this._metadataMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                const _step$value = _slicedToArray(_step.value, 2)
                const key = _step$value[0]
                const value = _step$value[1]

                obj[key] = value
              }
            } catch (err) {
              _didIteratorError = true
              _iteratorError = err
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return()
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError
                }
              }
            }

            return obj
          }
        }, {
          key: 'has',
          value: function has (name) {
            return this._metadataMap.has(name)
          }
        }])

        return Metadata
      }())

      exports.Metadata = Metadata
      /***/ },
    /* 202 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.SimpleXMLParser = void 0

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      function _slicedToArray (arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest() }

      function _nonIterableRest () { throw new TypeError('Invalid attempt to destructure non-iterable instance') }

      function _iterableToArrayLimit (arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === '[object Arguments]')) { return } const _arr = []; let _n = true; let _d = false; let _e; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break } } catch (err) { _d = true; _e = err } finally { try { if (!_n && _i.return != null) _i.return() } finally { if (_d) throw _e } } return _arr }

      function _arrayWithHoles (arr) { if (Array.isArray(arr)) return arr }

      function _possibleConstructorReturn (self, call) { if (call && (_typeof(call) === 'object' || typeof call === 'function')) { return call } return _assertThisInitialized(self) }

      function _assertThisInitialized (self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called") } return self }

      function _get (target, property, receiver) { if (typeof Reflect !== 'undefined' && Reflect.get) { _get = Reflect.get } else { _get = function _get (target, property, receiver) { const base = _superPropBase(target, property); if (!base) return; const desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver) } return desc.value } } return _get(target, property, receiver || target) }

      function _superPropBase (object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break } return object }

      function _getPrototypeOf (o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf (o) { return o.__proto__ || Object.getPrototypeOf(o) }; return _getPrototypeOf(o) }

      function _inherits (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function') } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass) }

      function _setPrototypeOf (o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf (o, p) { o.__proto__ = p; return o }; return _setPrototypeOf(o, p) }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      const XMLParserErrorCode = {
        NoError: 0,
        EndOfDocument: -1,
        UnterminatedCdat: -2,
        UnterminatedXmlDeclaration: -3,
        UnterminatedDoctypeDeclaration: -4,
        UnterminatedComment: -5,
        MalformedElement: -6,
        OutOfMemory: -7,
        UnterminatedAttributeValue: -8,
        UnterminatedElement: -9,
        ElementNeverBegun: -10
      }

      function isWhitespace (s, index) {
        const ch = s[index]
        return ch === ' ' || ch === '\n' || ch === '\r' || ch === '\t'
      }

      function isWhitespaceString (s) {
        for (let i = 0, ii = s.length; i < ii; i++) {
          if (!isWhitespace(s, i)) {
            return false
          }
        }

        return true
      }

      const XMLParserBase = /* #__PURE__ */(function () {
        function XMLParserBase () {
          _classCallCheck(this, XMLParserBase)
        }

        _createClass(XMLParserBase, [{
          key: '_resolveEntities',
          value: function _resolveEntities (s) {
            const _this = this

            return s.replace(/&([^;]+);/g, function (all, entity) {
              if (entity.substring(0, 2) === '#x') {
                return String.fromCharCode(parseInt(entity.substring(2), 16))
              } else if (entity.substring(0, 1) === '#') {
                return String.fromCharCode(parseInt(entity.substring(1), 10))
              }

              switch (entity) {
                case 'lt':
                  return '<'

                case 'gt':
                  return '>'

                case 'amp':
                  return '&'

                case 'quot':
                  return '"'
              }

              return _this.onResolveEntity(entity)
            })
          }
        }, {
          key: '_parseContent',
          value: function _parseContent (s, start) {
            const attributes = []
            let pos = start

            function skipWs () {
              while (pos < s.length && isWhitespace(s, pos)) {
                ++pos
              }
            }

            while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
              ++pos
            }

            const name = s.substring(start, pos)
            skipWs()

            while (pos < s.length && s[pos] !== '>' && s[pos] !== '/' && s[pos] !== '?') {
              skipWs()
              let attrName = ''
              let attrValue = ''

              while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '=') {
                attrName += s[pos]
                ++pos
              }

              skipWs()

              if (s[pos] !== '=') {
                return null
              }

              ++pos
              skipWs()
              const attrEndChar = s[pos]

              if (attrEndChar !== '"' && attrEndChar !== "'") {
                return null
              }

              const attrEndIndex = s.indexOf(attrEndChar, ++pos)

              if (attrEndIndex < 0) {
                return null
              }

              attrValue = s.substring(pos, attrEndIndex)
              attributes.push({
                name: attrName,
                value: this._resolveEntities(attrValue)
              })
              pos = attrEndIndex + 1
              skipWs()
            }

            return {
              name: name,
              attributes: attributes,
              parsed: pos - start
            }
          }
        }, {
          key: '_parseProcessingInstruction',
          value: function _parseProcessingInstruction (s, start) {
            let pos = start

            function skipWs () {
              while (pos < s.length && isWhitespace(s, pos)) {
                ++pos
              }
            }

            while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
              ++pos
            }

            const name = s.substring(start, pos)
            skipWs()
            const attrStart = pos

            while (pos < s.length && (s[pos] !== '?' || s[pos + 1] !== '>')) {
              ++pos
            }

            const value = s.substring(attrStart, pos)
            return {
              name: name,
              value: value,
              parsed: pos - start
            }
          }
        }, {
          key: 'parseXml',
          value: function parseXml (s) {
            let i = 0

            while (i < s.length) {
              const ch = s[i]
              let j = i

              if (ch === '<') {
                ++j
                const ch2 = s[j]
                let q = void 0

                switch (ch2) {
                  case '/':
                    ++j
                    q = s.indexOf('>', j)

                    if (q < 0) {
                      this.onError(XMLParserErrorCode.UnterminatedElement)
                      return
                    }

                    this.onEndElement(s.substring(j, q))
                    j = q + 1
                    break

                  case '?':
                    ++j

                    var pi = this._parseProcessingInstruction(s, j)

                    if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== '?>') {
                      this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration)
                      return
                    }

                    this.onPi(pi.name, pi.value)
                    j += pi.parsed + 2
                    break

                  case '!':
                    if (s.substring(j + 1, j + 3) === '--') {
                      q = s.indexOf('-->', j + 3)

                      if (q < 0) {
                        this.onError(XMLParserErrorCode.UnterminatedComment)
                        return
                      }

                      this.onComment(s.substring(j + 3, q))
                      j = q + 3
                    } else if (s.substring(j + 1, j + 8) === '[CDATA[') {
                      q = s.indexOf(']]>', j + 8)

                      if (q < 0) {
                        this.onError(XMLParserErrorCode.UnterminatedCdat)
                        return
                      }

                      this.onCdata(s.substring(j + 8, q))
                      j = q + 3
                    } else if (s.substring(j + 1, j + 8) === 'DOCTYPE') {
                      const q2 = s.indexOf('[', j + 8)
                      let complexDoctype = false
                      q = s.indexOf('>', j + 8)

                      if (q < 0) {
                        this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration)
                        return
                      }

                      if (q2 > 0 && q > q2) {
                        q = s.indexOf(']>', j + 8)

                        if (q < 0) {
                          this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration)
                          return
                        }

                        complexDoctype = true
                      }

                      const doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0))
                      this.onDoctype(doctypeContent)
                      j = q + (complexDoctype ? 2 : 1)
                    } else {
                      this.onError(XMLParserErrorCode.MalformedElement)
                      return
                    }

                    break

                  default:
                    var content = this._parseContent(s, j)

                    if (content === null) {
                      this.onError(XMLParserErrorCode.MalformedElement)
                      return
                    }

                    var isClosed = false

                    if (s.substring(j + content.parsed, j + content.parsed + 2) === '/>') {
                      isClosed = true
                    } else if (s.substring(j + content.parsed, j + content.parsed + 1) !== '>') {
                      this.onError(XMLParserErrorCode.UnterminatedElement)
                      return
                    }

                    this.onBeginElement(content.name, content.attributes, isClosed)
                    j += content.parsed + (isClosed ? 2 : 1)
                    break
                }
              } else {
                while (j < s.length && s[j] !== '<') {
                  j++
                }

                const text = s.substring(i, j)
                this.onText(this._resolveEntities(text))
              }

              i = j
            }
          }
        }, {
          key: 'onResolveEntity',
          value: function onResolveEntity (name) {
            return '&'.concat(name, ';')
          }
        }, {
          key: 'onPi',
          value: function onPi (name, value) {}
        }, {
          key: 'onComment',
          value: function onComment (text) {}
        }, {
          key: 'onCdata',
          value: function onCdata (text) {}
        }, {
          key: 'onDoctype',
          value: function onDoctype (doctypeContent) {}
        }, {
          key: 'onText',
          value: function onText (text) {}
        }, {
          key: 'onBeginElement',
          value: function onBeginElement (name, attributes, isEmpty) {}
        }, {
          key: 'onEndElement',
          value: function onEndElement (name) {}
        }, {
          key: 'onError',
          value: function onError (code) {}
        }])

        return XMLParserBase
      }())

      const SimpleDOMNode = /* #__PURE__ */(function () {
        function SimpleDOMNode (nodeName, nodeValue) {
          _classCallCheck(this, SimpleDOMNode)

          this.nodeName = nodeName
          this.nodeValue = nodeValue
          Object.defineProperty(this, 'parentNode', {
            value: null,
            writable: true
          })
        }

        _createClass(SimpleDOMNode, [{
          key: 'hasChildNodes',
          value: function hasChildNodes () {
            return this.childNodes && this.childNodes.length > 0
          }
        }, {
          key: 'firstChild',
          get: function get () {
            return this.childNodes && this.childNodes[0]
          }
        }, {
          key: 'nextSibling',
          get: function get () {
            const childNodes = this.parentNode.childNodes

            if (!childNodes) {
              return undefined
            }

            const index = childNodes.indexOf(this)

            if (index === -1) {
              return undefined
            }

            return childNodes[index + 1]
          }
        }, {
          key: 'textContent',
          get: function get () {
            if (!this.childNodes) {
              return this.nodeValue || ''
            }

            return this.childNodes.map(function (child) {
              return child.textContent
            }).join('')
          }
        }])

        return SimpleDOMNode
      }())

      const SimpleXMLParser = /* #__PURE__ */(function (_XMLParserBase) {
        _inherits(SimpleXMLParser, _XMLParserBase)

        function SimpleXMLParser () {
          let _this2

          _classCallCheck(this, SimpleXMLParser)

          _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SimpleXMLParser).call(this))
          _this2._currentFragment = null
          _this2._stack = null
          _this2._errorCode = XMLParserErrorCode.NoError
          return _this2
        }

        _createClass(SimpleXMLParser, [{
          key: 'parseFromString',
          value: function parseFromString (data) {
            this._currentFragment = []
            this._stack = []
            this._errorCode = XMLParserErrorCode.NoError
            this.parseXml(data)

            if (this._errorCode !== XMLParserErrorCode.NoError) {
              return undefined
            }

            const _this$_currentFragmen = _slicedToArray(this._currentFragment, 1)
            const documentElement = _this$_currentFragmen[0]

            if (!documentElement) {
              return undefined
            }

            return {
              documentElement: documentElement
            }
          }
        }, {
          key: 'onResolveEntity',
          value: function onResolveEntity (name) {
            switch (name) {
              case 'apos':
                return "'"
            }

            return _get(_getPrototypeOf(SimpleXMLParser.prototype), 'onResolveEntity', this).call(this, name)
          }
        }, {
          key: 'onText',
          value: function onText (text) {
            if (isWhitespaceString(text)) {
              return
            }

            const node = new SimpleDOMNode('#text', text)

            this._currentFragment.push(node)
          }
        }, {
          key: 'onCdata',
          value: function onCdata (text) {
            const node = new SimpleDOMNode('#text', text)

            this._currentFragment.push(node)
          }
        }, {
          key: 'onBeginElement',
          value: function onBeginElement (name, attributes, isEmpty) {
            const node = new SimpleDOMNode(name)
            node.childNodes = []

            this._currentFragment.push(node)

            if (isEmpty) {
              return
            }

            this._stack.push(this._currentFragment)

            this._currentFragment = node.childNodes
          }
        }, {
          key: 'onEndElement',
          value: function onEndElement (name) {
            this._currentFragment = this._stack.pop() || []
            const lastElement = this._currentFragment[this._currentFragment.length - 1]

            if (!lastElement) {
              return
            }

            for (let i = 0, ii = lastElement.childNodes.length; i < ii; i++) {
              lastElement.childNodes[i].parentNode = lastElement
            }
          }
        }, {
          key: 'onError',
          value: function onError (code) {
            this._errorCode = code
          }
        }])

        return SimpleXMLParser
      }(XMLParserBase))

      exports.SimpleXMLParser = SimpleXMLParser
      /***/ },
    /* 203 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.PDFDataTransportStream = void 0

      const _regenerator = _interopRequireDefault(__w_pdfjs_require__(191))

      const _util = __w_pdfjs_require__(1)

      function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

      function asyncGeneratorStep (gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value } catch (error) { reject(error); return } if (info.done) { resolve(value) } else { Promise.resolve(value).then(_next, _throw) } }

      function _asyncToGenerator (fn) { return function () { const self = this; const args = arguments; return new Promise(function (resolve, reject) { const gen = fn.apply(self, args); function _next (value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value) } function _throw (err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err) } _next(undefined) }) } }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      const PDFDataTransportStream = /* #__PURE__ */(function () {
        function PDFDataTransportStream (params, pdfDataRangeTransport) {
          const _this = this

          _classCallCheck(this, PDFDataTransportStream);

          (0, _util.assert)(pdfDataRangeTransport)
          this._queuedChunks = []
          this._progressiveDone = params.progressiveDone || false
          const initialData = params.initialData

          if (initialData && initialData.length > 0) {
            const buffer = new Uint8Array(initialData).buffer

            this._queuedChunks.push(buffer)
          }

          this._pdfDataRangeTransport = pdfDataRangeTransport
          this._isStreamingSupported = !params.disableStream
          this._isRangeSupported = !params.disableRange
          this._contentLength = params.length
          this._fullRequestReader = null
          this._rangeReaders = []

          this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
            _this._onReceiveData({
              begin: begin,
              chunk: chunk
            })
          })

          this._pdfDataRangeTransport.addProgressListener(function (loaded, total) {
            _this._onProgress({
              loaded: loaded,
              total: total
            })
          })

          this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
            _this._onReceiveData({
              chunk: chunk
            })
          })

          this._pdfDataRangeTransport.addProgressiveDoneListener(function () {
            _this._onProgressiveDone()
          })

          this._pdfDataRangeTransport.transportReady()
        }

        _createClass(PDFDataTransportStream, [{
          key: '_onReceiveData',
          value: function _onReceiveData (args) {
            const buffer = new Uint8Array(args.chunk).buffer

            if (args.begin === undefined) {
              if (this._fullRequestReader) {
                this._fullRequestReader._enqueue(buffer)
              } else {
                this._queuedChunks.push(buffer)
              }
            } else {
              const found = this._rangeReaders.some(function (rangeReader) {
                if (rangeReader._begin !== args.begin) {
                  return false
                }

                rangeReader._enqueue(buffer)

                return true
              });

              (0, _util.assert)(found)
            }
          }
        }, {
          key: '_onProgress',
          value: function _onProgress (evt) {
            if (evt.total === undefined) {
              const firstReader = this._rangeReaders[0]

              if (firstReader && firstReader.onProgress) {
                firstReader.onProgress({
                  loaded: evt.loaded
                })
              }
            } else {
              const fullReader = this._fullRequestReader

              if (fullReader && fullReader.onProgress) {
                fullReader.onProgress({
                  loaded: evt.loaded,
                  total: evt.total
                })
              }
            }
          }
        }, {
          key: '_onProgressiveDone',
          value: function _onProgressiveDone () {
            if (this._fullRequestReader) {
              this._fullRequestReader.progressiveDone()
            }

            this._progressiveDone = true
          }
        }, {
          key: '_removeRangeReader',
          value: function _removeRangeReader (reader) {
            const i = this._rangeReaders.indexOf(reader)

            if (i >= 0) {
              this._rangeReaders.splice(i, 1)
            }
          }
        }, {
          key: 'getFullReader',
          value: function getFullReader () {
            (0, _util.assert)(!this._fullRequestReader)
            const queuedChunks = this._queuedChunks
            this._queuedChunks = null
            return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone)
          }
        }, {
          key: 'getRangeReader',
          value: function getRangeReader (begin, end) {
            if (end <= this._progressiveDataLength) {
              return null
            }

            const reader = new PDFDataTransportStreamRangeReader(this, begin, end)

            this._pdfDataRangeTransport.requestDataRange(begin, end)

            this._rangeReaders.push(reader)

            return reader
          }
        }, {
          key: 'cancelAllRequests',
          value: function cancelAllRequests (reason) {
            if (this._fullRequestReader) {
              this._fullRequestReader.cancel(reason)
            }

            const readers = this._rangeReaders.slice(0)

            readers.forEach(function (rangeReader) {
              rangeReader.cancel(reason)
            })

            this._pdfDataRangeTransport.abort()
          }
        }, {
          key: '_progressiveDataLength',
          get: function get () {
            return this._fullRequestReader ? this._fullRequestReader._loaded : 0
          }
        }])

        return PDFDataTransportStream
      }())

      exports.PDFDataTransportStream = PDFDataTransportStream

      var PDFDataTransportStreamReader = /* #__PURE__ */(function () {
        function PDFDataTransportStreamReader (stream, queuedChunks) {
          const progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false

          _classCallCheck(this, PDFDataTransportStreamReader)

          this._stream = stream
          this._done = progressiveDone || false
          this._filename = null
          this._queuedChunks = queuedChunks || []
          this._loaded = 0
          let _iteratorNormalCompletion = true
          let _didIteratorError = false
          let _iteratorError

          try {
            for (var _iterator = this._queuedChunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              const chunk = _step.value
              this._loaded += chunk.byteLength
            }
          } catch (err) {
            _didIteratorError = true
            _iteratorError = err
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return()
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError
              }
            }
          }

          this._requests = []
          this._headersReady = Promise.resolve()
          stream._fullRequestReader = this
          this.onProgress = null
        }

        _createClass(PDFDataTransportStreamReader, [{
          key: '_enqueue',
          value: function _enqueue (chunk) {
            if (this._done) {
              return
            }

            if (this._requests.length > 0) {
              const requestCapability = this._requests.shift()

              requestCapability.resolve({
                value: chunk,
                done: false
              })
            } else {
              this._queuedChunks.push(chunk)
            }

            this._loaded += chunk.byteLength
          }
        }, {
          key: 'read',
          value: (function () {
            const _read = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee () {
              let chunk, requestCapability
              return _regenerator.default.wrap(function _callee$ (_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(this._queuedChunks.length > 0)) {
                        _context.next = 3
                        break
                      }

                      chunk = this._queuedChunks.shift()
                      return _context.abrupt('return', {
                        value: chunk,
                        done: false
                      })

                    case 3:
                      if (!this._done) {
                        _context.next = 5
                        break
                      }

                      return _context.abrupt('return', {
                        value: undefined,
                        done: true
                      })

                    case 5:
                      requestCapability = (0, _util.createPromiseCapability)()

                      this._requests.push(requestCapability)

                      return _context.abrupt('return', requestCapability.promise)

                    case 8:
                    case 'end':
                      return _context.stop()
                  }
                }
              }, _callee, this)
            }))

            function read () {
              return _read.apply(this, arguments)
            }

            return read
          }())
        }, {
          key: 'cancel',
          value: function cancel (reason) {
            this._done = true

            this._requests.forEach(function (requestCapability) {
              requestCapability.resolve({
                value: undefined,
                done: true
              })
            })

            this._requests = []
          }
        }, {
          key: 'progressiveDone',
          value: function progressiveDone () {
            if (this._done) {
              return
            }

            this._done = true
          }
        }, {
          key: 'headersReady',
          get: function get () {
            return this._headersReady
          }
        }, {
          key: 'filename',
          get: function get () {
            return this._filename
          }
        }, {
          key: 'isRangeSupported',
          get: function get () {
            return this._stream._isRangeSupported
          }
        }, {
          key: 'isStreamingSupported',
          get: function get () {
            return this._stream._isStreamingSupported
          }
        }, {
          key: 'contentLength',
          get: function get () {
            return this._stream._contentLength
          }
        }])

        return PDFDataTransportStreamReader
      }())

      var PDFDataTransportStreamRangeReader = /* #__PURE__ */(function () {
        function PDFDataTransportStreamRangeReader (stream, begin, end) {
          _classCallCheck(this, PDFDataTransportStreamRangeReader)

          this._stream = stream
          this._begin = begin
          this._end = end
          this._queuedChunk = null
          this._requests = []
          this._done = false
          this.onProgress = null
        }

        _createClass(PDFDataTransportStreamRangeReader, [{
          key: '_enqueue',
          value: function _enqueue (chunk) {
            if (this._done) {
              return
            }

            if (this._requests.length === 0) {
              this._queuedChunk = chunk
            } else {
              const requestsCapability = this._requests.shift()

              requestsCapability.resolve({
                value: chunk,
                done: false
              })

              this._requests.forEach(function (requestCapability) {
                requestCapability.resolve({
                  value: undefined,
                  done: true
                })
              })

              this._requests = []
            }

            this._done = true

            this._stream._removeRangeReader(this)
          }
        }, {
          key: 'read',
          value: (function () {
            const _read2 = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee2 () {
              let chunk, requestCapability
              return _regenerator.default.wrap(function _callee2$ (_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!this._queuedChunk) {
                        _context2.next = 4
                        break
                      }

                      chunk = this._queuedChunk
                      this._queuedChunk = null
                      return _context2.abrupt('return', {
                        value: chunk,
                        done: false
                      })

                    case 4:
                      if (!this._done) {
                        _context2.next = 6
                        break
                      }

                      return _context2.abrupt('return', {
                        value: undefined,
                        done: true
                      })

                    case 6:
                      requestCapability = (0, _util.createPromiseCapability)()

                      this._requests.push(requestCapability)

                      return _context2.abrupt('return', requestCapability.promise)

                    case 9:
                    case 'end':
                      return _context2.stop()
                  }
                }
              }, _callee2, this)
            }))

            function read () {
              return _read2.apply(this, arguments)
            }

            return read
          }())
        }, {
          key: 'cancel',
          value: function cancel (reason) {
            this._done = true

            this._requests.forEach(function (requestCapability) {
              requestCapability.resolve({
                value: undefined,
                done: true
              })
            })

            this._requests = []

            this._stream._removeRangeReader(this)
          }
        }, {
          key: 'isStreamingSupported',
          get: function get () {
            return false
          }
        }])

        return PDFDataTransportStreamRangeReader
      }())
      /***/ },
    /* 204 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.WebGLContext = void 0

      const _util = __w_pdfjs_require__(1)

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      const WebGLContext = /* #__PURE__ */(function () {
        function WebGLContext (_ref) {
          const _ref$enable = _ref.enable
          const enable = _ref$enable === void 0 ? false : _ref$enable

          _classCallCheck(this, WebGLContext)

          this._enabled = enable === true
        }

        _createClass(WebGLContext, [{
          key: 'composeSMask',
          value: function composeSMask (_ref2) {
            const layer = _ref2.layer
            const mask = _ref2.mask
            const properties = _ref2.properties
            return WebGLUtils.composeSMask(layer, mask, properties)
          }
        }, {
          key: 'drawFigures',
          value: function drawFigures (_ref3) {
            const width = _ref3.width
            const height = _ref3.height
            const backgroundColor = _ref3.backgroundColor
            const figures = _ref3.figures
            const context = _ref3.context
            return WebGLUtils.drawFigures(width, height, backgroundColor, figures, context)
          }
        }, {
          key: 'clear',
          value: function clear () {
            WebGLUtils.cleanup()
          }
        }, {
          key: 'isEnabled',
          get: function get () {
            let enabled = this._enabled

            if (enabled) {
              enabled = WebGLUtils.tryInitGL()
            }

            return (0, _util.shadow)(this, 'isEnabled', enabled)
          }
        }])

        return WebGLContext
      }())

      exports.WebGLContext = WebGLContext

      var WebGLUtils = (function WebGLUtilsClosure () {
        function loadShader (gl, code, shaderType) {
          const shader = gl.createShader(shaderType)
          gl.shaderSource(shader, code)
          gl.compileShader(shader)
          const compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS)

          if (!compiled) {
            const errorMsg = gl.getShaderInfoLog(shader)
            throw new Error('Error during shader compilation: ' + errorMsg)
          }

          return shader
        }

        function createVertexShader (gl, code) {
          return loadShader(gl, code, gl.VERTEX_SHADER)
        }

        function createFragmentShader (gl, code) {
          return loadShader(gl, code, gl.FRAGMENT_SHADER)
        }

        function createProgram (gl, shaders) {
          const program = gl.createProgram()

          for (let i = 0, ii = shaders.length; i < ii; ++i) {
            gl.attachShader(program, shaders[i])
          }

          gl.linkProgram(program)
          const linked = gl.getProgramParameter(program, gl.LINK_STATUS)

          if (!linked) {
            const errorMsg = gl.getProgramInfoLog(program)
            throw new Error('Error during program linking: ' + errorMsg)
          }

          return program
        }

        function createTexture (gl, image, textureId) {
          gl.activeTexture(textureId)
          const texture = gl.createTexture()
          gl.bindTexture(gl.TEXTURE_2D, texture)
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST)
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST)
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image)
          return texture
        }

        let currentGL, currentCanvas

        function generateGL () {
          if (currentGL) {
            return
          }

          currentCanvas = document.createElement('canvas')
          currentGL = currentCanvas.getContext('webgl', {
            premultipliedalpha: false
          })
        }

        const smaskVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec2 a_texCoord;                                    \
                                                                \
  uniform vec2 u_resolution;                                    \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_texCoord = a_texCoord;                                    \
  }                                                             '
        const smaskFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  uniform vec4 u_backdrop;                                      \
  uniform int u_subtype;                                        \
  uniform sampler2D u_image;                                    \
  uniform sampler2D u_mask;                                     \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec4 imageColor = texture2D(u_image, v_texCoord);           \
    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
    if (u_backdrop.a > 0.0) {                                   \
      maskColor.rgb = maskColor.rgb * maskColor.a +             \
                      u_backdrop.rgb * (1.0 - maskColor.a);     \
    }                                                           \
    float lum;                                                  \
    if (u_subtype == 0) {                                       \
      lum = maskColor.a;                                        \
    } else {                                                    \
      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
            maskColor.b * 0.11;                                 \
    }                                                           \
    imageColor.a *= lum;                                        \
    imageColor.rgb *= imageColor.a;                             \
    gl_FragColor = imageColor;                                  \
  }                                                             '
        let smaskCache = null

        function initSmaskGL () {
          let canvas, gl
          generateGL()
          canvas = currentCanvas
          currentCanvas = null
          gl = currentGL
          currentGL = null
          const vertexShader = createVertexShader(gl, smaskVertexShaderCode)
          const fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode)
          const program = createProgram(gl, [vertexShader, fragmentShader])
          gl.useProgram(program)
          const cache = {}
          cache.gl = gl
          cache.canvas = canvas
          cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution')
          cache.positionLocation = gl.getAttribLocation(program, 'a_position')
          cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop')
          cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype')
          const texCoordLocation = gl.getAttribLocation(program, 'a_texCoord')
          const texLayerLocation = gl.getUniformLocation(program, 'u_image')
          const texMaskLocation = gl.getUniformLocation(program, 'u_mask')
          const texCoordBuffer = gl.createBuffer()
          gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer)
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW)
          gl.enableVertexAttribArray(texCoordLocation)
          gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0)
          gl.uniform1i(texLayerLocation, 0)
          gl.uniform1i(texMaskLocation, 1)
          smaskCache = cache
        }

        function composeSMask (layer, mask, properties) {
          const width = layer.width
          const height = layer.height

          if (!smaskCache) {
            initSmaskGL()
          }

          const cache = smaskCache
          const canvas = cache.canvas
          const gl = cache.gl
          canvas.width = width
          canvas.height = height
          gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight)
          gl.uniform2f(cache.resolutionLocation, width, height)

          if (properties.backdrop) {
            gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1)
          } else {
            gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0)
          }

          gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0)
          const texture = createTexture(gl, layer, gl.TEXTURE0)
          const maskTexture = createTexture(gl, mask, gl.TEXTURE1)
          const buffer = gl.createBuffer()
          gl.bindBuffer(gl.ARRAY_BUFFER, buffer)
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW)
          gl.enableVertexAttribArray(cache.positionLocation)
          gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0)
          gl.clearColor(0, 0, 0, 0)
          gl.enable(gl.BLEND)
          gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA)
          gl.clear(gl.COLOR_BUFFER_BIT)
          gl.drawArrays(gl.TRIANGLES, 0, 6)
          gl.flush()
          gl.deleteTexture(texture)
          gl.deleteTexture(maskTexture)
          gl.deleteBuffer(buffer)
          return canvas
        }

        const figuresVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec3 a_color;                                       \
                                                                \
  uniform vec2 u_resolution;                                    \
  uniform vec2 u_scale;                                         \
  uniform vec2 u_offset;                                        \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    vec2 position = (a_position + u_offset) * u_scale;          \
    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_color = vec4(a_color / 255.0, 1.0);                       \
  }                                                             '
        const figuresFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    gl_FragColor = v_color;                                     \
  }                                                             '
        let figuresCache = null

        function initFiguresGL () {
          let canvas, gl
          generateGL()
          canvas = currentCanvas
          currentCanvas = null
          gl = currentGL
          currentGL = null
          const vertexShader = createVertexShader(gl, figuresVertexShaderCode)
          const fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode)
          const program = createProgram(gl, [vertexShader, fragmentShader])
          gl.useProgram(program)
          const cache = {}
          cache.gl = gl
          cache.canvas = canvas
          cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution')
          cache.scaleLocation = gl.getUniformLocation(program, 'u_scale')
          cache.offsetLocation = gl.getUniformLocation(program, 'u_offset')
          cache.positionLocation = gl.getAttribLocation(program, 'a_position')
          cache.colorLocation = gl.getAttribLocation(program, 'a_color')
          figuresCache = cache
        }

        function drawFigures (width, height, backgroundColor, figures, context) {
          if (!figuresCache) {
            initFiguresGL()
          }

          const cache = figuresCache
          const canvas = cache.canvas
          const gl = cache.gl
          canvas.width = width
          canvas.height = height
          gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight)
          gl.uniform2f(cache.resolutionLocation, width, height)
          let count = 0
          let i, ii, rows

          for (i = 0, ii = figures.length; i < ii; i++) {
            switch (figures[i].type) {
              case 'lattice':
                rows = figures[i].coords.length / figures[i].verticesPerRow | 0
                count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6
                break

              case 'triangles':
                count += figures[i].coords.length
                break
            }
          }

          const coords = new Float32Array(count * 2)
          const colors = new Uint8Array(count * 3)
          const coordsMap = context.coords
          const colorsMap = context.colors
          let pIndex = 0
          let cIndex = 0

          for (i = 0, ii = figures.length; i < ii; i++) {
            const figure = figures[i]
            const ps = figure.coords
            const cs = figure.colors

            switch (figure.type) {
              case 'lattice':
                var cols = figure.verticesPerRow
                rows = ps.length / cols | 0

                for (let row = 1; row < rows; row++) {
                  let offset = row * cols + 1

                  for (let col = 1; col < cols; col++, offset++) {
                    coords[pIndex] = coordsMap[ps[offset - cols - 1]]
                    coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1]
                    coords[pIndex + 2] = coordsMap[ps[offset - cols]]
                    coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1]
                    coords[pIndex + 4] = coordsMap[ps[offset - 1]]
                    coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1]
                    colors[cIndex] = colorsMap[cs[offset - cols - 1]]
                    colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1]
                    colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2]
                    colors[cIndex + 3] = colorsMap[cs[offset - cols]]
                    colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1]
                    colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2]
                    colors[cIndex + 6] = colorsMap[cs[offset - 1]]
                    colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1]
                    colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2]
                    coords[pIndex + 6] = coords[pIndex + 2]
                    coords[pIndex + 7] = coords[pIndex + 3]
                    coords[pIndex + 8] = coords[pIndex + 4]
                    coords[pIndex + 9] = coords[pIndex + 5]
                    coords[pIndex + 10] = coordsMap[ps[offset]]
                    coords[pIndex + 11] = coordsMap[ps[offset] + 1]
                    colors[cIndex + 9] = colors[cIndex + 3]
                    colors[cIndex + 10] = colors[cIndex + 4]
                    colors[cIndex + 11] = colors[cIndex + 5]
                    colors[cIndex + 12] = colors[cIndex + 6]
                    colors[cIndex + 13] = colors[cIndex + 7]
                    colors[cIndex + 14] = colors[cIndex + 8]
                    colors[cIndex + 15] = colorsMap[cs[offset]]
                    colors[cIndex + 16] = colorsMap[cs[offset] + 1]
                    colors[cIndex + 17] = colorsMap[cs[offset] + 2]
                    pIndex += 12
                    cIndex += 18
                  }
                }

                break

              case 'triangles':
                for (let j = 0, jj = ps.length; j < jj; j++) {
                  coords[pIndex] = coordsMap[ps[j]]
                  coords[pIndex + 1] = coordsMap[ps[j] + 1]
                  colors[cIndex] = colorsMap[cs[j]]
                  colors[cIndex + 1] = colorsMap[cs[j] + 1]
                  colors[cIndex + 2] = colorsMap[cs[j] + 2]
                  pIndex += 2
                  cIndex += 3
                }

                break
            }
          }

          if (backgroundColor) {
            gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0)
          } else {
            gl.clearColor(0, 0, 0, 0)
          }

          gl.clear(gl.COLOR_BUFFER_BIT)
          const coordsBuffer = gl.createBuffer()
          gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer)
          gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW)
          gl.enableVertexAttribArray(cache.positionLocation)
          gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0)
          const colorsBuffer = gl.createBuffer()
          gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer)
          gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW)
          gl.enableVertexAttribArray(cache.colorLocation)
          gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0)
          gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY)
          gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY)
          gl.drawArrays(gl.TRIANGLES, 0, count)
          gl.flush()
          gl.deleteBuffer(coordsBuffer)
          gl.deleteBuffer(colorsBuffer)
          return canvas
        }

        return {
          tryInitGL: function tryInitGL () {
            try {
              generateGL()
              return !!currentGL
            } catch (ex) {}

            return false
          },
          composeSMask: composeSMask,
          drawFigures: drawFigures,
          cleanup: function cleanup () {
            if (smaskCache && smaskCache.canvas) {
              smaskCache.canvas.width = 0
              smaskCache.canvas.height = 0
            }

            if (figuresCache && figuresCache.canvas) {
              figuresCache.canvas.width = 0
              figuresCache.canvas.height = 0
            }

            smaskCache = null
            figuresCache = null
          }
        }
      }())
      /***/ },
    /* 205 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.renderTextLayer = void 0

      const _util = __w_pdfjs_require__(1)

      const renderTextLayer = (function renderTextLayerClosure () {
        const MAX_TEXT_DIVS_TO_RENDER = 100000
        const NonWhitespaceRegexp = /\S/

        function isAllWhitespace (str) {
          return !NonWhitespaceRegexp.test(str)
        }

        function appendText (task, geom, styles) {
          const textDiv = document.createElement('span')
          const textDivProperties = {
            angle: 0,
            canvasWidth: 0,
            isWhitespace: false,
            originalTransform: null,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0,
            scale: 1
          }

          task._textDivs.push(textDiv)

          if (isAllWhitespace(geom.str)) {
            textDivProperties.isWhitespace = true

            task._textDivProperties.set(textDiv, textDivProperties)

            return
          }

          const tx = _util.Util.transform(task._viewport.transform, geom.transform)

          let angle = Math.atan2(tx[1], tx[0])
          const style = styles[geom.fontName]

          if (style.vertical) {
            angle += Math.PI / 2
          }

          const fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3])
          let fontAscent = fontHeight

          if (style.ascent) {
            fontAscent = style.ascent * fontAscent
          } else if (style.descent) {
            fontAscent = (1 + style.descent) * fontAscent
          }

          let left, top

          if (angle === 0) {
            left = tx[4]
            top = tx[5] - fontAscent
          } else {
            left = tx[4] + fontAscent * Math.sin(angle)
            top = tx[5] - fontAscent * Math.cos(angle)
          }

          textDiv.style.left = ''.concat(left, 'px')
          textDiv.style.top = ''.concat(top, 'px')
          textDiv.style.fontSize = ''.concat(fontHeight, 'px')
          textDiv.style.fontFamily = style.fontFamily
          textDiv.textContent = geom.str

          if (task._fontInspectorEnabled) {
            textDiv.dataset.fontName = geom.fontName
          }

          if (angle !== 0) {
            textDivProperties.angle = angle * (180 / Math.PI)
          }

          if (geom.str.length > 1) {
            if (style.vertical) {
              textDivProperties.canvasWidth = geom.height * task._viewport.scale
            } else {
              textDivProperties.canvasWidth = geom.width * task._viewport.scale
            }
          }

          task._textDivProperties.set(textDiv, textDivProperties)

          if (task._textContentStream) {
            task._layoutText(textDiv)
          }

          if (task._enhanceTextSelection) {
            let angleCos = 1
            let angleSin = 0

            if (angle !== 0) {
              angleCos = Math.cos(angle)
              angleSin = Math.sin(angle)
            }

            const divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale
            const divHeight = fontHeight
            let m, b

            if (angle !== 0) {
              m = [angleCos, angleSin, -angleSin, angleCos, left, top]
              b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m)
            } else {
              b = [left, top, left + divWidth, top + divHeight]
            }

            task._bounds.push({
              left: b[0],
              top: b[1],
              right: b[2],
              bottom: b[3],
              div: textDiv,
              size: [divWidth, divHeight],
              m: m
            })
          }
        }

        function render (task) {
          if (task._canceled) {
            return
          }

          const textDivs = task._textDivs
          const capability = task._capability
          const textDivsLength = textDivs.length

          if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
            task._renderingDone = true
            capability.resolve()
            return
          }

          if (!task._textContentStream) {
            for (let i = 0; i < textDivsLength; i++) {
              task._layoutText(textDivs[i])
            }
          }

          task._renderingDone = true
          capability.resolve()
        }

        function expand (task) {
          const bounds = task._bounds
          const viewport = task._viewport
          const expanded = expandBounds(viewport.width, viewport.height, bounds)

          for (let i = 0; i < expanded.length; i++) {
            const div = bounds[i].div

            const divProperties = task._textDivProperties.get(div)

            if (divProperties.angle === 0) {
              divProperties.paddingLeft = bounds[i].left - expanded[i].left
              divProperties.paddingTop = bounds[i].top - expanded[i].top
              divProperties.paddingRight = expanded[i].right - bounds[i].right
              divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom

              task._textDivProperties.set(div, divProperties)

              continue
            }

            var e = expanded[i]
            const b = bounds[i]
            var m = b.m
            var c = m[0]
            var s = m[1]
            const points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size]
            var ts = new Float64Array(64)
            points.forEach(function (p, i) {
              const t = _util.Util.applyTransform(p, m)

              ts[i + 0] = c && (e.left - t[0]) / c
              ts[i + 4] = s && (e.top - t[1]) / s
              ts[i + 8] = c && (e.right - t[0]) / c
              ts[i + 12] = s && (e.bottom - t[1]) / s
              ts[i + 16] = s && (e.left - t[0]) / -s
              ts[i + 20] = c && (e.top - t[1]) / c
              ts[i + 24] = s && (e.right - t[0]) / -s
              ts[i + 28] = c && (e.bottom - t[1]) / c
              ts[i + 32] = c && (e.left - t[0]) / -c
              ts[i + 36] = s && (e.top - t[1]) / -s
              ts[i + 40] = c && (e.right - t[0]) / -c
              ts[i + 44] = s && (e.bottom - t[1]) / -s
              ts[i + 48] = s && (e.left - t[0]) / s
              ts[i + 52] = c && (e.top - t[1]) / -c
              ts[i + 56] = s && (e.right - t[0]) / s
              ts[i + 60] = c && (e.bottom - t[1]) / -c
            })

            const findPositiveMin = function findPositiveMin (ts, offset, count) {
              let result = 0

              for (let i = 0; i < count; i++) {
                const t = ts[offset++]

                if (t > 0) {
                  result = result ? Math.min(t, result) : t
                }
              }

              return result
            }

            const boxScale = 1 + Math.min(Math.abs(c), Math.abs(s))
            divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale
            divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale
            divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale
            divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale

            task._textDivProperties.set(div, divProperties)
          }
        }

        function expandBounds (width, height, boxes) {
          const bounds = boxes.map(function (box, i) {
            return {
              x1: box.left,
              y1: box.top,
              x2: box.right,
              y2: box.bottom,
              index: i,
              x1New: undefined,
              x2New: undefined
            }
          })
          expandBoundsLTR(width, bounds)
          const expanded = new Array(boxes.length)
          bounds.forEach(function (b) {
            const i = b.index
            expanded[i] = {
              left: b.x1New,
              top: 0,
              right: b.x2New,
              bottom: 0
            }
          })
          boxes.map(function (box, i) {
            const e = expanded[i]
            const b = bounds[i]
            b.x1 = box.top
            b.y1 = width - e.right
            b.x2 = box.bottom
            b.y2 = width - e.left
            b.index = i
            b.x1New = undefined
            b.x2New = undefined
          })
          expandBoundsLTR(height, bounds)
          bounds.forEach(function (b) {
            const i = b.index
            expanded[i].top = b.x1New
            expanded[i].bottom = b.x2New
          })
          return expanded
        }

        function expandBoundsLTR (width, bounds) {
          bounds.sort(function (a, b) {
            return a.x1 - b.x1 || a.index - b.index
          })
          const fakeBoundary = {
            x1: -Infinity,
            y1: -Infinity,
            x2: 0,
            y2: Infinity,
            index: -1,
            x1New: 0,
            x2New: 0
          }
          const horizon = [{
            start: -Infinity,
            end: Infinity,
            boundary: fakeBoundary
          }]
          bounds.forEach(function (boundary) {
            let i = 0

            while (i < horizon.length && horizon[i].end <= boundary.y1) {
              i++
            }

            let j = horizon.length - 1

            while (j >= 0 && horizon[j].start >= boundary.y2) {
              j--
            }

            let horizonPart, affectedBoundary
            let q
            let k
            let maxXNew = -Infinity

            for (q = i; q <= j; q++) {
              horizonPart = horizon[q]
              affectedBoundary = horizonPart.boundary
              var xNew

              if (affectedBoundary.x2 > boundary.x1) {
                xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1
              } else if (affectedBoundary.x2New === undefined) {
                xNew = (affectedBoundary.x2 + boundary.x1) / 2
              } else {
                xNew = affectedBoundary.x2New
              }

              if (xNew > maxXNew) {
                maxXNew = xNew
              }
            }

            boundary.x1New = maxXNew

            for (q = i; q <= j; q++) {
              horizonPart = horizon[q]
              affectedBoundary = horizonPart.boundary

              if (affectedBoundary.x2New === undefined) {
                if (affectedBoundary.x2 > boundary.x1) {
                  if (affectedBoundary.index > boundary.index) {
                    affectedBoundary.x2New = affectedBoundary.x2
                  }
                } else {
                  affectedBoundary.x2New = maxXNew
                }
              } else if (affectedBoundary.x2New > maxXNew) {
                affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2)
              }
            }

            const changedHorizon = []
            let lastBoundary = null

            for (q = i; q <= j; q++) {
              horizonPart = horizon[q]
              affectedBoundary = horizonPart.boundary
              const useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary

              if (lastBoundary === useBoundary) {
                changedHorizon[changedHorizon.length - 1].end = horizonPart.end
              } else {
                changedHorizon.push({
                  start: horizonPart.start,
                  end: horizonPart.end,
                  boundary: useBoundary
                })
                lastBoundary = useBoundary
              }
            }

            if (horizon[i].start < boundary.y1) {
              changedHorizon[0].start = boundary.y1
              changedHorizon.unshift({
                start: horizon[i].start,
                end: boundary.y1,
                boundary: horizon[i].boundary
              })
            }

            if (boundary.y2 < horizon[j].end) {
              changedHorizon[changedHorizon.length - 1].end = boundary.y2
              changedHorizon.push({
                start: boundary.y2,
                end: horizon[j].end,
                boundary: horizon[j].boundary
              })
            }

            for (q = i; q <= j; q++) {
              horizonPart = horizon[q]
              affectedBoundary = horizonPart.boundary

              if (affectedBoundary.x2New !== undefined) {
                continue
              }

              let used = false

              for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
                used = horizon[k].boundary === affectedBoundary
              }

              for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
                used = horizon[k].boundary === affectedBoundary
              }

              for (k = 0; !used && k < changedHorizon.length; k++) {
                used = changedHorizon[k].boundary === affectedBoundary
              }

              if (!used) {
                affectedBoundary.x2New = maxXNew
              }
            }

            Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon))
          })
          horizon.forEach(function (horizonPart) {
            const affectedBoundary = horizonPart.boundary

            if (affectedBoundary.x2New === undefined) {
              affectedBoundary.x2New = Math.max(width, affectedBoundary.x2)
            }
          })
        }

        function TextLayerRenderTask (_ref) {
          const _this = this

          const textContent = _ref.textContent
          const textContentStream = _ref.textContentStream
          const container = _ref.container
          const viewport = _ref.viewport
          const textDivs = _ref.textDivs
          const textContentItemsStr = _ref.textContentItemsStr
          const enhanceTextSelection = _ref.enhanceTextSelection
          this._textContent = textContent
          this._textContentStream = textContentStream
          this._container = container
          this._viewport = viewport
          this._textDivs = textDivs || []
          this._textContentItemsStr = textContentItemsStr || []
          this._enhanceTextSelection = !!enhanceTextSelection
          this._fontInspectorEnabled = !!(globalThis.FontInspector && globalThis.FontInspector.enabled)
          this._reader = null
          this._layoutTextLastFontSize = null
          this._layoutTextLastFontFamily = null
          this._layoutTextCtx = null
          this._textDivProperties = new WeakMap()
          this._renderingDone = false
          this._canceled = false
          this._capability = (0, _util.createPromiseCapability)()
          this._renderTimer = null
          this._bounds = []

          this._capability.promise.finally(function () {
            if (_this._layoutTextCtx) {
              _this._layoutTextCtx.canvas.width = 0
              _this._layoutTextCtx.canvas.height = 0
              _this._layoutTextCtx = null
            }
          }).catch(function () {})
        }

        TextLayerRenderTask.prototype = {
          get promise () {
            return this._capability.promise
          },

          cancel: function TextLayer_cancel () {
            this._canceled = true

            if (this._reader) {
              this._reader.cancel(new _util.AbortException('TextLayer task cancelled.'))

              this._reader = null
            }

            if (this._renderTimer !== null) {
              clearTimeout(this._renderTimer)
              this._renderTimer = null
            }

            this._capability.reject(new Error('TextLayer task cancelled.'))
          },
          _processItems: function _processItems (items, styleCache) {
            for (let i = 0, len = items.length; i < len; i++) {
              this._textContentItemsStr.push(items[i].str)

              appendText(this, items[i], styleCache)
            }
          },
          _layoutText: function _layoutText (textDiv) {
            const textDivProperties = this._textDivProperties.get(textDiv)

            if (textDivProperties.isWhitespace) {
              return
            }

            let transform = ''

            if (textDivProperties.canvasWidth !== 0) {
              const _textDiv$style = textDiv.style
              const fontSize = _textDiv$style.fontSize
              const fontFamily = _textDiv$style.fontFamily

              if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
                this._layoutTextCtx.font = ''.concat(fontSize, ' ').concat(fontFamily)
                this._layoutTextLastFontSize = fontSize
                this._layoutTextLastFontFamily = fontFamily
              }

              const _this$_layoutTextCtx$ = this._layoutTextCtx.measureText(textDiv.textContent)
              const width = _this$_layoutTextCtx$.width

              if (width > 0) {
                textDivProperties.scale = textDivProperties.canvasWidth / width
                transform = 'scaleX('.concat(textDivProperties.scale, ')')
              }
            }

            if (textDivProperties.angle !== 0) {
              transform = 'rotate('.concat(textDivProperties.angle, 'deg) ').concat(transform)
            }

            if (transform.length > 0) {
              if (this._enhanceTextSelection) {
                textDivProperties.originalTransform = transform
              }

              textDiv.style.transform = transform
            }

            this._textDivProperties.set(textDiv, textDivProperties)

            this._container.appendChild(textDiv)
          },
          _render: function TextLayer_render (timeout) {
            const _this2 = this

            const capability = (0, _util.createPromiseCapability)()
            let styleCache = Object.create(null)
            const canvas = document.createElement('canvas')
            canvas.mozOpaque = true
            this._layoutTextCtx = canvas.getContext('2d', {
              alpha: false
            })

            if (this._textContent) {
              const textItems = this._textContent.items
              const textStyles = this._textContent.styles

              this._processItems(textItems, textStyles)

              capability.resolve()
            } else if (this._textContentStream) {
              const pump = function pump () {
                _this2._reader.read().then(function (_ref2) {
                  const value = _ref2.value
                  const done = _ref2.done

                  if (done) {
                    capability.resolve()
                    return
                  }

                  Object.assign(styleCache, value.styles)

                  _this2._processItems(value.items, styleCache)

                  pump()
                }, capability.reject)
              }

              this._reader = this._textContentStream.getReader()
              pump()
            } else {
              throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.')
            }

            capability.promise.then(function () {
              styleCache = null

              if (!timeout) {
                render(_this2)
              } else {
                _this2._renderTimer = setTimeout(function () {
                  render(_this2)
                  _this2._renderTimer = null
                }, timeout)
              }
            }, this._capability.reject)
          },
          expandTextDivs: function TextLayer_expandTextDivs (expandDivs) {
            if (!this._enhanceTextSelection || !this._renderingDone) {
              return
            }

            if (this._bounds !== null) {
              expand(this)
              this._bounds = null
            }

            const transformBuf = []
            const paddingBuf = []

            for (let i = 0, ii = this._textDivs.length; i < ii; i++) {
              const div = this._textDivs[i]

              const divProps = this._textDivProperties.get(div)

              if (divProps.isWhitespace) {
                continue
              }

              if (expandDivs) {
                transformBuf.length = 0
                paddingBuf.length = 0

                if (divProps.originalTransform) {
                  transformBuf.push(divProps.originalTransform)
                }

                if (divProps.paddingTop > 0) {
                  paddingBuf.push(''.concat(divProps.paddingTop, 'px'))
                  transformBuf.push('translateY('.concat(-divProps.paddingTop, 'px)'))
                } else {
                  paddingBuf.push(0)
                }

                if (divProps.paddingRight > 0) {
                  paddingBuf.push(''.concat(divProps.paddingRight / divProps.scale, 'px'))
                } else {
                  paddingBuf.push(0)
                }

                if (divProps.paddingBottom > 0) {
                  paddingBuf.push(''.concat(divProps.paddingBottom, 'px'))
                } else {
                  paddingBuf.push(0)
                }

                if (divProps.paddingLeft > 0) {
                  paddingBuf.push(''.concat(divProps.paddingLeft / divProps.scale, 'px'))
                  transformBuf.push('translateX('.concat(-divProps.paddingLeft / divProps.scale, 'px)'))
                } else {
                  paddingBuf.push(0)
                }

                div.style.padding = paddingBuf.join(' ')

                if (transformBuf.length) {
                  div.style.transform = transformBuf.join(' ')
                }
              } else {
                div.style.padding = null
                div.style.transform = divProps.originalTransform
              }
            }
          }
        }

        function renderTextLayer (renderParameters) {
          const task = new TextLayerRenderTask({
            textContent: renderParameters.textContent,
            textContentStream: renderParameters.textContentStream,
            container: renderParameters.container,
            viewport: renderParameters.viewport,
            textDivs: renderParameters.textDivs,
            textContentItemsStr: renderParameters.textContentItemsStr,
            enhanceTextSelection: renderParameters.enhanceTextSelection
          })

          task._render(renderParameters.timeout)

          return task
        }

        return renderTextLayer
      }())

      exports.renderTextLayer = renderTextLayer
      /***/ },
    /* 206 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.AnnotationLayer = void 0

      const _display_utils = __w_pdfjs_require__(194)

      const _util = __w_pdfjs_require__(1)

      function _get (target, property, receiver) { if (typeof Reflect !== 'undefined' && Reflect.get) { _get = Reflect.get } else { _get = function _get (target, property, receiver) { const base = _superPropBase(target, property); if (!base) return; const desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver) } return desc.value } } return _get(target, property, receiver || target) }

      function _superPropBase (object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break } return object }

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      function _possibleConstructorReturn (self, call) { if (call && (_typeof(call) === 'object' || typeof call === 'function')) { return call } return _assertThisInitialized(self) }

      function _assertThisInitialized (self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called") } return self }

      function _getPrototypeOf (o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf (o) { return o.__proto__ || Object.getPrototypeOf(o) }; return _getPrototypeOf(o) }

      function _inherits (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function') } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass) }

      function _setPrototypeOf (o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf (o, p) { o.__proto__ = p; return o }; return _setPrototypeOf(o, p) }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      const AnnotationElementFactory = /* #__PURE__ */(function () {
        function AnnotationElementFactory () {
          _classCallCheck(this, AnnotationElementFactory)
        }

        _createClass(AnnotationElementFactory, null, [{
          key: 'create',
          value: function create (parameters) {
            const subtype = parameters.data.annotationType

            switch (subtype) {
              case _util.AnnotationType.LINK:
                return new LinkAnnotationElement(parameters)

              case _util.AnnotationType.TEXT:
                return new TextAnnotationElement(parameters)

              case _util.AnnotationType.WIDGET:
                var fieldType = parameters.data.fieldType

                switch (fieldType) {
                  case 'Tx':
                    return new TextWidgetAnnotationElement(parameters)

                  case 'Btn':
                    if (parameters.data.radioButton) {
                      return new RadioButtonWidgetAnnotationElement(parameters)
                    } else if (parameters.data.checkBox) {
                      return new CheckboxWidgetAnnotationElement(parameters)
                    }

                    return new PushButtonWidgetAnnotationElement(parameters)

                  case 'Ch':
                    return new ChoiceWidgetAnnotationElement(parameters)
                }

                return new WidgetAnnotationElement(parameters)

              case _util.AnnotationType.POPUP:
                return new PopupAnnotationElement(parameters)

              case _util.AnnotationType.FREETEXT:
                return new FreeTextAnnotationElement(parameters)

              case _util.AnnotationType.LINE:
                return new LineAnnotationElement(parameters)

              case _util.AnnotationType.SQUARE:
                return new SquareAnnotationElement(parameters)

              case _util.AnnotationType.CIRCLE:
                return new CircleAnnotationElement(parameters)

              case _util.AnnotationType.POLYLINE:
                return new PolylineAnnotationElement(parameters)

              case _util.AnnotationType.CARET:
                return new CaretAnnotationElement(parameters)

              case _util.AnnotationType.INK:
                return new InkAnnotationElement(parameters)

              case _util.AnnotationType.POLYGON:
                return new PolygonAnnotationElement(parameters)

              case _util.AnnotationType.HIGHLIGHT:
                return new HighlightAnnotationElement(parameters)

              case _util.AnnotationType.UNDERLINE:
                return new UnderlineAnnotationElement(parameters)

              case _util.AnnotationType.SQUIGGLY:
                return new SquigglyAnnotationElement(parameters)

              case _util.AnnotationType.STRIKEOUT:
                return new StrikeOutAnnotationElement(parameters)

              case _util.AnnotationType.STAMP:
                return new StampAnnotationElement(parameters)

              case _util.AnnotationType.FILEATTACHMENT:
                return new FileAttachmentAnnotationElement(parameters)

              default:
                return new AnnotationElement(parameters)
            }
          }
        }])

        return AnnotationElementFactory
      }())

      var AnnotationElement = /* #__PURE__ */(function () {
        function AnnotationElement (parameters) {
          const isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
          const ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false

          _classCallCheck(this, AnnotationElement)

          this.isRenderable = isRenderable
          this.data = parameters.data
          this.layer = parameters.layer
          this.page = parameters.page
          this.viewport = parameters.viewport
          this.linkService = parameters.linkService
          this.downloadManager = parameters.downloadManager
          this.imageResourcesPath = parameters.imageResourcesPath
          this.renderInteractiveForms = parameters.renderInteractiveForms
          this.svgFactory = parameters.svgFactory

          if (isRenderable) {
            this.container = this._createContainer(ignoreBorder)
          }
        }

        _createClass(AnnotationElement, [{
          key: '_createContainer',
          value: function _createContainer () {
            const ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false
            const data = this.data
            const page = this.page
            const viewport = this.viewport
            const container = document.createElement('section')
            let width = data.rect[2] - data.rect[0]
            let height = data.rect[3] - data.rect[1]
            container.setAttribute('data-annotation-id', data.id)

            const rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]])

            container.style.transform = 'matrix('.concat(viewport.transform.join(','), ')')
            container.style.transformOrigin = '-'.concat(rect[0], 'px -').concat(rect[1], 'px')

            if (!ignoreBorder && data.borderStyle.width > 0) {
              container.style.borderWidth = ''.concat(data.borderStyle.width, 'px')

              if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
                width = width - 2 * data.borderStyle.width
                height = height - 2 * data.borderStyle.width
              }

              const horizontalRadius = data.borderStyle.horizontalCornerRadius
              const verticalRadius = data.borderStyle.verticalCornerRadius

              if (horizontalRadius > 0 || verticalRadius > 0) {
                const radius = ''.concat(horizontalRadius, 'px / ').concat(verticalRadius, 'px')
                container.style.borderRadius = radius
              }

              switch (data.borderStyle.style) {
                case _util.AnnotationBorderStyleType.SOLID:
                  container.style.borderStyle = 'solid'
                  break

                case _util.AnnotationBorderStyleType.DASHED:
                  container.style.borderStyle = 'dashed'
                  break

                case _util.AnnotationBorderStyleType.BEVELED:
                  (0, _util.warn)('Unimplemented border style: beveled')
                  break

                case _util.AnnotationBorderStyleType.INSET:
                  (0, _util.warn)('Unimplemented border style: inset')
                  break

                case _util.AnnotationBorderStyleType.UNDERLINE:
                  container.style.borderBottomStyle = 'solid'
                  break

                default:
                  break
              }

              if (data.color) {
                container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0)
              } else {
                container.style.borderWidth = 0
              }
            }

            container.style.left = ''.concat(rect[0], 'px')
            container.style.top = ''.concat(rect[1], 'px')
            container.style.width = ''.concat(width, 'px')
            container.style.height = ''.concat(height, 'px')
            return container
          }
        }, {
          key: '_createPopup',
          value: function _createPopup (container, trigger, data) {
            if (!trigger) {
              trigger = document.createElement('div')
              trigger.style.height = container.style.height
              trigger.style.width = container.style.width
              container.appendChild(trigger)
            }

            const popupElement = new PopupElement({
              container: container,
              trigger: trigger,
              color: data.color,
              title: data.title,
              modificationDate: data.modificationDate,
              contents: data.contents,
              hideWrapper: true
            })
            const popup = popupElement.render()
            popup.style.left = container.style.width
            container.appendChild(popup)
          }
        }, {
          key: 'render',
          value: function render () {
            (0, _util.unreachable)('Abstract method `AnnotationElement.render` called')
          }
        }])

        return AnnotationElement
      }())

      var LinkAnnotationElement = /* #__PURE__ */(function (_AnnotationElement) {
        _inherits(LinkAnnotationElement, _AnnotationElement)

        function LinkAnnotationElement (parameters) {
          _classCallCheck(this, LinkAnnotationElement)

          const isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action)
          return _possibleConstructorReturn(this, _getPrototypeOf(LinkAnnotationElement).call(this, parameters, isRenderable))
        }

        _createClass(LinkAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'linkAnnotation'
            const data = this.data
            const linkService = this.linkService
            const link = document.createElement('a')

            if (data.url) {
              (0, _display_utils.addLinkAttributes)(link, {
                url: data.url,
                target: data.newWindow ? _display_utils.LinkTarget.BLANK : linkService.externalLinkTarget,
                rel: linkService.externalLinkRel,
                enabled: linkService.externalLinkEnabled
              })
            } else if (data.action) {
              this._bindNamedAction(link, data.action)
            } else {
              this._bindLink(link, data.dest)
            }

            this.container.appendChild(link)
            return this.container
          }
        }, {
          key: '_bindLink',
          value: function _bindLink (link, destination) {
            const _this = this

            link.href = this.linkService.getDestinationHash(destination)

            link.onclick = function () {
              if (destination) {
                _this.linkService.navigateTo(destination)
              }

              return false
            }

            if (destination) {
              link.className = 'internalLink'
            }
          }
        }, {
          key: '_bindNamedAction',
          value: function _bindNamedAction (link, action) {
            const _this2 = this

            link.href = this.linkService.getAnchorUrl('')

            link.onclick = function () {
              _this2.linkService.executeNamedAction(action)

              return false
            }

            link.className = 'internalLink'
          }
        }])

        return LinkAnnotationElement
      }(AnnotationElement))

      var TextAnnotationElement = /* #__PURE__ */(function (_AnnotationElement2) {
        _inherits(TextAnnotationElement, _AnnotationElement2)

        function TextAnnotationElement (parameters) {
          _classCallCheck(this, TextAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(TextAnnotationElement).call(this, parameters, isRenderable))
        }

        _createClass(TextAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'textAnnotation'
            const image = document.createElement('img')
            image.style.height = this.container.style.height
            image.style.width = this.container.style.width
            image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg'
            image.alt = '[{{type}} Annotation]'
            image.dataset.l10nId = 'text_annotation_type'
            image.dataset.l10nArgs = JSON.stringify({
              type: this.data.name
            })

            if (!this.data.hasPopup) {
              this._createPopup(this.container, image, this.data)
            }

            this.container.appendChild(image)
            return this.container
          }
        }])

        return TextAnnotationElement
      }(AnnotationElement))

      var WidgetAnnotationElement = /* #__PURE__ */(function (_AnnotationElement3) {
        _inherits(WidgetAnnotationElement, _AnnotationElement3)

        function WidgetAnnotationElement () {
          _classCallCheck(this, WidgetAnnotationElement)

          return _possibleConstructorReturn(this, _getPrototypeOf(WidgetAnnotationElement).apply(this, arguments))
        }

        _createClass(WidgetAnnotationElement, [{
          key: 'render',
          value: function render () {
            return this.container
          }
        }])

        return WidgetAnnotationElement
      }(AnnotationElement))

      var TextWidgetAnnotationElement = /* #__PURE__ */(function (_WidgetAnnotationElem) {
        _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem)

        function TextWidgetAnnotationElement (parameters) {
          _classCallCheck(this, TextWidgetAnnotationElement)

          const isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue
          return _possibleConstructorReturn(this, _getPrototypeOf(TextWidgetAnnotationElement).call(this, parameters, isRenderable))
        }

        _createClass(TextWidgetAnnotationElement, [{
          key: 'render',
          value: function render () {
            const TEXT_ALIGNMENT = ['left', 'center', 'right']
            this.container.className = 'textWidgetAnnotation'
            let element = null

            if (this.renderInteractiveForms) {
              if (this.data.multiLine) {
                element = document.createElement('textarea')
                element.textContent = this.data.fieldValue
              } else {
                element = document.createElement('input')
                element.type = 'text'
                element.setAttribute('value', this.data.fieldValue)
              }

              element.disabled = this.data.readOnly

              if (this.data.maxLen !== null) {
                element.maxLength = this.data.maxLen
              }

              if (this.data.comb) {
                const fieldWidth = this.data.rect[2] - this.data.rect[0]
                const combWidth = fieldWidth / this.data.maxLen
                element.classList.add('comb')
                element.style.letterSpacing = 'calc('.concat(combWidth, 'px - 1ch)')
              }
            } else {
              element = document.createElement('div')
              element.textContent = this.data.fieldValue
              element.style.verticalAlign = 'middle'
              element.style.display = 'table-cell'
              let font = null

              if (this.data.fontRefName && this.page.commonObjs.has(this.data.fontRefName)) {
                font = this.page.commonObjs.get(this.data.fontRefName)
              }

              this._setTextStyle(element, font)
            }

            if (this.data.textAlignment !== null) {
              element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment]
            }

            this.container.appendChild(element)
            return this.container
          }
        }, {
          key: '_setTextStyle',
          value: function _setTextStyle (element, font) {
            const style = element.style
            style.fontSize = ''.concat(this.data.fontSize, 'px')
            style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr'

            if (!font) {
              return
            }

            let bold = 'normal'

            if (font.black) {
              bold = '900'
            } else if (font.bold) {
              bold = 'bold'
            }

            style.fontWeight = bold
            style.fontStyle = font.italic ? 'italic' : 'normal'
            const fontFamily = font.loadedName ? '"'.concat(font.loadedName, '", ') : ''
            const fallbackName = font.fallbackName || 'Helvetica, sans-serif'
            style.fontFamily = fontFamily + fallbackName
          }
        }])

        return TextWidgetAnnotationElement
      }(WidgetAnnotationElement))

      var CheckboxWidgetAnnotationElement = /* #__PURE__ */(function (_WidgetAnnotationElem2) {
        _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2)

        function CheckboxWidgetAnnotationElement (parameters) {
          _classCallCheck(this, CheckboxWidgetAnnotationElement)

          return _possibleConstructorReturn(this, _getPrototypeOf(CheckboxWidgetAnnotationElement).call(this, parameters, parameters.renderInteractiveForms))
        }

        _createClass(CheckboxWidgetAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'buttonWidgetAnnotation checkBox'
            const element = document.createElement('input')
            element.disabled = this.data.readOnly
            element.type = 'checkbox'

            if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
              element.setAttribute('checked', true)
            }

            this.container.appendChild(element)
            return this.container
          }
        }])

        return CheckboxWidgetAnnotationElement
      }(WidgetAnnotationElement))

      var RadioButtonWidgetAnnotationElement = /* #__PURE__ */(function (_WidgetAnnotationElem3) {
        _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3)

        function RadioButtonWidgetAnnotationElement (parameters) {
          _classCallCheck(this, RadioButtonWidgetAnnotationElement)

          return _possibleConstructorReturn(this, _getPrototypeOf(RadioButtonWidgetAnnotationElement).call(this, parameters, parameters.renderInteractiveForms))
        }

        _createClass(RadioButtonWidgetAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'buttonWidgetAnnotation radioButton'
            const element = document.createElement('input')
            element.disabled = this.data.readOnly
            element.type = 'radio'
            element.name = this.data.fieldName

            if (this.data.fieldValue === this.data.buttonValue) {
              element.setAttribute('checked', true)
            }

            this.container.appendChild(element)
            return this.container
          }
        }])

        return RadioButtonWidgetAnnotationElement
      }(WidgetAnnotationElement))

      var PushButtonWidgetAnnotationElement = /* #__PURE__ */(function (_LinkAnnotationElemen) {
        _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen)

        function PushButtonWidgetAnnotationElement () {
          _classCallCheck(this, PushButtonWidgetAnnotationElement)

          return _possibleConstructorReturn(this, _getPrototypeOf(PushButtonWidgetAnnotationElement).apply(this, arguments))
        }

        _createClass(PushButtonWidgetAnnotationElement, [{
          key: 'render',
          value: function render () {
            const container = _get(_getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), 'render', this).call(this)

            container.className = 'buttonWidgetAnnotation pushButton'
            return container
          }
        }])

        return PushButtonWidgetAnnotationElement
      }(LinkAnnotationElement))

      var ChoiceWidgetAnnotationElement = /* #__PURE__ */(function (_WidgetAnnotationElem4) {
        _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4)

        function ChoiceWidgetAnnotationElement (parameters) {
          _classCallCheck(this, ChoiceWidgetAnnotationElement)

          return _possibleConstructorReturn(this, _getPrototypeOf(ChoiceWidgetAnnotationElement).call(this, parameters, parameters.renderInteractiveForms))
        }

        _createClass(ChoiceWidgetAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'choiceWidgetAnnotation'
            const selectElement = document.createElement('select')
            selectElement.disabled = this.data.readOnly

            if (!this.data.combo) {
              selectElement.size = this.data.options.length

              if (this.data.multiSelect) {
                selectElement.multiple = true
              }
            }

            let _iteratorNormalCompletion = true
            let _didIteratorError = false
            let _iteratorError

            try {
              for (var _iterator = this.data.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                const option = _step.value
                const optionElement = document.createElement('option')
                optionElement.textContent = option.displayValue
                optionElement.value = option.exportValue

                if (this.data.fieldValue.includes(option.displayValue)) {
                  optionElement.setAttribute('selected', true)
                }

                selectElement.appendChild(optionElement)
              }
            } catch (err) {
              _didIteratorError = true
              _iteratorError = err
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return()
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError
                }
              }
            }

            this.container.appendChild(selectElement)
            return this.container
          }
        }])

        return ChoiceWidgetAnnotationElement
      }(WidgetAnnotationElement))

      var PopupAnnotationElement = /* #__PURE__ */(function (_AnnotationElement4) {
        _inherits(PopupAnnotationElement, _AnnotationElement4)

        function PopupAnnotationElement (parameters) {
          _classCallCheck(this, PopupAnnotationElement)

          const isRenderable = !!(parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(PopupAnnotationElement).call(this, parameters, isRenderable))
        }

        _createClass(PopupAnnotationElement, [{
          key: 'render',
          value: function render () {
            const IGNORE_TYPES = ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon', 'Ink']
            this.container.className = 'popupAnnotation'

            if (IGNORE_TYPES.includes(this.data.parentType)) {
              return this.container
            }

            const selector = '[data-annotation-id="'.concat(this.data.parentId, '"]')
            const parentElement = this.layer.querySelector(selector)

            if (!parentElement) {
              return this.container
            }

            const popup = new PopupElement({
              container: this.container,
              trigger: parentElement,
              color: this.data.color,
              title: this.data.title,
              modificationDate: this.data.modificationDate,
              contents: this.data.contents
            })
            const parentLeft = parseFloat(parentElement.style.left)
            const parentWidth = parseFloat(parentElement.style.width)
            this.container.style.transformOrigin = '-'.concat(parentLeft + parentWidth, 'px -').concat(parentElement.style.top)
            this.container.style.left = ''.concat(parentLeft + parentWidth, 'px')
            this.container.appendChild(popup.render())
            return this.container
          }
        }])

        return PopupAnnotationElement
      }(AnnotationElement))

      var PopupElement = /* #__PURE__ */(function () {
        function PopupElement (parameters) {
          _classCallCheck(this, PopupElement)

          this.container = parameters.container
          this.trigger = parameters.trigger
          this.color = parameters.color
          this.title = parameters.title
          this.modificationDate = parameters.modificationDate
          this.contents = parameters.contents
          this.hideWrapper = parameters.hideWrapper || false
          this.pinned = false
        }

        _createClass(PopupElement, [{
          key: 'render',
          value: function render () {
            const BACKGROUND_ENLIGHT = 0.7
            const wrapper = document.createElement('div')
            wrapper.className = 'popupWrapper'
            this.hideElement = this.hideWrapper ? wrapper : this.container
            this.hideElement.setAttribute('hidden', true)
            const popup = document.createElement('div')
            popup.className = 'popup'
            const color = this.color

            if (color) {
              const r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0]
              const g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1]
              const b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2]
              popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0)
            }

            const title = document.createElement('h1')
            title.textContent = this.title
            popup.appendChild(title)

            const dateObject = _display_utils.PDFDateString.toDateObject(this.modificationDate)

            if (dateObject) {
              const modificationDate = document.createElement('span')
              modificationDate.textContent = '{{date}}, {{time}}'
              modificationDate.dataset.l10nId = 'annotation_date_string'
              modificationDate.dataset.l10nArgs = JSON.stringify({
                date: dateObject.toLocaleDateString(),
                time: dateObject.toLocaleTimeString()
              })
              popup.appendChild(modificationDate)
            }

            const contents = this._formatContents(this.contents)

            popup.appendChild(contents)
            this.trigger.addEventListener('click', this._toggle.bind(this))
            this.trigger.addEventListener('mouseover', this._show.bind(this, false))
            this.trigger.addEventListener('mouseout', this._hide.bind(this, false))
            popup.addEventListener('click', this._hide.bind(this, true))
            wrapper.appendChild(popup)
            return wrapper
          }
        }, {
          key: '_formatContents',
          value: function _formatContents (contents) {
            const p = document.createElement('p')
            const lines = contents.split(/(?:\r\n?|\n)/)

            for (let i = 0, ii = lines.length; i < ii; ++i) {
              const line = lines[i]
              p.appendChild(document.createTextNode(line))

              if (i < ii - 1) {
                p.appendChild(document.createElement('br'))
              }
            }

            return p
          }
        }, {
          key: '_toggle',
          value: function _toggle () {
            if (this.pinned) {
              this._hide(true)
            } else {
              this._show(true)
            }
          }
        }, {
          key: '_show',
          value: function _show () {
            const pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false

            if (pin) {
              this.pinned = true
            }

            if (this.hideElement.hasAttribute('hidden')) {
              this.hideElement.removeAttribute('hidden')
              this.container.style.zIndex += 1
            }
          }
        }, {
          key: '_hide',
          value: function _hide () {
            const unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true

            if (unpin) {
              this.pinned = false
            }

            if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
              this.hideElement.setAttribute('hidden', true)
              this.container.style.zIndex -= 1
            }
          }
        }])

        return PopupElement
      }())

      var FreeTextAnnotationElement = /* #__PURE__ */(function (_AnnotationElement5) {
        _inherits(FreeTextAnnotationElement, _AnnotationElement5)

        function FreeTextAnnotationElement (parameters) {
          _classCallCheck(this, FreeTextAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(FreeTextAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(FreeTextAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'freeTextAnnotation'

            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data)
            }

            return this.container
          }
        }])

        return FreeTextAnnotationElement
      }(AnnotationElement))

      var LineAnnotationElement = /* #__PURE__ */(function (_AnnotationElement6) {
        _inherits(LineAnnotationElement, _AnnotationElement6)

        function LineAnnotationElement (parameters) {
          _classCallCheck(this, LineAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(LineAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(LineAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'lineAnnotation'
            const data = this.data
            const width = data.rect[2] - data.rect[0]
            const height = data.rect[3] - data.rect[1]
            const svg = this.svgFactory.create(width, height)
            const line = this.svgFactory.createElement('svg:line')
            line.setAttribute('x1', data.rect[2] - data.lineCoordinates[0])
            line.setAttribute('y1', data.rect[3] - data.lineCoordinates[1])
            line.setAttribute('x2', data.rect[2] - data.lineCoordinates[2])
            line.setAttribute('y2', data.rect[3] - data.lineCoordinates[3])
            line.setAttribute('stroke-width', data.borderStyle.width || 1)
            line.setAttribute('stroke', 'transparent')
            svg.appendChild(line)
            this.container.append(svg)

            this._createPopup(this.container, line, data)

            return this.container
          }
        }])

        return LineAnnotationElement
      }(AnnotationElement))

      var SquareAnnotationElement = /* #__PURE__ */(function (_AnnotationElement7) {
        _inherits(SquareAnnotationElement, _AnnotationElement7)

        function SquareAnnotationElement (parameters) {
          _classCallCheck(this, SquareAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(SquareAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(SquareAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'squareAnnotation'
            const data = this.data
            const width = data.rect[2] - data.rect[0]
            const height = data.rect[3] - data.rect[1]
            const svg = this.svgFactory.create(width, height)
            const borderWidth = data.borderStyle.width
            const square = this.svgFactory.createElement('svg:rect')
            square.setAttribute('x', borderWidth / 2)
            square.setAttribute('y', borderWidth / 2)
            square.setAttribute('width', width - borderWidth)
            square.setAttribute('height', height - borderWidth)
            square.setAttribute('stroke-width', borderWidth || 1)
            square.setAttribute('stroke', 'transparent')
            square.setAttribute('fill', 'none')
            svg.appendChild(square)
            this.container.append(svg)

            this._createPopup(this.container, square, data)

            return this.container
          }
        }])

        return SquareAnnotationElement
      }(AnnotationElement))

      var CircleAnnotationElement = /* #__PURE__ */(function (_AnnotationElement8) {
        _inherits(CircleAnnotationElement, _AnnotationElement8)

        function CircleAnnotationElement (parameters) {
          _classCallCheck(this, CircleAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(CircleAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(CircleAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'circleAnnotation'
            const data = this.data
            const width = data.rect[2] - data.rect[0]
            const height = data.rect[3] - data.rect[1]
            const svg = this.svgFactory.create(width, height)
            const borderWidth = data.borderStyle.width
            const circle = this.svgFactory.createElement('svg:ellipse')
            circle.setAttribute('cx', width / 2)
            circle.setAttribute('cy', height / 2)
            circle.setAttribute('rx', width / 2 - borderWidth / 2)
            circle.setAttribute('ry', height / 2 - borderWidth / 2)
            circle.setAttribute('stroke-width', borderWidth || 1)
            circle.setAttribute('stroke', 'transparent')
            circle.setAttribute('fill', 'none')
            svg.appendChild(circle)
            this.container.append(svg)

            this._createPopup(this.container, circle, data)

            return this.container
          }
        }])

        return CircleAnnotationElement
      }(AnnotationElement))

      var PolylineAnnotationElement = /* #__PURE__ */(function (_AnnotationElement9) {
        _inherits(PolylineAnnotationElement, _AnnotationElement9)

        function PolylineAnnotationElement (parameters) {
          let _this3

          _classCallCheck(this, PolylineAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PolylineAnnotationElement).call(this, parameters, isRenderable, true))
          _this3.containerClassName = 'polylineAnnotation'
          _this3.svgElementName = 'svg:polyline'
          return _this3
        }

        _createClass(PolylineAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = this.containerClassName
            const data = this.data
            const width = data.rect[2] - data.rect[0]
            const height = data.rect[3] - data.rect[1]
            const svg = this.svgFactory.create(width, height)
            let points = []
            let _iteratorNormalCompletion2 = true
            let _didIteratorError2 = false
            let _iteratorError2

            try {
              for (var _iterator2 = data.vertices[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                const coordinate = _step2.value
                const x = coordinate.x - data.rect[0]
                const y = data.rect[3] - coordinate.y
                points.push(x + ',' + y)
              }
            } catch (err) {
              _didIteratorError2 = true
              _iteratorError2 = err
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return()
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2
                }
              }
            }

            points = points.join(' ')
            const polyline = this.svgFactory.createElement(this.svgElementName)
            polyline.setAttribute('points', points)
            polyline.setAttribute('stroke-width', data.borderStyle.width || 1)
            polyline.setAttribute('stroke', 'transparent')
            polyline.setAttribute('fill', 'none')
            svg.appendChild(polyline)
            this.container.append(svg)

            this._createPopup(this.container, polyline, data)

            return this.container
          }
        }])

        return PolylineAnnotationElement
      }(AnnotationElement))

      var PolygonAnnotationElement = /* #__PURE__ */(function (_PolylineAnnotationEl) {
        _inherits(PolygonAnnotationElement, _PolylineAnnotationEl)

        function PolygonAnnotationElement (parameters) {
          let _this4

          _classCallCheck(this, PolygonAnnotationElement)

          _this4 = _possibleConstructorReturn(this, _getPrototypeOf(PolygonAnnotationElement).call(this, parameters))
          _this4.containerClassName = 'polygonAnnotation'
          _this4.svgElementName = 'svg:polygon'
          return _this4
        }

        return PolygonAnnotationElement
      }(PolylineAnnotationElement))

      var CaretAnnotationElement = /* #__PURE__ */(function (_AnnotationElement10) {
        _inherits(CaretAnnotationElement, _AnnotationElement10)

        function CaretAnnotationElement (parameters) {
          _classCallCheck(this, CaretAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(CaretAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(CaretAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'caretAnnotation'

            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data)
            }

            return this.container
          }
        }])

        return CaretAnnotationElement
      }(AnnotationElement))

      var InkAnnotationElement = /* #__PURE__ */(function (_AnnotationElement11) {
        _inherits(InkAnnotationElement, _AnnotationElement11)

        function InkAnnotationElement (parameters) {
          let _this5

          _classCallCheck(this, InkAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          _this5 = _possibleConstructorReturn(this, _getPrototypeOf(InkAnnotationElement).call(this, parameters, isRenderable, true))
          _this5.containerClassName = 'inkAnnotation'
          _this5.svgElementName = 'svg:polyline'
          return _this5
        }

        _createClass(InkAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = this.containerClassName
            const data = this.data
            const width = data.rect[2] - data.rect[0]
            const height = data.rect[3] - data.rect[1]
            const svg = this.svgFactory.create(width, height)
            let _iteratorNormalCompletion3 = true
            let _didIteratorError3 = false
            let _iteratorError3

            try {
              for (var _iterator3 = data.inkLists[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                const inkList = _step3.value
                let points = []
                let _iteratorNormalCompletion4 = true
                let _didIteratorError4 = false
                let _iteratorError4

                try {
                  for (var _iterator4 = inkList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    const coordinate = _step4.value
                    const x = coordinate.x - data.rect[0]
                    const y = data.rect[3] - coordinate.y
                    points.push(''.concat(x, ',').concat(y))
                  }
                } catch (err) {
                  _didIteratorError4 = true
                  _iteratorError4 = err
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                      _iterator4.return()
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4
                    }
                  }
                }

                points = points.join(' ')
                const polyline = this.svgFactory.createElement(this.svgElementName)
                polyline.setAttribute('points', points)
                polyline.setAttribute('stroke-width', data.borderStyle.width || 1)
                polyline.setAttribute('stroke', 'transparent')
                polyline.setAttribute('fill', 'none')

                this._createPopup(this.container, polyline, data)

                svg.appendChild(polyline)
              }
            } catch (err) {
              _didIteratorError3 = true
              _iteratorError3 = err
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return()
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3
                }
              }
            }

            this.container.append(svg)
            return this.container
          }
        }])

        return InkAnnotationElement
      }(AnnotationElement))

      var HighlightAnnotationElement = /* #__PURE__ */(function (_AnnotationElement12) {
        _inherits(HighlightAnnotationElement, _AnnotationElement12)

        function HighlightAnnotationElement (parameters) {
          _classCallCheck(this, HighlightAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(HighlightAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(HighlightAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'highlightAnnotation'

            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data)
            }

            return this.container
          }
        }])

        return HighlightAnnotationElement
      }(AnnotationElement))

      var UnderlineAnnotationElement = /* #__PURE__ */(function (_AnnotationElement13) {
        _inherits(UnderlineAnnotationElement, _AnnotationElement13)

        function UnderlineAnnotationElement (parameters) {
          _classCallCheck(this, UnderlineAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(UnderlineAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(UnderlineAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'underlineAnnotation'

            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data)
            }

            return this.container
          }
        }])

        return UnderlineAnnotationElement
      }(AnnotationElement))

      var SquigglyAnnotationElement = /* #__PURE__ */(function (_AnnotationElement14) {
        _inherits(SquigglyAnnotationElement, _AnnotationElement14)

        function SquigglyAnnotationElement (parameters) {
          _classCallCheck(this, SquigglyAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(SquigglyAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(SquigglyAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'squigglyAnnotation'

            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data)
            }

            return this.container
          }
        }])

        return SquigglyAnnotationElement
      }(AnnotationElement))

      var StrikeOutAnnotationElement = /* #__PURE__ */(function (_AnnotationElement15) {
        _inherits(StrikeOutAnnotationElement, _AnnotationElement15)

        function StrikeOutAnnotationElement (parameters) {
          _classCallCheck(this, StrikeOutAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(StrikeOutAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(StrikeOutAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'strikeoutAnnotation'

            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data)
            }

            return this.container
          }
        }])

        return StrikeOutAnnotationElement
      }(AnnotationElement))

      var StampAnnotationElement = /* #__PURE__ */(function (_AnnotationElement16) {
        _inherits(StampAnnotationElement, _AnnotationElement16)

        function StampAnnotationElement (parameters) {
          _classCallCheck(this, StampAnnotationElement)

          const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents)
          return _possibleConstructorReturn(this, _getPrototypeOf(StampAnnotationElement).call(this, parameters, isRenderable, true))
        }

        _createClass(StampAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'stampAnnotation'

            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data)
            }

            return this.container
          }
        }])

        return StampAnnotationElement
      }(AnnotationElement))

      var FileAttachmentAnnotationElement = /* #__PURE__ */(function (_AnnotationElement17) {
        _inherits(FileAttachmentAnnotationElement, _AnnotationElement17)

        function FileAttachmentAnnotationElement (parameters) {
          let _this6

          _classCallCheck(this, FileAttachmentAnnotationElement)

          _this6 = _possibleConstructorReturn(this, _getPrototypeOf(FileAttachmentAnnotationElement).call(this, parameters, true))
          const _this6$data$file = _this6.data.file
          const filename = _this6$data$file.filename
          const content = _this6$data$file.content
          _this6.filename = (0, _display_utils.getFilenameFromUrl)(filename)
          _this6.content = content

          if (_this6.linkService.eventBus) {
            _this6.linkService.eventBus.dispatch('fileattachmentannotation', {
              source: _assertThisInitialized(_this6),
              id: (0, _util.stringToPDFString)(filename),
              filename: filename,
              content: content
            })
          }

          return _this6
        }

        _createClass(FileAttachmentAnnotationElement, [{
          key: 'render',
          value: function render () {
            this.container.className = 'fileAttachmentAnnotation'
            const trigger = document.createElement('div')
            trigger.style.height = this.container.style.height
            trigger.style.width = this.container.style.width
            trigger.addEventListener('dblclick', this._download.bind(this))

            if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
              this._createPopup(this.container, trigger, this.data)
            }

            this.container.appendChild(trigger)
            return this.container
          }
        }, {
          key: '_download',
          value: function _download () {
            if (!this.downloadManager) {
              (0, _util.warn)('Download cannot be started due to unavailable download manager')
              return
            }

            this.downloadManager.downloadData(this.content, this.filename, '')
          }
        }])

        return FileAttachmentAnnotationElement
      }(AnnotationElement))

      const AnnotationLayer = /* #__PURE__ */(function () {
        function AnnotationLayer () {
          _classCallCheck(this, AnnotationLayer)
        }

        _createClass(AnnotationLayer, null, [{
          key: 'render',
          value: function render (parameters) {
            const sortedAnnotations = []
            const popupAnnotations = []
            let _iteratorNormalCompletion5 = true
            let _didIteratorError5 = false
            let _iteratorError5

            try {
              for (var _iterator5 = parameters.annotations[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                const data = _step5.value

                if (!data) {
                  continue
                }

                if (data.annotationType === _util.AnnotationType.POPUP) {
                  popupAnnotations.push(data)
                  continue
                }

                sortedAnnotations.push(data)
              }
            } catch (err) {
              _didIteratorError5 = true
              _iteratorError5 = err
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                  _iterator5.return()
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5
                }
              }
            }

            if (popupAnnotations.length) {
              sortedAnnotations.push.apply(sortedAnnotations, popupAnnotations)
            }

            for (let _i = 0, _sortedAnnotations = sortedAnnotations; _i < _sortedAnnotations.length; _i++) {
              const _data = _sortedAnnotations[_i]
              const element = AnnotationElementFactory.create({
                data: _data,
                layer: parameters.div,
                page: parameters.page,
                viewport: parameters.viewport,
                linkService: parameters.linkService,
                downloadManager: parameters.downloadManager,
                imageResourcesPath: parameters.imageResourcesPath || '',
                renderInteractiveForms: parameters.renderInteractiveForms || false,
                svgFactory: new _display_utils.DOMSVGFactory()
              })

              if (element.isRenderable) {
                parameters.div.appendChild(element.render())
              }
            }
          }
        }, {
          key: 'update',
          value: function update (parameters) {
            let _iteratorNormalCompletion6 = true
            let _didIteratorError6 = false
            let _iteratorError6

            try {
              for (var _iterator6 = parameters.annotations[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                const data = _step6.value
                const element = parameters.div.querySelector('[data-annotation-id="'.concat(data.id, '"]'))

                if (element) {
                  element.style.transform = 'matrix('.concat(parameters.viewport.transform.join(','), ')')
                }
              }
            } catch (err) {
              _didIteratorError6 = true
              _iteratorError6 = err
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                  _iterator6.return()
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6
                }
              }
            }

            parameters.div.removeAttribute('hidden')
          }
        }])

        return AnnotationLayer
      }())

      exports.AnnotationLayer = AnnotationLayer
      /***/ },
    /* 207 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.SVGGraphics = void 0

      const _util = __w_pdfjs_require__(1)

      const _display_utils = __w_pdfjs_require__(194)

      const _is_node = __w_pdfjs_require__(48)

      function _toConsumableArray (arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread() }

      function _nonIterableSpread () { throw new TypeError('Invalid attempt to spread non-iterable instance') }

      function _iterableToArray (iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === '[object Arguments]') return Array.from(iter) }

      function _arrayWithoutHoles (arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i] } return arr2 } }

      function _slicedToArray (arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest() }

      function _nonIterableRest () { throw new TypeError('Invalid attempt to destructure non-iterable instance') }

      function _iterableToArrayLimit (arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === '[object Arguments]')) { return } const _arr = []; let _n = true; let _d = false; let _e; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break } } catch (err) { _d = true; _e = err } finally { try { if (!_n && _i.return != null) _i.return() } finally { if (_d) throw _e } } return _arr }

      function _arrayWithHoles (arr) { if (Array.isArray(arr)) return arr }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      let SVGGraphics = function SVGGraphics () {
        throw new Error('Not implemented: SVGGraphics')
      }

      exports.SVGGraphics = SVGGraphics
      {
        const opListToTree = function opListToTree (opList) {
          let opTree = []
          const tmp = []
          let _iteratorNormalCompletion = true
          let _didIteratorError = false
          let _iteratorError

          try {
            for (var _iterator = opList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              const opListElement = _step.value

              if (opListElement.fn === 'save') {
                opTree.push({
                  fnId: 92,
                  fn: 'group',
                  items: []
                })
                tmp.push(opTree)
                opTree = opTree[opTree.length - 1].items
                continue
              }

              if (opListElement.fn === 'restore') {
                opTree = tmp.pop()
              } else {
                opTree.push(opListElement)
              }
            }
          } catch (err) {
            _didIteratorError = true
            _iteratorError = err
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return()
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError
              }
            }
          }

          return opTree
        }

        const pf = function pf (value) {
          if (Number.isInteger(value)) {
            return value.toString()
          }

          const s = value.toFixed(10)
          let i = s.length - 1

          if (s[i] !== '0') {
            return s
          }

          do {
            i--
          } while (s[i] === '0')

          return s.substring(0, s[i] === '.' ? i : i + 1)
        }

        const pm = function pm (m) {
          if (m[4] === 0 && m[5] === 0) {
            if (m[1] === 0 && m[2] === 0) {
              if (m[0] === 1 && m[3] === 1) {
                return ''
              }

              return 'scale('.concat(pf(m[0]), ' ').concat(pf(m[3]), ')')
            }

            if (m[0] === m[3] && m[1] === -m[2]) {
              const a = Math.acos(m[0]) * 180 / Math.PI
              return 'rotate('.concat(pf(a), ')')
            }
          } else {
            if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
              return 'translate('.concat(pf(m[4]), ' ').concat(pf(m[5]), ')')
            }
          }

          return 'matrix('.concat(pf(m[0]), ' ').concat(pf(m[1]), ' ').concat(pf(m[2]), ' ').concat(pf(m[3]), ' ').concat(pf(m[4]), ' ') + ''.concat(pf(m[5]), ')')
        }

        const SVG_DEFAULTS = {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fillColor: '#000000'
        }
        const XML_NS = 'http://www.w3.org/XML/1998/namespace'
        const XLINK_NS = 'http://www.w3.org/1999/xlink'
        const LINE_CAP_STYLES = ['butt', 'round', 'square']
        const LINE_JOIN_STYLES = ['miter', 'round', 'bevel']

        const convertImgDataToPng = (function () {
          const PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a])
          const CHUNK_WRAPPER_SIZE = 12
          const crcTable = new Int32Array(256)

          for (let i = 0; i < 256; i++) {
            let c = i

            for (let h = 0; h < 8; h++) {
              if (c & 1) {
                c = 0xedb88320 ^ c >> 1 & 0x7fffffff
              } else {
                c = c >> 1 & 0x7fffffff
              }
            }

            crcTable[i] = c
          }

          function crc32 (data, start, end) {
            let crc = -1

            for (let _i = start; _i < end; _i++) {
              const a = (crc ^ data[_i]) & 0xff
              const b = crcTable[a]
              crc = crc >>> 8 ^ b
            }

            return crc ^ -1
          }

          function writePngChunk (type, body, data, offset) {
            let p = offset
            const len = body.length
            data[p] = len >> 24 & 0xff
            data[p + 1] = len >> 16 & 0xff
            data[p + 2] = len >> 8 & 0xff
            data[p + 3] = len & 0xff
            p += 4
            data[p] = type.charCodeAt(0) & 0xff
            data[p + 1] = type.charCodeAt(1) & 0xff
            data[p + 2] = type.charCodeAt(2) & 0xff
            data[p + 3] = type.charCodeAt(3) & 0xff
            p += 4
            data.set(body, p)
            p += body.length
            const crc = crc32(data, offset + 4, p)
            data[p] = crc >> 24 & 0xff
            data[p + 1] = crc >> 16 & 0xff
            data[p + 2] = crc >> 8 & 0xff
            data[p + 3] = crc & 0xff
          }

          function adler32 (data, start, end) {
            let a = 1
            let b = 0

            for (let _i2 = start; _i2 < end; ++_i2) {
              a = (a + (data[_i2] & 0xff)) % 65521
              b = (b + a) % 65521
            }

            return b << 16 | a
          }

          function deflateSync (literals) {
            if (!_is_node.isNodeJS) {
              return deflateSyncUncompressed(literals)
            }

            try {
              let input

              if (parseInt(process.versions.node) >= 8) {
                input = literals
              } else {
                input = Buffer.from(literals)
              }

              const output = require('zlib').deflateSync(input, {
                level: 9
              })

              return output instanceof Uint8Array ? output : new Uint8Array(output)
            } catch (e) {
              (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e)
            }

            return deflateSyncUncompressed(literals)
          }

          function deflateSyncUncompressed (literals) {
            let len = literals.length
            const maxBlockLength = 0xffff
            const deflateBlocks = Math.ceil(len / maxBlockLength)
            const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4)
            let pi = 0
            idat[pi++] = 0x78
            idat[pi++] = 0x9c
            let pos = 0

            while (len > maxBlockLength) {
              idat[pi++] = 0x00
              idat[pi++] = 0xff
              idat[pi++] = 0xff
              idat[pi++] = 0x00
              idat[pi++] = 0x00
              idat.set(literals.subarray(pos, pos + maxBlockLength), pi)
              pi += maxBlockLength
              pos += maxBlockLength
              len -= maxBlockLength
            }

            idat[pi++] = 0x01
            idat[pi++] = len & 0xff
            idat[pi++] = len >> 8 & 0xff
            idat[pi++] = ~len & 0xffff & 0xff
            idat[pi++] = (~len & 0xffff) >> 8 & 0xff
            idat.set(literals.subarray(pos), pi)
            pi += literals.length - pos
            const adler = adler32(literals, 0, literals.length)
            idat[pi++] = adler >> 24 & 0xff
            idat[pi++] = adler >> 16 & 0xff
            idat[pi++] = adler >> 8 & 0xff
            idat[pi++] = adler & 0xff
            return idat
          }

          function encode (imgData, kind, forceDataSchema, isMask) {
            const width = imgData.width
            const height = imgData.height
            let bitDepth, colorType, lineSize
            const bytes = imgData.data

            switch (kind) {
              case _util.ImageKind.GRAYSCALE_1BPP:
                colorType = 0
                bitDepth = 1
                lineSize = width + 7 >> 3
                break

              case _util.ImageKind.RGB_24BPP:
                colorType = 2
                bitDepth = 8
                lineSize = width * 3
                break

              case _util.ImageKind.RGBA_32BPP:
                colorType = 6
                bitDepth = 8
                lineSize = width * 4
                break

              default:
                throw new Error('invalid format')
            }

            const literals = new Uint8Array((1 + lineSize) * height)
            let offsetLiterals = 0
            let offsetBytes = 0

            for (let y = 0; y < height; ++y) {
              literals[offsetLiterals++] = 0
              literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals)
              offsetBytes += lineSize
              offsetLiterals += lineSize
            }

            if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
              offsetLiterals = 0

              for (let _y = 0; _y < height; _y++) {
                offsetLiterals++

                for (let _i3 = 0; _i3 < lineSize; _i3++) {
                  literals[offsetLiterals++] ^= 0xff
                }
              }
            }

            const ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00])
            const idat = deflateSync(literals)
            const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length
            const data = new Uint8Array(pngLength)
            let offset = 0
            data.set(PNG_HEADER, offset)
            offset += PNG_HEADER.length
            writePngChunk('IHDR', ihdr, data, offset)
            offset += CHUNK_WRAPPER_SIZE + ihdr.length
            writePngChunk('IDATA', idat, data, offset)
            offset += CHUNK_WRAPPER_SIZE + idat.length
            writePngChunk('IEND', new Uint8Array(0), data, offset)
            return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema)
          }

          return function convertImgDataToPng (imgData, forceDataSchema, isMask) {
            const kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind
            return encode(imgData, kind, forceDataSchema, isMask)
          }
        }())

        const SVGExtraState = /* #__PURE__ */(function () {
          function SVGExtraState () {
            _classCallCheck(this, SVGExtraState)

            this.fontSizeScale = 1
            this.fontWeight = SVG_DEFAULTS.fontWeight
            this.fontSize = 0
            this.textMatrix = _util.IDENTITY_MATRIX
            this.fontMatrix = _util.FONT_IDENTITY_MATRIX
            this.leading = 0
            this.textRenderingMode = _util.TextRenderingMode.FILL
            this.textMatrixScale = 1
            this.x = 0
            this.y = 0
            this.lineX = 0
            this.lineY = 0
            this.charSpacing = 0
            this.wordSpacing = 0
            this.textHScale = 1
            this.textRise = 0
            this.fillColor = SVG_DEFAULTS.fillColor
            this.strokeColor = '#000000'
            this.fillAlpha = 1
            this.strokeAlpha = 1
            this.lineWidth = 1
            this.lineJoin = ''
            this.lineCap = ''
            this.miterLimit = 0
            this.dashArray = []
            this.dashPhase = 0
            this.dependencies = []
            this.activeClipUrl = null
            this.clipGroup = null
            this.maskId = ''
          }

          _createClass(SVGExtraState, [{
            key: 'clone',
            value: function clone () {
              return Object.create(this)
            }
          }, {
            key: 'setCurrentPoint',
            value: function setCurrentPoint (x, y) {
              this.x = x
              this.y = y
            }
          }])

          return SVGExtraState
        }())

        let clipCount = 0
        let maskCount = 0
        let shadingCount = 0

        exports.SVGGraphics = SVGGraphics = /* #__PURE__ */(function () {
          function SVGGraphics (commonObjs, objs, forceDataSchema) {
            _classCallCheck(this, SVGGraphics)

            this.svgFactory = new _display_utils.DOMSVGFactory()
            this.current = new SVGExtraState()
            this.transformMatrix = _util.IDENTITY_MATRIX
            this.transformStack = []
            this.extraStack = []
            this.commonObjs = commonObjs
            this.objs = objs
            this.pendingClip = null
            this.pendingEOFill = false
            this.embedFonts = false
            this.embeddedFonts = Object.create(null)
            this.cssStyle = null
            this.forceDataSchema = !!forceDataSchema
            this._operatorIdMapping = []

            for (const op in _util.OPS) {
              this._operatorIdMapping[_util.OPS[op]] = op
            }
          }

          _createClass(SVGGraphics, [{
            key: 'save',
            value: function save () {
              this.transformStack.push(this.transformMatrix)
              const old = this.current
              this.extraStack.push(old)
              this.current = old.clone()
            }
          }, {
            key: 'restore',
            value: function restore () {
              this.transformMatrix = this.transformStack.pop()
              this.current = this.extraStack.pop()
              this.pendingClip = null
              this.tgrp = null
            }
          }, {
            key: 'group',
            value: function group (items) {
              this.save()
              this.executeOpTree(items)
              this.restore()
            }
          }, {
            key: 'loadDependencies',
            value: function loadDependencies (operatorList) {
              const _this = this

              const fnArray = operatorList.fnArray
              const argsArray = operatorList.argsArray

              for (let i = 0, ii = fnArray.length; i < ii; i++) {
                if (fnArray[i] !== _util.OPS.dependency) {
                  continue
                }

                let _iteratorNormalCompletion2 = true
                let _didIteratorError2 = false
                let _iteratorError2

                try {
                  const _loop = function _loop () {
                    const obj = _step2.value
                    const objsPool = obj.startsWith('g_') ? _this.commonObjs : _this.objs
                    const promise = new Promise(function (resolve) {
                      objsPool.get(obj, resolve)
                    })

                    _this.current.dependencies.push(promise)
                  }

                  for (var _iterator2 = argsArray[i][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    _loop()
                  }
                } catch (err) {
                  _didIteratorError2 = true
                  _iteratorError2 = err
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                      _iterator2.return()
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2
                    }
                  }
                }
              }

              return Promise.all(this.current.dependencies)
            }
          }, {
            key: 'transform',
            value: function transform (a, b, c, d, e, f) {
              const transformMatrix = [a, b, c, d, e, f]
              this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix)
              this.tgrp = null
            }
          }, {
            key: 'getSVG',
            value: function getSVG (operatorList, viewport) {
              const _this2 = this

              this.viewport = viewport

              const svgElement = this._initialize(viewport)

              return this.loadDependencies(operatorList).then(function () {
                _this2.transformMatrix = _util.IDENTITY_MATRIX

                _this2.executeOpTree(_this2.convertOpList(operatorList))

                return svgElement
              })
            }
          }, {
            key: 'convertOpList',
            value: function convertOpList (operatorList) {
              const operatorIdMapping = this._operatorIdMapping
              const argsArray = operatorList.argsArray
              const fnArray = operatorList.fnArray
              const opList = []

              for (let i = 0, ii = fnArray.length; i < ii; i++) {
                const fnId = fnArray[i]
                opList.push({
                  fnId: fnId,
                  fn: operatorIdMapping[fnId],
                  args: argsArray[i]
                })
              }

              return opListToTree(opList)
            }
          }, {
            key: 'executeOpTree',
            value: function executeOpTree (opTree) {
              let _iteratorNormalCompletion3 = true
              let _didIteratorError3 = false
              let _iteratorError3

              try {
                for (var _iterator3 = opTree[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  const opTreeElement = _step3.value
                  const fn = opTreeElement.fn
                  const fnId = opTreeElement.fnId
                  const args = opTreeElement.args

                  switch (fnId | 0) {
                    case _util.OPS.beginText:
                      this.beginText()
                      break

                    case _util.OPS.dependency:
                      break

                    case _util.OPS.setLeading:
                      this.setLeading(args)
                      break

                    case _util.OPS.setLeadingMoveText:
                      this.setLeadingMoveText(args[0], args[1])
                      break

                    case _util.OPS.setFont:
                      this.setFont(args)
                      break

                    case _util.OPS.showText:
                      this.showText(args[0])
                      break

                    case _util.OPS.showSpacedText:
                      this.showText(args[0])
                      break

                    case _util.OPS.endText:
                      this.endText()
                      break

                    case _util.OPS.moveText:
                      this.moveText(args[0], args[1])
                      break

                    case _util.OPS.setCharSpacing:
                      this.setCharSpacing(args[0])
                      break

                    case _util.OPS.setWordSpacing:
                      this.setWordSpacing(args[0])
                      break

                    case _util.OPS.setHScale:
                      this.setHScale(args[0])
                      break

                    case _util.OPS.setTextMatrix:
                      this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5])
                      break

                    case _util.OPS.setTextRise:
                      this.setTextRise(args[0])
                      break

                    case _util.OPS.setTextRenderingMode:
                      this.setTextRenderingMode(args[0])
                      break

                    case _util.OPS.setLineWidth:
                      this.setLineWidth(args[0])
                      break

                    case _util.OPS.setLineJoin:
                      this.setLineJoin(args[0])
                      break

                    case _util.OPS.setLineCap:
                      this.setLineCap(args[0])
                      break

                    case _util.OPS.setMiterLimit:
                      this.setMiterLimit(args[0])
                      break

                    case _util.OPS.setFillRGBColor:
                      this.setFillRGBColor(args[0], args[1], args[2])
                      break

                    case _util.OPS.setStrokeRGBColor:
                      this.setStrokeRGBColor(args[0], args[1], args[2])
                      break

                    case _util.OPS.setStrokeColorN:
                      this.setStrokeColorN(args)
                      break

                    case _util.OPS.setFillColorN:
                      this.setFillColorN(args)
                      break

                    case _util.OPS.shadingFill:
                      this.shadingFill(args[0])
                      break

                    case _util.OPS.setDash:
                      this.setDash(args[0], args[1])
                      break

                    case _util.OPS.setRenderingIntent:
                      this.setRenderingIntent(args[0])
                      break

                    case _util.OPS.setFlatness:
                      this.setFlatness(args[0])
                      break

                    case _util.OPS.setGState:
                      this.setGState(args[0])
                      break

                    case _util.OPS.fill:
                      this.fill()
                      break

                    case _util.OPS.eoFill:
                      this.eoFill()
                      break

                    case _util.OPS.stroke:
                      this.stroke()
                      break

                    case _util.OPS.fillStroke:
                      this.fillStroke()
                      break

                    case _util.OPS.eoFillStroke:
                      this.eoFillStroke()
                      break

                    case _util.OPS.clip:
                      this.clip('nonzero')
                      break

                    case _util.OPS.eoClip:
                      this.clip('evenodd')
                      break

                    case _util.OPS.paintSolidColorImageMask:
                      this.paintSolidColorImageMask()
                      break

                    case _util.OPS.paintJpegXObject:
                      this.paintJpegXObject(args[0], args[1], args[2])
                      break

                    case _util.OPS.paintImageXObject:
                      this.paintImageXObject(args[0])
                      break

                    case _util.OPS.paintInlineImageXObject:
                      this.paintInlineImageXObject(args[0])
                      break

                    case _util.OPS.paintImageMaskXObject:
                      this.paintImageMaskXObject(args[0])
                      break

                    case _util.OPS.paintFormXObjectBegin:
                      this.paintFormXObjectBegin(args[0], args[1])
                      break

                    case _util.OPS.paintFormXObjectEnd:
                      this.paintFormXObjectEnd()
                      break

                    case _util.OPS.closePath:
                      this.closePath()
                      break

                    case _util.OPS.closeStroke:
                      this.closeStroke()
                      break

                    case _util.OPS.closeFillStroke:
                      this.closeFillStroke()
                      break

                    case _util.OPS.closeEOFillStroke:
                      this.closeEOFillStroke()
                      break

                    case _util.OPS.nextLine:
                      this.nextLine()
                      break

                    case _util.OPS.transform:
                      this.transform(args[0], args[1], args[2], args[3], args[4], args[5])
                      break

                    case _util.OPS.constructPath:
                      this.constructPath(args[0], args[1])
                      break

                    case _util.OPS.endPath:
                      this.endPath()
                      break

                    case 92:
                      this.group(opTreeElement.items)
                      break

                    default:
                      (0, _util.warn)('Unimplemented operator '.concat(fn))
                      break
                  }
                }
              } catch (err) {
                _didIteratorError3 = true
                _iteratorError3 = err
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return()
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3
                  }
                }
              }
            }
          }, {
            key: 'setWordSpacing',
            value: function setWordSpacing (wordSpacing) {
              this.current.wordSpacing = wordSpacing
            }
          }, {
            key: 'setCharSpacing',
            value: function setCharSpacing (charSpacing) {
              this.current.charSpacing = charSpacing
            }
          }, {
            key: 'nextLine',
            value: function nextLine () {
              this.moveText(0, this.current.leading)
            }
          }, {
            key: 'setTextMatrix',
            value: function setTextMatrix (a, b, c, d, e, f) {
              const current = this.current
              current.textMatrix = current.lineMatrix = [a, b, c, d, e, f]
              current.textMatrixScale = Math.sqrt(a * a + b * b)
              current.x = current.lineX = 0
              current.y = current.lineY = 0
              current.xcoords = []
              current.tspan = this.svgFactory.createElement('svg:tspan')
              current.tspan.setAttributeNS(null, 'font-family', current.fontFamily)
              current.tspan.setAttributeNS(null, 'font-size', ''.concat(pf(current.fontSize), 'px'))
              current.tspan.setAttributeNS(null, 'y', pf(-current.y))
              current.txtElement = this.svgFactory.createElement('svg:text')
              current.txtElement.appendChild(current.tspan)
            }
          }, {
            key: 'beginText',
            value: function beginText () {
              const current = this.current
              current.x = current.lineX = 0
              current.y = current.lineY = 0
              current.textMatrix = _util.IDENTITY_MATRIX
              current.lineMatrix = _util.IDENTITY_MATRIX
              current.textMatrixScale = 1
              current.tspan = this.svgFactory.createElement('svg:tspan')
              current.txtElement = this.svgFactory.createElement('svg:text')
              current.txtgrp = this.svgFactory.createElement('svg:g')
              current.xcoords = []
            }
          }, {
            key: 'moveText',
            value: function moveText (x, y) {
              const current = this.current
              current.x = current.lineX += x
              current.y = current.lineY += y
              current.xcoords = []
              current.tspan = this.svgFactory.createElement('svg:tspan')
              current.tspan.setAttributeNS(null, 'font-family', current.fontFamily)
              current.tspan.setAttributeNS(null, 'font-size', ''.concat(pf(current.fontSize), 'px'))
              current.tspan.setAttributeNS(null, 'y', pf(-current.y))
            }
          }, {
            key: 'showText',
            value: function showText (glyphs) {
              const current = this.current
              const font = current.font
              const fontSize = current.fontSize

              if (fontSize === 0) {
                return
              }

              const charSpacing = current.charSpacing
              const wordSpacing = current.wordSpacing
              const fontDirection = current.fontDirection
              const textHScale = current.textHScale * fontDirection
              const vertical = font.vertical
              const widthAdvanceScale = fontSize * current.fontMatrix[0]
              let x = 0
              let _iteratorNormalCompletion4 = true
              let _didIteratorError4 = false
              let _iteratorError4

              try {
                for (var _iterator4 = glyphs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  const glyph = _step4.value

                  if (glyph === null) {
                    x += fontDirection * wordSpacing
                    continue
                  } else if ((0, _util.isNum)(glyph)) {
                    x += -glyph * fontSize * 0.001
                    continue
                  }

                  const width = glyph.width
                  const character = glyph.fontChar
                  const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing
                  const charWidth = width * widthAdvanceScale + spacing * fontDirection

                  if (!glyph.isInFont && !font.missingFile) {
                    x += charWidth
                    continue
                  }

                  current.xcoords.push(current.x + x)
                  current.tspan.textContent += character
                  x += charWidth
                }
              } catch (err) {
                _didIteratorError4 = true
                _iteratorError4 = err
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return()
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4
                  }
                }
              }

              if (vertical) {
                current.y -= x * textHScale
              } else {
                current.x += x * textHScale
              }

              current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '))
              current.tspan.setAttributeNS(null, 'y', pf(-current.y))
              current.tspan.setAttributeNS(null, 'font-family', current.fontFamily)
              current.tspan.setAttributeNS(null, 'font-size', ''.concat(pf(current.fontSize), 'px'))

              if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
                current.tspan.setAttributeNS(null, 'font-style', current.fontStyle)
              }

              if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
                current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight)
              }

              const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK

              if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                if (current.fillColor !== SVG_DEFAULTS.fillColor) {
                  current.tspan.setAttributeNS(null, 'fill', current.fillColor)
                }

                if (current.fillAlpha < 1) {
                  current.tspan.setAttributeNS(null, 'fill-opacity', current.fillAlpha)
                }
              } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) {
                current.tspan.setAttributeNS(null, 'fill', 'transparent')
              } else {
                current.tspan.setAttributeNS(null, 'fill', 'none')
              }

              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                const lineWidthScale = 1 / (current.textMatrixScale || 1)

                this._setStrokeAttributes(current.tspan, lineWidthScale)
              }

              let textMatrix = current.textMatrix

              if (current.textRise !== 0) {
                textMatrix = textMatrix.slice()
                textMatrix[5] += current.textRise
              }

              current.txtElement.setAttributeNS(null, 'transform', ''.concat(pm(textMatrix), ' scale(').concat(pf(textHScale), ', -1)'))
              current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve')
              current.txtElement.appendChild(current.tspan)
              current.txtgrp.appendChild(current.txtElement)

              this._ensureTransformGroup().appendChild(current.txtElement)
            }
          }, {
            key: 'setLeadingMoveText',
            value: function setLeadingMoveText (x, y) {
              this.setLeading(-y)
              this.moveText(x, y)
            }
          }, {
            key: 'addFontStyle',
            value: function addFontStyle (fontObj) {
              if (!this.cssStyle) {
                this.cssStyle = this.svgFactory.createElement('svg:style')
                this.cssStyle.setAttributeNS(null, 'type', 'text/css')
                this.defs.appendChild(this.cssStyle)
              }

              const url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema)
              this.cssStyle.textContent += '@font-face { font-family: "'.concat(fontObj.loadedName, '";') + ' src: url('.concat(url, '); }\n')
            }
          }, {
            key: 'setFont',
            value: function setFont (details) {
              const current = this.current
              const fontObj = this.commonObjs.get(details[0])
              let size = details[1]
              current.font = fontObj

              if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
                this.addFontStyle(fontObj)
                this.embeddedFonts[fontObj.loadedName] = fontObj
              }

              current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX
              let bold = 'normal'

              if (fontObj.black) {
                bold = '900'
              } else if (fontObj.bold) {
                bold = 'bold'
              }

              const italic = fontObj.italic ? 'italic' : 'normal'

              if (size < 0) {
                size = -size
                current.fontDirection = -1
              } else {
                current.fontDirection = 1
              }

              current.fontSize = size
              current.fontFamily = fontObj.loadedName
              current.fontWeight = bold
              current.fontStyle = italic
              current.tspan = this.svgFactory.createElement('svg:tspan')
              current.tspan.setAttributeNS(null, 'y', pf(-current.y))
              current.xcoords = []
            }
          }, {
            key: 'endText',
            value: function endText () {
              const current = this.current

              if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement && current.txtElement.hasChildNodes()) {
                current.element = current.txtElement
                this.clip('nonzero')
                this.endPath()
              }
            }
          }, {
            key: 'setLineWidth',
            value: function setLineWidth (width) {
              if (width > 0) {
                this.current.lineWidth = width
              }
            }
          }, {
            key: 'setLineCap',
            value: function setLineCap (style) {
              this.current.lineCap = LINE_CAP_STYLES[style]
            }
          }, {
            key: 'setLineJoin',
            value: function setLineJoin (style) {
              this.current.lineJoin = LINE_JOIN_STYLES[style]
            }
          }, {
            key: 'setMiterLimit',
            value: function setMiterLimit (limit) {
              this.current.miterLimit = limit
            }
          }, {
            key: 'setStrokeAlpha',
            value: function setStrokeAlpha (strokeAlpha) {
              this.current.strokeAlpha = strokeAlpha
            }
          }, {
            key: 'setStrokeRGBColor',
            value: function setStrokeRGBColor (r, g, b) {
              this.current.strokeColor = _util.Util.makeCssRgb(r, g, b)
            }
          }, {
            key: 'setFillAlpha',
            value: function setFillAlpha (fillAlpha) {
              this.current.fillAlpha = fillAlpha
            }
          }, {
            key: 'setFillRGBColor',
            value: function setFillRGBColor (r, g, b) {
              this.current.fillColor = _util.Util.makeCssRgb(r, g, b)
              this.current.tspan = this.svgFactory.createElement('svg:tspan')
              this.current.xcoords = []
            }
          }, {
            key: 'setStrokeColorN',
            value: function setStrokeColorN (args) {
              this.current.strokeColor = this._makeColorN_Pattern(args)
            }
          }, {
            key: 'setFillColorN',
            value: function setFillColorN (args) {
              this.current.fillColor = this._makeColorN_Pattern(args)
            }
          }, {
            key: 'shadingFill',
            value: function shadingFill (args) {
              const width = this.viewport.width
              const height = this.viewport.height

              const inv = _util.Util.inverseTransform(this.transformMatrix)

              const bl = _util.Util.applyTransform([0, 0], inv)

              const br = _util.Util.applyTransform([0, height], inv)

              const ul = _util.Util.applyTransform([width, 0], inv)

              const ur = _util.Util.applyTransform([width, height], inv)

              const x0 = Math.min(bl[0], br[0], ul[0], ur[0])
              const y0 = Math.min(bl[1], br[1], ul[1], ur[1])
              const x1 = Math.max(bl[0], br[0], ul[0], ur[0])
              const y1 = Math.max(bl[1], br[1], ul[1], ur[1])
              const rect = this.svgFactory.createElement('svg:rect')
              rect.setAttributeNS(null, 'x', x0)
              rect.setAttributeNS(null, 'y', y0)
              rect.setAttributeNS(null, 'width', x1 - x0)
              rect.setAttributeNS(null, 'height', y1 - y0)
              rect.setAttributeNS(null, 'fill', this._makeShadingPattern(args))

              this._ensureTransformGroup().appendChild(rect)
            }
          }, {
            key: '_makeColorN_Pattern',
            value: function _makeColorN_Pattern (args) {
              if (args[0] === 'TilingPattern') {
                return this._makeTilingPattern(args)
              }

              return this._makeShadingPattern(args)
            }
          }, {
            key: '_makeTilingPattern',
            value: function _makeTilingPattern (args) {
              const color = args[1]
              const operatorList = args[2]
              const matrix = args[3] || _util.IDENTITY_MATRIX

              const _args$ = _slicedToArray(args[4], 4)
              const x0 = _args$[0]
              const y0 = _args$[1]
              const x1 = _args$[2]
              const y1 = _args$[3]

              const xstep = args[5]
              const ystep = args[6]
              const paintType = args[7]
              const tilingId = 'shading'.concat(shadingCount++)

              const _Util$applyTransform = _util.Util.applyTransform([x0, y0], matrix)
              const _Util$applyTransform2 = _slicedToArray(_Util$applyTransform, 2)
              const tx0 = _Util$applyTransform2[0]
              const ty0 = _Util$applyTransform2[1]

              const _Util$applyTransform3 = _util.Util.applyTransform([x1, y1], matrix)
              const _Util$applyTransform4 = _slicedToArray(_Util$applyTransform3, 2)
              const tx1 = _Util$applyTransform4[0]
              const ty1 = _Util$applyTransform4[1]

              const _Util$singularValueDe = _util.Util.singularValueDecompose2dScale(matrix)
              const _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2)
              const xscale = _Util$singularValueDe2[0]
              const yscale = _Util$singularValueDe2[1]

              const txstep = xstep * xscale
              const tystep = ystep * yscale
              const tiling = this.svgFactory.createElement('svg:pattern')
              tiling.setAttributeNS(null, 'id', tilingId)
              tiling.setAttributeNS(null, 'patternUnits', 'userSpaceOnUse')
              tiling.setAttributeNS(null, 'width', txstep)
              tiling.setAttributeNS(null, 'height', tystep)
              tiling.setAttributeNS(null, 'x', ''.concat(tx0))
              tiling.setAttributeNS(null, 'y', ''.concat(ty0))
              const svg = this.svg
              const transformMatrix = this.transformMatrix
              const fillColor = this.current.fillColor
              const strokeColor = this.current.strokeColor
              const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0)
              this.svg = bbox
              this.transformMatrix = matrix

              if (paintType === 2) {
                const cssColor = _util.Util.makeCssRgb.apply(_util.Util, _toConsumableArray(color))

                this.current.fillColor = cssColor
                this.current.strokeColor = cssColor
              }

              this.executeOpTree(this.convertOpList(operatorList))
              this.svg = svg
              this.transformMatrix = transformMatrix
              this.current.fillColor = fillColor
              this.current.strokeColor = strokeColor
              tiling.appendChild(bbox.childNodes[0])
              this.defs.appendChild(tiling)
              return 'url(#'.concat(tilingId, ')')
            }
          }, {
            key: '_makeShadingPattern',
            value: function _makeShadingPattern (args) {
              switch (args[0]) {
                case 'RadialAxial':
                  var shadingId = 'shading'.concat(shadingCount++)
                  var colorStops = args[3]
                  var gradient

                  switch (args[1]) {
                    case 'axial':
                      var point0 = args[4]
                      var point1 = args[5]
                      gradient = this.svgFactory.createElement('svg:linearGradient')
                      gradient.setAttributeNS(null, 'id', shadingId)
                      gradient.setAttributeNS(null, 'gradientUnits', 'userSpaceOnUse')
                      gradient.setAttributeNS(null, 'x1', point0[0])
                      gradient.setAttributeNS(null, 'y1', point0[1])
                      gradient.setAttributeNS(null, 'x2', point1[0])
                      gradient.setAttributeNS(null, 'y2', point1[1])
                      break

                    case 'radial':
                      var focalPoint = args[4]
                      var circlePoint = args[5]
                      var focalRadius = args[6]
                      var circleRadius = args[7]
                      gradient = this.svgFactory.createElement('svg:radialGradient')
                      gradient.setAttributeNS(null, 'id', shadingId)
                      gradient.setAttributeNS(null, 'gradientUnits', 'userSpaceOnUse')
                      gradient.setAttributeNS(null, 'cx', circlePoint[0])
                      gradient.setAttributeNS(null, 'cy', circlePoint[1])
                      gradient.setAttributeNS(null, 'r', circleRadius)
                      gradient.setAttributeNS(null, 'fx', focalPoint[0])
                      gradient.setAttributeNS(null, 'fy', focalPoint[1])
                      gradient.setAttributeNS(null, 'fr', focalRadius)
                      break

                    default:
                      throw new Error('Unknown RadialAxial type: '.concat(args[1]))
                  }

                  var _iteratorNormalCompletion5 = true
                  var _didIteratorError5 = false
                  var _iteratorError5 = undefined

                  try {
                    for (var _iterator5 = colorStops[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                      const colorStop = _step5.value
                      const stop = this.svgFactory.createElement('svg:stop')
                      stop.setAttributeNS(null, 'offset', colorStop[0])
                      stop.setAttributeNS(null, 'stop-color', colorStop[1])
                      gradient.appendChild(stop)
                    }
                  } catch (err) {
                    _didIteratorError5 = true
                    _iteratorError5 = err
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                        _iterator5.return()
                      }
                    } finally {
                      if (_didIteratorError5) {
                        throw _iteratorError5
                      }
                    }
                  }

                  this.defs.appendChild(gradient)
                  return 'url(#'.concat(shadingId, ')')

                case 'Mesh':
                  (0, _util.warn)('Unimplemented pattern Mesh')
                  return null

                case 'Dummy':
                  return 'hotpink'

                default:
                  throw new Error('Unknown IR type: '.concat(args[0]))
              }
            }
          }, {
            key: 'setDash',
            value: function setDash (dashArray, dashPhase) {
              this.current.dashArray = dashArray
              this.current.dashPhase = dashPhase
            }
          }, {
            key: 'constructPath',
            value: function constructPath (ops, args) {
              const current = this.current
              let x = current.x
              let y = current.y
              let d = []
              let j = 0
              let _iteratorNormalCompletion6 = true
              let _didIteratorError6 = false
              let _iteratorError6

              try {
                for (var _iterator6 = ops[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  const op = _step6.value

                  switch (op | 0) {
                    case _util.OPS.rectangle:
                      x = args[j++]
                      y = args[j++]
                      var width = args[j++]
                      var height = args[j++]
                      var xw = x + width
                      var yh = y + height
                      d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z')
                      break

                    case _util.OPS.moveTo:
                      x = args[j++]
                      y = args[j++]
                      d.push('M', pf(x), pf(y))
                      break

                    case _util.OPS.lineTo:
                      x = args[j++]
                      y = args[j++]
                      d.push('L', pf(x), pf(y))
                      break

                    case _util.OPS.curveTo:
                      x = args[j + 4]
                      y = args[j + 5]
                      d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y))
                      j += 6
                      break

                    case _util.OPS.curveTo2:
                      d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]))
                      x = args[j + 2]
                      y = args[j + 3]
                      j += 4
                      break

                    case _util.OPS.curveTo3:
                      x = args[j + 2]
                      y = args[j + 3]
                      d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y))
                      j += 4
                      break

                    case _util.OPS.closePath:
                      d.push('Z')
                      break
                  }
                }
              } catch (err) {
                _didIteratorError6 = true
                _iteratorError6 = err
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                    _iterator6.return()
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6
                  }
                }
              }

              d = d.join(' ')

              if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) {
                d = current.path.getAttributeNS(null, 'd') + d
              } else {
                current.path = this.svgFactory.createElement('svg:path')

                this._ensureTransformGroup().appendChild(current.path)
              }

              current.path.setAttributeNS(null, 'd', d)
              current.path.setAttributeNS(null, 'fill', 'none')
              current.element = current.path
              current.setCurrentPoint(x, y)
            }
          }, {
            key: 'endPath',
            value: function endPath () {
              const current = this.current
              current.path = null

              if (!this.pendingClip) {
                return
              }

              if (!current.element) {
                this.pendingClip = null
                return
              }

              const clipId = 'clippath'.concat(clipCount++)
              const clipPath = this.svgFactory.createElement('svg:clipPath')
              clipPath.setAttributeNS(null, 'id', clipId)
              clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix))
              const clipElement = current.element.cloneNode(true)

              if (this.pendingClip === 'evenodd') {
                clipElement.setAttributeNS(null, 'clip-rule', 'evenodd')
              } else {
                clipElement.setAttributeNS(null, 'clip-rule', 'nonzero')
              }

              this.pendingClip = null
              clipPath.appendChild(clipElement)
              this.defs.appendChild(clipPath)

              if (current.activeClipUrl) {
                current.clipGroup = null
                this.extraStack.forEach(function (prev) {
                  prev.clipGroup = null
                })
                clipPath.setAttributeNS(null, 'clip-path', current.activeClipUrl)
              }

              current.activeClipUrl = 'url(#'.concat(clipId, ')')
              this.tgrp = null
            }
          }, {
            key: 'clip',
            value: function clip (type) {
              this.pendingClip = type
            }
          }, {
            key: 'closePath',
            value: function closePath () {
              const current = this.current

              if (current.path) {
                const d = ''.concat(current.path.getAttributeNS(null, 'd'), 'Z')
                current.path.setAttributeNS(null, 'd', d)
              }
            }
          }, {
            key: 'setLeading',
            value: function setLeading (leading) {
              this.current.leading = -leading
            }
          }, {
            key: 'setTextRise',
            value: function setTextRise (textRise) {
              this.current.textRise = textRise
            }
          }, {
            key: 'setTextRenderingMode',
            value: function setTextRenderingMode (textRenderingMode) {
              this.current.textRenderingMode = textRenderingMode
            }
          }, {
            key: 'setHScale',
            value: function setHScale (scale) {
              this.current.textHScale = scale / 100
            }
          }, {
            key: 'setRenderingIntent',
            value: function setRenderingIntent (intent) {}
          }, {
            key: 'setFlatness',
            value: function setFlatness (flatness) {}
          }, {
            key: 'setGState',
            value: function setGState (states) {
              let _iteratorNormalCompletion7 = true
              let _didIteratorError7 = false
              let _iteratorError7

              try {
                for (var _iterator7 = states[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  const _step7$value = _slicedToArray(_step7.value, 2)
                  const key = _step7$value[0]
                  const value = _step7$value[1]

                  switch (key) {
                    case 'LW':
                      this.setLineWidth(value)
                      break

                    case 'LC':
                      this.setLineCap(value)
                      break

                    case 'LJ':
                      this.setLineJoin(value)
                      break

                    case 'ML':
                      this.setMiterLimit(value)
                      break

                    case 'D':
                      this.setDash(value[0], value[1])
                      break

                    case 'RI':
                      this.setRenderingIntent(value)
                      break

                    case 'FL':
                      this.setFlatness(value)
                      break

                    case 'Font':
                      this.setFont(value)
                      break

                    case 'CA':
                      this.setStrokeAlpha(value)
                      break

                    case 'ca':
                      this.setFillAlpha(value)
                      break

                    default:
                      (0, _util.warn)('Unimplemented graphic state operator '.concat(key))
                      break
                  }
                }
              } catch (err) {
                _didIteratorError7 = true
                _iteratorError7 = err
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                    _iterator7.return()
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7
                  }
                }
              }
            }
          }, {
            key: 'fill',
            value: function fill () {
              const current = this.current

              if (current.element) {
                current.element.setAttributeNS(null, 'fill', current.fillColor)
                current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha)
                this.endPath()
              }
            }
          }, {
            key: 'stroke',
            value: function stroke () {
              const current = this.current

              if (current.element) {
                this._setStrokeAttributes(current.element)

                current.element.setAttributeNS(null, 'fill', 'none')
                this.endPath()
              }
            }
          }, {
            key: '_setStrokeAttributes',
            value: function _setStrokeAttributes (element) {
              const lineWidthScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1
              const current = this.current
              let dashArray = current.dashArray

              if (lineWidthScale !== 1 && dashArray.length > 0) {
                dashArray = dashArray.map(function (value) {
                  return lineWidthScale * value
                })
              }

              element.setAttributeNS(null, 'stroke', current.strokeColor)
              element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha)
              element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit))
              element.setAttributeNS(null, 'stroke-linecap', current.lineCap)
              element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin)
              element.setAttributeNS(null, 'stroke-width', pf(lineWidthScale * current.lineWidth) + 'px')
              element.setAttributeNS(null, 'stroke-dasharray', dashArray.map(pf).join(' '))
              element.setAttributeNS(null, 'stroke-dashoffset', pf(lineWidthScale * current.dashPhase) + 'px')
            }
          }, {
            key: 'eoFill',
            value: function eoFill () {
              if (this.current.element) {
                this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd')
              }

              this.fill()
            }
          }, {
            key: 'fillStroke',
            value: function fillStroke () {
              this.stroke()
              this.fill()
            }
          }, {
            key: 'eoFillStroke',
            value: function eoFillStroke () {
              if (this.current.element) {
                this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd')
              }

              this.fillStroke()
            }
          }, {
            key: 'closeStroke',
            value: function closeStroke () {
              this.closePath()
              this.stroke()
            }
          }, {
            key: 'closeFillStroke',
            value: function closeFillStroke () {
              this.closePath()
              this.fillStroke()
            }
          }, {
            key: 'closeEOFillStroke',
            value: function closeEOFillStroke () {
              this.closePath()
              this.eoFillStroke()
            }
          }, {
            key: 'paintSolidColorImageMask',
            value: function paintSolidColorImageMask () {
              const rect = this.svgFactory.createElement('svg:rect')
              rect.setAttributeNS(null, 'x', '0')
              rect.setAttributeNS(null, 'y', '0')
              rect.setAttributeNS(null, 'width', '1px')
              rect.setAttributeNS(null, 'height', '1px')
              rect.setAttributeNS(null, 'fill', this.current.fillColor)

              this._ensureTransformGroup().appendChild(rect)
            }
          }, {
            key: 'paintJpegXObject',
            value: function paintJpegXObject (objId, w, h) {
              const imgObj = this.objs.get(objId)
              const imgEl = this.svgFactory.createElement('svg:image')
              imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src)
              imgEl.setAttributeNS(null, 'width', pf(w))
              imgEl.setAttributeNS(null, 'height', pf(h))
              imgEl.setAttributeNS(null, 'x', '0')
              imgEl.setAttributeNS(null, 'y', pf(-h))
              imgEl.setAttributeNS(null, 'transform', 'scale('.concat(pf(1 / w), ' ').concat(pf(-1 / h), ')'))

              this._ensureTransformGroup().appendChild(imgEl)
            }
          }, {
            key: 'paintImageXObject',
            value: function paintImageXObject (objId) {
              const imgData = this.objs.get(objId)

              if (!imgData) {
                (0, _util.warn)('Dependent image with object ID '.concat(objId, ' is not ready yet'))
                return
              }

              this.paintInlineImageXObject(imgData)
            }
          }, {
            key: 'paintInlineImageXObject',
            value: function paintInlineImageXObject (imgData, mask) {
              const width = imgData.width
              const height = imgData.height
              const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask)
              const cliprect = this.svgFactory.createElement('svg:rect')
              cliprect.setAttributeNS(null, 'x', '0')
              cliprect.setAttributeNS(null, 'y', '0')
              cliprect.setAttributeNS(null, 'width', pf(width))
              cliprect.setAttributeNS(null, 'height', pf(height))
              this.current.element = cliprect
              this.clip('nonzero')
              const imgEl = this.svgFactory.createElement('svg:image')
              imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc)
              imgEl.setAttributeNS(null, 'x', '0')
              imgEl.setAttributeNS(null, 'y', pf(-height))
              imgEl.setAttributeNS(null, 'width', pf(width) + 'px')
              imgEl.setAttributeNS(null, 'height', pf(height) + 'px')
              imgEl.setAttributeNS(null, 'transform', 'scale('.concat(pf(1 / width), ' ').concat(pf(-1 / height), ')'))

              if (mask) {
                mask.appendChild(imgEl)
              } else {
                this._ensureTransformGroup().appendChild(imgEl)
              }
            }
          }, {
            key: 'paintImageMaskXObject',
            value: function paintImageMaskXObject (imgData) {
              const current = this.current
              const width = imgData.width
              const height = imgData.height
              const fillColor = current.fillColor
              current.maskId = 'mask'.concat(maskCount++)
              const mask = this.svgFactory.createElement('svg:mask')
              mask.setAttributeNS(null, 'id', current.maskId)
              const rect = this.svgFactory.createElement('svg:rect')
              rect.setAttributeNS(null, 'x', '0')
              rect.setAttributeNS(null, 'y', '0')
              rect.setAttributeNS(null, 'width', pf(width))
              rect.setAttributeNS(null, 'height', pf(height))
              rect.setAttributeNS(null, 'fill', fillColor)
              rect.setAttributeNS(null, 'mask', 'url(#'.concat(current.maskId, ')'))
              this.defs.appendChild(mask)

              this._ensureTransformGroup().appendChild(rect)

              this.paintInlineImageXObject(imgData, mask)
            }
          }, {
            key: 'paintFormXObjectBegin',
            value: function paintFormXObjectBegin (matrix, bbox) {
              if (Array.isArray(matrix) && matrix.length === 6) {
                this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5])
              }

              if (bbox) {
                const width = bbox[2] - bbox[0]
                const height = bbox[3] - bbox[1]
                const cliprect = this.svgFactory.createElement('svg:rect')
                cliprect.setAttributeNS(null, 'x', bbox[0])
                cliprect.setAttributeNS(null, 'y', bbox[1])
                cliprect.setAttributeNS(null, 'width', pf(width))
                cliprect.setAttributeNS(null, 'height', pf(height))
                this.current.element = cliprect
                this.clip('nonzero')
                this.endPath()
              }
            }
          }, {
            key: 'paintFormXObjectEnd',
            value: function paintFormXObjectEnd () {}
          }, {
            key: '_initialize',
            value: function _initialize (viewport) {
              const svg = this.svgFactory.create(viewport.width, viewport.height)
              const definitions = this.svgFactory.createElement('svg:defs')
              svg.appendChild(definitions)
              this.defs = definitions
              const rootGroup = this.svgFactory.createElement('svg:g')
              rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform))
              svg.appendChild(rootGroup)
              this.svg = rootGroup
              return svg
            }
          }, {
            key: '_ensureClipGroup',
            value: function _ensureClipGroup () {
              if (!this.current.clipGroup) {
                const clipGroup = this.svgFactory.createElement('svg:g')
                clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl)
                this.svg.appendChild(clipGroup)
                this.current.clipGroup = clipGroup
              }

              return this.current.clipGroup
            }
          }, {
            key: '_ensureTransformGroup',
            value: function _ensureTransformGroup () {
              if (!this.tgrp) {
                this.tgrp = this.svgFactory.createElement('svg:g')
                this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix))

                if (this.current.activeClipUrl) {
                  this._ensureClipGroup().appendChild(this.tgrp)
                } else {
                  this.svg.appendChild(this.tgrp)
                }
              }

              return this.tgrp
            }
          }])

          return SVGGraphics
        }())
      }
      /***/ },
    /* 208 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.PDFNodeStream = void 0

      const _regenerator = _interopRequireDefault(__w_pdfjs_require__(191))

      const _util = __w_pdfjs_require__(1)

      const _network_utils = __w_pdfjs_require__(209)

      function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

      function _typeof (obj) { '@babel/helpers - typeof'; if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof (obj) { return typeof obj } } else { _typeof = function _typeof (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } } return _typeof(obj) }

      function _possibleConstructorReturn (self, call) { if (call && (_typeof(call) === 'object' || typeof call === 'function')) { return call } return _assertThisInitialized(self) }

      function _assertThisInitialized (self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called") } return self }

      function _getPrototypeOf (o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf (o) { return o.__proto__ || Object.getPrototypeOf(o) }; return _getPrototypeOf(o) }

      function _inherits (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function') } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass) }

      function _setPrototypeOf (o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf (o, p) { o.__proto__ = p; return o }; return _setPrototypeOf(o, p) }

      function asyncGeneratorStep (gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value } catch (error) { reject(error); return } if (info.done) { resolve(value) } else { Promise.resolve(value).then(_next, _throw) } }

      function _asyncToGenerator (fn) { return function () { const self = this; const args = arguments; return new Promise(function (resolve, reject) { const gen = fn.apply(self, args); function _next (value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value) } function _throw (err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err) } _next(undefined) }) } }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      const fs = require('fs')

      const http = require('http')

      const https = require('https')

      const url = require('url')

      const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//

      function parseUrl (sourceUrl) {
        const parsedUrl = url.parse(sourceUrl)

        if (parsedUrl.protocol === 'file:' || parsedUrl.host) {
          return parsedUrl
        }

        if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
          return url.parse('file:///'.concat(sourceUrl))
        }

        if (!parsedUrl.host) {
          parsedUrl.protocol = 'file:'
        }

        return parsedUrl
      }

      const PDFNodeStream = /* #__PURE__ */(function () {
        function PDFNodeStream (source) {
          _classCallCheck(this, PDFNodeStream)

          this.source = source
          this.url = parseUrl(source.url)
          this.isHttp = this.url.protocol === 'http:' || this.url.protocol === 'https:'
          this.isFsUrl = this.url.protocol === 'file:'
          this.httpHeaders = this.isHttp && source.httpHeaders || {}
          this._fullRequestReader = null
          this._rangeRequestReaders = []
        }

        _createClass(PDFNodeStream, [{
          key: 'getFullReader',
          value: function getFullReader () {
            (0, _util.assert)(!this._fullRequestReader)
            this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this)
            return this._fullRequestReader
          }
        }, {
          key: 'getRangeReader',
          value: function getRangeReader (start, end) {
            if (end <= this._progressiveDataLength) {
              return null
            }

            const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end)

            this._rangeRequestReaders.push(rangeReader)

            return rangeReader
          }
        }, {
          key: 'cancelAllRequests',
          value: function cancelAllRequests (reason) {
            if (this._fullRequestReader) {
              this._fullRequestReader.cancel(reason)
            }

            const readers = this._rangeRequestReaders.slice(0)

            readers.forEach(function (reader) {
              reader.cancel(reason)
            })
          }
        }, {
          key: '_progressiveDataLength',
          get: function get () {
            return this._fullRequestReader ? this._fullRequestReader._loaded : 0
          }
        }])

        return PDFNodeStream
      }())

      exports.PDFNodeStream = PDFNodeStream

      const BaseFullReader = /* #__PURE__ */(function () {
        function BaseFullReader (stream) {
          _classCallCheck(this, BaseFullReader)

          this._url = stream.url
          this._done = false
          this._storedError = null
          this.onProgress = null
          const source = stream.source
          this._contentLength = source.length
          this._loaded = 0
          this._filename = null
          this._disableRange = source.disableRange || false
          this._rangeChunkSize = source.rangeChunkSize

          if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true
          }

          this._isStreamingSupported = !source.disableStream
          this._isRangeSupported = !source.disableRange
          this._readableStream = null
          this._readCapability = (0, _util.createPromiseCapability)()
          this._headersCapability = (0, _util.createPromiseCapability)()
        }

        _createClass(BaseFullReader, [{
          key: 'read',
          value: (function () {
            const _read = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee () {
              let chunk, buffer
              return _regenerator.default.wrap(function _callee$ (_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2
                      return this._readCapability.promise

                    case 2:
                      if (!this._done) {
                        _context.next = 4
                        break
                      }

                      return _context.abrupt('return', {
                        value: undefined,
                        done: true
                      })

                    case 4:
                      if (!this._storedError) {
                        _context.next = 6
                        break
                      }

                      throw this._storedError

                    case 6:
                      chunk = this._readableStream.read()

                      if (!(chunk === null)) {
                        _context.next = 10
                        break
                      }

                      this._readCapability = (0, _util.createPromiseCapability)()
                      return _context.abrupt('return', this.read())

                    case 10:
                      this._loaded += chunk.length

                      if (this.onProgress) {
                        this.onProgress({
                          loaded: this._loaded,
                          total: this._contentLength
                        })
                      }

                      buffer = new Uint8Array(chunk).buffer
                      return _context.abrupt('return', {
                        value: buffer,
                        done: false
                      })

                    case 14:
                    case 'end':
                      return _context.stop()
                  }
                }
              }, _callee, this)
            }))

            function read () {
              return _read.apply(this, arguments)
            }

            return read
          }())
        }, {
          key: 'cancel',
          value: function cancel (reason) {
            if (!this._readableStream) {
              this._error(reason)

              return
            }

            this._readableStream.destroy(reason)
          }
        }, {
          key: '_error',
          value: function _error (reason) {
            this._storedError = reason

            this._readCapability.resolve()
          }
        }, {
          key: '_setReadableStream',
          value: function _setReadableStream (readableStream) {
            const _this = this

            this._readableStream = readableStream
            readableStream.on('readable', function () {
              _this._readCapability.resolve()
            })
            readableStream.on('end', function () {
              readableStream.destroy()
              _this._done = true

              _this._readCapability.resolve()
            })
            readableStream.on('error', function (reason) {
              _this._error(reason)
            })

            if (!this._isStreamingSupported && this._isRangeSupported) {
              this._error(new _util.AbortException('streaming is disabled'))
            }

            if (this._storedError) {
              this._readableStream.destroy(this._storedError)
            }
          }
        }, {
          key: 'headersReady',
          get: function get () {
            return this._headersCapability.promise
          }
        }, {
          key: 'filename',
          get: function get () {
            return this._filename
          }
        }, {
          key: 'contentLength',
          get: function get () {
            return this._contentLength
          }
        }, {
          key: 'isRangeSupported',
          get: function get () {
            return this._isRangeSupported
          }
        }, {
          key: 'isStreamingSupported',
          get: function get () {
            return this._isStreamingSupported
          }
        }])

        return BaseFullReader
      }())

      const BaseRangeReader = /* #__PURE__ */(function () {
        function BaseRangeReader (stream) {
          _classCallCheck(this, BaseRangeReader)

          this._url = stream.url
          this._done = false
          this._storedError = null
          this.onProgress = null
          this._loaded = 0
          this._readableStream = null
          this._readCapability = (0, _util.createPromiseCapability)()
          const source = stream.source
          this._isStreamingSupported = !source.disableStream
        }

        _createClass(BaseRangeReader, [{
          key: 'read',
          value: (function () {
            const _read2 = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee2 () {
              let chunk, buffer
              return _regenerator.default.wrap(function _callee2$ (_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2
                      return this._readCapability.promise

                    case 2:
                      if (!this._done) {
                        _context2.next = 4
                        break
                      }

                      return _context2.abrupt('return', {
                        value: undefined,
                        done: true
                      })

                    case 4:
                      if (!this._storedError) {
                        _context2.next = 6
                        break
                      }

                      throw this._storedError

                    case 6:
                      chunk = this._readableStream.read()

                      if (!(chunk === null)) {
                        _context2.next = 10
                        break
                      }

                      this._readCapability = (0, _util.createPromiseCapability)()
                      return _context2.abrupt('return', this.read())

                    case 10:
                      this._loaded += chunk.length

                      if (this.onProgress) {
                        this.onProgress({
                          loaded: this._loaded
                        })
                      }

                      buffer = new Uint8Array(chunk).buffer
                      return _context2.abrupt('return', {
                        value: buffer,
                        done: false
                      })

                    case 14:
                    case 'end':
                      return _context2.stop()
                  }
                }
              }, _callee2, this)
            }))

            function read () {
              return _read2.apply(this, arguments)
            }

            return read
          }())
        }, {
          key: 'cancel',
          value: function cancel (reason) {
            if (!this._readableStream) {
              this._error(reason)

              return
            }

            this._readableStream.destroy(reason)
          }
        }, {
          key: '_error',
          value: function _error (reason) {
            this._storedError = reason

            this._readCapability.resolve()
          }
        }, {
          key: '_setReadableStream',
          value: function _setReadableStream (readableStream) {
            const _this2 = this

            this._readableStream = readableStream
            readableStream.on('readable', function () {
              _this2._readCapability.resolve()
            })
            readableStream.on('end', function () {
              readableStream.destroy()
              _this2._done = true

              _this2._readCapability.resolve()
            })
            readableStream.on('error', function (reason) {
              _this2._error(reason)
            })

            if (this._storedError) {
              this._readableStream.destroy(this._storedError)
            }
          }
        }, {
          key: 'isStreamingSupported',
          get: function get () {
            return this._isStreamingSupported
          }
        }])

        return BaseRangeReader
      }())

      function createRequestOptions (url, headers) {
        return {
          protocol: url.protocol,
          auth: url.auth,
          host: url.hostname,
          port: url.port,
          path: url.path,
          method: 'GET',
          headers: headers
        }
      }

      var PDFNodeStreamFullReader = /* #__PURE__ */(function (_BaseFullReader) {
        _inherits(PDFNodeStreamFullReader, _BaseFullReader)

        function PDFNodeStreamFullReader (stream) {
          let _this3

          _classCallCheck(this, PDFNodeStreamFullReader)

          _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamFullReader).call(this, stream))

          const handleResponse = function handleResponse (response) {
            if (response.statusCode === 404) {
              const error = new _util.MissingPDFException('Missing PDF "'.concat(_this3._url, '".'))
              _this3._storedError = error

              _this3._headersCapability.reject(error)

              return
            }

            _this3._headersCapability.resolve()

            _this3._setReadableStream(response)

            const getResponseHeader = function getResponseHeader (name) {
              return _this3._readableStream.headers[name.toLowerCase()]
            }

            const _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
              getResponseHeader: getResponseHeader,
              isHttp: stream.isHttp,
              rangeChunkSize: _this3._rangeChunkSize,
              disableRange: _this3._disableRange
            })
            const allowRangeRequests = _validateRangeRequest.allowRangeRequests
            const suggestedLength = _validateRangeRequest.suggestedLength

            _this3._isRangeSupported = allowRangeRequests
            _this3._contentLength = suggestedLength || _this3._contentLength
            _this3._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader)
          }

          _this3._request = null

          if (_this3._url.protocol === 'http:') {
            _this3._request = http.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse)
          } else {
            _this3._request = https.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse)
          }

          _this3._request.on('error', function (reason) {
            _this3._storedError = reason

            _this3._headersCapability.reject(reason)
          })

          _this3._request.end()

          return _this3
        }

        return PDFNodeStreamFullReader
      }(BaseFullReader))

      var PDFNodeStreamRangeReader = /* #__PURE__ */(function (_BaseRangeReader) {
        _inherits(PDFNodeStreamRangeReader, _BaseRangeReader)

        function PDFNodeStreamRangeReader (stream, start, end) {
          let _this4

          _classCallCheck(this, PDFNodeStreamRangeReader)

          _this4 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamRangeReader).call(this, stream))
          _this4._httpHeaders = {}

          for (const property in stream.httpHeaders) {
            const value = stream.httpHeaders[property]

            if (typeof value === 'undefined') {
              continue
            }

            _this4._httpHeaders[property] = value
          }

          _this4._httpHeaders.Range = 'bytes='.concat(start, '-').concat(end - 1)

          const handleResponse = function handleResponse (response) {
            if (response.statusCode === 404) {
              const error = new _util.MissingPDFException('Missing PDF "'.concat(_this4._url, '".'))
              _this4._storedError = error
              return
            }

            _this4._setReadableStream(response)
          }

          _this4._request = null

          if (_this4._url.protocol === 'http:') {
            _this4._request = http.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse)
          } else {
            _this4._request = https.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse)
          }

          _this4._request.on('error', function (reason) {
            _this4._storedError = reason
          })

          _this4._request.end()

          return _this4
        }

        return PDFNodeStreamRangeReader
      }(BaseRangeReader))

      var PDFNodeStreamFsFullReader = /* #__PURE__ */(function (_BaseFullReader2) {
        _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2)

        function PDFNodeStreamFsFullReader (stream) {
          let _this5

          _classCallCheck(this, PDFNodeStreamFsFullReader)

          _this5 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamFsFullReader).call(this, stream))
          let path = decodeURIComponent(_this5._url.path)

          if (fileUriRegex.test(_this5._url.href)) {
            path = path.replace(/^\//, '')
          }

          fs.lstat(path, function (error, stat) {
            if (error) {
              if (error.code === 'ENOENT') {
                error = new _util.MissingPDFException('Missing PDF "'.concat(path, '".'))
              }

              _this5._storedError = error

              _this5._headersCapability.reject(error)

              return
            }

            _this5._contentLength = stat.size

            _this5._setReadableStream(fs.createReadStream(path))

            _this5._headersCapability.resolve()
          })
          return _this5
        }

        return PDFNodeStreamFsFullReader
      }(BaseFullReader))

      var PDFNodeStreamFsRangeReader = /* #__PURE__ */(function (_BaseRangeReader2) {
        _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2)

        function PDFNodeStreamFsRangeReader (stream, start, end) {
          let _this6

          _classCallCheck(this, PDFNodeStreamFsRangeReader)

          _this6 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamFsRangeReader).call(this, stream))
          let path = decodeURIComponent(_this6._url.path)

          if (fileUriRegex.test(_this6._url.href)) {
            path = path.replace(/^\//, '')
          }

          _this6._setReadableStream(fs.createReadStream(path, {
            start: start,
            end: end - 1
          }))

          return _this6
        }

        return PDFNodeStreamFsRangeReader
      }(BaseRangeReader))
      /***/ },
    /* 209 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.createResponseStatusError = createResponseStatusError
      exports.extractFilenameFromHeader = extractFilenameFromHeader
      exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities
      exports.validateResponseStatus = validateResponseStatus

      const _util = __w_pdfjs_require__(1)

      const _content_disposition = __w_pdfjs_require__(210)

      function validateRangeRequestCapabilities (_ref) {
        const getResponseHeader = _ref.getResponseHeader
        const isHttp = _ref.isHttp
        const rangeChunkSize = _ref.rangeChunkSize
        const disableRange = _ref.disableRange;
        (0, _util.assert)(rangeChunkSize > 0, 'Range chunk size must be larger than zero')
        const returnValues = {
          allowRangeRequests: false,
          suggestedLength: undefined
        }
        const length = parseInt(getResponseHeader('Content-Length'), 10)

        if (!Number.isInteger(length)) {
          return returnValues
        }

        returnValues.suggestedLength = length

        if (length <= 2 * rangeChunkSize) {
          return returnValues
        }

        if (disableRange || !isHttp) {
          return returnValues
        }

        if (getResponseHeader('Accept-Ranges') !== 'bytes') {
          return returnValues
        }

        const contentEncoding = getResponseHeader('Content-Encoding') || 'identity'

        if (contentEncoding !== 'identity') {
          return returnValues
        }

        returnValues.allowRangeRequests = true
        return returnValues
      }

      function extractFilenameFromHeader (getResponseHeader) {
        const contentDisposition = getResponseHeader('Content-Disposition')

        if (contentDisposition) {
          let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition)

          if (filename.includes('%')) {
            try {
              filename = decodeURIComponent(filename)
            } catch (ex) {}
          }

          if (/\.pdf$/i.test(filename)) {
            return filename
          }
        }

        return null
      }

      function createResponseStatusError (status, url) {
        if (status === 404 || status === 0 && url.startsWith('file:')) {
          return new _util.MissingPDFException('Missing PDF "' + url + '".')
        }

        return new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status)
      }

      function validateResponseStatus (status) {
        return status === 200 || status === 206
      }
      /***/ },
    /* 210 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader

      function _slicedToArray (arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest() }

      function _nonIterableRest () { throw new TypeError('Invalid attempt to destructure non-iterable instance') }

      function _iterableToArrayLimit (arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === '[object Arguments]')) { return } const _arr = []; let _n = true; let _d = false; let _e; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break } } catch (err) { _d = true; _e = err } finally { try { if (!_n && _i.return != null) _i.return() } finally { if (_d) throw _e } } return _arr }

      function _arrayWithHoles (arr) { if (Array.isArray(arr)) return arr }

      function getFilenameFromContentDispositionHeader (contentDisposition) {
        let needsEncodingFixup = true
        let tmp = toParamRegExp('filename\\*', 'i').exec(contentDisposition)

        if (tmp) {
          tmp = tmp[1]
          let filename = rfc2616unquote(tmp)
          filename = unescape(filename)
          filename = rfc5987decode(filename)
          filename = rfc2047decode(filename)
          return fixupEncoding(filename)
        }

        tmp = rfc2231getparam(contentDisposition)

        if (tmp) {
          const _filename = rfc2047decode(tmp)

          return fixupEncoding(_filename)
        }

        tmp = toParamRegExp('filename', 'i').exec(contentDisposition)

        if (tmp) {
          tmp = tmp[1]

          let _filename2 = rfc2616unquote(tmp)

          _filename2 = rfc2047decode(_filename2)
          return fixupEncoding(_filename2)
        }

        function toParamRegExp (attributePattern, flags) {
          return new RegExp('(?:^|;)\\s*' + attributePattern + '\\s*=\\s*' + '(' + '[^";\\s][^;\\s]*' + '|' + '"(?:[^"\\\\]|\\\\"?)+"?' + ')', flags)
        }

        function textdecode (encoding, value) {
          if (encoding) {
            if (!/^[\x00-\xFF]+$/.test(value)) {
              return value
            }

            try {
              const decoder = new TextDecoder(encoding, {
                fatal: true
              })
              const bytes = Array.from(value, function (ch) {
                return ch.charCodeAt(0) & 0xff
              })
              value = decoder.decode(new Uint8Array(bytes))
              needsEncodingFixup = false
            } catch (e) {
              if (/^utf-?8$/i.test(encoding)) {
                try {
                  value = decodeURIComponent(escape(value))
                  needsEncodingFixup = false
                } catch (err) {}
              }
            }
          }

          return value
        }

        function fixupEncoding (value) {
          if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
            value = textdecode('utf-8', value)

            if (needsEncodingFixup) {
              value = textdecode('iso-8859-1', value)
            }
          }

          return value
        }

        function rfc2231getparam (contentDisposition) {
          const matches = []
          let match
          const iter = toParamRegExp('filename\\*((?!0\\d)\\d+)(\\*?)', 'ig')

          while ((match = iter.exec(contentDisposition)) !== null) {
            const _match = match
            const _match2 = _slicedToArray(_match, 4)
            let n = _match2[1]
            const quot = _match2[2]
            const part = _match2[3]

            n = parseInt(n, 10)

            if (n in matches) {
              if (n === 0) {
                break
              }

              continue
            }

            matches[n] = [quot, part]
          }

          const parts = []

          for (let _n2 = 0; _n2 < matches.length; ++_n2) {
            if (!(_n2 in matches)) {
              break
            }

            const _matches$_n = _slicedToArray(matches[_n2], 2)
            const _quot = _matches$_n[0]
            let _part = _matches$_n[1]

            _part = rfc2616unquote(_part)

            if (_quot) {
              _part = unescape(_part)

              if (_n2 === 0) {
                _part = rfc5987decode(_part)
              }
            }

            parts.push(_part)
          }

          return parts.join('')
        }

        function rfc2616unquote (value) {
          if (value.startsWith('"')) {
            const parts = value.slice(1).split('\\"')

            for (let i = 0; i < parts.length; ++i) {
              const quotindex = parts[i].indexOf('"')

              if (quotindex !== -1) {
                parts[i] = parts[i].slice(0, quotindex)
                parts.length = i + 1
              }

              parts[i] = parts[i].replace(/\\(.)/g, '$1')
            }

            value = parts.join('"')
          }

          return value
        }

        function rfc5987decode (extvalue) {
          const encodingend = extvalue.indexOf("'")

          if (encodingend === -1) {
            return extvalue
          }

          const encoding = extvalue.slice(0, encodingend)
          const langvalue = extvalue.slice(encodingend + 1)
          const value = langvalue.replace(/^[^']*'/, '')
          return textdecode(encoding, value)
        }

        function rfc2047decode (value) {
          if (!value.startsWith('=?') || /[\x00-\x19\x80-\xff]/.test(value)) {
            return value
          }

          return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (_, charset, encoding, text) {
            if (encoding === 'q' || encoding === 'Q') {
              text = text.replace(/_/g, ' ')
              text = text.replace(/=([0-9a-fA-F]{2})/g, function (_, hex) {
                return String.fromCharCode(parseInt(hex, 16))
              })
              return textdecode(charset, text)
            }

            try {
              text = atob(text)
            } catch (e) {}

            return textdecode(charset, text)
          })
        }

        return ''
      }
      /***/ },
    /* 211 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.PDFNetworkStream = void 0

      const _regenerator = _interopRequireDefault(__w_pdfjs_require__(191))

      const _util = __w_pdfjs_require__(1)

      const _network_utils = __w_pdfjs_require__(209)

      function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

      function asyncGeneratorStep (gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value } catch (error) { reject(error); return } if (info.done) { resolve(value) } else { Promise.resolve(value).then(_next, _throw) } }

      function _asyncToGenerator (fn) { return function () { const self = this; const args = arguments; return new Promise(function (resolve, reject) { const gen = fn.apply(self, args); function _next (value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value) } function _throw (err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err) } _next(undefined) }) } }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      const OK_RESPONSE = 200
      const PARTIAL_CONTENT_RESPONSE = 206

      function getArrayBuffer (xhr) {
        const data = xhr.response

        if (typeof data !== 'string') {
          return data
        }

        const array = (0, _util.stringToBytes)(data)
        return array.buffer
      }

      const NetworkManager = /* #__PURE__ */(function () {
        function NetworkManager (url, args) {
          _classCallCheck(this, NetworkManager)

          this.url = url
          args = args || {}
          this.isHttp = /^https?:/i.test(url)
          this.httpHeaders = this.isHttp && args.httpHeaders || {}
          this.withCredentials = args.withCredentials || false

          this.getXhr = args.getXhr || function NetworkManager_getXhr () {
            return new XMLHttpRequest()
          }

          this.currXhrId = 0
          this.pendingRequests = Object.create(null)
        }

        _createClass(NetworkManager, [{
          key: 'requestRange',
          value: function requestRange (begin, end, listeners) {
            const args = {
              begin: begin,
              end: end
            }

            for (const prop in listeners) {
              args[prop] = listeners[prop]
            }

            return this.request(args)
          }
        }, {
          key: 'requestFull',
          value: function requestFull (listeners) {
            return this.request(listeners)
          }
        }, {
          key: 'request',
          value: function request (args) {
            const xhr = this.getXhr()
            const xhrId = this.currXhrId++
            const pendingRequest = this.pendingRequests[xhrId] = {
              xhr: xhr
            }
            xhr.open('GET', this.url)
            xhr.withCredentials = this.withCredentials

            for (const property in this.httpHeaders) {
              const value = this.httpHeaders[property]

              if (typeof value === 'undefined') {
                continue
              }

              xhr.setRequestHeader(property, value)
            }

            if (this.isHttp && 'begin' in args && 'end' in args) {
              xhr.setRequestHeader('Range', 'bytes='.concat(args.begin, '-').concat(args.end - 1))
              pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE
            } else {
              pendingRequest.expectedStatus = OK_RESPONSE
            }

            xhr.responseType = 'arraybuffer'

            if (args.onError) {
              xhr.onerror = function (evt) {
                args.onError(xhr.status)
              }
            }

            xhr.onreadystatechange = this.onStateChange.bind(this, xhrId)
            xhr.onprogress = this.onProgress.bind(this, xhrId)
            pendingRequest.onHeadersReceived = args.onHeadersReceived
            pendingRequest.onDone = args.onDone
            pendingRequest.onError = args.onError
            pendingRequest.onProgress = args.onProgress
            xhr.send(null)
            return xhrId
          }
        }, {
          key: 'onProgress',
          value: function onProgress (xhrId, evt) {
            const pendingRequest = this.pendingRequests[xhrId]

            if (!pendingRequest) {
              return
            }

            if (pendingRequest.onProgress) {
              pendingRequest.onProgress(evt)
            }
          }
        }, {
          key: 'onStateChange',
          value: function onStateChange (xhrId, evt) {
            const pendingRequest = this.pendingRequests[xhrId]

            if (!pendingRequest) {
              return
            }

            const xhr = pendingRequest.xhr

            if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
              pendingRequest.onHeadersReceived()
              delete pendingRequest.onHeadersReceived
            }

            if (xhr.readyState !== 4) {
              return
            }

            if (!(xhrId in this.pendingRequests)) {
              return
            }

            delete this.pendingRequests[xhrId]

            if (xhr.status === 0 && this.isHttp) {
              if (pendingRequest.onError) {
                pendingRequest.onError(xhr.status)
              }

              return
            }

            const xhrStatus = xhr.status || OK_RESPONSE
            const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE

            if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
              if (pendingRequest.onError) {
                pendingRequest.onError(xhr.status)
              }

              return
            }

            const chunk = getArrayBuffer(xhr)

            if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
              const rangeHeader = xhr.getResponseHeader('Content-Range')
              const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader)
              pendingRequest.onDone({
                begin: parseInt(matches[1], 10),
                chunk: chunk
              })
            } else if (chunk) {
              pendingRequest.onDone({
                begin: 0,
                chunk: chunk
              })
            } else if (pendingRequest.onError) {
              pendingRequest.onError(xhr.status)
            }
          }
        }, {
          key: 'hasPendingRequests',
          value: function hasPendingRequests () {
            for (const xhrId in this.pendingRequests) {
              return true
            }

            return false
          }
        }, {
          key: 'getRequestXhr',
          value: function getRequestXhr (xhrId) {
            return this.pendingRequests[xhrId].xhr
          }
        }, {
          key: 'isPendingRequest',
          value: function isPendingRequest (xhrId) {
            return xhrId in this.pendingRequests
          }
        }, {
          key: 'abortAllRequests',
          value: function abortAllRequests () {
            for (const xhrId in this.pendingRequests) {
              this.abortRequest(xhrId | 0)
            }
          }
        }, {
          key: 'abortRequest',
          value: function abortRequest (xhrId) {
            const xhr = this.pendingRequests[xhrId].xhr
            delete this.pendingRequests[xhrId]
            xhr.abort()
          }
        }])

        return NetworkManager
      }())

      const PDFNetworkStream = /* #__PURE__ */(function () {
        function PDFNetworkStream (source) {
          _classCallCheck(this, PDFNetworkStream)

          this._source = source
          this._manager = new NetworkManager(source.url, {
            httpHeaders: source.httpHeaders,
            withCredentials: source.withCredentials
          })
          this._rangeChunkSize = source.rangeChunkSize
          this._fullRequestReader = null
          this._rangeRequestReaders = []
        }

        _createClass(PDFNetworkStream, [{
          key: '_onRangeRequestReaderClosed',
          value: function _onRangeRequestReaderClosed (reader) {
            const i = this._rangeRequestReaders.indexOf(reader)

            if (i >= 0) {
              this._rangeRequestReaders.splice(i, 1)
            }
          }
        }, {
          key: 'getFullReader',
          value: function getFullReader () {
            (0, _util.assert)(!this._fullRequestReader)
            this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source)
            return this._fullRequestReader
          }
        }, {
          key: 'getRangeReader',
          value: function getRangeReader (begin, end) {
            const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end)
            reader.onClosed = this._onRangeRequestReaderClosed.bind(this)

            this._rangeRequestReaders.push(reader)

            return reader
          }
        }, {
          key: 'cancelAllRequests',
          value: function cancelAllRequests (reason) {
            if (this._fullRequestReader) {
              this._fullRequestReader.cancel(reason)
            }

            const readers = this._rangeRequestReaders.slice(0)

            readers.forEach(function (reader) {
              reader.cancel(reason)
            })
          }
        }])

        return PDFNetworkStream
      }())

      exports.PDFNetworkStream = PDFNetworkStream

      var PDFNetworkStreamFullRequestReader = /* #__PURE__ */(function () {
        function PDFNetworkStreamFullRequestReader (manager, source) {
          _classCallCheck(this, PDFNetworkStreamFullRequestReader)

          this._manager = manager
          const args = {
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
          }
          this._url = source.url
          this._fullRequestId = manager.requestFull(args)
          this._headersReceivedCapability = (0, _util.createPromiseCapability)()
          this._disableRange = source.disableRange || false
          this._contentLength = source.length
          this._rangeChunkSize = source.rangeChunkSize

          if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true
          }

          this._isStreamingSupported = false
          this._isRangeSupported = false
          this._cachedChunks = []
          this._requests = []
          this._done = false
          this._storedError = undefined
          this._filename = null
          this.onProgress = null
        }

        _createClass(PDFNetworkStreamFullRequestReader, [{
          key: '_onHeadersReceived',
          value: function _onHeadersReceived () {
            const fullRequestXhrId = this._fullRequestId

            const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId)

            const getResponseHeader = function getResponseHeader (name) {
              return fullRequestXhr.getResponseHeader(name)
            }

            const _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
              getResponseHeader: getResponseHeader,
              isHttp: this._manager.isHttp,
              rangeChunkSize: this._rangeChunkSize,
              disableRange: this._disableRange
            })
            const allowRangeRequests = _validateRangeRequest.allowRangeRequests
            const suggestedLength = _validateRangeRequest.suggestedLength

            if (allowRangeRequests) {
              this._isRangeSupported = true
            }

            this._contentLength = suggestedLength || this._contentLength
            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader)

            if (this._isRangeSupported) {
              this._manager.abortRequest(fullRequestXhrId)
            }

            this._headersReceivedCapability.resolve()
          }
        }, {
          key: '_onDone',
          value: function _onDone (args) {
            if (args) {
              if (this._requests.length > 0) {
                const requestCapability = this._requests.shift()

                requestCapability.resolve({
                  value: args.chunk,
                  done: false
                })
              } else {
                this._cachedChunks.push(args.chunk)
              }
            }

            this._done = true

            if (this._cachedChunks.length > 0) {
              return
            }

            this._requests.forEach(function (requestCapability) {
              requestCapability.resolve({
                value: undefined,
                done: true
              })
            })

            this._requests = []
          }
        }, {
          key: '_onError',
          value: function _onError (status) {
            const url = this._url
            const exception = (0, _network_utils.createResponseStatusError)(status, url)
            this._storedError = exception

            this._headersReceivedCapability.reject(exception)

            this._requests.forEach(function (requestCapability) {
              requestCapability.reject(exception)
            })

            this._requests = []
            this._cachedChunks = []
          }
        }, {
          key: '_onProgress',
          value: function _onProgress (data) {
            if (this.onProgress) {
              this.onProgress({
                loaded: data.loaded,
                total: data.lengthComputable ? data.total : this._contentLength
              })
            }
          }
        }, {
          key: 'read',
          value: (function () {
            const _read = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee () {
              let chunk, requestCapability
              return _regenerator.default.wrap(function _callee$ (_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!this._storedError) {
                        _context.next = 2
                        break
                      }

                      throw this._storedError

                    case 2:
                      if (!(this._cachedChunks.length > 0)) {
                        _context.next = 5
                        break
                      }

                      chunk = this._cachedChunks.shift()
                      return _context.abrupt('return', {
                        value: chunk,
                        done: false
                      })

                    case 5:
                      if (!this._done) {
                        _context.next = 7
                        break
                      }

                      return _context.abrupt('return', {
                        value: undefined,
                        done: true
                      })

                    case 7:
                      requestCapability = (0, _util.createPromiseCapability)()

                      this._requests.push(requestCapability)

                      return _context.abrupt('return', requestCapability.promise)

                    case 10:
                    case 'end':
                      return _context.stop()
                  }
                }
              }, _callee, this)
            }))

            function read () {
              return _read.apply(this, arguments)
            }

            return read
          }())
        }, {
          key: 'cancel',
          value: function cancel (reason) {
            this._done = true

            this._headersReceivedCapability.reject(reason)

            this._requests.forEach(function (requestCapability) {
              requestCapability.resolve({
                value: undefined,
                done: true
              })
            })

            this._requests = []

            if (this._manager.isPendingRequest(this._fullRequestId)) {
              this._manager.abortRequest(this._fullRequestId)
            }

            this._fullRequestReader = null
          }
        }, {
          key: 'filename',
          get: function get () {
            return this._filename
          }
        }, {
          key: 'isRangeSupported',
          get: function get () {
            return this._isRangeSupported
          }
        }, {
          key: 'isStreamingSupported',
          get: function get () {
            return this._isStreamingSupported
          }
        }, {
          key: 'contentLength',
          get: function get () {
            return this._contentLength
          }
        }, {
          key: 'headersReady',
          get: function get () {
            return this._headersReceivedCapability.promise
          }
        }])

        return PDFNetworkStreamFullRequestReader
      }())

      var PDFNetworkStreamRangeRequestReader = /* #__PURE__ */(function () {
        function PDFNetworkStreamRangeRequestReader (manager, begin, end) {
          _classCallCheck(this, PDFNetworkStreamRangeRequestReader)

          this._manager = manager
          const args = {
            onDone: this._onDone.bind(this),
            onProgress: this._onProgress.bind(this)
          }
          this._requestId = manager.requestRange(begin, end, args)
          this._requests = []
          this._queuedChunk = null
          this._done = false
          this.onProgress = null
          this.onClosed = null
        }

        _createClass(PDFNetworkStreamRangeRequestReader, [{
          key: '_close',
          value: function _close () {
            if (this.onClosed) {
              this.onClosed(this)
            }
          }
        }, {
          key: '_onDone',
          value: function _onDone (data) {
            const chunk = data.chunk

            if (this._requests.length > 0) {
              const requestCapability = this._requests.shift()

              requestCapability.resolve({
                value: chunk,
                done: false
              })
            } else {
              this._queuedChunk = chunk
            }

            this._done = true

            this._requests.forEach(function (requestCapability) {
              requestCapability.resolve({
                value: undefined,
                done: true
              })
            })

            this._requests = []

            this._close()
          }
        }, {
          key: '_onProgress',
          value: function _onProgress (evt) {
            if (!this.isStreamingSupported && this.onProgress) {
              this.onProgress({
                loaded: evt.loaded
              })
            }
          }
        }, {
          key: 'read',
          value: (function () {
            const _read2 = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee2 () {
              let chunk, requestCapability
              return _regenerator.default.wrap(function _callee2$ (_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!(this._queuedChunk !== null)) {
                        _context2.next = 4
                        break
                      }

                      chunk = this._queuedChunk
                      this._queuedChunk = null
                      return _context2.abrupt('return', {
                        value: chunk,
                        done: false
                      })

                    case 4:
                      if (!this._done) {
                        _context2.next = 6
                        break
                      }

                      return _context2.abrupt('return', {
                        value: undefined,
                        done: true
                      })

                    case 6:
                      requestCapability = (0, _util.createPromiseCapability)()

                      this._requests.push(requestCapability)

                      return _context2.abrupt('return', requestCapability.promise)

                    case 9:
                    case 'end':
                      return _context2.stop()
                  }
                }
              }, _callee2, this)
            }))

            function read () {
              return _read2.apply(this, arguments)
            }

            return read
          }())
        }, {
          key: 'cancel',
          value: function cancel (reason) {
            this._done = true

            this._requests.forEach(function (requestCapability) {
              requestCapability.resolve({
                value: undefined,
                done: true
              })
            })

            this._requests = []

            if (this._manager.isPendingRequest(this._requestId)) {
              this._manager.abortRequest(this._requestId)
            }

            this._close()
          }
        }, {
          key: 'isStreamingSupported',
          get: function get () {
            return false
          }
        }])

        return PDFNetworkStreamRangeRequestReader
      }())
      /***/ },
    /* 212 */
    /***/ function (module, exports, __w_pdfjs_require__) {
      'use strict'

      Object.defineProperty(exports, '__esModule', {
        value: true
      })
      exports.PDFFetchStream = void 0

      const _regenerator = _interopRequireDefault(__w_pdfjs_require__(191))

      const _util = __w_pdfjs_require__(1)

      const _network_utils = __w_pdfjs_require__(209)

      function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

      function asyncGeneratorStep (gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value } catch (error) { reject(error); return } if (info.done) { resolve(value) } else { Promise.resolve(value).then(_next, _throw) } }

      function _asyncToGenerator (fn) { return function () { const self = this; const args = arguments; return new Promise(function (resolve, reject) { const gen = fn.apply(self, args); function _next (value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value) } function _throw (err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err) } _next(undefined) }) } }

      function _classCallCheck (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function') } }

      function _defineProperties (target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor) } }

      function _createClass (Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor }

      function createFetchOptions (headers, withCredentials, abortController) {
        return {
          method: 'GET',
          headers: headers,
          signal: abortController && abortController.signal,
          mode: 'cors',
          credentials: withCredentials ? 'include' : 'same-origin',
          redirect: 'follow'
        }
      }

      function createHeaders (httpHeaders) {
        const headers = new Headers()

        for (const property in httpHeaders) {
          const value = httpHeaders[property]

          if (typeof value === 'undefined') {
            continue
          }

          headers.append(property, value)
        }

        return headers
      }

      const PDFFetchStream = /* #__PURE__ */(function () {
        function PDFFetchStream (source) {
          _classCallCheck(this, PDFFetchStream)

          this.source = source
          this.isHttp = /^https?:/i.test(source.url)
          this.httpHeaders = this.isHttp && source.httpHeaders || {}
          this._fullRequestReader = null
          this._rangeRequestReaders = []
        }

        _createClass(PDFFetchStream, [{
          key: 'getFullReader',
          value: function getFullReader () {
            (0, _util.assert)(!this._fullRequestReader)
            this._fullRequestReader = new PDFFetchStreamReader(this)
            return this._fullRequestReader
          }
        }, {
          key: 'getRangeReader',
          value: function getRangeReader (begin, end) {
            if (end <= this._progressiveDataLength) {
              return null
            }

            const reader = new PDFFetchStreamRangeReader(this, begin, end)

            this._rangeRequestReaders.push(reader)

            return reader
          }
        }, {
          key: 'cancelAllRequests',
          value: function cancelAllRequests (reason) {
            if (this._fullRequestReader) {
              this._fullRequestReader.cancel(reason)
            }

            const readers = this._rangeRequestReaders.slice(0)

            readers.forEach(function (reader) {
              reader.cancel(reason)
            })
          }
        }, {
          key: '_progressiveDataLength',
          get: function get () {
            return this._fullRequestReader ? this._fullRequestReader._loaded : 0
          }
        }])

        return PDFFetchStream
      }())

      exports.PDFFetchStream = PDFFetchStream

      var PDFFetchStreamReader = /* #__PURE__ */(function () {
        function PDFFetchStreamReader (stream) {
          const _this = this

          _classCallCheck(this, PDFFetchStreamReader)

          this._stream = stream
          this._reader = null
          this._loaded = 0
          this._filename = null
          const source = stream.source
          this._withCredentials = source.withCredentials || false
          this._contentLength = source.length
          this._headersCapability = (0, _util.createPromiseCapability)()
          this._disableRange = source.disableRange || false
          this._rangeChunkSize = source.rangeChunkSize

          if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true
          }

          if (typeof AbortController !== 'undefined') {
            this._abortController = new AbortController()
          }

          this._isStreamingSupported = !source.disableStream
          this._isRangeSupported = !source.disableRange
          this._headers = createHeaders(this._stream.httpHeaders)
          const url = source.url
          fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
            if (!(0, _network_utils.validateResponseStatus)(response.status)) {
              throw (0, _network_utils.createResponseStatusError)(response.status, url)
            }

            _this._reader = response.body.getReader()

            _this._headersCapability.resolve()

            const getResponseHeader = function getResponseHeader (name) {
              return response.headers.get(name)
            }

            const _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
              getResponseHeader: getResponseHeader,
              isHttp: _this._stream.isHttp,
              rangeChunkSize: _this._rangeChunkSize,
              disableRange: _this._disableRange
            })
            const allowRangeRequests = _validateRangeRequest.allowRangeRequests
            const suggestedLength = _validateRangeRequest.suggestedLength

            _this._isRangeSupported = allowRangeRequests
            _this._contentLength = suggestedLength || _this._contentLength
            _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader)

            if (!_this._isStreamingSupported && _this._isRangeSupported) {
              _this.cancel(new _util.AbortException('Streaming is disabled.'))
            }
          }).catch(this._headersCapability.reject)
          this.onProgress = null
        }

        _createClass(PDFFetchStreamReader, [{
          key: 'read',
          value: (function () {
            const _read = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee () {
              let _ref, value, done, buffer

              return _regenerator.default.wrap(function _callee$ (_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2
                      return this._headersCapability.promise

                    case 2:
                      _context.next = 4
                      return this._reader.read()

                    case 4:
                      _ref = _context.sent
                      value = _ref.value
                      done = _ref.done

                      if (!done) {
                        _context.next = 9
                        break
                      }

                      return _context.abrupt('return', {
                        value: value,
                        done: done
                      })

                    case 9:
                      this._loaded += value.byteLength

                      if (this.onProgress) {
                        this.onProgress({
                          loaded: this._loaded,
                          total: this._contentLength
                        })
                      }

                      buffer = new Uint8Array(value).buffer
                      return _context.abrupt('return', {
                        value: buffer,
                        done: false
                      })

                    case 13:
                    case 'end':
                      return _context.stop()
                  }
                }
              }, _callee, this)
            }))

            function read () {
              return _read.apply(this, arguments)
            }

            return read
          }())
        }, {
          key: 'cancel',
          value: function cancel (reason) {
            if (this._reader) {
              this._reader.cancel(reason)
            }

            if (this._abortController) {
              this._abortController.abort()
            }
          }
        }, {
          key: 'headersReady',
          get: function get () {
            return this._headersCapability.promise
          }
        }, {
          key: 'filename',
          get: function get () {
            return this._filename
          }
        }, {
          key: 'contentLength',
          get: function get () {
            return this._contentLength
          }
        }, {
          key: 'isRangeSupported',
          get: function get () {
            return this._isRangeSupported
          }
        }, {
          key: 'isStreamingSupported',
          get: function get () {
            return this._isStreamingSupported
          }
        }])

        return PDFFetchStreamReader
      }())

      var PDFFetchStreamRangeReader = /* #__PURE__ */(function () {
        function PDFFetchStreamRangeReader (stream, begin, end) {
          const _this2 = this

          _classCallCheck(this, PDFFetchStreamRangeReader)

          this._stream = stream
          this._reader = null
          this._loaded = 0
          const source = stream.source
          this._withCredentials = source.withCredentials || false
          this._readCapability = (0, _util.createPromiseCapability)()
          this._isStreamingSupported = !source.disableStream

          if (typeof AbortController !== 'undefined') {
            this._abortController = new AbortController()
          }

          this._headers = createHeaders(this._stream.httpHeaders)

          this._headers.append('Range', 'bytes='.concat(begin, '-').concat(end - 1))

          const url = source.url
          fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
            if (!(0, _network_utils.validateResponseStatus)(response.status)) {
              throw (0, _network_utils.createResponseStatusError)(response.status, url)
            }

            _this2._readCapability.resolve()

            _this2._reader = response.body.getReader()
          })
          this.onProgress = null
        }

        _createClass(PDFFetchStreamRangeReader, [{
          key: 'read',
          value: (function () {
            const _read2 = _asyncToGenerator(/* #__PURE__ */_regenerator.default.mark(function _callee2 () {
              let _ref2, value, done, buffer

              return _regenerator.default.wrap(function _callee2$ (_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2
                      return this._readCapability.promise

                    case 2:
                      _context2.next = 4
                      return this._reader.read()

                    case 4:
                      _ref2 = _context2.sent
                      value = _ref2.value
                      done = _ref2.done

                      if (!done) {
                        _context2.next = 9
                        break
                      }

                      return _context2.abrupt('return', {
                        value: value,
                        done: done
                      })

                    case 9:
                      this._loaded += value.byteLength

                      if (this.onProgress) {
                        this.onProgress({
                          loaded: this._loaded
                        })
                      }

                      buffer = new Uint8Array(value).buffer
                      return _context2.abrupt('return', {
                        value: buffer,
                        done: false
                      })

                    case 13:
                    case 'end':
                      return _context2.stop()
                  }
                }
              }, _callee2, this)
            }))

            function read () {
              return _read2.apply(this, arguments)
            }

            return read
          }())
        }, {
          key: 'cancel',
          value: function cancel (reason) {
            if (this._reader) {
              this._reader.cancel(reason)
            }

            if (this._abortController) {
              this._abortController.abort()
            }
          }
        }, {
          key: 'isStreamingSupported',
          get: function get () {
            return this._isStreamingSupported
          }
        }])

        return PDFFetchStreamRangeReader
      }())
      /***/ }
    /******/ ])
})
// # sourceMappingURL=pdf.js.map
